import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty2 from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _toConsumableArray2 from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject205() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.5rem !important;\n  border-radius: 4px;\n  box-shadow: 0 0 4px 0 rgba(73, 73, 73, 0.2);\n  color: #323231;\n"]);

  _templateObject205 = function _templateObject205() {
    return data;
  };

  return data;
}

function _templateObject204() {
  var data = _taggedTemplateLiteral(["\n  @media ", " {\n    width: 100%;\n\n    ", " {\n      justify-content: stretch;\n    }\n\n    ", ",\n    ", ",\n    fieldset,\n    label {\n      width: inherit;\n    }\n  }\n"]);

  _templateObject204 = function _templateObject204() {
    return data;
  };

  return data;
}

function _templateObject203() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject203 = function _templateObject203() {
    return data;
  };

  return data;
}

function _templateObject202() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: solid;\n  border-width: ", ";\n  color: ", ";\n  cursor: ", ";\n  font: ", ";\n  height: ", ";\n  margin-right: -", ";\n  padding: ", ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  position: relative;\n  box-sizing: content-box;\n\n  ", ":first-of-type & {\n    border-radius: ", ";\n  }\n\n  ", ":last-of-type & {\n    border-radius: ", ";\n    margin-right: 0;\n  }\n\n  ", ":focus + & {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    z-index: 200;\n  }\n\n  ", ":not(:focus-visible) + & {\n    background-color: ", ";\n    color: ", ";\n\n    box-shadow: unset;\n    z-index: unset;\n  }\n\n  ", ":focus-visible + & {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    z-index: 200;\n  }\n\n  ", ":hover + & {\n    border-color: ", ";\n    z-index: 100;\n  }\n\n  ", ":checked + & {\n    background-color: ", ";\n    color: ", ";\n    z-index: 200;\n  }\n\n  ", "[aria-invalid=\"true\"] + & {\n    border-color: ", ";\n  }\n\n  ", "[disabled] + & {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject202 = function _templateObject202() {
    return data;
  };

  return data;
}

function _templateObject201() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject201 = function _templateObject201() {
    return data;
  };

  return data;
}

function _templateObject200() {
  var data = _taggedTemplateLiteral(["\n  /* Some style to help in the calculation of ideal height */\n  height: auto;\n  overflow: hidden;\n\n  /* Hiding the reference textarea */\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  pointer-events: none;\n"]);

  _templateObject200 = function _templateObject200() {
    return data;
  };

  return data;
}

function _templateObject199() {
  var data = _taggedTemplateLiteral(["\n  resize: vertical;\n\n  min-height: var(--height-minus-border);\n  overflow: auto;\n\n  /* Resetting the line height set by the text input */\n  font: ", ";\n"]);

  _templateObject199 = function _templateObject199() {
    return data;
  };

  return data;
}

function _templateObject198() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  position: relative;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n\n  /** Shows no outline on click\n    * Falls back to showing outline on click in browsers\n    * that do not support :focus-visible (e.g., Safari)\n    */\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:not(:focus-visible) {\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"]);

  _templateObject198 = function _templateObject198() {
    return data;
  };

  return data;
}

function _templateObject197() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: pointer;\n    "]);

  _templateObject197 = function _templateObject197() {
    return data;
  };

  return data;
}

function _templateObject196() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        cursor: not-allowed;\n      "]);

  _templateObject196 = function _templateObject196() {
    return data;
  };

  return data;
}

function _templateObject195() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        border-bottom: 1px solid ", ";\n      }\n    "]);

  _templateObject195 = function _templateObject195() {
    return data;
  };

  return data;
}

function _templateObject194() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid ", ";\n  transition: ", ";\n  font: ", ";\n  &:focus {\n    background-color: ", ";\n    outline: none;\n  }\n  &:not(:focus-visible) {\n    background-color: transparent;\n  }\n  &:focus-visible {\n    background-color: ", ";\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject194 = function _templateObject194() {
    return data;
  };

  return data;
}

function _templateObject193() {
  var data = _taggedTemplateLiteral(["\n  height: 3px;\n  background-color: ", ";\n  width: ", ";\n  transform: ", ";\n  transition: ", ";\n  position: absolute;\n  bottom: 0;\n"]);

  _templateObject193 = function _templateObject193() {
    return data;
  };

  return data;
}

function _templateObject192() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject192 = function _templateObject192() {
    return data;
  };

  return data;
}

function _templateObject191() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: ", ";\n  position: relative;\n"]);

  _templateObject191 = function _templateObject191() {
    return data;
  };

  return data;
}

function _templateObject190() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  font: ", ";\n  color: ", ";\n  &:hover,\n  &:focus {\n    ", " {\n      box-shadow: ", ";\n    }\n  }\n  &:hover {\n    cursor: pointer;\n  }\n  &[disabled] {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject190 = function _templateObject190() {
    return data;
  };

  return data;
}

function _templateObject189() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: column;\n  ", " {\n    justify-self: end;\n  }\n"]);

  _templateObject189 = function _templateObject189() {
    return data;
  };

  return data;
}

function _templateObject188() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: none;\n  border-radius: 50px;\n  width: 50px;\n  height: 24px;\n  position: relative;\n  background: ", ";\n  vertical-align: middle;\n\n  ", "\n  &:hover,\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n  ::after {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    background: ", ";\n    height: 18px;\n    width: 18px;\n    top: 3px;\n    left: 3px;\n    transition: 0.2s ease-out transform;\n  }\n  &[aria-checked='true'] {\n    background: ", ";\n    ::after {\n      transform: translateX(25px);\n    }\n  }\n"]);

  _templateObject188 = function _templateObject188() {
    return data;
  };

  return data;
}

function _templateObject187() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 12px;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  ", "\n"]);

  _templateObject187 = function _templateObject187() {
    return data;
  };

  return data;
}

function _templateObject186() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.2s;\n  position: absolute;\n  font: ", ";\n  margin: 0;\n  z-index: 1;\n  background: ", ";\n  border-radius: ", ";\n  white-space: nowrap;\n\n  color: ", ";\n  // If there is no value selected yet and the input state is error, set the color to the default one\n  ", "\n\n  // Centering the input when used as placeholder\n  top: 1px;\n  bottom: 1px;\n  left: 1px;\n  margin: 1px;\n  display: flex;\n  align-items: center;\n\n  // Adding an ellipsis overflow instead of letting the select text go under the icon\n  overflow: hidden;\n  right: calc(15px + 24px);\n  padding-left: 15px;\n  text-overflow: ellipsis;\n  // This is needed for the overflow:\n  // 2px === borders, 16px === left padding, 24px === select icon width, 24px === 12px icon padding x 2\n  width: calc(100% - 2px - 16px - 24px - 24px);\n\n  // Animation + styles of the label when there is a selected value\n  ", "\n\n  ", "\n"]);

  _templateObject186 = function _templateObject186() {
    return data;
  };

  return data;
}

function _templateObject185() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  top: -9px;\n  left: 13px;\n  right: unset;\n  padding: 2px 4px;\n  height: min-content;\n  width: unset;\n"]);

  _templateObject185 = function _templateObject185() {
    return data;
  };

  return data;
}

function _templateObject184() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.2s;\n  cursor: ", ";\n  width: 100%;\n  height: ", ";\n  font: ", ";\n  margin: 0;\n  // Adding an ellipsis overflow instead of letting the select text go under the icon\n  padding: 0 calc(12px + 24px + 12px) 0 16px;\n  text-overflow: ellipsis;\n\n  /* Do the color and the border color at the same time */\n  ", "\n\n  background-color: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n\n  // Removing the default arrow icon\n  appearance: none;\n\n  /* Do not change the input on hover when it's disabled */\n  :hover {\n    ", ";\n  }\n\n  :focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n"]);

  _templateObject184 = function _templateObject184() {
    return data;
  };

  return data;
}

function _templateObject183() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject183 = function _templateObject183() {
    return data;
  };

  return data;
}

function _templateObject182() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px 0 24px;\n"]);

  _templateObject182 = function _templateObject182() {
    return data;
  };

  return data;
}

function _templateObject181() {
  var data = _taggedTemplateLiteral(["\n  transform: ", ";\n  transition: transform ", "s ease;\n"]);

  _templateObject181 = function _templateObject181() {
    return data;
  };

  return data;
}

function _templateObject180() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n"]);

  _templateObject180 = function _templateObject180() {
    return data;
  };

  return data;
}

function _templateObject179() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  color: ", ";\n\n  font: ", ";\n\n  border-radius: ", ";\n  height: ", ";\n  width: fit-content;\n  min-width: 24px;\n  padding: 0 ", ";\n  display: flex;\n  align-items: center;\n"]);

  _templateObject179 = function _templateObject179() {
    return data;
  };

  return data;
}

function _templateObject178() {
  var data = _taggedTemplateLiteral(["\n      border-style: solid;\n      border-width: ", ";\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject178 = function _templateObject178() {
    return data;
  };

  return data;
}

function _templateObject177() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject177 = function _templateObject177() {
    return data;
  };

  return data;
}

function _templateObject176() {
  var data = _taggedTemplateLiteral(["\n        border-style: solid;\n        border-width: ", ";\n        border-color: ", ";\n      "]);

  _templateObject176 = function _templateObject176() {
    return data;
  };

  return data;
}

function _templateObject175() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject175 = function _templateObject175() {
    return data;
  };

  return data;
}

function _templateObject174() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject174 = function _templateObject174() {
    return data;
  };

  return data;
}

function _templateObject173() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: ", ";\n\n  ", ":focus + ", " & {\n    box-shadow: ", ";\n  }\n\n  ", ":hover + ", " & {\n    border-color: ", ";\n  }\n\n  ", "[disabled]:hover + ", " & {\n    border-color: ", ";\n  }\n\n  ", "\n\n  &:after {\n    ", ";\n    content: '';\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n  }\n"]);

  _templateObject173 = function _templateObject173() {
    return data;
  };

  return data;
}

function _templateObject172() {
  var data = _taggedTemplateLiteral(["\n  min-width: ", ";\n  min-height: ", ";\n  position: relative;\n  cursor: ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 1px;\n    bottom: -1px;\n    left: 0;\n    right: 0;\n    border-radius: 50%;\n  }\n"]);

  _templateObject172 = function _templateObject172() {
    return data;
  };

  return data;
}

function _templateObject171() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  width: fit-content;\n  cursor: ", ";\n  margin-bottom: 8px;\n"]);

  _templateObject171 = function _templateObject171() {
    return data;
  };

  return data;
}

function _templateObject170() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n    "]);

  _templateObject170 = function _templateObject170() {
    return data;
  };

  return data;
}

function _templateObject169() {
  var data = _taggedTemplateLiteral(["\n  height: 48px;\n  min-width: 48px;\n  background: ", ";\n  margin: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n\n  ", "\n"]);

  _templateObject169 = function _templateObject169() {
    return data;
  };

  return data;
}

function _templateObject168() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.3s;\n  height: 48px;\n  width: 48px;\n  border-radius: ", ";\n  background-color: ", ";\n  margin: 0 8px;\n  text-align: center;\n  border: ", " solid;\n  border-color: transparent;\n  font: ", ";\n  color: ", ";\n\n  ", "\n\n  // Remove the native steppers\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n\n  :focus {\n    outline: none;\n    box-shadow: ", ";\n    border-color: ", ";\n  }\n\n  :hover {\n    ", ";\n  }\n\n  :disabled {\n    color: ", ";\n    border-color: transparent;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject168 = function _templateObject168() {
    return data;
  };

  return data;
}

function _templateObject167() {
  var data = _taggedTemplateLiteral(["\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  ", "\n"]);

  _templateObject167 = function _templateObject167() {
    return data;
  };

  return data;
}

function _templateObject166() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n"]);

  _templateObject166 = function _templateObject166() {
    return data;
  };

  return data;
}

function _templateObject165() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  padding-top: ", ";\n  text-align: center;\n"]);

  _templateObject165 = function _templateObject165() {
    return data;
  };

  return data;
}

function _templateObject164() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject164 = function _templateObject164() {
    return data;
  };

  return data;
}

function _templateObject163() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding-top: ", ";\n  font: ", ";\n  text-align: center;\n  min-height: ", ";\n  ", ":hover & {\n    color: ", ";\n  }\n"]);

  _templateObject163 = function _templateObject163() {
    return data;
  };

  return data;
}

function _templateObject162() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n\n  & > * {\n    display: block;\n    width: auto;\n    object-fit: contain;\n    object-position: center;\n    max-height: 100px;\n    margin: auto;\n\n    @media ", " {\n      max-height: 120px;\n    }\n    @media ", " {\n      max-height: 160px;\n    }\n  }\n"]);

  _templateObject162 = function _templateObject162() {
    return data;
  };

  return data;
}

function _templateObject161() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-decoration: none;\n  border-radius: ", ";\n  color: ", ";\n  padding: ", " ", " ", ";\n  cursor: pointer;\n  height: 100%;\n  max-width: 150px;\n  width: 40vw;\n  background: ", ";\n  border: 1px solid ", ";\n\n  &:focus {\n    outline: none;\n    background: ", ";\n  }\n\n  @media ", " {\n    max-width: unset;\n    width: 140px;\n    background: none;\n    border: none;\n  }\n\n  @media ", " {\n    width: 180px;\n  }\n"]);

  _templateObject161 = function _templateObject161() {
    return data;
  };

  return data;
}

function _templateObject160() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n"]);

  _templateObject160 = function _templateObject160() {
    return data;
  };

  return data;
}

function _templateObject159() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  min-width: 40px;\n\n  @media ", " {\n    display: flex;\n    align-items: center;\n  }\n"]);

  _templateObject159 = function _templateObject159() {
    return data;
  };

  return data;
}

function _templateObject158() {
  var data = _taggedTemplateLiteral(["\n  padding-inline-start: 0;\n  margin: 0;\n  display: flex;\n  width: 100%;\n  & > li {\n    padding-right: ", ";\n    :last-child {\n      padding-right: ", ";\n    }\n  }\n\n  @media ", " {\n    justify-content: space-around;\n    min-width: 100%;\n    width: calc((100% / ", ") * ", ");\n    transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);\n    transform: translateX(calc(-", " * 100%));\n    & > li {\n      padding-right: ", ";\n      :last-child {\n        padding-right: unset;\n      }\n    }\n  }\n"]);

  _templateObject158 = function _templateObject158() {
    return data;
  };

  return data;
}

function _templateObject157() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow: auto;\n  position: relative;\n\n  @media ", " {\n    overflow: hidden;\n  }\n"]);

  _templateObject157 = function _templateObject157() {
    return data;
  };

  return data;
}

function _templateObject156() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 0 6%;\n\n  // setting the original Grid margin values\n  @media ", " {\n    margin: 0 6%;\n  }\n  @media ", " {\n    margin: 0 auto;\n  }\n"]);

  _templateObject156 = function _templateObject156() {
    return data;
  };

  return data;
}

function _templateObject155() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: row;\n  background: ", ";\n  padding: 0 0 ", " 0;\n\n  @media ", " {\n    width: inherit;\n    background: none;\n    padding: 0;\n    margin: auto;\n    justify-content: center;\n  }\n"]);

  _templateObject155 = function _templateObject155() {
    return data;
  };

  return data;
}

function _templateObject154() {
  var data = _taggedTemplateLiteral(["\n  justify-self: end;\n"]);

  _templateObject154 = function _templateObject154() {
    return data;
  };

  return data;
}

function _templateObject153() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  grid-column-start: 1;\n  margin: 0;\n\n  @media ", " {\n    grid-column-start: ", ";\n    text-align: center;\n  }\n"]);

  _templateObject153 = function _templateObject153() {
    return data;
  };

  return data;
}

function _templateObject152() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  align-items: center;\n  grid-template-columns: ", ";\n  padding: ", " 0 ", ";\n  margin: 0 0 0 6%;\n\n  @media ", " {\n    background: none;\n    padding: ", " 0 ", ";\n    grid-template-columns: ", ";\n    margin: 0 6%;\n  }\n\n  @media ", " {\n    margin: 0;\n  }\n"]);

  _templateObject152 = function _templateObject152() {
    return data;
  };

  return data;
}

function _templateObject151() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  background: none;\n  font: ", ";\n  color: ", ";\n  text-align: center;\n  height: ", ";\n  padding: 0 calc(", " + ", ") 0\n    calc(", " + ", ");\n  border-radius: ", ";\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n  /* For browsers that support :focus-visible, undo the :focus\n    behavior we just enabled, and enable it only on :focus-visible.\n    This way the focus appearance is still activated on keyboard focus,\n    but does not linger after a click. The more specific selector of\n    the hover styles keeps it from being overridden by the broad\n    selector of &:not(:focus-visible). */\n  &:not(:focus-visible) {\n    box-shadow: none;\n  }\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"]);

  _templateObject151 = function _templateObject151() {
    return data;
  };

  return data;
}

function _templateObject150() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  left: auto;\n  right: 0;\n"]);

  _templateObject150 = function _templateObject150() {
    return data;
  };

  return data;
}

function _templateObject149() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n  position: absolute;\n  width: ", ";\n  height: ", ";\n  top: 0;\n  left: 0;\n  pointer-events: none;\n\n  & > svg {\n    vertical-align: middle;\n    stroke: ", ";\n    fill: ", ";\n  }\n"]);

  _templateObject149 = function _templateObject149() {
    return data;
  };

  return data;
}

function _templateObject148() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  font-size: 0;\n"]);

  _templateObject148 = function _templateObject148() {
    return data;
  };

  return data;
}

function _templateObject147() {
  var data = _taggedTemplateLiteral(["\n  justify-self: ", ";\n  grid-column: ", ";\n"]);

  _templateObject147 = function _templateObject147() {
    return data;
  };

  return data;
}

function _templateObject146() {
  var data = _taggedTemplateLiteral(["\n  justify-self: center;\n  grid-column: ", ";\n"]);

  _templateObject146 = function _templateObject146() {
    return data;
  };

  return data;
}

function _templateObject145() {
  var data = _taggedTemplateLiteral(["\n  justify-self: ", ";\n  grid-column: 1;\n"]);

  _templateObject145 = function _templateObject145() {
    return data;
  };

  return data;
}

function _templateObject144() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: ", ";\n  align-items: center;\n  @media screen and (max-width: 300px) {\n    grid-template-columns: 1fr;\n    > div {\n      justify-self: center;\n      grid-column: 1;\n    }\n  }\n"]);

  _templateObject144 = function _templateObject144() {
    return data;
  };

  return data;
}

function _templateObject143() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n"]);

  _templateObject143 = function _templateObject143() {
    return data;
  };

  return data;
}

function _templateObject142() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  margin-right: ", ";\n"]);

  _templateObject142 = function _templateObject142() {
    return data;
  };

  return data;
}

function _templateObject141() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  ", "\n"]);

  _templateObject141 = function _templateObject141() {
    return data;
  };

  return data;
}

function _templateObject140() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  ", "\n"]);

  _templateObject140 = function _templateObject140() {
    return data;
  };

  return data;
}

function _templateObject139() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  ", "\n"]);

  _templateObject139 = function _templateObject139() {
    return data;
  };

  return data;
}

function _templateObject138() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  ", "\n"]);

  _templateObject138 = function _templateObject138() {
    return data;
  };

  return data;
}

function _templateObject137() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n\n  @media ", " {\n    padding-top: ", ";\n  }\n"]);

  _templateObject137 = function _templateObject137() {
    return data;
  };

  return data;
}

function _templateObject136() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  color: ", ";\n\n  @media ", " {\n    align-items: ", ";\n  }\n"]);

  _templateObject136 = function _templateObject136() {
    return data;
  };

  return data;
}

function _templateObject135() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  margin-right: ", ";\n\n  & > * {\n    display: block;\n    width: 100%;\n    object-fit: contain;\n    object-position: center;\n    height: ", ";\n  }\n\n  @media ", " {\n    margin-right: 0;\n\n    & > * {\n      height: 160px;\n    }\n  }\n"]);

  _templateObject135 = function _templateObject135() {
    return data;
  };

  return data;
}

function _templateObject134() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  align-items: center;\n\n  @media ", " {\n    display: unset;\n  }\n"]);

  _templateObject134 = function _templateObject134() {
    return data;
  };

  return data;
}

function _templateObject133() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n  font: ", ";\n  color: ", ";\n"]);

  _templateObject133 = function _templateObject133() {
    return data;
  };

  return data;
}

function _templateObject132() {
  var data = _taggedTemplateLiteral(["\n  width: 16px;\n\n  @media ", " {\n    width: 20px;\n  }\n"]);

  _templateObject132 = function _templateObject132() {
    return data;
  };

  return data;
}

function _templateObject131() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  padding: ", " 6%;\n  width: 100%;\n\n  @media ", " {\n    padding: ", ";\n  }\n"]);

  _templateObject131 = function _templateObject131() {
    return data;
  };

  return data;
}

function _templateObject130() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: inherit;\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject130 = function _templateObject130() {
    return data;
  };

  return data;
}

function _templateObject129() {
  var data = _taggedTemplateLiteral(["\n      position: absolute;\n      right: ", ";\n      bottom: ", ";\n      right: ", ";\n      bottom: ", ";\n    "]);

  _templateObject129 = function _templateObject129() {
    return data;
  };

  return data;
}

function _templateObject128() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  text-align: right;\n\n  ", "\n"]);

  _templateObject128 = function _templateObject128() {
    return data;
  };

  return data;
}

function _templateObject127() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n\n  @media ", " {\n    white-space: nowrap;\n  }\n\n  @media ", " {\n    margin-top: ", ";\n  }\n"]);

  _templateObject127 = function _templateObject127() {
    return data;
  };

  return data;
}

function _templateObject126() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  font: ", ";\n\n  @media ", " {\n    margin-top: ", ";\n  }\n"]);

  _templateObject126 = function _templateObject126() {
    return data;
  };

  return data;
}

function _templateObject125() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n"]);

  _templateObject125 = function _templateObject125() {
    return data;
  };

  return data;
}

function _templateObject124() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  width: 80%;\n  height: 240px;\n  margin: 0 10%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > * {\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  @media ", " {\n    margin: 0 6%;\n    width: 88%;\n    height: 280px;\n  }\n\n  @media ", " {\n    height: 440px;\n  }\n"]);

  _templateObject124 = function _templateObject124() {
    return data;
  };

  return data;
}

function _templateObject123() {
  var data = _taggedTemplateLiteral(["\n  row-gap: ", ";\n  align-items: center;\n\n  margin-top: ", ";\n  margin-bottom: ", ";\n  color: ", ";\n\n  @media ", " {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject123 = function _templateObject123() {
    return data;
  };

  return data;
}

function _templateObject122() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n"]);

  _templateObject122 = function _templateObject122() {
    return data;
  };

  return data;
}

function _templateObject121() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n\n  align-items: ", ";\n  align-content: ", ";\n  align-self: ", ";\n  justify-content: ", ";\n  flex-direction: ", ";\n\n  flex-wrap: ", ";\n  overflow: ", ";\n\n  position: ", ";\n  z-index: ", ";\n  left: ", ";\n  top: ", ";\n  bottom: ", ";\n  right: ", ";\n\n  margin: ", ";\n  padding: ", ";\n\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  min-height: ", ";\n  background: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject121 = function _templateObject121() {
    return data;
  };

  return data;
}

function _templateObject120() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media ", " {\n    justify-self: end;\n  }\n\n  @media ", " {\n    padding-left: ", ";\n  }\n"]);

  _templateObject120 = function _templateObject120() {
    return data;
  };

  return data;
}

function _templateObject119() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  margin-top: 0;\n\n  @media ", " {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject119 = function _templateObject119() {
    return data;
  };

  return data;
}

function _templateObject118() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-auto-flow: row;\n  justify-items: start;\n  align-items: center;\n\n  @media ", " {\n    display: grid;\n    grid-area: 2/1/2/8;\n    grid-auto-flow: column;\n    align-items: center;\n  }\n  @media ", " {\n    grid-area: 1 / 2 / 1 / 3;\n    display: grid;\n    grid-auto-flow: column;\n    justify-items: end;\n    align-items: center;\n  }\n"]);

  _templateObject118 = function _templateObject118() {
    return data;
  };

  return data;
}

function _templateObject117() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-auto-flow: column;\n  grid-auto-columns: min-width;\n  align-items: center;\n"]);

  _templateObject117 = function _templateObject117() {
    return data;
  };

  return data;
}

function _templateObject116() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  grid-row-gap: ", ";\n  margin: 0 6%;\n  justify-items: start;\n  align-items: center;\n\n  @media ", " {\n    grid-template-columns: 1fr auto;\n  }\n\n  @media ", " {\n    grid-template-columns: 1fr auto;\n    padding: ", " ", " ", " 0;\n    max-width: 1136px;\n    margin: auto;\n  }\n"]);

  _templateObject116 = function _templateObject116() {
    return data;
  };

  return data;
}

function _templateObject115() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n  margin: 0 6%;\n\n  @media ", " {\n    max-width: 1136px;\n    margin: 0 auto;\n  }\n"]);

  _templateObject115 = function _templateObject115() {
    return data;
  };

  return data;
}

function _templateObject114() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject114 = function _templateObject114() {
    return data;
  };

  return data;
}

function _templateObject113() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-rows: min-content;\n  grid-area: 2 / 2 / 3 / 3;\n  grid-row-gap: ", ";\n\n  @media ", " {\n    grid-area: 2 / 5 / 2 / 9;\n  }\n\n  @media ", " {\n    grid-area: 1 / 7 / 1 / 9;\n  }\n\n  @media ", " {\n    grid-area: 1 / 10 / 1 / 12;\n    grid-row-gap: ", ";\n  }\n"]);

  _templateObject113 = function _templateObject113() {
    return data;
  };

  return data;
}

function _templateObject112() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-rows: min-content;\n  grid-row-gap: ", ";\n\n  @media ", " {\n    grid-area: 2 / 1 / 2 / 5;\n  }\n\n  @media ", " {\n    grid-area: 1 / 5 / 1 / 7;\n  }\n\n  @media ", " {\n    grid-area: 1 / 7 / 1 / 10;\n    grid-row-gap: ", ";\n  }\n"]);

  _templateObject112 = function _templateObject112() {
    return data;
  };

  return data;
}

function _templateObject111() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject111 = function _templateObject111() {
    return data;
  };

  return data;
}

function _templateObject110() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-rows: min-content;\n  grid-area: 1 / 1 / 1 / 3;\n  padding-bottom: ", ";\n  grid-row-gap: ", ";\n\n  @media ", " {\n    grid-area: 1 / 1 / 1 / 8;\n  }\n\n  @media ", " {\n    grid-area: 1 / 3 / 1 / 5;\n    padding-bottom: ", ";\n  }\n\n  @media ", " {\n    grid-area: 1 / 4 / 1 / 7;\n    grid-row-gap: ", ";\n  }\n"]);

  _templateObject110 = function _templateObject110() {
    return data;
  };

  return data;
}

function _templateObject109() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media ", " {\n    display: grid;\n    grid-area: 1 / 1 / 1 / 3;\n  }\n\n  @media ", " {\n    grid-area: 1 / 1 / 1 / 4;\n  }\n"]);

  _templateObject109 = function _templateObject109() {
    return data;
  };

  return data;
}

function _templateObject108() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  @media ", " {\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n"]);

  _templateObject108 = function _templateObject108() {
    return data;
  };

  return data;
}

function _templateObject107() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  background-color: ", ";\n"]);

  _templateObject107 = function _templateObject107() {
    return data;
  };

  return data;
}

function _templateObject106() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  column-gap: ", ";\n  margin: 0 6%;\n\n  & > * {\n    min-width: 0;\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(", ", 1fr);\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(", ", 1fr);\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(", ", 1fr);\n    max-width: 1136px;\n    margin: 0 auto;\n  }\n"]);

  _templateObject106 = function _templateObject106() {
    return data;
  };

  return data;
}

function _templateObject105() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 0 ", ";\n  margin: 0;\n\n  @media ", " {\n    padding: 0 0 ", ";\n  }\n"]);

  _templateObject105 = function _templateObject105() {
    return data;
  };

  return data;
}

function _templateObject104() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  text-align: left;\n  margin: 0;\n"]);

  _templateObject104 = function _templateObject104() {
    return data;
  };

  return data;
}

function _templateObject103() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  padding: 0 0 ", " 0;\n  text-align: left;\n  overflow-wrap: anywhere;\n  margin: 0;\n"]);

  _templateObject103 = function _templateObject103() {
    return data;
  };

  return data;
}

function _templateObject102() {
  var data = _taggedTemplateLiteral(["\n  grid-row-gap: 8px;\n  &:nth-last-child(1) {\n    justify-items: end;\n  }\n"]);

  _templateObject102 = function _templateObject102() {
    return data;
  };

  return data;
}

function _templateObject101() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  text-align: center;\n  margin: auto;\n  grid-row-gap: ", ";\n  grid-column-start: 2;\n  padding: ", " ", " ", ";\n  max-width: 400px;\n  background: ", ";\n  border-radius: ", ";\n\n  @media ", " {\n    padding: ", " ", " ", ";\n  }\n"]);

  _templateObject101 = function _templateObject101() {
    return data;
  };

  return data;
}

function _templateObject100() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 6% auto 6%;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  z-index: 500;\n"]);

  _templateObject100 = function _templateObject100() {
    return data;
  };

  return data;
}

function _templateObject99() {
  var data = _taggedTemplateLiteral(["\n  /* Counters the top and bottom margins of the TextInput components */\n  margin: -", " 0 -", " 0;\n\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: ", ";\n"]);

  _templateObject99 = function _templateObject99() {
    return data;
  };

  return data;
}

function _templateObject98() {
  var data = _taggedTemplateLiteral(["\n  /* margin-top: -", "; */\n"]);

  _templateObject98 = function _templateObject98() {
    return data;
  };

  return data;
}

function _templateObject97() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject97 = function _templateObject97() {
    return data;
  };

  return data;
}

function _templateObject96() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject96 = function _templateObject96() {
    return data;
  };

  return data;
}

function _templateObject95() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  font: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject95 = function _templateObject95() {
    return data;
  };

  return data;
}

function _templateObject94() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  padding: 0;\n  margin: ", " 0 ", " 0;\n"]);

  _templateObject94 = function _templateObject94() {
    return data;
  };

  return data;
}

function _templateObject93() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n"]);

  _templateObject93 = function _templateObject93() {
    return data;
  };

  return data;
}

function _templateObject92() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  color: ", ";\n\n  font: ", ";\n\n  border-radius: ", ";\n  height: ", ";\n  width: fit-content;\n  min-width: 24px;\n  padding: 0 ", ";\n  display: flex;\n  align-items: center;\n"]);

  _templateObject92 = function _templateObject92() {
    return data;
  };

  return data;
}

function _templateObject91() {
  var data = _taggedTemplateLiteral(["\n        border-style: solid;\n        border-width: ", ";\n        border-color: ", ";\n        background-color: ", ";\n      "]);

  _templateObject91 = function _templateObject91() {
    return data;
  };

  return data;
}

function _templateObject90() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject90 = function _templateObject90() {
    return data;
  };

  return data;
}

function _templateObject89() {
  var data = _taggedTemplateLiteral(["\n          border-style: solid;\n          border-width: ", ";\n          border-color: ", ";\n        "]);

  _templateObject89 = function _templateObject89() {
    return data;
  };

  return data;
}

function _templateObject88() {
  var data = _taggedTemplateLiteral(["\n            background-color: ", ";\n          "]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative;\n  width: ", ";\n  height: ", ";\n\n  ", ":hover + ", " & {\n    &::after {\n      ", ";\n    }\n  }\n\n  ", "[disabled]:hover + ", " & {\n    &::after {\n      ", ";\n    }\n  }\n\n  ", ":focus + ", " & {\n    &::after {\n      box-shadow: ", ";\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: ", ";\n    transition: ", ";\n\n    ", "\n  }\n"]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  margin: 8px 0;\n  width: fit-content;\n  cursor: ", ";\n"]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 100;\n  svg {\n    padding: 2px;\n  }\n"]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  margin: 0;\n  ", "\n"]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  color: ", ";\n  margin: 0 0 4px 0;\n  ", "\n"]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 0 8px;\n  cursor: ", ";\n"]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n    text-decoration: underline;\n    &:hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteral(["\n      grid-column-end: span ", ";\n      grid-column-start: ", ";\n      grid-row-start: ", ";\n\n      @media ", " {\n        grid-column-end: span ", ";\n        grid-column-start: ", ";\n        grid-row-start: ", ";\n      }\n\n      @media ", " {\n        grid-column-end: span ", ";\n        grid-column-start: ", ";\n        grid-row-start: ", ";\n      }\n\n      @media ", " {\n        grid-column-end: span ", ";\n        grid-column-start: ", ";\n        grid-row-start: ", ";\n      }\n    "]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n"]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font: ", ";\n  max-width: 100%;\n  margin-bottom: ", ";\n"]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  margin: ", " 0 0 0;\n  align-self: flex-start;\n\n  @media ", " {\n    align-self: flex-end;\n    margin: 0 0 0 ", ";\n  }\n"]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-grow: 1;\n\n  @media ", " {\n    padding: ", " ", ";\n\n    flex-direction: row;\n  }\n"]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  border-radius: ", ";\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  overflow: hidden;\n\n  /* Counters line height produced by inline-block behavior of basic <img> tags */\n  line-height: 0;\n\n  & > * {\n    width: 100%;\n  }\n"]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  color: ", ";\n  background: ", ";\n  border-radius: ", ";\n"]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n\n  cursor: pointer;\n  color: ", ";\n  font: inherit;\n  text-decoration: underline;\n"]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteral(["\n  html {\n    --font-hero: ", ";\n    --font-headerOne: ", ";\n    --font-headerTwo: ", ";\n    --font-headerThree: ", ";\n    --font-copyOne: ", ";\n    --font-copyTwo: ", ";\n\n    @media ", " {\n      --font-headerOne: ", ";\n      --font-headerTwo: ", ";\n      --font-headerThree: ", ";\n      --font-copyOne: ", ";\n      --font-copyTwo: ", ";\n    }\n\n    @media ", " {\n      --font-hero: ", ";\n    }\n  }\n"]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteral(["\n  html {\n    --font-hero: ", ";\n    --font-headerOne: ", ";\n    --font-headerTwo: ", ";\n    --font-headerThree: ", ";\n    --font-copyOne: ", ";\n    --font-copyTwo: ", ";\n\n    @media ", " {\n      --font-headerOne: ", ";\n      --font-headerTwo: ", ";\n      --font-headerThree: ", ";\n      --font-copyOne: ", ";\n      --font-copyTwo: ", ";\n    }\n\n    @media ", " {\n      --font-hero: ", ";\n    }\n  }\n"]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteral(["\n  html {\n    --font-hero: ", ";\n    --font-headerOne: ", ";\n    --font-headerTwo: ", ";\n    --font-headerThree: ", ";\n    --font-copyOne: ", ";\n    --font-copyTwo: ", ";\n\n    @media ", " {\n      --font-headerOne: ", ";\n      --font-headerTwo: ", ";\n      --font-headerThree: ", ";\n      --font-copyOne: ", ";\n      --font-copyTwo: ", ";\n    }\n\n    @media ", " {\n      --font-hero: ", ";\n    }\n  }\n"]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteral(["\n  html {\n    --font-hero: ", ";\n    --font-headerOne: ", ";\n    --font-headerTwo: ", ";\n    --font-headerThree: ", ";\n    --font-copyOne: ", ";\n    --font-copyTwo: ", ";\n\n    @media ", " {\n      --font-headerOne: ", ";\n      --font-headerTwo: ", ";\n      --font-headerThree: ", ";\n      --font-copyOne: ", ";\n      --font-copyTwo: ", ";\n    }\n\n    @media ", " {\n      --font-hero: ", ";\n    }\n  }\n"]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n"]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteral(["\n  /*\n   * We technically shouldn't need extra vertical padding on the text, but this\n   * keeps low-hanging letters like \"g\" in the font from getting cut off by\n   * overflow: hidden;. It doesn't affect the appearance otherwise, thanks to\n   * the flexbox alignment.\n   */\n  padding: ", " ", ";\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteral(["\n          height: 40px;\n          padding: 0 calc(12px - ", ");\n        "]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteral(["\n          height: 24px;\n          padding: 0 calc(4px - ", ");\n        "]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    height: ", ";\n    width: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n            color: ", ";\n\n            svg {\n              fill: ", ";\n              stroke: ", ";\n            }\n          "]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n            background: ", ";\n          "]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  background: transparent;\n  color: ", ";\n\n  svg {\n    --icon-color: ", ";\n    fill: var(--icon-color);\n    stroke: var(--icon-color);\n  }\n\n  &:hover:not(:disabled) {\n    ", "\n  }\n\n  &:disabled {\n    color: ", ";\n  }\n"]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  color: ", ";\n\n  svg {\n    --icon-color: ", ";\n    fill: var(--icon-color);\n    stroke: var(--icon-color);\n  }\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:disabled {\n    /* Override the hover effect */\n    background: transparent;\n\n    color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n\n        svg {\n          fill: ", ";\n          stroke: ", ";\n        }\n      "]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  background: ", ";\n\n  border: none;\n\n  svg {\n    --icon-color: ", ";\n    fill: var(--icon-color);\n    stroke: var(--icon-color);\n  }\n\n  &:hover {\n    background: ", ";\n    ", ";\n  }\n\n  &:disabled {\n    background: transparent;\n    color: ", ";\n    border-width: ", ";\n    border-color: ", ";\n    border-style: solid;\n  }\n"]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n      /*\n       * This is just used to avoid hover appearance. It will not prevent\n       * clicking via the keyboard. The component contains logic to prevent\n       * clicks when loading.\n       */\n      pointer-events: none;\n\n      /* Make all descendants of the button invisible except for the loading indicator */\n      & > *:not(", ") {\n        opacity: 0;\n      }\n    "]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n          font: ", ";\n          height: ", ";\n          padding: 0 ", ";\n\n          svg {\n            height: ", ";\n            width: ", ";\n\n            &[data-legacy-icon] {\n              height: 16px;\n              width: 16px;\n            }\n          }\n        "]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n          font: ", ";\n          height: ", ";\n          padding: 0 ", ";\n\n          svg {\n            height: ", ";\n            width: ", ";\n\n            &[data-legacy-icon] {\n              height: 12px;\n              width: 12px;\n            }\n          }\n        "]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  border-radius: 999px;\n  transition: background 300ms, color 300ms, width 300ms, height 300ms;\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  vertical-align: middle;\n  text-align: center;\n  max-width: 100%;\n  text-decoration: none;\n  width: ", ";\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n\n  & + & {\n    margin: 0 0 0 ", ";\n  }\n\n  & + &[data-full-width] {\n    /*\n     * This relies on a data attribute selector instead of the component props\n     * because of a styled-components bug that results in all buttons adopting\n     * this style if even one of them had the $fullWidth prop equal true.\n     * The issue: https://github.com/styled-components/styled-components/issues/3265\n     */\n\n    /*\n     * Assume that the only time buttons will be siblings vertically is when\n     * they are full width (ignoring the case of lines wrapping)\n     */\n    margin: ", " 0 0 0;\n  }\n\n  svg {\n    transition: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n\n    svg {\n      --icon-disabled-color: ", ";\n      fill: var(--icon-disabled-color);\n      stroke: var(--icon-disabled-color);\n    }\n  }\n\n  --box-shadow: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: var(--box-shadow);\n  }\n\n  &:not(:focus-visible) {\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    box-shadow: var(--box-shadow);\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: var(--box-shadow);\n  }\n"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 auto;\n  width: 48px;\n\n  & > span {\n    background: currentColor;\n    border-radius: 50%;\n    display: block;\n    height: 10px;\n    width: 10px;\n    transform-origin: 50% 50%;\n\n    &:nth-child(3n + 1) {\n      --translation-direction: -80%;\n      animation: ", " ", "s ", "s infinite;\n    }\n\n    &:nth-child(3n + 2) {\n      animation: ", " ", "s ", "s infinite;\n    }\n\n    &:nth-child(3n + 3) {\n      --translation-direction: 80%;\n      animation: ", " ", "s ", "s infinite;\n    }\n  }\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0.5);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  42.5% {\n    transform: scale(1) translate3d(var(--translation-direction, 0), 0, 0);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  85% {\n    transform: scale(0.5) translate3d(0, 0, 0);\n  }\n  100% {\n    transform: scale(0.5);\n  }\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n  word-wrap: normal;\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  border-radius: 50%;\n  left: ", ";\n  top: ", ";\n  padding: ", ";\n  border: none;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow: auto;\n  padding-bottom: ", ";\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 ", ";\n  color: ", ";\n  font: ", ";\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  padding-top: ", ";\n  overflow: auto;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transform: translateY(100%);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 100px);\n  transition: transform 250ms ease-in-out;\n  &:focus {\n    outline: none;\n  }\n  &[data-enter] {\n    transform: translateY(0);\n  }\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  inset: 0px;\n  position: fixed;\n  z-index: 500;\n  transition: opacity 250ms ease-in-out;\n  opacity: 0;\n  &[data-enter] {\n    opacity: 1;\n  }\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  svg {\n    fill: ", ";\n    stroke: ", ";\n    stroke-width: ", ";\n    width: 100%;\n    height: 100%;\n  }\n  &:hover {\n    svg {\n      ", "\n    }\n  }\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  color: ", ";\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0;\n\n  div {\n    > svg {\n      transition: fill 0.125s ease;\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n\n  &:hover {\n    color: ", ";\n    background-color: transparent;\n    div {\n      > svg {\n        transition: fill 0.125s ease;\n        fill: ", ";\n        stroke: ", ";\n      }\n    }\n  }\n\n  &:active {\n    transform: ", ";\n    color: ", ";\n    background-color: transparent;\n    div {\n      > svg {\n        transition: fill 0.125s ease;\n        fill: ", ";\n        stroke: ", ";\n      }\n    }\n  }\n\n  &[data-active],\n  &:focus {\n    box-shadow: none;\n    border-bottom: 0.1rem solid ", ";\n    color: ", ";\n    background-color: transparent;\n    div {\n      > svg {\n        transition: fill 0.125s ease;\n        fill: ", ";\n        stroke: ", ";\n      }\n    }\n  }\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px 0px;\n\n  &:focus {\n    box-shadow: 0 0.5rem 1.25rem 0 rgba(0, 0, 0, 0.3);\n  }\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  color: ", ";\n\n  div {\n    > svg {\n      transition: fill 0.125s ease;\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 0.25rem\n      ", ";\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n\n  color: ", ";\n  background-color: ", ";\n\n  border-radius: 0.5rem;\n\n  width: 22rem;\n  margin: 0 1.25rem 1.25rem;\n  padding: 1.25rem;\n\n  box-shadow: 0 0.5rem 1.25rem 0 rgba(0, 0, 0, 0.1);\n\n  > span {\n    width: 16rem;\n    margin-right: 1.25rem;\n  }\n\n  > div {\n    text-align: right;\n    svg {\n      & {\n        align-items: center;\n        height: 1.5rem;\n        width: 1.5rem;\n      }\n      fill: ", ";\n    }\n  }\n\n  &:hover,\n  &:active {\n    transform: scale(0.95);\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0.5rem 1.25rem 0 rgba(0, 0, 0, 0.3);\n  }\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n\n  text-align: ", ";\n  color: ", ";\n  margin: 0;\n  width: 100%;\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: flex-end;\n  justify-content: flex-end;\n\n  button {\n    margin-right: 1rem;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  border: 0.0625rem solid\n    ", ";\n\n  background-color: ", ";\n  color: ", ";\n\n  div {\n    > svg {\n      transition: fill 0.125s ease;\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    div {\n      > svg {\n        transition: fill 0.125s ease;\n        fill: ", ";\n        stroke: ", ";\n      }\n    }\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  text-align: center;\n  text-transform: ", ";\n  letter-spacing: ", ";\n  // The button should not be more than 100% of the component that it's being wrapped in.\n  max-width: 100%;\n\n  // Adding an ellipsis if the button text makes the button larger than the string\n  ", "\n\n  color: ", ";\n\n  background-color: ", ";\n\n  outline: 0;\n\n  border: 0;\n  border-radius: ", ";\n\n  width: ", ";\n\n  cursor: ", ";\n\n  margin: 0;\n  padding: ", ";\n\n  transition: all 0.125s ease;\n\n  display: ", ";\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: center;\n\n  div {\n    > svg {\n      & {\n        align-items: center;\n        height: ", ";\n        width: ", ";\n      }\n      fill: ", ";\n\n      stroke: ", ";\n    }\n    > svg[data-legacy-icon] {\n      height: ", ";\n      width: ", ";\n    }\n  }\n\n  > span {\n    margin-left: ", ";\n    margin-right: ", ";\n    /*  Large Buttons Works for PLK transform: translateY(-7%);\n    none for BK and for TH transform: translateY(-2%);*/\n    /*  SMALL Buttons Works for PLK transform: translateY(-5%);\n    none for BK and for TH NONE;*/\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    outline: 0;\n    transform: ", ";\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem ", ";\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  margin-right: 0.5em;\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  font: ", ";\n  border: 1px solid ", ";\n  color: inherit;\n  display: block;\n  font-size: inherit;\n  margin: 0;\n  padding: 1rem;\n  text-align: left;\n  width: 100%;\n  height: 100%;\n  outline: none;\n  &:hover {\n    background-color: ", ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background-color: ", ";\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: table-cell;\n  height: 48px;\n  list-style-type: none;\n  color: ", ";\n  font: ", ";\n  background-color: white;\n\n  & + & {\n    margin-top: -1px;\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: row;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  box-shadow: ", ";\n  border-radius: 10px;\n  z-index: 200;\n  position: absolute;\n  width: inherit;\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  line-height: 0;\n  top: calc(", " - ", ");\n  right: ", ";\n  display: flex;\n\n  /* Disable pointer events on this presentation-only container, and reenable\n    them for the children */\n  pointer-events: none;\n  & > * {\n    pointer-events: auto;\n    margin-left: ", ";\n  }\n\n  svg {\n    height: ", ";\n    width: ", ";\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n      padding-right: ", ";\n\n      /* Hides native password reveal button on input[type=password] fields in\n        Edge, but only when we've replaced it with our own icon */\n      &::-ms-reveal {\n        display: none;\n      }\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n  margin: 0;\n  font: ", ";\n  height: var(--height-minus-border);\n  line-height: var(--height-minus-border);\n  border: none;\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n  appearance: none;\n  width: 100%;\n\n  ", "\n\n  ", "\n\n  ", ";\n\n  &:invalid {\n    /* Reset browser-native styling for invalid fields */\n    box-shadow: none;\n  }\n\n  /* Hides native clear button on input[type=search] fields */\n  &::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button,\n  &::-webkit-search-results-decoration {\n    -webkit-appearance: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      /* Fixes an issue in Firefox where autofilled fields overlap the label */\n      z-index: 1;\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      background: #fff;\n      font: ", ";\n      top: -10px;\n      padding: 4px;\n      /* No longer need to account for overlapping with icons when the label appears at\n        the top */\n      max-width: calc(100% - 12px - 12px);\n\n      ", "\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: ", ";\n  font: ", ";\n  line-height: var(--height-minus-border);\n  background: transparent;\n  border-radius: 4px;\n  padding: 0 4px;\n  transition: top 300ms, font 300ms, background 300ms, color 300ms, max-width 300ms;\n  color: ", ";\n  pointer-events: none;\n  user-select: none;\n\n  /* Account for the input width and the presence of icons to avoid long label\n    text going outside of the input or overlapping with icons  */\n  max-width: calc(100% - ", " - ", ");\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        border-color: ", ";\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: inherit;\n  min-width: inherit;\n  max-width: inherit;\n  border-radius: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-width: ", ";\n  transition: border 300ms;\n\n  ", "\n\n  &:focus-within {\n    box-shadow: ", ";\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  /* Prevents the label and shadow from overlapping with elements above */\n  margin-top: 8px;\n\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 100%;\n\n  --height-minus-border: calc(\n    ", " -\n      ", "\n  );\n  --padding-right-input: ", ";\n  --width-icon: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      stroke: ", ";\n      fill: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  stroke-width: 0;\n  stroke: ", ";\n  fill: ", ";\n\n  /* Doubled the specificity here to work around the wrapping div re-enabling\n    pointer events that it disables on itself */\n  &[aria-hidden][aria-hidden] {\n    pointer-events: none;\n  }\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font: ", ";\n  padding-top: 8px;\n  text-align: left;\n  color: ", ";\n\n  a {\n    color: inherit;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  /* Webkit browsers */\n  &:-webkit-autofill {\n    animation: ", " 50000s infinite;\n  }\n  &:not(:-webkit-autofill) {\n    animation: ", " 50000s infinite;\n  }\n  /* Firefox */\n  &:autofill {\n    animation: ", " 50000s infinite;\n  }\n  &:not(:autofill) {\n    animation: ", " 50000s infinite;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["from {/* end */} to {/**/}"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["from {/**/} to {/**/}"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          & > svg {\n            stroke: ", ";\n            fill: ", ";\n          }\n\n          &:hover:not(:disabled) > svg,\n          &:focus > svg {\n            stroke: ", ";\n            fill: ", ";\n          }\n\n          /* For browsers that support :focus-visible, undo the :focus\n            behavior we just enabled, and enable it only on :focus-visible.\n            This way the focus appearance is still activated on keyboard focus,\n            but does not linger after a click. The more specific selector of\n            the hover styles keeps it from being overridden by the broad\n            selector of &:not(:focus-visible). */\n          &:not(:focus-visible) > svg {\n            stroke: ", ";\n            fill: ", ";\n          }\n          &:focus-visible > svg {\n            stroke: ", ";\n            fill: ", ";\n          }\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          & > svg {\n            stroke: ", ";\n            fill: ", ";\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  outline-offset: 4px;\n  border-radius: ", ";\n  transition: background 300ms;\n\n  &:focus,\n  &:hover:not(:disabled) {\n    /* Replace the default outline with some custom focus styles */\n    outline: none;\n\n    background: ", ";\n  }\n\n  /* For browsers that support :focus-visible, undo the :focus\n    behavior we just enabled, and enable it only on :focus-visible.\n    This way the focus appearance is still activated on keyboard focus,\n    but does not linger after a click. The more specific selector of\n    the hover styles keeps it from being overridden by the broad\n    selector of &:not(:focus-visible). */\n  &:not(:focus-visible) {\n    background: transparent;\n  }\n  &:focus-visible {\n    background: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  & > svg {\n    transition: fill 300ms, stroke 300ms;\n    stroke-width: 0;\n    display: block;\n\n    /* Prevents SVG-embedded tooltips from being shown, because we require title text at the button level anyway */\n    pointer-events: none;\n  }\n\n  ", "\n\n  &:disabled > svg {\n    stroke: ", ";\n    fill: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mix-blend-mode: multiply;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import React__default, { useState, useCallback, useRef, useEffect, useLayoutEffect, useMemo, forwardRef as forwardRef$1, createContext, useContext, createElement, memo as memo$1, useDebugValue, useReducer, isValidElement, cloneElement } from 'react';
import styled, { useTheme, css, keyframes, createGlobalStyle } from 'styled-components';
import { useCombobox } from 'downshift';
import { createPortal } from 'react-dom';
import MaskedInput from 'react-text-mask';
import { IntlMessageFormat } from 'intl-messageformat';
import ReactTooltip from 'react-tooltip';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var account = function account(_a) {
  var _a$title = _a.title,
      title = _a$title === void 0 ? '' : _a$title,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22 0.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
  }));
};

var add = function add(_a) {
  var _a$title2 = _a.title,
      title = _a$title2 === void 0 ? '' : _a$title2,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2z"
  }));
};

var amex = function amex(_a) {
  var _a$title3 = _a.title,
      title = _a$title3 === void 0 ? '' : _a$title3,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 32 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "icon-/-card-/-amex",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("rect", {
    id: "bg",
    fill: "#60BAEB",
    x: "0",
    y: "0",
    width: "32",
    height: "20",
    rx: "2"
  }), React__default.createElement("path", {
    d: "M21.7699115,8.30088496 L21.7699115,9.10619469 L19.0448673,9.10619469 L19.0448673,9.97345133 L21.7699115,9.97345133 L21.7699115,10.9646018 L19.0448673,10.9646018 L19.0448673,11.9557522 L21.7699115,11.9557522 L21.7699115,12.699115 C22.4519469,11.9557522 23.0714159,11.2743363 23.7522124,10.5309735 C23.0714159,9.78761062 22.4519469,9.04424779 21.7699115,8.30088496 L21.7699115,8.30088496 Z M6.65486726,10.840708 L8.20353982,10.840708 L7.39823009,8.92035398 L6.65486726,10.840708 Z M27.4076991,13.0088496 L26.1687611,13.0088496 C25.9823009,13.0088496 25.920354,12.9469027 25.7964602,12.8230088 L24.5575221,11.3982301 C24.5575221,11.3982301 23.4424779,12.5752212 23.1327434,12.9469027 C23.0714159,13.0088496 23.0088496,13.0088496 22.9469027,13.0088496 L17.9292035,13.0088496 L17.9292035,8.11504425 L23.0088496,8.11504425 C23.1327434,8.11504425 23.1946903,8.17699115 23.2566372,8.23893805 C23.6283186,8.73451327 24.0619469,9.2300885 24.4955752,9.72566372 L25.920354,8.17699115 C25.9823009,8.11504425 25.9823009,8.11504425 26.0442478,8.11504425 L27.4690265,8.11504425 C26.7256637,8.92035398 25.9823009,9.72566372 25.2395575,10.5929204 C25.9823009,11.3362832 26.6637168,12.1415929 27.4076991,13.0088496 L27.4076991,13.0088496 Z M16.9380531,13.0088496 L15.7610619,13.0088496 L15.7610619,9.2920354 C15.7610619,9.2920354 14.6460177,11.7699115 14.1504425,12.8849558 C14.0884956,13.0088496 14.0884956,13.0088496 13.9646018,13.0088496 L13.2212389,13.0088496 C13.0973451,13.0088496 13.0973451,12.9469027 13.0353982,12.8849558 L11.4247788,9.2300885 L11.4247788,13.0088496 L9.25663717,13.0088496 C9.13274336,13.0088496 9.07079646,12.9469027 9.07079646,12.8849558 C8.94690265,12.5752212 8.82300885,12.3274336 8.76106195,12.0176991 C8.76106195,11.9557522 8.69911504,11.8938053 8.63716814,11.8938053 L6.46902655,11.8938053 C6.40707965,11.8938053 6.34513274,11.8938053 6.34513274,12.0176991 C6.22123894,12.3274336 6.09734513,12.6371681 5.97345133,12.8849558 C5.97345133,12.9469027 5.91150442,13.0088496 5.84955752,13.0088496 L4.67256637,13.0088496 L6.65486726,8.23893805 C6.71681416,8.11504425 6.77876106,8.11504425 6.84070796,8.11504425 L8.26548673,8.11504425 C8.38938053,8.11504425 8.38938053,8.17699115 8.45132743,8.23893805 L10.3097345,12.6371681 L10.3097345,8.11504425 L12.0442478,8.11504425 C12.1681416,8.11504425 12.1681416,8.17699115 12.2300885,8.23893805 L13.6548673,11.3982301 L15.0176991,8.23893805 C15.0176991,8.17699115 15.079646,8.11504425 15.1415929,8.11504425 L17,8.11504425 L17,13.0088496 L16.9380531,13.0088496 Z M29.6371681,7.12389381 L25.6725664,7.12389381 C25.6106195,7.12389381 25.549292,7.18584071 25.4867257,7.18584071 C25.1769912,7.49557522 24.929823,7.80530973 24.6200885,8.11504425 C24.3716814,7.80530973 24.0619469,7.49557522 23.8141593,7.18584071 C23.7522124,7.12389381 23.690885,7.0619469 23.6283186,7.0619469 L14.460177,7.0619469 C14.3362832,7.0619469 14.3362832,7.12389381 14.2743363,7.18584071 L13.5929204,8.79646018 C13.3451327,8.23893805 13.0973451,7.74336283 12.9115044,7.18584071 C12.8495575,7.0619469 12.7876106,7 12.6637168,7 L6.09734513,7 C5.97345133,7 5.91150442,7.0619469 5.84955752,7.18584071 L3,13.9380531 L6.40707965,13.9380531 C6.46902655,13.9380531 6.53097345,13.8761062 6.53097345,13.8141593 C6.65486726,13.5044248 6.77876106,13.1946903 6.90265487,12.9469027 C6.90265487,12.8849558 6.96460177,12.8230088 7.02654867,12.8230088 L7.7699115,12.8230088 C7.89380531,12.8230088 7.89380531,12.8230088 7.95575221,12.9469027 C8.07964602,13.1946903 8.20353982,13.4424779 8.26548673,13.7522124 C8.32743363,13.8761062 8.38938053,13.9380531 8.51327434,13.9380531 L23.3185841,13.9380531 C23.5044248,13.9380531 23.6283186,13.8761062 23.7522124,13.7522124 C24.0006195,13.4424779 24.2477876,13.1946903 24.4955752,12.8849558 C24.8053097,13.1946903 25.0530973,13.5663717 25.300885,13.8761062 C25.3628319,13.9380531 25.4247788,14 25.4867257,14 L29.3893805,14 C28.3982301,12.8849558 27.4076991,11.7079646 26.4159292,10.5929204 C27.5309735,9.4159292 29.6371681,7.12389381 29.6371681,7.12389381 L29.6371681,7.12389381 Z",
    id: "logo",
    fill: "#FFFFFF"
  })));
};

var applepay = function applepay(_a) {
  var _a$title4 = _a.title,
      title = _a$title4 === void 0 ? '' : _a$title4,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 166 106"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M151.134 0H14.8661C14.2985 0 13.73 0 13.1635 0.00330109C12.6846 0.00670221 12.2068 0.012004 11.729 0.0250082C10.687 0.0531175 9.63608 0.114438 8.60711 0.298898C7.56169 0.48656 6.58889 0.792661 5.63985 1.27462C4.70686 1.74788 3.85269 2.36688 3.11247 3.10552C2.37192 3.84417 1.75133 4.69475 1.27696 5.62635C0.793666 6.57296 0.48658 7.54358 0.299741 8.58713C0.113814 9.61377 0.0519258 10.6618 0.0238448 11.7001C0.0110078 12.1766 0.00550187 12.6532 0.00238287 13.1296C-0.000926674 13.6959 0.000176509 14.2618 0.000176509 14.8291V91.172C0.000176509 91.7393 -0.000926674 92.3042 0.00238287 92.8716C0.00550187 93.348 0.0110078 93.8246 0.0238448 94.3012C0.0519258 95.3385 0.113814 96.3865 0.299741 97.4129C0.48658 98.4568 0.793666 99.427 1.27696 100.374C1.75133 101.305 2.37192 102.157 3.11247 102.895C3.85269 103.634 4.70686 104.253 5.63985 104.725C6.58889 105.209 7.56169 105.515 8.60711 105.702C9.63608 105.886 10.687 105.948 11.729 105.976C12.2068 105.987 12.6846 105.993 13.1635 105.996C13.73 106 14.2985 106 14.8661 106H151.134C151.701 106 152.269 106 152.836 105.996C153.313 105.993 153.791 105.987 154.271 105.976C155.311 105.948 156.362 105.886 157.393 105.702C158.437 105.515 159.41 105.209 160.359 104.725C161.293 104.253 162.145 103.634 162.887 102.895C163.626 102.157 164.247 101.305 164.722 100.374C165.207 99.427 165.513 98.4568 165.699 97.4129C165.885 96.3865 165.946 95.3385 165.974 94.3012C165.987 93.8246 165.993 93.348 165.996 92.8716C166 92.3042 166 91.7393 166 91.172V14.8291C166 14.2618 166 13.6959 165.996 13.1296C165.993 12.6532 165.987 12.1766 165.974 11.7001C165.946 10.6618 165.885 9.61377 165.699 8.58713C165.513 7.54358 165.207 6.57296 164.722 5.62635C164.247 4.69475 163.626 3.84417 162.887 3.10552C162.145 2.36688 161.293 1.74788 160.359 1.27462C159.41 0.792661 158.437 0.48656 157.393 0.298898C156.362 0.114438 155.311 0.0531175 154.271 0.0250082C153.791 0.012004 153.313 0.00670221 152.836 0.00330109C152.269 0 151.701 0 151.134 0Z",
    fill: "black"
  }), React__default.createElement("path", {
    d: "M151.134 3.5332L152.81 3.5364C153.264 3.53961 153.719 3.54451 154.175 3.55691C154.97 3.57832 155.899 3.62123 156.765 3.77608C157.518 3.91133 158.149 4.117 158.755 4.4247C159.353 4.7279 159.901 5.12523 160.38 5.60188C160.86 6.08174 161.259 6.62932 161.567 7.23262C161.874 7.83232 162.079 8.45912 162.214 9.21557C162.368 10.0701 162.411 10.9994 162.433 11.7965C162.445 12.2465 162.451 12.6964 162.454 13.1571C162.458 13.7142 162.458 14.2709 162.458 14.8291V91.172C162.458 91.7302 162.458 92.286 162.453 92.855C162.451 93.3049 162.445 93.7548 162.433 94.2055C162.411 95.0015 162.368 95.9303 162.212 96.7949C162.079 97.5409 161.874 98.1679 161.566 98.7706C161.258 99.3723 160.86 99.9193 160.382 100.396C159.901 100.876 159.354 101.272 158.749 101.578C158.148 101.885 157.517 102.09 156.772 102.224C155.888 102.381 154.92 102.424 154.191 102.444C153.732 102.454 153.276 102.46 152.808 102.463C152.251 102.467 151.691 102.467 151.134 102.467H14.866C14.8586 102.467 14.8514 102.467 14.8438 102.467C14.2929 102.467 13.7408 102.467 13.1797 102.463C12.7223 102.46 12.2659 102.454 11.8246 102.444C11.0789 102.424 10.1102 102.381 9.23376 102.225C8.4819 102.09 7.85157 101.885 7.24221 101.574C6.64259 101.271 6.09671 100.875 5.61522 100.394C5.13744 99.9186 4.74039 99.3733 4.43341 98.7707C4.12612 98.1686 3.92053 97.5397 3.78535 96.7848C3.62909 95.9219 3.58616 94.9968 3.56471 94.2063C3.55247 93.7536 3.54735 93.3011 3.54444 92.8511L3.54224 91.5228L3.54234 91.172V14.8291L3.54224 14.4784L3.54434 13.1529C3.54735 12.7002 3.55247 12.2477 3.56471 11.7954C3.58616 11.0041 3.62909 10.0786 3.78664 9.20847C3.92063 8.46033 4.12612 7.83152 4.43501 7.22642C4.73959 6.62832 5.13734 6.08234 5.61763 5.60338C6.09601 5.12603 6.64368 4.7292 7.24713 4.4231C7.84996 4.1169 8.48149 3.91133 9.23336 3.77638C10.0997 3.62113 11.0294 3.57832 11.8257 3.55681C12.2796 3.54451 12.7336 3.53961 13.1841 3.5365L14.866 3.5332H151.134",
    fill: "white"
  }), React__default.createElement("path", {
    d: "M45.317 35.6522C46.7383 33.8789 47.7028 31.498 47.4484 29.0649C45.3678 29.1681 42.8288 30.4341 41.3588 32.2087C40.0389 33.7284 38.8707 36.2091 39.1753 38.5401C41.5109 38.7422 43.8444 37.3757 45.317 35.6522Z",
    fill: "black"
  }), React__default.createElement("path", {
    d: "M47.4218 38.9952C44.0299 38.7937 41.1459 40.9153 39.5261 40.9153C37.9054 40.9153 35.425 39.0967 32.7422 39.1458C29.2503 39.1969 26.0103 41.1662 24.2384 44.2982C20.5937 50.5639 23.2765 59.8581 26.8207 64.9611C28.5419 67.4857 30.6162 70.2655 33.3493 70.1657C35.9317 70.0646 36.9439 68.4978 40.0829 68.4978C43.2196 68.4978 44.1314 70.1657 46.865 70.1152C49.6998 70.0646 51.4721 67.5893 53.1932 65.0622C55.1677 62.1842 55.976 59.4053 56.0268 59.2528C55.976 59.2023 50.5605 57.13 50.5103 50.9165C50.4591 45.7137 54.762 43.239 54.9646 43.0856C52.5347 39.5009 48.738 39.0967 47.4218 38.9952Z",
    fill: "black"
  }), React__default.createElement("path", {
    d: "M76.9559 31.9534C84.3281 31.9534 89.4617 37.0221 89.4617 44.4018C89.4617 51.8079 84.2225 56.903 76.771 56.903H68.6086V69.8504H62.7112V31.9534H76.9559V31.9534ZM68.6086 51.9655H75.3754C80.51 51.9655 83.4322 49.2082 83.4322 44.4282C83.4322 39.6487 80.51 36.9173 75.4018 36.9173H68.6086V51.9655V51.9655Z",
    fill: "black"
  }), React__default.createElement("path", {
    d: "M91.0024 61.9991C91.0024 57.1664 94.715 54.1989 101.298 53.8312L108.88 53.3849V51.2578C108.88 48.1849 106.8 46.3466 103.325 46.3466C100.033 46.3466 97.9795 47.922 97.4798 50.391H92.1086C92.4245 45.4008 96.6896 41.7241 103.536 41.7241C110.25 41.7241 114.541 45.2696 114.541 50.811V69.8515H109.091V65.308H108.96C107.354 68.3809 103.852 70.3241 100.218 70.3241C94.7942 70.3241 91.0024 66.9625 91.0024 61.9991ZM108.88 59.5043V57.3245L102.061 57.7444C98.6642 57.981 96.7424 59.4779 96.7424 61.8416C96.7424 64.2574 98.7434 65.8333 101.798 65.8333C105.773 65.8333 108.88 63.1019 108.88 59.5043Z",
    fill: "black"
  }), React__default.createElement("path", {
    d: "M119.687 80.0154V75.4193C120.107 75.5241 121.055 75.5241 121.529 75.5241C124.162 75.5241 125.584 74.4213 126.453 71.585C126.453 71.5323 126.954 69.9042 126.954 69.8779L116.948 42.2231H123.109L130.113 64.7043H130.218L137.223 42.2231H143.226L132.851 71.2958C130.482 77.9931 127.744 80.1466 122.004 80.1466C121.529 80.1466 120.107 80.0939 119.687 80.0154Z",
    fill: "black"
  }));
};

var arrowUp = function arrowUp(_a) {
  var _a$title5 = _a.title,
      title = _a$title5 === void 0 ? '' : _a$title5,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 11.26 7.1"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M0 5.63L1.47 7.1l4.16-4.16L9.79 7.1l1.47-1.47L5.63 0 0 5.63z"
  }));
};

var back = function back(_a) {
  var _a$title6 = _a.title,
      title = _a$title6 === void 0 ? '' : _a$title6,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
  }));
};

var bkCrown = function bkCrown(_a) {
  var _a$title7 = _a.title,
      title = _a$title7 === void 0 ? '' : _a$title7,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m2.0277 9.278c-0.20458-0.94579 0.76414-1.7156 1.6393-1.3027l3.5847 1.6912c0.54601 0.2576 1.1984 0.05645 1.5045-0.46392l2.1338-3.6271c0.456-0.77521 1.5805-0.76534 2.0228 0.01777l2.0695 3.6634c0.2908 0.51498 0.9208 0.73106 1.4666 0.50306l3.9324-1.643c0.8729-0.36473 1.7944 0.40584 1.59 1.3296l-1.7464 7.8906c-0.1182 0.5347-0.5923 0.9152-1.1398 0.9152h-14.174c-0.54968 0-1.0249-0.3834-1.1411-0.9206l-1.742-8.0535z"
  }));
};

var book = function book(_a) {
  var _a$title8 = _a.title,
      title = _a$title8 === void 0 ? '' : _a$title8,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 16 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    transform: "translate(-16 -8)",
    fillRule: "evenodd"
  }, React__default.createElement("rect", {
    x: 16,
    y: 13,
    width: 16,
    height: 19,
    rx: 0.5
  }), React__default.createElement("path", {
    d: "M29 11.5V8.694a.5.5 0 0 0-.658-.475l-8.419 2.807a.5.5 0 0 0 .158.974H28.5a.5.5 0 0 0 .5-.5z"
  })));
};

var burgerKingLogo = function burgerKingLogo(_a) {
  var _a$title9 = _a.title,
      title = _a$title9 === void 0 ? '' : _a$title9,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 80 80"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fill: "white",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 39.686C0 17.768 17.764 0 39.684 0c21.92 0 39.684 17.768 39.684 39.686 0 21.916-17.764 39.686-39.684 39.686C17.764 79.372 0 61.602 0 39.686",
    fill: "#FEFEFE"
  }), React__default.createElement("path", {
    d: "M62.777 47.958c.456-.108.784-.1 1.018.136.272.288.218.766.144 1.066-.35 1.458-3.434 11.794-18.046 15.328-9.568 2.31-18.38-.848-20.368-3.338 0 0-.462-.462-.258-.932.134-.304.324-.368.742-.548 9.734-4.17 26.618-9.326 36.768-11.712zm-2.306 4.246c.668-1.416-1.26-2.136-1.802-.478-1.354 3.478-4.136 7.562-9.032 10.344 4.35-1.71 8.526-4.974 10.834-9.866zm-32.397-41.99c4.89-2.639 11.874-3.677 16.998-3.129 9.284.99 12.112 5.353 12.272 5.612l.014.02c.047.06.322.435.17.816-.122.29-.402.392-.718.446-4.414.75-11.29 2.1-19.664 4.322-5.88 1.56-15.204 4.652-18.33 5.708-.37.124-.664.128-.866-.126-.198-.25-.116-.836-.066-1.03 0 0 1.33-7.866 10.19-12.64zm1.97-.09c-5.37 2.37-8.998 8.013-9.198 10.401-.076.95 1.18 1.086 1.302.076 1.134-4.354 4.6-8.466 7.896-10.478zm22.318 1.935c.044-2.166-6.136-4.68-11.798-4.224 5.77.384 9.23 2.606 9.246 4.152.014.98-.834 1.844-1.968 2.184 2.896-.71 4.49-.818 4.52-2.112z",
    fill: "#FAAE17"
  }), React__default.createElement("path", {
    d: "M67.084 50.607c-5.01 11.258-14.622 19.09-27.22 19.268C30.686 70 22.588 66.86 16.74 61.38l-3.536 1.508.008-5.476c-3.854-5.194-6.088-11.768-6.088-19.238 0-19.13 14.648-34.21 35.082-34.21 3.336 0 6.352.52 8.626 1.034-3.504-1.12-6.982-1.728-10.858-1.728-21.926 0-36.686 17.782-36.686 36.122 0 19.986 15.678 36.724 36.256 36.724 19.654 0 30.254-13.858 33.648-22.188l-6.108-3.322z",
    fill: "#0054A5"
  }), React__default.createElement("path", {
    d: "M24.058 40.053c.55-.84 1.84-1.602 3.346-.92 1.368.62 1.744 2.112.994 3.314-.56.906-4.002 6.332-4.002 6.332l3.908 3.938c.774.854.984 2.756-.398 3.87-1.528 1.234-3.258.734-4.202-.246l-4.292-4.554-.008 5.684s.02 1.108-.4 1.764c-.456.72-1.212.93-1.212.93l-3.838 1.612.016-17.938 5.454-2.258.006 6.34zm11.485-4.477L35.535 49.1v1.677c0 2.116-.758 3.15-2.772 3.908-1.414.532-2.932 1.054-2.932 1.054l.005-13.295V40.79c0-2.622.997-3.624 2.73-4.252 1.337-.48 2.977-.962 2.977-.962zm17.12-4.442s.014 11.058.002 15.586c-.024 1.354-.896 2.316-1.944 2.62-1.014.296-2.128.22-3.008-.694l-5.45-6.272s.006 4.102.03 6.2c.01 1.942-.678 3.06-2.56 3.71-.204.068-2.544.874-2.544.874l-.002-17.986 2.614-.79s1.77-.64 2.84.43c2.002 2.006 5.072 5.846 5.072 5.846v-5.396c0-2.26 1.032-3.116 2.378-3.498 1-.285 2.176-.544 2.491-.613zm19.36 14.184c1.67 0 3.072 1.312 3.072 3.052a3.05 3.05 0 01-3.072 3.076c-1.686 0-3.088-1.312-3.088-3.076 0-1.74 1.402-3.052 3.088-3.052zm0 .454c-1.442 0-2.532 1.124-2.532 2.598 0 1.498 1.09 2.622 2.532 2.622 1.414 0 2.516-1.124 2.516-2.622 0-1.474-1.102-2.598-2.516-2.598zm.068.822c.902 0 1.414.278 1.414 1.068 0 .662-.414.916-.952.962l.964 1.58h-.74l-.886-1.548h-.454v1.548h-.702v-3.61zm-.048.558h-.606v.952h.642c.406 0 .71-.06.71-.5 0-.396-.404-.452-.746-.452zM61.836 28.528c2.104-.418 4.31-.296 6.008.39 2.3.888 1.584 4.678-.944 4.298-.754-.112-2.032-.652-4.3-.132-2.006.46-3.666 2.154-3.718 5.088.028 2.734 1.172 4.282 3.69 3.888 1.787-.355 1.81-1.117 1.811-1.19l.001-.004-.01-1.454s-.594.188-.986.25c-1.234.228-1.804-.414-1.82-1.592l.005-1.449.001-.335 7.63-1.65s.04 4.652 0 6.124c0 1.002-.234 2.356-1.232 3.332-1.094 1.078-3.09 2.234-5.972 2.566-4.018.454-8.49-1.52-8.506-7.586.016-7.634 5.534-9.982 8.342-10.544zm-46.669-.069c2.82-1.026 4.474.21 4.474 2.092 0 1.256-.536 2.324-1.706 3.264 1.152.188 2.132 1.132 2.154 2.44.042 2.508-1.764 3.842-4.118 4.818l-4.82 2.048-.014-13.062s3.038-1.24 4.03-1.6zm1.438 8.25c-.016-.99-.786-1.528-2.112-.862l-.004 3.178s.43-.19.744-.336c.778-.36 1.384-1.01 1.372-1.98zM27.572 24.1c.916-.263 1.674.03 1.674 1.13l.002 6.823c-.034 3.588-1.702 4.99-4.2 5.728-2.836.836-4.694-.508-4.682-3.206.012-2.03.006-6.76.004-7.833v-.219s.616-.246 1.642-.588c.912-.302 1.682.028 1.682 1.134l.01 6.646c.004.808.364 1.32 1.13 1.128.996-.25 1.118-1.264 1.128-2.074l.004-8.122s.866-.336 1.606-.548zm6.923-2.107c2.498-.582 4.278.558 4.242 2.576-.012 1.922-1.084 3.09-2.046 3.888l2.114 2.032c.654.632.694 1.772-.032 2.46-.436.408-1.598.83-2.506-.096l-2.822-2.912-.012 3.2c-.006.864-.596 1.488-1.342 1.774-.62.214-1.95.668-1.95.668l.008-12.264s2.734-.952 4.346-1.326zm-18.182 9.735c.008-.96-.778-1.206-1.844-.656v2.766a8.92 8.92 0 00.606-.268c.72-.352 1.232-1 1.238-1.842zm29.781-12.842c2.114-.074 3.102.614 3.076 1.724-.026 1.038-.746 1.642-2.006 1.438-.51-.064-1.172-.156-1.898.03-1.458.374-2.526 1.708-2.566 3.978.02 1.73.666 2.636 1.834 2.666.836.022 1.638-.33 1.636-.866l-.008-1.352s-.32.074-.72.156c-.638.132-1.082-.276-1.086-.906l.004-1.354 4.872-1.108v4.632c0 .7-.26 1.52-.882 2.07-.628.548-1.528 1.136-3.342 1.502-3.216.58-5.842-1.198-5.842-5.224 0-3.934 2.346-7.228 6.928-7.386zm11.004-2.257s-.006.675-.008 1.16v.224c0 .71-.254 1.23-1.008 1.388l-2.776.58v1.824l3.47-.734s.003.453.004 1.032v.298c0 .766-.352 1.13-1.018 1.276-.532.118-2.452.522-2.452.522L53.3 26.5l3.912-.854v1.394c0 .88-.45 1.388-1.17 1.544-2.144.466-6.038 1.384-6.038 1.384l.026-11.91a172.387 172.387 0 017.068-1.43zm5.16-.88c2.46-.316 4.113 1.052 4.083 2.99-.016 1.706-1.088 2.734-2 3.35 0 0 1.674 1.886 2.12 2.386.604.672.576 1.824-.314 2.384-.876.556-1.744.264-2.248-.292l-2.762-3.24s.006 1.992.002 2.864c-.008.864-.508 1.496-1.408 1.684l-1.802.354.008-11.758s3.432-.61 4.322-.722zM35.354 25.52c-.02-1.354-1.268-1.056-1.912-.82l-.004 3.404c.008-.002 1.936-1 1.916-2.584zm27.658-6.266c-.014-1.29-1.288-1.056-1.888-.922l.004 3.176c.004 0 1.912-.726 1.884-2.254z",
    fill: "#EC1D24"
  })));
};

var calendar = function calendar(_a) {
  var _a$title10 = _a.title,
      title = _a$title10 === void 0 ? '' : _a$title10,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
  }));
};

var cart = function cart(_a) {
  var _a$title11 = _a.title,
      title = _a$title11 === void 0 ? '' : _a$title11,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m18 6h-2c0-2.21-1.79-4-4-4s-4 1.79-4 4h-2c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zm-8 4c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2h2v2zm2-6c1.1 0 2 0.9 2 2h-4c0-1.1 0.9-2 2-2zm4 6c0 0.55-0.45 1-1 1s-1-0.45-1-1v-2h2v2z"
  }));
};

var catering = function catering(_a) {
  var _a$title12 = _a.title,
      title = _a$title12 === void 0 ? '' : _a$title12,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 90 72"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M18 0c9.941 0 18 8.06 18 18s-8.059 18-18 18S0 27.94 0 18 8.059 0 18 0zm32.963 44.106H69c-1.863 3.436-10.979 5.007-10.979 5.007l-11.37 15.12s-.98 1.561-3.072 1.734l.033.033H4s2.992-27 12.556-27c9.566 0 26.86 14.923 26.86 14.923l7.547-9.72v-.097zM61.315 22h1.142c13.581 0 16.206 13.73 16.206 13.73 1.712 0 4.109.432 4.337 3.243C83 41.676 79.12 42 79.12 42H44.88S41 41.676 41 38.973c0-2.703 2.397-3.243 4.109-3.243 0 0 2.625-13.73 16.206-13.73zm2.749-5c.515 0 .936.45.936 1s-.42 1-.936 1h-6.126c-.516 0-.938-.45-.938-1s.422-1 .938-1h6.126z",
    fillRule: "evenodd"
  }));
};

var cateringPLK = function cateringPLK(_a) {
  var _a$title13 = _a.title,
      title = _a$title13 === void 0 ? '' : _a$title13,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 90 72"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M24.75,28.08c3.75,3,1.13,9.17,0.78,12.72c-0.17,1.71-0.11,3.29,0.12,4.75c0.5,2.03,2.73,1.01,12.67,1.31\n      c7.54,0.23,15.11-0.78,22.63,0.13c2.04,0.25,6-0.73,6.39-2.76c0.01-0.03,0.01-0.06,0.02-0.09c0-0.02,0.01-0.04,0.01-0.07\n      c0.59-3.23,0.29-6.9-1.28-10.99c-2.89-7.56-9.01-18.84-9.01-18.84l0.07-0.02c2.42-0.62,2.89-3.76,0.06-5.45l2.02-1.87l-2.96-1.21\n      l1.1-4.04l-6.35,2.52c0.01-0.01,0.02-0.01,0.02-0.01S49.45,0.79,47,0.76c-2.06-0.02-3.04,1.47-3.04,1.47S43.41,0.7,42,0.28\n      s-3.71,0.4-4.01,2.96c-0.33,2.87,1.99,4.35,2.76,4.59c0.91,0.29,2.16,0.87,4.78-0.23c0,2.64-0.01,8.74-0.02,11.81\n      c-0.01,3.98,0.35,10.43-1.36,13.93s-3.66,4.96-6.23,4.65c-2.88-0.34-3.87-3.03-2.87-8.04s1.85-9.98-2.35-13.69\n      s-11.75-4.12-20.46,6.4l5.7,6.88C17.95,29.55,20.99,25.07,24.75,28.08z M51.59,6.6c0.65-0.33,1.48-0.01,1.85,0.72\n      s0.15,1.59-0.5,1.92s-1.48,0.01-1.85-0.72C50.72,7.79,50.94,6.93,51.59,6.6z"
  }), React__default.createElement("path", {
    d: "M73.23,49.46c-0.53-0.48-1.11-0.69-1.75-0.72c-0.53-0.02-1.06-0.09-1.6-0.12c-1.22-0.06-2.19-0.36-3.75-0.26\n\t\t\tc-1.08,0.07-2.16,0.08-3.24,0.1c-0.69,0.01-1.39-0.02-2.06,0c-0.76,0.03-1.51-0.09-2.26-0.07c-0.83,0.02-1.64,0.28-2.46,0.24\n\t\t\tc-0.9-0.05-1.75-0.33-2.65-0.37c-0.66-0.03-1.32-0.03-1.98-0.02c-3.48,0.03-6.96,0.07-10.44,0.1c-3.31,0-6.61,0.26-9.92,0.02\n\t\t\tc-0.41-0.03-0.83-0.07-1.24,0c-1.35,0.22-2.74,0.17-4.11,0.21c-0.61,0.02-1.22,0.04-1.84,0.07c-0.25,0.01-0.78,0.18-1.01,0.11\n\t\t\tc-1.31-0.38-4.79,0.59-3.02,2.31c0.52,0.51,1.1,0.62,1.7,0.53c0.16,0.43,0.37,1,0.42,1.18c0.6,2.44,2.16,2,2.61,2.24\n\t\t\tc0.01,0.01,1.62-0.02,3.22-0.06c-0.17,0.86,0.25,1.57,1.2,1.71c0.34,0.05,0.88,0.11,1.51,0.2c1.61,0.37,4.06,1.16,5.16,2.12\n\t\t\tc0.2,0.26,0.42,0.51,0.66,0.76c0.18,0.23,0.37,0.47,0.55,0.69c0.39,0.49,0.77,0.97,1.15,1.48c0.25,0.33-0.48,1.65-0.94,2.19\n\t\t\tl-0.27,0.31c-0.66,0.38-1.32,0.76-1.96,1.27c-0.97,0.78-2.31,0.98-3.5,1.33c-0.17,0.05-0.33,0.15-0.46,0.26\n\t\t\tc-0.97,0.87-2.21,1.1-3.45,1.17c-1.59,0.08-2.96,0.79-4.64,0.34c-0.15-0.04-0.4,0.25-0.41,0.45c0,0.2,0.21,0.52,0.4,0.72\n\t\t\tc0.67,0.69,1.42,0.75,2.04,0.53c1.73-0.63,3.65-0.85,5.6-1.14c0.71-0.11,1.39-0.33,2.08-0.55c0.63-0.19,1.25-0.4,1.87-0.63\n\t\t\tc1.2-0.54,2.42-0.98,3.6-1.59c0.83-0.45,1.68-0.89,2.07-1.43c0.15-0.22,0.24-0.42,0.31-0.59c0.05,0.02,0.1,0.04,0.14,0.07\n\t\t\tc0.2,0.66,0.58,1.28,1.22,1.74c1.59,1.14,3.1,1.73,4.11,2.23c-0.03,0.03-0.06,0.06-0.1,0.09c-0.86,0.9-2.16,1.27-3.3,1.77\n\t\t\tc-0.12,0.05-0.23,0.14-0.32,0.23c0.1,1.01,0.98,1.3,2.1,1.19c0.47-0.22,0.93-0.44,1.39-0.68c0.83-0.52,3.13-1.88,3.36-2.04\n\t\t\tc0.76-0.56,1.55-1.1,1.87-1.68c0.55-1.12,0.14-1.6-0.38-1.77c0.84-1.66,2.04-3.57,4.58-3.14c2.68,0.45,5.35,0.69,7.37,0.85\n\t\t\tc1.77,0.14,3.39-0.51,4.67-1.89c0.18-0.19,0.37-0.4,0.51-0.61c0.03-0.04,0.06-0.08,0.08-0.13c0.23-0.4,0.27-0.83-0.2-1.32\n\t\t\tc-1.02-1.05-2.77-0.27-3.28-0.13c-0.52,0.13-2.8,0.33-3.82,0.41c-0.45,0.04-2.29-0.26-3.72-0.51c0.54-0.22,2.25-0.48,2.88-0.76\n\t\t\tc0.51-0.22,1.49-1.27,2.16-2.34c0.19-0.24,0.33-0.49,0.4-0.74c0.12-0.27,0.2-0.53,0.24-0.76c1.22,0.03,2.43,0.03,3.65,0.13\n\t\t\tc0.83,0.07,3.23,0.15,4.44-2.43c0-0.01,0.01-0.03,0.01-0.04c0.16-0.33,0.32-0.77,0.49-1.26C74.24,50.84,73.44,49.64,73.23,49.46z\n\t\t\t M25.7,53.36c-0.98,0.12-1.8-1.01-2.03-1.97c-0.02-0.07-0.03-0.13-0.05-0.19c0.37-0.09,0.75-0.19,1.11-0.34\n\t\t\tc0.83-0.34,1.62-0.25,2.38,0.04c1.35,0.51,2.73,0.55,4.11,0.71c1.26,0.15,2.53-0.14,3.8-0.05c0.84,0.05,1.7,0.07,2.53-0.13\n\t\t\tc2.19-0.54,3.96-0.61,6.15-0.57c0.27,0.01,0.53,0.12,0.8,0.17c0.76,0.14,2.12-0.45,2.88-0.42c2,0.08,4-0.01,6,0.11\n\t\t\tc1.8,0.11,3.34,0.63,5.1,0.26c0.11-0.02,0.22-0.1,0.33-0.17c0.51-0.36,1.03-0.36,1.58-0.25c0.16,0.03,0.31,0.06,0.47,0.08\n\t\t\tc-0.02,0-0.04,0-0.06,0.01c-0.1,0.01-0.2,0.01-0.3,0.03c-1.85,0.38-3.66,1.15-5.34,2.09c-0.35,0.02-0.69,0.03-1.04,0.04\n\t\t\tc-1.27,0.04-2.54,0.06-3.8,0.11c-0.66,0.02-1.31,0.14-1.97,0.12c-0.78-0.02-1.55,0.07-2.31,0.23c-0.63,0.13-1.26,0.22-1.91,0.08\n\t\t\tc-0.36-0.08-0.96-0.08-1.33-0.07c-0.8,0.03-1.6,0.03-2.39-0.25c-0.34-0.12-4.77,0.09-5.62,0.12c-0.36-0.19-0.72-0.35-1.1-0.48\n\t\t\tc-1.16-0.53-2.39-0.72-3.65-0.14c-0.12,0.06-0.55,0.34-0.99,0.72c-0.17,0-0.29,0-0.35-0.01C27.4,53.17,26.43,53.27,25.7,53.36z\n\t\t\t M52.08,54.75c-0.86,0.63-1.66,1.27-2.35,1.87c-0.15,0.13-0.3,0.27-0.45,0.41c-0.76,0.69-1.55,1.4-2.66,1.37\n\t\t\tc-2.45-0.09-4.99-0.18-6.91-1.97c-0.64-0.6-1.21-0.93-1.81-1.29c-0.03-0.02-0.06-0.03-0.08-0.05c0.29,0,0.58,0,0.86,0\n\t\t\tc0.42,0,0.84,0.04,1.26,0.06c0.54,0.02,1.1,0.18,1.6,0.04c1.93-0.52,3.89-0.34,5.84-0.33C48.03,54.86,49.95,54.81,52.08,54.75z\n\t\t\t M50.4,60.47c2.9-1.2,7.69-4.73,10.81-6.06c0.01,0.15,0.03,0.28,0.05,0.39c-0.3,0.57-1.03,1.39-1.74,2.07\n\t\t\tc-0.48,0.32-0.97,0.59-1.34,0.75c-0.4,0.17-1.47,0.49-2.32,0.76c-1.79,0.55-1.79,0.55-1.82,0.89c0,0,0,0.35,0.2,0.42\n\t\t\tc0.22,0.08,0.74,0.15,1.24,0.23c0.23,0.04,0.46,0.08,0.69,0.12c1.24,0.28,2.36,0.46,3.38,0.53c0.43,0.05,0.76,0.07,0.95,0.06\n\t\t\tc0.12-0.01,0.23-0.02,0.34-0.03c0.24-0.01,0.47-0.02,0.71-0.04c0.46-0.03,0.88-0.05,1.49-0.13c0,0,1.26-0.16,1.48-0.25\n\t\t\tc0.85-0.36,1.79-0.69,2.37-0.1c0.11,0.11,0.15,0.17,0.01,0.36c-0.05,0.07-0.11,0.14-0.17,0.2c-0.01,0.02-0.02,0.03-0.04,0.04\n\t\t\tc-0.3,0.32-0.66,0.58-0.97,0.79c-1.83,1.21-4.15,0.85-6.21,0.36c-1.24-0.3-2.52-0.49-3.8-0.59c-3.46-0.27-5.88,1.2-7.1,4.4\n\t\t\tc-0.82,0.83-5.24-1.48-7.79-2.21c-0.57-0.16-1.03-0.56-1.26-1.1c-0.18-0.42-0.41-0.92-0.64-1.28c-1.85-2.93-4.34-4.78-7.82-4.97\n\t\t\tc-0.64-0.16-1.16-0.26-1.39-0.3c-0.18-0.03-0.46-0.07-0.63-0.11c-0.05-0.03-0.1-0.07-0.14-0.1c0.01-0.06,0.03-0.17,0.11-0.38\n\t\t\tc0.19-0.49,0.95-1.11,1.41-1.43c0.95-0.18,2.08-0.02,2.85,0.26c0.9,0.33,1.71,0.47,2.45,0.76c0.14,0.1,0.28,0.19,0.41,0.29\n\t\t\tc0.43,0.31,0.81,0.54,1.19,0.76c0.02,0.02,0.04,0.04,0.07,0.07c1.56,1.74,4.84,4.04,6.32,4.24c3.6,0.49,3.9-0.49,5.58-1.6\n\t\t\tc3.35-2.21,6.66-4.47,10.01-6.68c0.44-0.14,0.88-0.26,1.32-0.35c0.37-0.08,0.75-0.06,1.14,0.02c0.34,0.12,0.66,0.31,0.93,0.57\n\t\t\tC57.12,56.42,50.27,58.31,50.4,60.47z M68.04,51.49c-0.05,0.16-0.11,0.32-0.17,0.48c-0.36,0.97-1.34,1.56-2.36,1.43h-0.02\n\t\t\tc-0.76-0.1-1.51-0.17-2.27-0.24c0.02-0.02,0.04-0.04,0.06-0.07c0.4-0.35,0.67-0.68,0.63-1.1c-0.04-0.46-0.44-0.73-0.79-0.91\n\t\t\tc-0.12-0.09-0.26-0.18-0.41-0.27c0.75,0.02,1.5-0.03,2.25-0.19c0.42-0.09,0.83-0.12,1.23,0.16c0.23,0.16,0.52,0.21,0.78,0.22\n\t\t\tc0.42,0.01,0.84,0,1.26-0.01C68.16,51.15,68.1,51.32,68.04,51.49z"
  }), React__default.createElement("path", {
    d: "M23.62 59.35h.56v1.67h.26v-1.67H25v-.23h-1.38zM26.19 60.48l-.6-1.36h-.33v1.9h.25v-1.53l.56 1.27h.24l.55-1.27v1.53h.25v-1.9h-.33z"
  }));
};

var cateringTwo = function cateringTwo(_a) {
  var _a$title14 = _a.title,
      title = _a$title14 === void 0 ? '' : _a$title14,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 28 29"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M22.866 17.165c0-4.258-3.14-7.773-7.218-8.362v-.095c0-.668-.537-1.208-1.203-1.208-.665 0-1.203.54-1.203 1.208v.095c-4.079.589-7.218 4.104-7.218 8.362v1.209h16.842v-1.209zm-7.218-6.645c-3.577 0-6.547 2.627-7.115 6.059-.054.33-.33.586-.664.586-.354 0-.645-.288-.614-.641.325-3.699 3.424-6.608 7.19-6.608 1.395 0 2.695.408 3.8 1.099-.808-.317-1.68-.495-2.597-.495z"
  }), React__default.createElement("rect", {
    width: "19.557",
    height: "1.559",
    x: "4.667",
    y: "19.941",
    rx: ".779"
  }));
};

var check = function check(_a) {
  var _a$title15 = _a.title,
      title = _a$title15 === void 0 ? '' : _a$title15,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m9.0002 16.17-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z"
  }));
};

var checkCircle = function checkCircle(_a) {
  var _a$title16 = _a.title,
      title = _a$title16 === void 0 ? '' : _a$title16,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  }));
};

var circlePlus = function circlePlus(_a) {
  var _a$title17 = _a.title,
      title = _a$title17 === void 0 ? '' : _a$title17,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 20 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M10 0a10 10 0 0 1 10 10 10 10 0 0 1-10 10A10 10 0 0 1 0 10 10 10 0 0 1 10 0z M14 9.2h-3.22V6A.79.79 0 0 0 9.2 6v3.2H6a.79.79 0 1 0 0 1.58h3.2V14a.79.79 0 1 0 1.58 0v-3.22H14a.79.79 0 0 0 0-1.58z"
  }));
};

var close = function close(_a) {
  var _a$title18 = _a.title,
      title = _a$title18 === void 0 ? '' : _a$title18,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m7.2441 7.2441c0.32543-0.32544 0.85307-0.32544 1.1785 0l3.5774 3.5774 3.5774-3.5774c0.3254-0.32544 0.8531-0.32544 1.1785 0 0.3255 0.32543 0.3255 0.85307 0 1.1785l-3.5774 3.5774 3.5774 3.5774c0.3255 0.3254 0.3255 0.8531 0 1.1785-0.3254 0.3255-0.8531 0.3255-1.1785 0l-3.5774-3.5774-3.5774 3.5774c-0.32544 0.3255-0.85308 0.3255-1.1785 0-0.32544-0.3254-0.32544-0.8531 0-1.1785l3.5774-3.5774-3.5774-3.5774c-0.32544-0.32544-0.32544-0.85308 0-1.1785z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

var cluckNorris = function cluckNorris(_a) {
  var _a$title19 = _a.title,
      title = _a$title19 === void 0 ? '' : _a$title19,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 109.8 131"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M80.5,18.8c1.1-0.5,1.6-1.9,1.2-3.3c-0.1-0.2-0.1-0.4-0.2-0.5c-0.7-1.5-2.3-2.2-3.6-1.6c-0.4,0.2-0.7,0.5-0.9,0.8 c-0.5,0.8-0.6,1.9-0.1,3C77.6,18.7,79.2,19.4,80.5,18.8z M88.7,28.8c3.7,7.4,16.2,32.3,17.7,37c4.7,15.5,4.1,33.9-18.3,46 c-6.9,3.7-13.3,5.6-19.1,6.1l-1.1,12h-8.4l-1.2-12.5C43,114.7,33,103.1,29.7,96.7c-0.1-0.3-0.3-0.5-0.4-0.8 c-0.2-0.3-0.3-0.6-0.4-0.9c-6.2-14.9,6.7-32.5-4.3-39.2c0,0-7.2-4.8-12.3,3.8c0,0.1-0.1,0.1-0.1,0.2l-11.7-13 c8.7-12.6,24.1-23.8,36.8-16c19.2,11.8-0.2,35.8,11.6,43.1c0,0,7.1,4.5,12.7-4.7c2.9-4.9,4.1-12.5,4.4-15.4l0.1-38.3l-1.8,0.7 c-0.1,0.1-0.4,0.1-0.6,0.2c-0.3,0.1-0.6,0.2-0.9,0.2c-0.8,0.2-1.5,0.2-2.3,0.2c-3.8-0.2-6.1-1.9-7.5-3.8c-0.7-0.8-1.2-1.8-1.5-3 c-0.2-0.7-0.3-1.4-0.2-2.1c0-0.1,0-0.2,0-0.4c0.3-3.9,3.3-6.8,6.6-6.5c2.3,0.2,4.1,1.8,5,4.1c0.8-1,1.9-1.9,3.5-2.4 c5.3-1.9,8.6,3,10.2,6.2L88.9,4l-1.6,7.5l5.3,2.8l-0.5,0.3l-3.2,2.9c2.5,1.6,5.3,4.5,3.4,8.6C91.7,27.8,90.3,28.6,88.7,28.8 L88.7,28.8z"
  }));
};

var cluckNorrisLoveThatChicken = function cluckNorrisLoveThatChicken(_a) {
  var _a$title20 = _a.title,
      title = _a$title20 === void 0 ? '' : _a$title20,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    version: "1.1",
    viewBox: "0 0 150 150"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M0.92,95.63l6.75,8.14c0,0,3.61-5.3,8.05-1.74c4.45,3.56,1.34,10.86,0.93,15.06c-0.52,5.35,0.8,9.68,2.95,13.12 c2.74,4.37,9.1,8.01,15.93,9.3c0.52,0.1,1.02,0.17,1.52,0.23l0.71,7.53h5.15l0.69-7.36c11.81-0.95,28.51-12.5,21.08-31.96 c-3.42-8.95-10.67-22.31-10.67-22.31l0.08-0.02c2.87-0.73,3.42-4.45,0.07-6.45l2.4-2.22l-3.5-1.44l1.31-4.79l-7.52,2.98 c0.01-0.01,0.02-0.02,0.02-0.02s-1.91-3.98-4.8-4.01c-2.44-0.03-3.6,1.74-3.6,1.74s-0.65-1.82-2.32-2.31 c-1.67-0.5-4.4,0.48-4.74,3.51c-0.39,3.4,2.36,5.15,3.26,5.44c1.07,0.34,2.56,1.04,5.66-0.28c-0.01,3.12-0.02,10.35-0.02,13.99 c-0.01,4.71,0.42,12.35-1.61,16.5c-2.02,4.14-4.33,5.87-7.38,5.51c-3.41-0.4-4.58-3.59-3.39-9.52c1.19-5.93,2.19-11.82-2.78-16.22 C20.18,83.66,11.24,83.18,0.92,95.63z M47.51,76.61c0.77-0.39,1.75-0.01,2.19,0.85c0.44,0.86,0.18,1.88-0.59,2.27 c-0.77,0.39-1.75,0.01-2.19-0.85C46.47,78.02,46.74,77,47.51,76.61z"
  }), React__default.createElement("g", null, React__default.createElement("polygon", {
    points: "47.07,145.43 47.69,145.43 47.69,147.28 47.97,147.28 47.97,145.43 48.59,145.43 48.59,145.17 47.07,145.17 49.91,146.68 49.25,145.17 48.89,145.17 48.89,147.28 49.16,147.28 49.16,145.58 49.78,146.99 50.05,146.99 50.67,145.58 50.67,147.28 50.94,147.28 50.94,145.17 50.57,145.17 \t"
  })), React__default.createElement("g", {
    id: "Love_that_Chicken_2_"
  }, React__default.createElement("path", {
    d: "M76.57,43.17c0.57,0.36,0.4,1.37,0.55,1.95c0.24,0.88,0.61,1.74,0.94,2.59c0.23,0.6,0.51,0.98,0.97,1.43 c0.65,0.64,1.03,1.44,1.37,2.28c1.22,2.94,1.92,6.08,3,9.07c0.41,1.12,0.87,1.96,2.19,1.65c0.46-0.11,1.59-0.46,1.86-0.89 c0.18-0.28,0-0.71-0.12-1.06c-1.15-3.28-2.8-6.45-4.16-9.65c-0.84-1.97-1.68-3.94-2.45-5.93c-0.15-0.38-0.48-0.94-0.49-1.36 c-0.02-0.65,0.77-1.14,1.32-1.48c0.9-0.57,3.05,0.01,3.58-0.94c0.34-0.6-0.12-1.38-0.69-1.59c-0.6-0.22-1.36,0.01-1.95,0.18 c-3.16,0.9-6.36,1.57-9.59,2.23c-2.01,0.41-4.35,0.63-6.21,1.54c-0.62,0.3-1.37,0.79-1.69,1.42c-0.28,0.55-0.07,0.61,0.63,0.82 c0.94,0.28,1.64-0.22,2.51-0.49c1.03-0.32,2.09-0.28,3.15-0.41c0.85-0.11,1.63-0.38,2.42-0.71C74.47,43.49,75.76,42.66,76.57,43.17 z\n        M99.56,51.12c0.06-1.75-1.05-3.08-1.53-4.66c-0.33-1.11-0.81-2.18-1.28-3.24c-0.91-2.07-2-4.17-2.49-6.39 c-0.19-0.88-0.82-2.85-2.18-1.92c-1.05,0.71,0.13,2.62,0.48,3.47c1.08,2.61,2.43,5.18,3.33,7.86c0.54,1.61,0.76,3.51,1.57,5.02 C97.84,51.99,99.52,52.42,99.56,51.12z\n        M95.28,47.87c-0.69-0.06-1.42-0.01-2.11,0.08c-0.51,0.06-1.52,0.55-1.98,0.44c-0.61-0.15-1.03-1.57-1.29-2.15 c-0.3-0.67-0.65-1.34-0.8-2.06c-0.1-0.47-0.05-1.08-0.44-1.43c-0.66-0.59-2.48-0.25-2.62,0.73c-0.11,0.82,0.81,2.09,1.17,2.79 c0.55,1.07,1.11,2.14,1.68,3.2c0.64,1.19,1.22,2.32,1.57,3.63c0.29,1.09,0.67,2.1,1.19,3.08c0.18,0.33,0.6,0.41,0.89,0.18 c0.12-0.09,0.23-0.19,0.3-0.31c0.28-0.45,0.31-1.55,0.33-2.1c0.02-0.71-0.24-1.28-0.61-1.87c-0.31-0.49-0.9-0.98-0.51-1.49 c0.32-0.4,1.19-0.4,1.63-0.51c0.5-0.13,1.04-0.31,1.52-0.5C96.13,49.22,96.74,48.01,95.28,47.87z\n        M69.71,33.44c0.07-0.88,1.99-0.27,2.6-0.24c1.18,0.05,2.46-0.03,3.52-0.59c1.04-0.54,1.74-1.31,2.31-2.31 c0.24-0.4,0.46-1.51,0.46-1.51c-0.03-0.2-0.14-0.44-0.21-0.63c-0.11-0.31-0.22-0.62-0.31-0.94c-0.2-0.68-0.37-1.36-0.52-2.05 c-0.3-1.38-0.51-2.77-0.61-4.18c-0.11-1.43-0.15-2.91-0.08-4.34c0.07-1.36,0.31-2.72,0.85-3.98c0.09-0.21,0.19-0.42,0.3-0.63 c0.78-1.5,2.47-3.27,4.04-1.57c1.93,2.09,1.72,5.63,1.51,8.2c-0.19,2.33-0.97,4.61-1.78,6.82c-0.58,1.58-1,3.02-0.94,3.25 c0.09,0.36,2.25,2.77,4.81,2.24c2.01-0.41,3.32-1.83,3.74-3.79c0.27-1.28,0.22-2.63,0.3-3.93c0.08-1.28,0.54-2.32,1.32-3.34 c0.92-1.19,2.17-2.14,3.71-2.28c1.49-0.14,2.94,0.54,3.65,1.87c0.7,1.32,0.78,2.92,0.75,4.39c-0.01,0.36-0.03,0.72-0.05,1.08 c-0.12,1.81-0.99,3.31-2.42,4.4c-1.71,1.31-3.88,1.05-5.62-0.16c-0.26,2.65-2.02,4.7-4.69,5.12c-2.69,0.42-4.47-1.41-6.29-3.08 c-1.13,1.44-2.23,3.33-4,4.05c-0.64,0.26-1.32,0.35-2.01,0.41c-0.09,0.01-0.23,0.01-0.39,0c-0.59-0.01-1.17-0.13-1.72-0.35 C70.93,35,69.63,34.37,69.71,33.44z M92.43,26.89c0.59,0.32,1.47,0.31,2.08,0.05c1.52-0.65,2-3.18,1.66-4.61 c-0.13-0.54-0.36-1.06-0.48-1.6c-0.1-0.44-0.07-1-0.32-1.39c-0.64-0.98-1.78-0.47-2.36,0.21c-1.29,1.53-2.05,3.04-1.68,5.07 C91.49,25.49,91.57,26.43,92.43,26.89z M78.92,23.65c0.19,0.69,0.45,1.36,0.78,2.01c0.01,0.03,0.05,0.04,0.07,0.02 c1.04-1.08,1.17-3.25,1.43-4.6c0.41-2.12,1.04-4.38,0.93-6.55c-0.03-0.69-0.23-1.7-1.19-1.52c-0.98,0.18-1.71,1.77-2.01,2.6 c-0.41,1.15-0.51,2.4-0.53,3.62C78.38,20.71,78.51,22.21,78.92,23.65z\n        M111.96,41.76c0,0.04,0,0.08,0,0.13c-0.01,0.95-0.18,2.13-0.86,2.85c-1.29,1.37-3.67,1.2-4.73-0.34 c0.08,0.12-0.83,0.95-0.93,1.03c-1.14,0.98-2.87,1.18-4.19,0.42c-2.16-1.26-1.95-4.65-0.21-6.15c0.52-0.45,1.17-0.75,1.85-0.88 c0.74-0.13,1.58-0.18,2.32-0.13c0.01,0-0.16-0.7-0.19-0.77c-0.11-0.26-0.28-0.5-0.52-0.66c-0.48-0.33-1.06-0.54-1.64-0.56 c-0.64-0.02-1.21,0.18-1.76,0.49c-0.23,0.13-0.57,0.31-0.84,0.21c-0.32-0.11-0.27-0.57-0.18-0.82c0.08-0.2,0.21-0.38,0.35-0.55 c0.79-0.92,1.98-1.45,3.18-1.47c0.63-0.01,1.28,0.13,1.81,0.49c1.77,1.19,2,2.95,2.4,4.93c0.15,0.77,0.57,4.49,2.13,3.46 c0.55-0.36,0.82-1.18,0.87-1.79c0.03-0.39-0.02-0.77,0.06-1.16c0.1-0.49,0.6-0.36,0.79,0C111.87,40.89,111.95,41.32,111.96,41.76z M105.61,40.89c-0.02-0.09-0.12-0.54-0.12-0.54c-0.52-0.15-1.25-0.01-1.75,0.18c-0.57,0.22-1.06,0.64-1.36,1.18 c-0.41,0.76-0.43,1.82,0.06,2.55c0.14,0.2,0.33,0.38,0.57,0.44c0.36,0.08,0.71-0.12,1-0.31c0.62-0.42,1.23-0.91,1.59-1.59 C105.9,42.23,105.73,41.5,105.61,40.89z\n        M96.67,13.27c0.32,0.78,2.08,2.6,3.19,4.06c1.53,2.02,3.15,3.98,4.81,5.9c1.06,1.23,2.16,2.94,3.48,3.9 c0.53,0.38,1.01,0.3,1.36-0.26c0.5-0.81,0.08-1.59-0.23-2.36c-0.69-1.76-0.48-3.93-0.66-5.79c-0.27-2.68-0.05-5.13,0.21-7.91 c0.03-0.37,0.06-0.73,0.08-1.1c0.03-0.94,0.2-1.88,0.19-2.83c0-0.28-0.04-0.55-0.08-0.83c-0.04-0.2-0.08-0.4-0.13-0.6 c-0.1-0.37-0.23-0.76-0.5-1.05c-0.78-0.83-1.05,0.61-1.13,1.25c-0.15,1.26-0.32,2.5-0.39,3.76c-0.17,3.03-0.12,6.09-0.45,9.11 c-0.01,0.11-0.03,0.22-0.04,0.33c-0.02,0.19-0.04,0.38-0.06,0.57c-0.02,0.23-0.05,0.45-0.07,0.68c-0.02,0.22-0.04,0.44-0.05,0.66 c-0.01,0.16-0.02,0.33-0.01,0.5c0,0.07,0.01,0.13,0.01,0.2c0,0.03,0.01,0.06-0.03,0.04c-0.03-0.01-0.06-0.03-0.09-0.05 c-0.11-0.07-0.21-0.15-0.3-0.24c-0.16-0.15-0.3-0.32-0.44-0.49c-0.15-0.18-0.29-0.37-0.42-0.56c-0.11-0.16-0.22-0.32-0.33-0.47 c-0.04-0.06-0.08-0.12-0.13-0.18c-1.21-1.53-2.49-2.96-3.65-4.53c-0.7-0.96-1.46-2.46-2.44-3.16c-0.39-0.28-1.01-0.35-1.5-0.14 C96.39,11.9,96.22,12.18,96.67,13.27z\n        M113.32,29.34c-0.2,0.36-0.29,0.81-0.27,1.26c0.05,1.21,0.59,2.37,0.84,3.54c-0.01-0.03-1.13,0.47-1.22,0.51 c-0.31,0.13-0.64,0.24-0.95,0.38c-0.44,0.2-1.13,0.38-1.25,0.93c-0.38,1.61,3.64,0.59,4.37,0.42c0.09,0.65,0.34,1.26,0.49,1.89 c0.19,0.8,0.3,1.61,0.52,2.4c0.43,1.55,1.46,2.81,2.98,3.39c1.29,0.49,3,0.54,4.1-0.4c0.7-0.6,1.1-1.61,0.48-2.41 c-0.15-0.19-0.36-0.35-0.61-0.39c-0.18-0.03-0.37,0-0.55,0.06c-0.59,0.23-0.73,0.93-1.3,1.15c-0.33,0.13-0.71,0.04-1.03-0.1 c-1.24-0.55-1.67-1.76-1.94-3c-0.27-1.23-0.64-2.42-0.72-3.69c1.65-0.75,3.42-1.28,5.19-1.68c0.39-0.09,0.8-0.17,1.12-0.42 c0.71-0.54,0.45-1.8-0.48-1.89c-0.72-0.07-1.67,0.34-2.37,0.51c-1.37,0.35-2.76,0.68-4.1,1.14c-0.12-0.56-0.29-1.11-0.4-1.67 c-0.09-0.47-0.13-0.95-0.25-1.41c-0.19-0.75-0.35-1.24-1.2-1.32C114.09,28.5,113.6,28.84,113.32,29.34z\n        M112.79,19.09c-0.21-2.1,0.33-4.27,1.86-5.78c2.34-2.3,6.33-2.42,8.54,0.12c1.23,1.41,1.76,3.09,0.07,4.33 c-1,0.73-2.19,1.13-3.32,1.64c-1.12,0.5-2.26,1.04-3.47,1.36c0.49,1.23,1.8,2.42,2.82,3.2c0.96,0.74,2.13,1.26,3.34,1.22 c0.83-0.02,1.7-0.35,2.17-1.04c0.67-0.97,0.38-2.32,0.87-3.38c0.1-0.22,0.24-0.43,0.45-0.55c0.32-0.19,0.75-0.1,1.05,0.12 c0.3,0.23,0.49,0.57,0.62,0.92c0.48,1.24,0.37,2.7-0.29,3.85c-2.1,3.65-7.48,2.57-10.43,0.81 C114.53,24.41,113.08,21.99,112.79,19.09z M120.05,17.03c0.27-0.14,0.53-0.28,0.79-0.44c0.46-0.27,0.9-0.7,0.71-1.28 c-0.09-0.29-0.31-0.52-0.54-0.71c-0.7-0.59-2.24-1.19-3.13-0.74c-1.05,0.53-1.95,1.42-2.14,2.62c-0.11,0.68,0.01,1.57,0.08,2.24 c0,0,2.25-0.81,2.49-0.9C118.91,17.58,119.49,17.32,120.05,17.03z\n        M99.89,69.23c-0.12-0.63-0.16-1.29-0.3-1.92c-0.13-0.59-0.48-0.96-0.82-1.46c-0.32-0.46-0.64-0.93-0.82-1.47 c-0.21-0.65-0.16-1.32-0.37-1.97c-0.36-1.09-1.22-0.97-1.63-0.83c-0.44,0.15-0.76,0.1-1.12,0.51c-0.25,0.28-0.15,0.54-0.14,0.68 c0.06,0.74,0.38,1.27,0.61,1.95c0.18,0.54,0.16,1.12,0.34,1.65c0.19,0.57,0.58,0.81,0.92,1.26c0.41,0.54,0.28,0.98,0.32,1.61 c0.03,0.6,0.25,1.11,0.52,1.63c0.26,0.52,0.43,1.08,0.74,1.57c0.5,0.78,0.99,0.41,1.65-0.06c0.58-0.41,0.81-0.71,0.78-1.42 C100.53,70.25,100.01,69.88,99.89,69.23z\n        M124.84,61.82c-1.48-1.21-3.11-2.23-4.73-3.25c-0.81-0.51-1.62-1.01-2.42-1.55c-0.39-0.26-1.37-0.59-1.33-1.18 c0.01-0.17,0.09-0.33,0.16-0.48c0.98-2,1.85-4.05,2.82-6.06c0.15-0.32,0.31-0.65,0.32-1.01s-0.17-0.74-0.51-0.85 c-0.4-0.13-0.81,0.15-1.08,0.46c-0.49,0.56-0.78,1.25-1.14,1.9c-0.96,1.74-2.43,3.24-3.41,4.97c-0.29-0.7-0.49-1.14-0.64-1.74 s-0.41-1.24-0.97-1.5c-0.14-0.06-0.31-0.1-0.43-0.01c-0.13,0.09-0.16,0.28-0.16,0.44c0.01,0.49,0.16,0.96,0.33,1.43 c0.8,2.25,1.83,4.42,2.62,6.68c0.5,1.42,0.91,2.86,1.41,4.28c0.18,0.51,0.4,1.04,0.84,1.36c0.44,0.32,1.17,0.29,1.42-0.18 c0.21-0.38,0.03-0.85-0.14-1.25c-0.81-1.86-1.59-3.83-2.4-5.69c1.29,0.27,2.56,0.8,3.65,1.49c0.85,0.54,1.65,1.17,2.51,1.7 c1.05,0.65,2.18,1.1,3.27,1.69C126.52,64.37,125.59,62.43,124.84,61.82z\n        M68.93,53.68c-1.67-0.36-3.36-0.01-4.79,1.65c-1.46,1.69-1.94,4.01-2.07,6.24c-0.19,3.31,0.34,6.71,1.74,9.73 c1.09,2.36,3.62,6.49,6.65,6.37c0.66-0.03,1.3-0.28,1.89-0.58c3.24-1.63,6.48-5.16,4.65-8.96c-0.48-1-1.83-1.81-2.71-0.83 c-0.68,0.76-0.93,1.98-1.22,2.92c-0.44,1.43-0.95,4.41-2.73,4.85c-1.13,0.28-2.07-0.85-2.65-1.86c-2.39-4.18-4.33-9.55-2.59-14.4 c0.6-1.68,1.94-2.46,3.74-2.1c1.89,0.39,2.27,3.04,4.19,3.57c0.92,0.26,1.85-0.58,2.13-1.42c0.35-1.02-0.48-1.6-1.16-2.23 C72.59,55.32,70.77,54.07,68.93,53.68z\n        M109.27,59.4c-1.22,0.11-1.61,2.36-2.08,3.21c-0.44,0.8-1.43,1.51-2.36,1.12c-0.42-0.18-0.76-0.5-1.08-0.84 c-0.8-0.86-1.51-1.84-1.91-2.95c-0.49-1.33-0.59-3.23,0.34-4.41c0.32-0.4,0.81-0.65,1.31-0.75c0.51-0.1,1.12-0.12,1.61,0.05 c0.51,0.19,0.94,0.57,1.39,0.86c0.78,0.5,1.99,0.86,2.61-0.1c0.61-0.94-0.82-1.38-1.53-1.71c-2.79-1.31-6.54-0.98-7.63,2.38 c-0.44,1.35-0.29,2.84,0.19,4.18c0.72,1.97,2.22,3.69,4.18,4.44c0.82,0.32,1.75,0.45,2.58,0.09c0.91-0.39,1.75-0.94,2.57-1.49 c0.7-0.46,1.49-1.15,1.61-2.04C111.23,60.34,110.41,59.3,109.27,59.4z\n        M133.36,51.08c-1.37,0.22-2.48,1.3-3.56,2.09c-0.3,0.22-0.57,0.48-0.86,0.71c-0.38,0.31-0.8,0.57-1.2,0.85 c-0.37-0.4-0.75-0.81-1.12-1.21c0.07-0.06,0.13-0.12,0.2-0.18c0.67-0.61,1.3-1.24,2.01-1.8c0.6-0.47,1.23-0.91,1.86-1.33 c0.25-0.16,0.24-0.52-0.01-0.69c-0.32-0.21-0.63-0.3-1.12-0.11c-0.64,0.25-1.24,0.88-1.78,1.29c-0.36,0.27-0.69,0.59-1.05,0.86 c-0.14,0.11-0.27,0.24-0.41,0.34c-0.18,0.13-0.43,0.26-0.62,0.36c0,0-0.46-0.56-0.5-0.63c-0.07-0.09-0.76-1.14-0.68-1.2 c0.87-0.66,1.72-1.36,2.54-2.08c0.57-0.5,1.59-0.96,2.16-1.61c0.35-0.4,0.04-1.02-0.48-0.98c-2.25,0.2-3.7,2.08-5.61,3.24 c-1.14,0.7-1.4,0.93-0.53,2.11c0.76,1.03,1.45,2.03,2.15,3.09c0.57,0.86,1.38,1.93,2.24,2.52c0.88,0.61,1.6-0.25,2.3-0.79 c1.01-0.78,2.05-1.56,2.94-2.48c0.43-0.44,0.89-0.93,1.24-1.44C133.61,51.83,134.08,50.96,133.36,51.08z\n        M91.74,68.97c-0.08-0.92-0.6-1.99-1.03-2.78c-0.21-0.39-0.44-0.88-0.95-0.9c-0.77-0.03-0.86,0.77-0.8,1.33 c0.12,1.15,0.8,2.42-0.68,3.04c-0.54,0.23-1.09,0.46-1.66,0.61c-0.34,0.09-0.69,0.16-1.03,0.22c-0.28,0.05-0.62,0.19-0.91,0.18 c-0.15,0-0.21-0.11-0.27-0.23c-0.5-0.91-1-1.82-1.52-2.71c-0.25-0.42-0.57-1.28-1-1.55c-0.98-0.62-1.2,0.87-1.04,1.51 c0.28,1.13,0.68,2.33,1.05,3.46c0.74,2.27,0.85,4.57,1.42,6.88c0.15,0.59,0.71,1.6,1.38,0.76c0.44-0.55,0.18-1.44,0.02-2.04 c-0.17-0.61-0.37-1.24-0.52-1.87c-0.11-0.49-0.35-1.23-0.18-1.73c0.13-0.38,0.62-0.61,0.96-0.78c1.31-0.64,2.68-0.95,4.13-0.91 c0.26,0.01,0.54,0.04,0.74,0.21c0.32,0.25,0.49,0.77,0.66,1.12c0.47,0.95,0.74,2.11,1.5,2.88c0.81,0.83,2.03,0.61,1.98-0.7 c-0.03-0.79-0.64-1.56-1-2.24C92.37,71.56,91.86,70.31,91.74,68.97z\n        M146.16,45.26c-0.19-0.32-0.37-0.64-0.63-0.9c-0.29-0.29-0.79-0.45-1.04-0.75c-0.61-0.75-0.78-2.25-1.17-3.15 c-0.6-1.4-1.18-2.86-1.88-4.2c-0.64-1.22-1.41-2.37-2.16-3.53c-0.64-0.98-1.06-1.74-1.45-2.82c-0.56-1.55-2.24-3.22-3.96-3.38 c-2.06-0.19-0.97,1.89-0.4,2.77c1.36,2.11,2.84,4.16,4.23,6.25c0.67,1.01,1.37,2.02,1.98,3.07c0.33,0.58,0.61,1.19,0.96,1.76 c0.29,0.48,1.45,1.54,1.17,2.15c-1.55-0.98-3.67-0.89-5.15-1.91c-0.81-0.55-1.6-0.97-2.48-1.42c-0.9-0.46-1.84-0.57-2.77-0.95 c-0.84-0.35-2.43-1.19-3.33-1.23c-0.42-0.02-0.78,0.22-0.88,0.62c-0.25,0.93,0.85,1.72,1.42,2.23c0.88,0.78,1.71,1.56,2.46,2.48 c1.59,1.93,3.62,3.59,4.88,5.77c0.53,0.92,0.81,1.91,1.61,2.66c0.61,0.58,1.9,1.37,2.15,0.07c0.44-2.31-2.03-3.73-3.33-5.2 c-0.69-0.78-1.34-1.6-2-2.4c-0.45-0.56-0.87-1.15-1.16-1.81c0.59-0.13,1.28,0.39,1.78,0.63c0.53,0.25,1.05,0.52,1.59,0.75 c1.2,0.52,2.43,0.96,3.66,1.4c1.18,0.42,2.31,0.97,3.46,1.48c0.45,0.2,0.96,0.63,1.45,0.67C145.69,46.41,146.53,45.88,146.16,45.26 z\n        M146.39,39.73c-0.76,0.5-1.08,1.41-0.46,2.35c0.61,0.93,1.57,1,2.34,0.5c0.76-0.5,1.07-1.42,0.46-2.35 C148.11,39.3,147.15,39.23,146.39,39.73z M148.09,42.31c-0.68,0.45-1.42,0.27-1.88-0.42s-0.33-1.44,0.35-1.89 c0.68-0.45,1.43-0.27,1.88,0.42C148.9,41.11,148.77,41.86,148.09,42.31z M147.68,40.47c-0.2-0.3-0.48-0.31-0.82-0.09l-0.53,0.35 l0.99,1.5l0.26-0.17l-0.41-0.62l0.26-0.17l0.02-0.01l0.66,0.45l0.29-0.19l-0.72-0.47C147.81,40.87,147.82,40.68,147.68,40.47z M146.76,40.8l0.28-0.18c0.18-0.12,0.29-0.1,0.38,0.03c0.09,0.14,0.06,0.25-0.11,0.37l-0.28,0.18L146.76,40.8z"
  }))));
};

var cluckNorrisSaxophone = function cluckNorrisSaxophone(_a) {
  var _a$title21 = _a.title,
      title = _a$title21 === void 0 ? '' : _a$title21,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 134 108"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M55.182 15.706c.794 1.063 2.17 1.354 3.073.65.798-.62.956-1.803.447-2.8a2.784 2.784 0 0 0-.25-.402c-.787-1.07-2.17-1.35-3.073-.65-.273.212-.47.491-.593.805-.284.73-.158 1.655.396 2.397zM86.34 49.468c5.517 10.194 8.133 22.95-2.172 35.023L94 88.789l-1.54 5.188-16.847-1.829c-3.407 2.378-6.747 4.016-9.975 5.063L64.644 108h-6.76l-.857-9.28c-12.452.351-22.203-7.195-25.92-11.746a16.777 16.777 0 0 1-.46-.586c-.179-.24-.335-.466-.474-.682-7.315-10.817-.08-27.022-9.779-30.507 0 0-6.424-2.638-9.065 5.074-.016.045-.03.093-.045.138L0 52.143C4.815 40.688 15.03 29.148 26.31 33.25c17.061 6.18 5.741 28.535 16.216 32.323 0 0 6.32 2.403 9.187-5.85 1.516-4.376 1.152-10.636.94-13.011l-6.24-30.54L45.1 17c-.084.06-.272.174-.442.274a6.494 6.494 0 0 1-.637.343 6.999 6.999 0 0 1-1.773.526c-3.01.486-5.087-.474-6.491-1.77a5.759 5.759 0 0 1-1.653-2.129 5.09 5.09 0 0 1-.508-1.66c-.017-.1-.037-.198-.05-.3-.38-3.129 1.45-5.96 4.135-6.303 1.812-.224 3.548.75 4.585 2.388.441-.93 1.19-1.803 2.379-2.544 3.834-2.385 7.276.937 9.03 3.203l11.97-1.713-1.446 6.3c2.272.773 5.55 2.585 4.685 6.487-.35 1.565-1.323 2.43-2.502 2.88 4.149 5.258 18.055 22.97 19.958 26.486zm47.599-18.336s2.205 28.392-19.586 33.474c-7.607 1.774-16.524-2.683-19.508-8.54-2.373-4.66-4.557-17.337-6.495-27.72C86.2 16.833 85.237 8.303 83.087 7.082c-3.203-1.82-3.824 7.643-11.403 5.994L70 8.064c8.982 1.97 7.277-6.93 14.422-7.98 2.715-.399 7.356.467 9.391 6.019.666 1.817 1.234 4.15 1.767 6.784l1.741-.605c.037-.945.608-1.758 1.461-1.94 1.028-.216 2.076.567 2.32 1.764.249 1.19-.376 2.344-1.41 2.562-.653.14-1.308-.126-1.765-.644l-2.033.471c.402 2.118.79 4.39 1.193 6.718l2.179-.235c.246-.913.984-1.576 1.856-1.56 1.05.02 1.897 1.02 1.868 2.241-.022 1.216-.888 2.2-1.945 2.18-.667-.012-1.247-.42-1.576-1.026h-2.103a223.394 223.394 0 0 0 1.705 8.848l2.095-.634c.074-.943.678-1.732 1.538-1.88 1.035-.173 2.051.652 2.247 1.858.2 1.2-.47 2.326-1.512 2.502-.658.114-1.303-.18-1.738-.715l-2.295.435c1.707 7.894 2.913 11.745 5.829 12.867 4.28 1.646 5.43-2.488 6.059-4.651l-2.51-7.799 25.154-2.512z",
    fillRule: "evenodd"
  }));
};

var coffeeCup = function coffeeCup(_a) {
  var _a$title22 = _a.title,
      title = _a$title22 === void 0 ? '' : _a$title22,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 15 21"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    fill: "none",
    d: "M2 5l1.93 15h7.14L13 5H2zM12.19 1H2.81l-.5 1h10.38l-.5-1zM1 3v1h13V3H1z"
  }), React__default.createElement("path", {
    d: "M14 2h-.19L13 .28a.51.51 0 0 0-.5-.28h-10a.51.51 0 0 0-.45.28L1.19 2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1v.13l1.92 15a1 1 0 0 0 1 .87h7.14a1 1 0 0 0 1-.87l1.94-15V5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM2.81 1h9.38l.5 1H2.31zm8.26 19H3.93L2 5h11zM1 3h13v1H1V3"
  }));
};

var coffeeCupFilled = function coffeeCupFilled(_a) {
  var _a$title23 = _a.title,
      title = _a$title23 === void 0 ? '' : _a$title23,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 14 21"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M1.51 6h10.98a.5.5 0 0 1 .496.568l-1.912 14a.5.5 0 0 1-.496.432H3.422a.5.5 0 0 1-.496-.432l-1.912-14A.5.5 0 0 1 1.509 6zM.5 3h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 3zM1 2l1-2h10l1 2"
  }));
};

var combo = function combo(_a) {
  var _a$title24 = _a.title,
      title = _a$title24 === void 0 ? '' : _a$title24,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 86 78"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M64.42 45.096c-1.22.21-2.533.393-3.975.557-1.501.171-2.307.248-6.6.617-5.293.457-8.297.899-11.01 1.652l2.282-7.942v-.002a2 2 0 0 0-1.372-2.473L37.96 35.85l.482-2.267a2 2 0 0 0-1.54-2.372l-5.065-1.077a2 2 0 0 0-2.001.736l-.826-8.68A2 2 0 0 1 31 20h33.602a2 2 0 0 1 1.991 2.189L64.42 45.096zM37.662 50c-1.138.644-2.293 1.422-3.117 2.111-1.478 1.236-2.612 2.601-3.63 4.368-.202.356-.984 2.109-1.097 2.464-.385 1.215-.567 2.008-.7 3.04a15.368 15.368 0 0 0 .45 6.035c.574 2.037 1.567 3.944 2.946 5.67.26.324.758.87 1.19 1.312H6.187a2 2 0 0 1-1.968-1.645L.213 51.178A1 1 0 0 1 1.197 50h36.466zm8.139-33L52.628.615A1 1 0 0 1 53.55 0h8.75a.5.5 0 0 1 .5.5v2.09a.5.5 0 0 1-.5.5h-7.485a.5.5 0 0 0-.464.316L48.924 17H45.8zM3.379 48l-1.828-6.375a2 2 0 0 1 1.372-2.473l2.093-.6a2 2 0 0 1 2.474 1.37L9.806 48H3.38zm8.191 0L8.19 35.382a2 2 0 0 1 1.413-2.45l2.104-.563a2 2 0 0 1 2.45 1.414L17.967 48H11.57zM19 48V31a2 2 0 0 1 2-2h2.178a2 2 0 0 1 2 2v17H19zm8.016 0l3.01-14.161a2 2 0 0 1 2.372-1.54l2.13.452a2 2 0 0 1 1.541 2.372L33.332 48h-6.316zm6.97 0l2.316-8.077a2 2 0 0 1 2.474-1.372l2.094.6a2 2 0 0 1 1.371 2.474L40.413 48h-6.427zm-1.274 11.63c.1-.309.78-1.837.957-2.148.886-1.541 1.873-2.733 3.16-3.81.882-.738 2.197-1.594 3.386-2.205.573-.293 2.226-.959 2.925-1.18 2.628-.828 5.292-1.26 10.499-1.71 3.739-.323 4.44-.39 5.748-.54 2.155-.245 3.98-.54 5.632-.916.36-.08.77-.158.906-.172a3.69 3.69 0 0 1 2.926 1.004c.243.233.426.483 1.328 1.84.56.842.698 1.071.818 1.36.316.77.327 1.592.038 2.383-.177.48-.292.668-.845 1.353-1.749 2.177-3.039 4.125-5.81 8.784-1.572 2.643-2.283 3.796-3.102 5.03-1.934 2.917-3.766 4.966-5.671 6.342-1.19.86-2.035 1.34-3.22 1.831-2.127.883-4.298 1.238-6.62 1.092-3.46-.22-6.681-1.577-9.209-3.879a19.057 19.057 0 0 1-1.497-1.595c-1.202-1.506-2.066-3.17-2.567-4.947a13.426 13.426 0 0 1-.39-5.264c.114-.9.273-1.592.608-2.652zm38.343-14.166c.045-.186.19-.47.32-.635.205-.253.434-.407.913-.612 1.06-.453 4.15-1.823 4.157-1.842a.599.599 0 0 0-.091-.153c-.141-.188-.375-.696-.459-.998a3.226 3.226 0 0 1 .146-2.136 3.298 3.298 0 0 1 1.824-1.822c1.206-.491 2.703-.289 3.708.497.732.574 1.25 1.54 1.295 2.413.034.606.04.661.143.887.161.365.47.66.862.813.566.221 1.108.662 1.504 1.215.214.3.502.979.568 1.332a3.268 3.268 0 0 1-1.12 3.117c-.518.44-1.052.69-1.738.817-1.253.236-2.63-.263-3.424-1.238-.078-.092-.162-.2-.192-.236a1.822 1.822 0 0 1-.087-.117c-.035-.063-.048-.056-2.29 1.831-.84.706-1.604 1.33-1.697 1.384-.677.393-1.626.237-2.168-.358-.221-.244-1.963-2.847-2.078-3.105a1.726 1.726 0 0 1-.096-1.054z",
    fillRule: "evenodd"
  }));
};

var curbside = function curbside(_a) {
  var _a$title25 = _a.title,
      title = _a$title25 === void 0 ? '' : _a$title25,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 28 22"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M6,20 L28,20 L28,22 L4,22 L4,18 L0,18 L0,16 L4,16 L4,7 L2,7 L2,0 L7,0 L7,7 L5,7 L5,16 L6,16 L6,20 Z M6,1 L3,1 L3,6 L6,6 L6,1 Z"
  }), React__default.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Car",
    transform: "translate(7.000000, 6.000000)"
  }, React__default.createElement("path", {
    d: "M16,6 C17.1045695,6 18,6.8954305 18,8 L18,12 L-4.01360012e-08,12 L-4.01360012e-08,8 C-4.01360013e-08,6.8954305 0.89543046,6 1.99999996,6 L16,6 Z M2.49999996,8 C1.67157284,8 0.99999996,8.44771525 0.99999996,9 C0.99999996,9.55228475 1.67157284,10 2.49999996,10 C3.32842708,10 3.99999996,9.55228475 3.99999996,9 C3.99999996,8.44771525 3.32842708,8 2.49999996,8 Z M15.5,8 C14.6715728,8 14,8.44771525 14,9 C14,9.55228475 14.6715728,10 15.5,10 C16.3284271,10 17,9.55228475 17,9 C17,8.44771525 16.3284271,8 15.5,8 Z",
    id: "Combined-Shape"
  }), React__default.createElement("rect", {
    id: "Rectangle",
    x: "16",
    y: "12",
    width: "2",
    height: "2"
  }), React__default.createElement("rect", {
    id: "Rectangle",
    x: "-4.01360012e-08",
    y: "12",
    width: "2",
    height: "2"
  }), React__default.createElement("path", {
    d: "M13.2802952,-3.06421555e-14 C13.7102146,-3.00549966e-14 14.0920198,0.274787096 14.2285385,0.682455277 L16.0092611,6 L14.7562922,5.999 L13.2793232,1.49589256 C13.2215962,1.31988619 13.0725473,1.19274109 12.8950517,1.16000589 L12.8042244,1.15171665 L5.33110395,1.15171665 C5.11456275,1.15171665 4.92263135,1.29110575 4.85563605,1.49702254 L4.85563605,1.49702254 L3.39029219,5.999 L2.01929219,6 L3.77336691,0.686521526 C3.90863187,0.276774172 4.2914654,-3.08959577e-14 4.72296221,-3.06421555e-14 L13.2802952,-3.06421555e-14 Z",
    id: "Combined-Shape"
  })));
};

var deleteCredit = function deleteCredit(_a) {
  var _a$title26 = _a.title,
      title = _a$title26 === void 0 ? '' : _a$title26,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M5.64705882,11.2941176 L18.3529411,11.2941176 L18.3529411,12.7058824 L5.64705882,12.7058824 L5.64705882,11.2941176 Z"
  }), ' ');
};

var delivery = function delivery(_a) {
  var _a$title27 = _a.title,
      title = _a$title27 === void 0 ? '' : _a$title27,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m19 7c0-1.1-0.9-2-2-2h-3v2h3v2.65l-3.48 4.35h-3.52v-5h-4c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48l4.52-5.65v-3.35zm-12 10c-0.55 0-1-0.45-1-1h2c0 0.55-0.45 1-1 1zm3-11h-5v2h5v-2zm6 10c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3zm2 0c0 0.55 0.45 1 1 1s1-0.45 1-1-0.45-1-1-1-1 0.45-1 1z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

var deliveryPLK = function deliveryPLK(_a) {
  var _a$title28 = _a.title,
      title = _a$title28 === void 0 ? '' : _a$title28,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 89 72"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M39.39,53.17c1.15-0.95,2.13-2.08,3.08-3.16c0.18-0.21,0.37-0.42,0.55-0.63c0.26-0.29,0.56-0.54,0.89-0.8\n\t\t\tc0.15-0.12,0.29-0.23,0.43-0.36c0.03-0.02,0.06-0.04,0.09-0.06c0.08-0.05,0.18-0.12,0.26-0.22c0.59-0.73,1.35-1.23,2.09-1.66\n\t\t\tc0.11-0.05,0.27-0.12,0.46-0.21c0.94-0.42,3.44-1.55,4.01-1.6c0.28-0.02,0.54-0.15,0.79-0.28c0.12-0.06,0.23-0.12,0.34-0.16\n\t\t\tc0.11-0.04,0.22-0.09,0.32-0.13c0.27-0.12,0.52-0.23,0.73-0.23c0.88-0.03,1.89-0.03,2.81,0.22c0.08,0.02,0.15,0.05,0.23,0.07\n\t\t\tc0.22,0.07,0.46,0.15,0.72,0.16c0.99,0.03,1.87,0.14,2.69,0.35c0.05,0.01,0.1,0.02,0.14,0.03c0.18,0.04,0.36,0.08,0.49,0.15\n\t\t\tc1.01,0.59,2.09,1.26,3.4,2.11c0.47,0.31,0.9,0.7,1.32,1.09c0.14,0.13,0.29,0.26,0.43,0.39c0.14,0.12,0.22,0.24,0.24,0.34\n\t\t\tc0.05,0.27,0.17,0.5,0.36,0.72c0.34,0.9,0.85,2.24,0.97,2.95c0.08,0.48,0.1,1.83,0.11,2.92c0.01,0.47,1.18,0.21,2.42-0.46\n\t\t\tc5.57-4.53,9.1-11.93,5.37-21.71c-2.87-7.51-8.95-18.72-8.95-18.72l0.07-0.02c2.41-0.61,2.87-3.73,0.06-5.41l2.01-1.86L65.4,5.78\n\t\t\tl1.1-4.02l-6.31,2.5c0.01-0.01,0.02-0.01,0.02-0.01s-1.6-3.34-4.03-3.36c-2.05-0.02-3.02,1.46-3.02,1.46s-0.55-1.52-1.95-1.94\n\t\t\tc-1.4-0.42-3.69,0.4-3.98,2.95c-0.33,2.85,1.98,4.32,2.74,4.56c0.9,0.29,2.14,0.87,4.75-0.23c0,2.62-0.01,8.69-0.02,11.74\n\t\t\tc-0.01,3.95,0.35,10.37-1.35,13.84c-1.7,3.48-3.63,4.92-6.19,4.62c-2.86-0.34-3.84-3.02-2.85-7.99c0.99-4.97,1.83-9.92-2.34-13.61\n\t\t\tc-4.17-3.69-11.67-4.09-20.33,6.36l5.66,6.83c0,0,3.03-4.45,6.76-1.46c3.73,2.98,1.12,9.11,0.78,12.64\n\t\t\tc-0.44,4.49,0.67,8.12,2.48,11.01c0.37,0.59,0.82,1.15,1.33,1.7C38.99,53.48,39.2,53.32,39.39,53.17z M60.74,6.69\n\t\t\tc0.64-0.33,1.47-0.01,1.84,0.71c0.37,0.72,0.15,1.58-0.5,1.91c-0.64,0.33-1.47,0.01-1.84-0.71C59.87,7.87,60.09,7.02,60.74,6.69z"
  }), React__default.createElement("path", {
    d: "M35.68,55.55c-0.23-0.02-0.45-0.02-0.68-0.02c-0.61-0.01-1.22,0.03-1.82,0.06c-0.09,0-0.17,0.01-0.26,0.01\n\t\t\t\tc-2.75,0.14-5.5,0.39-8.24,0.45c-2.86,0.07-5.71,0.16-8.57,0.28c-6.6,0.27-5.21,1.35-0.48,1.4c3.45,0.04,6.91,0.05,10.37,0.06\n\t\t\t\tc2.2,0.01,4.41,0.08,6.61,0.12c1.08,0.02,2.16,0.03,3.24,0.02c0.48,0,0.97-0.06,1.44-0.05c0.35,0,0.84,0.05,1.17-0.09\n\t\t\t\tc0.11-0.05,0.2-0.18,0.15-0.3c-0.03-0.08-0.11-0.13-0.19-0.17c-0.64-0.36-1.2-0.88-1.6-1.49c-0.03-0.04-0.06-0.09-0.1-0.12\n\t\t\t\tc-0.05-0.03-0.11-0.05-0.17-0.06C36.25,55.6,35.96,55.57,35.68,55.55z"
  }), React__default.createElement("path", {
    d: "M36.31,61.68c-2.98-0.2-6.27,0.19-9.17,0.48c-3.1,0.3-2.45,1.5-0.22,1.56c1.62,0.08,3.27,0.06,4.89,0.07\n\t\t\t\tc1.83,0.01,3.62,0.07,5.42-0.15c0.05-0.01,0.1-0.01,0.14-0.04c0.04-0.03,0.05-0.06,0.06-0.1c0.15-0.52,0.17-1.05,0.08-1.57\n\t\t\t\tc-0.01-0.04-0.02-0.08-0.05-0.11c-0.04-0.03-0.11-0.04-0.17-0.05C36.97,61.73,36.64,61.7,36.31,61.68z"
  }), React__default.createElement("path", {
    d: "M22.06,52.12c1.55,0.03,3.1,0.05,4.65,0.06c0.94,0.01,1.93-0.02,2.86,0.08c0.8,0.09,1.61-0.05,2.43,0.03\n\t\t\t\tc0.37,0.04,0.78,0.09,1.09-0.13c-0.31-0.43-0.49-0.94-0.52-1.46c0-0.08-0.01-0.16-0.07-0.21c-0.05-0.04-0.12-0.04-0.19-0.04\n\t\t\t\tc-1.61,0.03-3.22-0.06-4.85,0.01c-1.73,0.07-3.45,0.18-5.18,0.32C19.19,51.03,19.84,52.08,22.06,52.12z"
  }), React__default.createElement("path", {
    d: "M65.14,56.44c-0.02-0.27-0.04-0.54-0.06-0.82c-0.08-1.06-0.15-2.03-0.21-2.32c-0.08-0.35-0.38-0.94-0.7-1.56\n\t\t\t\tc-0.13-0.25-0.29-0.51-0.39-0.77c-0.09-0.25-0.08-0.53-0.23-0.76c-0.09-0.13-0.22-0.22-0.36-0.3c-0.34-0.22-0.64-0.43-0.87-0.77\n\t\t\t\tc-0.23-0.36-0.4-0.75-0.7-1.05c-0.09-0.09-0.18-0.18-0.25-0.27c-0.15-0.18-0.36-0.34-0.6-0.45c-0.42-0.2-2.21-0.91-2.73-1.04\n\t\t\t\tc-0.53-0.2-1.03-0.43-1.6-0.37C56,46.02,55.62,46,55.2,45.94c-0.64-0.1-1.32-0.07-2,0.07c-0.11,0.02-0.21,0.05-0.31,0.08\n\t\t\t\tc-1.02,0.28-2.02,0.64-2.98,1.07c-1.01,0.46-1.96,1.05-2.87,1.69c-1.02,0.71-2.04,1.33-2.88,2.25c-0.68,0.75-1.46,1.57-1.99,2.43\n\t\t\t\tc-0.18,0.3-0.36,0.59-0.54,0.89c-0.21,0.34-0.43,0.74-0.42,1.24c0,0.07-0.01,0.13-0.01,0.2c-0.05,0.07-0.1,0.14-0.16,0.21\n\t\t\t\tc-0.28,0.31-0.34,0.63-0.34,0.89c-0.08,0.26-0.06,0.5-0.02,0.68c0.01,0.05,0.01,0.11,0.02,0.16c0.08,0.6-0.34,1.32-0.33,1.96\n\t\t\t\tc0.01,0.83,0.02,1.64,0.17,2.47c0.02,0.12,0.06,0.36,0.11,0.66c0.17,1.04,0.32,2.01,0.41,2.29c0.11,0.34,0.46,0.9,0.83,1.49\n\t\t\t\tc0.15,0.24,0.34,0.48,0.46,0.73c0.12,0.24,0.12,0.52,0.3,0.73c0.1,0.12,0.24,0.2,0.38,0.27c0.36,0.19,0.68,0.37,0.93,0.69\n\t\t\t\tc0.26,0.34,0.46,0.71,0.79,0.99c0.1,0.08,0.19,0.16,0.28,0.25c0.17,0.17,0.39,0.31,0.63,0.4c0.44,0.16,2.28,0.72,2.81,0.8\n\t\t\t\tc0.54,0.15,1.06,0.34,1.63,0.23c0.42-0.08,0.8-0.1,1.23-0.07c0.65,0.04,1.33-0.04,1.98-0.25c0.1-0.03,0.2-0.07,0.31-0.1\n\t\t\t\tc0.99-0.36,1.96-0.81,2.88-1.32c0.97-0.54,1.86-1.22,2.72-1.93c0.57-0.48,1.16-0.94,1.71-1.45c0.3-0.28,0.67-0.45,0.98-0.71\n\t\t\t\tc0.4-0.32,0.58-0.71,0.88-1.12c0.2-0.28,0.41-0.56,0.62-0.84c0.24-0.32,0.49-0.7,0.52-1.2c0.02-0.3,0.15-0.59,0.37-0.83\n\t\t\t\tc0.36-0.39,0.36-0.81,0.33-1.09c-0.02-0.17-0.01-0.35,0-0.53c0.24-0.35,0.25-0.68,0.21-0.94c0.02-0.05,0.03-0.1,0.05-0.15\n\t\t\t\tC65.19,58.32,65.19,57.39,65.14,56.44z M63.07,58.24c-0.16,0.62-0.25,1.12-0.29,1.58c-0.03,0.31-0.14,0.6-0.32,0.8\n\t\t\t\tc-0.65,0.73-1.18,1.56-1.7,2.36c-0.1,0.15-0.2,0.31-0.3,0.46c-0.14,0.21-0.31,0.4-0.5,0.61c-0.08,0.09-0.17,0.18-0.25,0.27\n\t\t\t\tc-0.02,0.02-0.03,0.03-0.05,0.05c-0.05,0.04-0.1,0.09-0.15,0.17c-0.32,0.53-0.76,0.93-1.2,1.28c-0.07,0.04-0.16,0.1-0.28,0.18\n\t\t\t\tc-0.57,0.37-2.08,1.34-2.45,1.43c-0.02,0-0.03,0.01-0.05,0.01c-0.16,0.05-0.3,0.15-0.44,0.25c-0.07,0.05-0.14,0.1-0.21,0.14\n\t\t\t\tc-0.07,0.04-0.13,0.08-0.2,0.12c-0.16,0.1-0.32,0.2-0.46,0.22c-0.57,0.1-1.23,0.2-1.85,0.13c-0.05-0.01-0.1-0.01-0.16-0.02\n\t\t\t\tc-0.15-0.03-0.31-0.05-0.48-0.03c-0.58,0.07-3.73-0.66-4.63-1.07c-0.34-0.15-0.66-0.37-0.96-0.58c-0.11-0.07-0.21-0.14-0.32-0.21\n\t\t\t\tc-0.1-0.06-0.17-0.13-0.19-0.2c-0.06-0.17-0.16-0.31-0.3-0.43c-0.31-0.55-0.77-1.37-0.92-1.82c-0.1-0.3-0.24-1.18-0.35-1.89\n\t\t\t\tc-0.08-0.49-0.15-0.91-0.19-1.12c-0.07-0.33-0.09-0.67-0.11-1.01c-0.02-0.31-0.03-0.64-0.1-0.95c-0.05-0.24-0.03-0.51,0.04-0.78\n\t\t\t\tc0.16-0.62,0.25-1.12,0.29-1.58c0.03-0.31,0.14-0.6,0.32-0.8c0.65-0.73,1.18-1.56,1.7-2.36c0.1-0.15,0.2-0.31,0.3-0.46\n\t\t\t\tc0.14-0.21,0.31-0.4,0.5-0.61c0.08-0.09,0.17-0.18,0.25-0.27c0.02-0.02,0.03-0.03,0.05-0.05c0.05-0.04,0.1-0.09,0.15-0.17\n\t\t\t\tc0.32-0.53,0.76-0.93,1.2-1.28c0.07-0.04,0.16-0.1,0.28-0.18c0.57-0.37,2.09-1.34,2.45-1.43c0.18-0.04,0.33-0.15,0.48-0.26\n\t\t\t\tc0.07-0.05,0.14-0.1,0.21-0.14c0.07-0.04,0.13-0.08,0.2-0.12c0.16-0.1,0.32-0.2,0.46-0.22c0.57-0.1,1.23-0.21,1.84-0.13\n\t\t\t\tc0.05,0.01,0.1,0.02,0.16,0.02c0.15,0.03,0.31,0.05,0.48,0.03c0.65-0.08,1.23-0.09,1.78-0.03c0.03,0,0.06,0,0.09,0.01\n\t\t\t\tc0.12,0.01,0.24,0.02,0.33,0.05c0.72,0.29,1.48,0.62,2.42,1.04c0.34,0.15,0.66,0.37,0.97,0.58c0.11,0.07,0.21,0.14,0.32,0.21\n\t\t\t\tc0.1,0.06,0.17,0.13,0.19,0.2c0.06,0.17,0.16,0.31,0.3,0.43c0.31,0.55,0.77,1.37,0.92,1.82c0.1,0.3,0.24,1.18,0.35,1.89\n\t\t\t\tc0.08,0.49,0.15,0.91,0.19,1.12c0.07,0.33,0.09,0.67,0.11,1.01c0.02,0.31,0.03,0.64,0.09,0.95\n\t\t\t\tC63.16,57.69,63.15,57.96,63.07,58.24z"
  }), React__default.createElement("polygon", {
    points: "63.76,68.96 64.31,68.96 64.31,70.61 64.56,70.61 64.56,68.96 65.12,68.96 65.12,68.72 63.76,68.72"
  }), React__default.createElement("polygon", {
    points: "66.3,70.08 65.71,68.72 65.39,68.72 65.39,70.61 65.63,70.61 65.63,69.09 66.18,70.35 66.42,70.35\n\t\t\t66.98,69.09 66.98,70.61 67.22,70.61 67.22,68.72 66.89,68.72"
  }));
};

var desserts = function desserts(_a) {
  var _a$title29 = _a.title,
      title = _a$title29 === void 0 ? '' : _a$title29,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 68 49"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M44.703 4.53c.259-1.913 2.144-3.383 4.198-3.746A4.439 4.439 0 0 1 54.108 4.9a4.432 4.432 0 0 1 2.28-1.142 4.439 4.439 0 0 1 5.094 5.386c.403-.215.846-.37 1.32-.454a4.439 4.439 0 0 1 5.147 3.594 4.439 4.439 0 0 1-3.952 5.185l.003.005L.053 29.233 44.703 4.53zM.053 31.5L67.95 20v16.773a2 2 0 0 1-1.709 1.979l-63.895 9.41a2 2 0 0 1-2.292-1.978V31.5z",
    fillRule: "evenodd"
  }));
};

var dineIn = function dineIn(_a) {
  var _a$title30 = _a.title,
      title = _a$title30 === void 0 ? '' : _a$title30,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 106 67",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), React__default.createElement("title", null, title), React__default.createElement("circle", {
    cx: "55",
    cy: "34",
    r: "30"
  }), React__default.createElement("path", {
    d: "M99,45.2V64c0,1.7-1.3,3-3,3s-3-1.3-3-3V4c0-0.3,0-0.6,0.1-0.8L93,1.6C93,0.7,93.7,0,94.6,0h0.7\n\tc7,0,10.7,21.9,10.7,43.6c0,0.9-0.7,1.6-1.6,1.6H99z"
  }), React__default.createElement("path", {
    d: "M14,14.7V16c0,0.6,0.4,1,1,1s1-0.4,1-1V4c0-1.7,1.3-3,3-3s3,1.3,3,3v13c0,4.1-3.6,8.2-8,9.5V64c0,1.7-1.3,3-3,3\n\ts-3-1.3-3-3V26.4c-4.6-1.2-8-6-8-9.3L0,4c0-1.7,1.3-3,3-3s3,1.3,3,3v12c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.4V4c0-1.7,1.3-3,3-3s3,1.3,3,3\n\tV14.7z"
  }));
};

var discover = function discover(_a) {
  var _a$title31 = _a.title,
      title = _a$title31 === void 0 ? '' : _a$title31,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 32 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("defs", null, React__default.createElement("rect", {
    id: "path-1",
    x: "-3.55271368e-15",
    y: "0",
    width: "32",
    height: "20",
    rx: "2"
  }), React__default.createElement("path", {
    d: "M8.28458443,1.65286575 C8.28458443,2.57378152 8.95636181,3.26180411 9.85264965,3.26180411 C10.7268874,3.26180411 11.4169563,2.56468413 11.4169563,1.6708006 C11.4169563,0.782895367 10.7313976,0.085255538 9.85264965,0.085255538 C8.98668074,0.085255538 8.28458443,0.786794249 8.28458443,1.65286575 Z",
    id: "path-3"
  }), React__default.createElement("filter", {
    x: "-16.0%",
    y: "-15.7%",
    width: "131.9%",
    height: "131.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, React__default.createElement("feGaussianBlur", {
    stdDeviation: "0.5",
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), React__default.createElement("feOffset", {
    dx: "0",
    dy: "0",
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), React__default.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1",
    result: "shadowInnerInner1"
  }), React__default.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  }))), React__default.createElement("g", {
    id: "icon-/-card-/-discovery",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "discover"
  }, React__default.createElement("mask", {
    id: "mask-discover",
    fill: "white"
  }, React__default.createElement("use", {
    xlinkHref: "#path-1"
  })), React__default.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), React__default.createElement("g", {
    mask: "url(#mask-discover)"
  }, React__default.createElement("g", {
    transform: "translate(6.000000, 7.000000)"
  }, React__default.createElement("path", {
    d: "M23.9991358,13 C25.1041826,13 25.9994727,12.1132936 25.9988117,11.0018986 L25.9952424,5 C23.8894584,6.25934099 15.9514946,10.6013121 3,13 L23.9991358,13 Z",
    id: "pointed",
    fill: "#F58220"
  }), React__default.createElement("g", {
    id: "logo",
    strokeWidth: "1",
    fill: "none",
    transform: "translate(0.058669, 0.823930)"
  }, React__default.createElement("g", {
    id: "registered",
    transform: "translate(18.291589, 0.140793)",
    fill: "#231F20"
  }, React__default.createElement("path", {
    d: "M0.768670649,0.443438941 C0.768670649,0.335057843 0.700314923,0.274787379 0.574081356,0.274787379 L0.407932036,0.274787379 L0.407932036,0.82250844 L0.530174028,0.82250844 L0.530174028,0.609447062 L0.674369684,0.82250844 L0.828045331,0.82250844 L0.655409701,0.596229855 C0.72825595,0.575611012 0.768670649,0.519570054 0.768670649,0.443438941 L0.768670649,0.443438941 Z M0.553125586,0.517455301 L0.530174028,0.517455301 L0.530174028,0.376295529 L0.554622426,0.376295529 C0.614995002,0.376295529 0.64592971,0.399029125 0.64592971,0.445553694 C0.64592971,0.49313564 0.613498161,0.517455301 0.553125586,0.517455301 L0.553125586,0.517455301 Z",
    id: "r"
  }), React__default.createElement("path", {
    d: "M0.61771148,0.0848512096 C0.36773908,0.0848512096 0.168160318,0.297383899 0.168160318,0.562785418 C0.168160318,0.827129559 0.368736974,1.04019094 0.61771148,1.04019094 C0.862694411,1.04019094 1.06277212,0.825014806 1.06277212,0.562785418 C1.06277212,0.300556029 0.862694411,0.0848512096 0.61771148,0.0848512096 L0.61771148,0.0848512096 Z M0.617212533,0.954014747 C0.417633771,0.954014747 0.25647392,0.78060499 0.25647392,0.563842794 C0.25647392,0.344965845 0.416635877,0.171556088 0.617212533,0.171556088 C0.812300774,0.171556088 0.971963784,0.348137975 0.971963784,0.563842794 C0.971963784,0.778490237 0.812300774,0.954014747 0.617212533,0.954014747 L0.617212533,0.954014747 Z",
    id: "Fill-12"
  })), React__default.createElement("path", {
    d: "M18.2893317,1.04282079 C18.2893317,0.470984862 17.9104703,0.142179205 17.2487157,0.142179205 L16.3972798,0.142179205 L16.3972798,3.19318379 L16.9710844,3.19318379 L16.9710844,1.96711558 L17.0462553,1.96711558 L17.839559,3.19318379 L18.5454139,3.19318379 L17.6185566,1.90785259 C18.051541,1.81635884 18.2893317,1.50990677 18.2893317,1.04282079 L18.2893317,1.04282079 Z M17.1379639,1.54629633 L16.9710844,1.54629633 L16.9710844,0.622001532 L17.1474855,0.622001532 C17.5050485,0.622001532 17.6994906,0.77821671 17.6994906,1.07479162 C17.6994906,1.38124369 17.5050485,1.54629633 17.1379639,1.54629633 L17.1379639,1.54629633 Z",
    id: "r",
    fill: "#231F20"
  }), React__default.createElement("polyline", {
    id: "e",
    fill: "#231F20",
    points: "14.3914693 3.19318379 16.018669 3.19318379 16.018669 2.67645206 14.9647728 2.67645206 14.9647728 1.85248847 15.9785778 1.85248847 15.9785778 1.33627659 14.9647728 1.33627659 14.9647728 0.658910942 16.018669 0.658910942 16.018669 0.142179205 14.3914693 0.142179205 14.3914693 3.19318379"
  }), React__default.createElement("polyline", {
    id: "v",
    fill: "#231F20",
    points: "12.7149074 2.19169115 11.9296219 0.142179205 11.3034482 0.142179205 12.5520371 3.27142135 12.8604884 3.27142135 14.1308768 0.142179205 13.5092134 0.142179205 12.7149074 2.19169115"
  }), React__default.createElement("g", {
    id: "Fill-1"
  }, React__default.createElement("use", {
    fill: "#F48027",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), React__default.createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), React__default.createElement("path", {
    d: "M5.79517439,1.66924105 C5.79517439,2.56676353 6.47471944,3.26180411 7.34770429,3.26180411 C7.59501659,3.26180411 7.80649743,3.2116385 8.06708992,3.08349527 L8.06708992,2.38351611 C7.83706693,2.62160779 7.63435604,2.71700042 7.37401411,2.71700042 C6.79645094,2.71700042 6.38601776,2.28240512 6.38601776,1.66456239 C6.38601776,1.0797302 6.80922999,0.617322874 7.34770429,0.617322874 C7.62082527,0.617322874 7.82829699,0.718433863 8.06708992,0.96042443 L8.06708992,0.260445272 C7.81576851,0.127883307 7.60779565,0.0735588941 7.36123506,0.0735588941 C6.49200875,0.0735588941 5.79517439,0.782895367 5.79517439,1.66924105",
    id: "c",
    fill: "#231F20"
  }), React__default.createElement("path", {
    d: "M4.76808917,1.31236345 C4.42355582,1.18032134 4.32257623,1.09298639 4.32257623,0.928453603 C4.32257623,0.736628643 4.50248528,0.590290631 4.75029872,0.590290631 C4.92218954,0.590290631 5.06326028,0.663589599 5.2136021,0.83669993 L5.5130329,0.430436497 C5.26597117,0.205601008 4.97080006,0.0914937481 4.64856742,0.0914937481 C4.12863528,0.0914937481 3.73148229,0.46656613 3.73148229,0.965103087 C3.73148229,1.38644219 3.9166533,1.60114059 4.45462646,1.80232287 C4.67963806,1.8844593 4.79414842,1.93930356 4.85152888,1.97621297 C4.9662898,2.05445053 5.02392084,2.1636192 5.02392084,2.29150251 C5.02392084,2.53921144 4.833989,2.72167908 4.57790676,2.72167908 C4.30428464,2.72167908 4.08403387,2.58053958 3.95173306,2.3148958 L3.58189218,2.6860693 C3.84599265,3.08817392 4.16346446,3.26674269 4.60045803,3.26674269 C5.19581165,3.26674269 5.61451363,2.85450097 5.61451363,2.26473019 C5.61451363,1.77996928 5.42107382,1.56007238 4.76808917,1.31236345",
    id: "s",
    fill: "#231F20"
  }), React__default.createElement("polygon", {
    id: "i",
    fill: "#231F20",
    points: "2.79209646 0.142179205 3.36539995 0.142179205 3.36539995 3.19318379 2.79209646 3.19318379"
  }), React__default.createElement("path", {
    d: "M0.948655131,0.142179205 L0.105738639,0.142179205 L0.105738639,3.19318379 L0.944646016,3.19318379 C1.38940724,3.19318379 1.71138932,3.08349527 1.99378138,2.8415047 C2.3285425,2.55246763 2.52724428,2.11787233 2.52724428,1.66924105 C2.52724428,0.768599469 1.87851931,0.142179205 0.948655131,0.142179205 L0.948655131,0.142179205 Z M1.61943024,2.43368171 C1.43801777,2.60341301 1.20473737,2.67645206 0.833894206,2.67645206 L0.679543267,2.67645206 L0.679543267,0.658910942 L0.833894206,0.658910942 C1.20473737,0.658910942 1.42899726,0.727531253 1.61943024,0.905580166 C1.81788144,1.08882759 1.93589977,1.3721463 1.93589977,1.66456239 C1.93589977,1.95801819 1.81788144,2.25147399 1.61943024,2.43368171 L1.61943024,2.43368171 Z",
    id: "d",
    fill: "#231F20"
  })))))));
};

var drinks = function drinks(_a) {
  var _a$title32 = _a.title,
      title = _a$title32 === void 0 ? '' : _a$title32,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 38 70"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M2.2 20H35.8a2 2 0 0 1 1.991 2.189l-4.363 46A2 2 0 0 1 31.438 70H6.573a2 2 0 0 1-1.99-1.81l-4.375-46A2 2 0 0 1 2.2 20zM17 17L23.827.615A1 1 0 0 1 24.75 0h8.75a.5.5 0 0 1 .5.5v2.09a.5.5 0 0 1-.5.5h-7.485a.5.5 0 0 0-.464.316L20.123 17H17z",
    fillRule: "evenodd"
  }));
};

var driveThru = function driveThru(_a) {
  var _a$title33 = _a.title,
      title = _a$title33 === void 0 ? '' : _a$title33,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 22 15"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M20 6.2L18.2.9c-.1-.4-.5-.7-.9-.7H8.7c-.4 0-.8.3-.9.7L6 6.2c-1.1 0-2 .9-2 2V14.3c0 .3.2.5.5.5h1.6c.3 0 .5-.2.5-.5v-1.7h12.8v1.7c0 .3.2.5.5.5h1.6c.3 0 .5-.2.5-.5V8.2c0-1.1-.9-2-2-2zM8.9 1.7c.1-.2.3-.3.5-.3h7.5c.2 0 .4.1.5.3l1.5 4.5H7.4l1.5-4.5zm-2.3 9.1c-.7 0-1.2-.6-1.2-1.2S6 8.4 6.6 8.4s1.2.6 1.2 1.2-.5 1.2-1.2 1.2zm12.8 0c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2c.7 0 1.2.6 1.2 1.2s-.5 1.2-1.2 1.2zM3.4 4.1c-.1-.3-.4-.4-.6-.4l-2.4.6c-.2.1-.4.3-.4.5v.9c0 .3.2.5.5.5h.2v8.2c0 .3.2.5.5.5h.3c.3 0 .5-.2.5-.5V6.2h.9c.3 0 .5-.2.5-.5V4.2v-.1z"
  }));
};

var drive = function drive(_a) {
  var _a$title34 = _a.title,
      title = _a$title34 === void 0 ? '' : _a$title34,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m18.92 5.01c-0.2-0.59-0.76-1.01-1.42-1.01h-11c-0.66 0-1.21 0.42-1.42 1.01l-2.08 5.99v8c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-1h12v1c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-8l-2.08-5.99zm-12.42 9.99c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5zm11 0c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5zm-12.5-5 1.5-4.5h11l1.5 4.5h-14z"
  }));
};

var edit = function edit(_a) {
  var _a$title35 = _a.title,
      title = _a$title35 === void 0 ? '' : _a$title35,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 12.7 11.7"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M11.3856337,0.714290757 L12.0200062,1.39068361 C12.7756278,2.1963571 12.7350527,3.46203685 11.9293792,4.21765845 C11.9265987,4.22026624 11.9238107,4.22286609 11.9210153,4.22545794 L6.28268331,9.45323531 C4.69029811,10.9296711 2.5524454,11.6718889 0.387739568,11.4998364 L0.387739568,11.4998364 C0.404139094,9.3784854 1.29543142,7.35797546 2.85106502,5.91561518 L8.56702281,0.615864308 C9.37373077,-0.132103282 10.6330655,-0.0881270627 11.3856337,0.714290757 Z"
  }));
};

var editWithEraser = function editWithEraser(_a) {
  var _a$title36 = _a.title,
      title = _a$title36 === void 0 ? '' : _a$title36,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 13 13"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M0 10.14V12.1667C0 12.3534 0.146667 12.5 0.333333 12.5H2.36C2.44667 12.5 2.53333 12.4667 2.59333 12.4L9.87333 5.12671L7.37333 2.62671L0.1 9.90004C0.0333334 9.96671 0 10.0467 0 10.14ZM11.8067 3.19337C12.0667 2.93337 12.0667 2.51337 11.8067 2.25337L10.2467 0.693372C9.98667 0.433372 9.56667 0.433372 9.30667 0.693372L8.08667 1.91337L10.5867 4.41337L11.8067 3.19337Z"
  }));
};

var error = function error(_a) {
  var _a$title37 = _a.title,
      title = _a$title37 === void 0 ? '' : _a$title37,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m11 15h2v2h-2v-2zm0-8h2v6h-2v-6zm0.99-5c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm0.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};

var facebook = function facebook(_a) {
  var _a$title38 = _a.title,
      title = _a$title38 === void 0 ? '' : _a$title38,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m13.36 22h-4.2412v-10.002h-2.1193v-3.446h2.1193v-2.0689c0-2.8111 1.196-4.4837 4.5962-4.4837h2.8301v3.4473h-1.7688c-1.3237 0-1.4112 0.48156-1.4112 1.3803l-0.0058 1.7249h3.2052l-0.3752 3.446h-2.83v10.001h7e-4v1e-4z",
    fillRule: "evenodd"
  }));
};

var familyMeals = function familyMeals(_a) {
  var _a$title39 = _a.title,
      title = _a$title39 === void 0 ? '' : _a$title39,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 78 67"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M41.143 41h-2.366c.337-1.797.625-3.642 1.165-7.422a270.1 270.1 0 0 1 .834-5.516c.26-.117.514-.235.763-.354.308-.145.66-.3.78-.34a3.277 3.277 0 0 1 2.821.371c.264.171.477.37 1.55 1.466.667.681.836.87 1 1.118.433.66.603 1.429.497 2.227-.065.486-.132.685-.495 1.435-.822 1.71-1.454 3.262-2.329 5.813A3.288 3.288 0 0 0 44 39.5c-1.119 0-2.13.574-2.857 1.5zm-1.123 3c-.013.164-.02.331-.02.5 0 1.172.322 2.249.862 3.101h-1.956a2 2 0 0 0-1.939 2.489l3.445 13.667H2a2 2 0 0 1-2-2V44h40.02zm6.562-19.993c.002-.176.075-.459.16-.631.136-.266.315-.447.714-.717.883-.599 3.446-2.388 3.449-2.406a.586.586 0 0 0-.117-.122c-.17-.146-.494-.565-.635-.823a2.953 2.953 0 0 1-.32-1.962 2.912 2.912 0 0 1 1.299-1.974c1.01-.66 2.435-.741 3.53-.207.799.39 1.482 1.174 1.71 1.957.16.544.177.592.32.778.226.303.575.515.969.585.57.1 1.164.403 1.647.835.261.234.672.797.808 1.106.449 1.031.31 2.16-.372 3.023-.386.49-.826.812-1.432 1.049-1.108.435-2.486.227-3.427-.516-.091-.07-.192-.152-.227-.18a1.799 1.799 0 0 1-.105-.09c-.046-.051-.056-.043-1.727 2.065-.626.788-1.199 1.49-1.274 1.554-.542.476-1.451.504-2.079.06-.256-.182-2.417-2.232-2.579-2.446a1.61 1.61 0 0 1-.312-.938zM34.393 41H3.823a32.109 32.109 0 0 1-.02-.207c-.028-.345.013-2.12.058-2.496.234-1.868.706-3.429 1.51-4.993.552-1.071 1.473-2.427 2.371-3.492.433-.512 1.754-1.81 2.338-2.3 2.194-1.836 4.58-3.296 9.404-5.758 3.463-1.766 4.111-2.104 5.308-2.758 1.972-1.078 3.608-2.076 5.045-3.088.314-.218.676-.455.801-.521a3.762 3.762 0 0 1 3.214-.14c.327.137.603.314 2.014 1.306.876.616 1.1.79 1.331 1.03.613.638.953 1.447.991 2.342.023.543-.013.774-.27 1.665-.807 2.831-1.266 5.258-2.061 10.94-.453 3.223-.674 4.638-.966 6.177-.153.808-.319 1.571-.498 2.293zm.845-29.014a1.934 1.934 0 0 1 .053-.716c.097-.314.256-.543.637-.912.842-.817 3.276-3.245 3.276-3.265a.645.645 0 0 0-.15-.11c-.212-.126-.642-.518-.845-.77-.474-.591-.72-1.3-.72-2.065 0-.927.358-1.759 1.029-2.387.967-.907 2.496-1.267 3.785-.898.94.27 1.829.988 2.225 1.794.278.558.306.607.496.782.303.285.721.447 1.161.447.637 0 1.339.216 1.944.59.328.204.88.736 1.086 1.044.684 1.032.75 2.282.175 3.346-.325.605-.74 1.038-1.351 1.41-1.117.683-2.65.721-3.81.096-.113-.058-.238-.128-.281-.151a1.979 1.979 0 0 1-.131-.078c-.06-.047-.069-.035-1.476 2.566-.528.974-1.015 1.844-1.083 1.928-.496.62-1.476.823-2.24.462-.313-.148-3.046-1.956-3.262-2.157a1.77 1.77 0 0 1-.518-.956z"
  }), React__default.createElement("path", {
    d: "M40.534 49.91h35.868a1 1 0 0 1 .967 1.253L73.6 65.508A2 2 0 0 1 71.663 67H45.811a2 2 0 0 1-1.915-1.425l-4.32-14.378a1 1 0 0 1 .958-1.288zm16.17-11.733A2.943 2.943 0 0 1 59.062 37c.964 0 1.82.462 2.357 1.177a2.947 2.947 0 0 1 5.259 1.247A2.946 2.946 0 0 1 70.26 42.3a2.946 2.946 0 0 1 4.715 2.356A2.946 2.946 0 0 1 72 47.598H44.916a2.946 2.946 0 0 1-2.947-2.944 2.946 2.946 0 0 1 4.716-2.355 2.946 2.946 0 0 1 4.715-2.356 2.946 2.946 0 0 1 5.304-1.767z"
  })));
};

var fastFood = function fastFood(_a) {
  var _a$title40 = _a.title,
      title = _a$title40 === void 0 ? '' : _a$title40,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m18.06 22.99h1.66c0.84 0 1.53-0.64 1.63-1.46l1.65-16.48h-5v-4.05h-1.97v4.05h-4.97l0.3 2.34c1.71 0.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zm-17.06-1v-0.99h15.03v0.99c0 0.55-0.45 1-1.01 1h-13.01c-0.56 0-1.01-0.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zm-15.01 2.01h15v2h-15v-2z"
  }));
};

var favorite = function favorite(_a) {
  var _a$title41 = _a.title,
      title = _a$title41 === void 0 ? '' : _a$title41,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z"
  }));
};

var favoriteFill = function favoriteFill(_a) {
  var _a$title42 = _a.title,
      title = _a$title42 === void 0 ? '' : _a$title42,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z"
  }));
};

var gear = function gear(_a) {
  var _a$title43 = _a.title,
      title = _a$title43 === void 0 ? '' : _a$title43,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 19 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M11.323.685l.314 2.046c1.22.342 2.327.971 3.235 1.826l1.972-.757c.357-.137.773-.06.975.28l1.086 1.84c.202.342.062.732-.237.964l-1.657 1.29a7.426 7.426 0 0 1 0 3.653l1.657 1.289c.299.232.44.622.237.964l-1.086 1.84c-.202.34-.618.417-.975.28l-1.972-.757a7.777 7.777 0 0 1-3.235 1.826l-.314 2.046c-.057.371-.333.685-.737.685H8.414c-.404 0-.68-.314-.737-.685l-.314-2.046a7.762 7.762 0 0 1-3.235-1.826l-1.972.757c-.357.137-.773.06-.975-.28L.095 14.08c-.202-.342-.062-.732.237-.964l1.657-1.29a7.426 7.426 0 0 1 0-3.653L.332 6.884c-.299-.232-.44-.622-.237-.964L1.18 4.08c.1-.169.254-.273.428-.32a.906.906 0 0 1 .547.04l1.972.757a7.762 7.762 0 0 1 3.235-1.826L7.677.685C7.734.314 8.01 0 8.414 0h2.172c.404 0 .68.314.737.685zm.982 6.573c-1.55-1.514-4.062-1.514-5.61 0a3.815 3.815 0 0 0 0 5.484c1.548 1.514 4.06 1.514 5.61 0a3.815 3.815 0 0 0 0-5.484z",
    fillRule: "nonzero"
  }));
};

var googlePay = function googlePay(_a) {
  var _a$title44 = _a.title,
      title = _a$title44 === void 0 ? '' : _a$title44,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 425 272"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "GooglePay"
  }, React__default.createElement("g", {
    id: "border"
  }, React__default.createElement("path", {
    d: "M386.731012,0.0897642745 L38.039747,0.0897642745 C36.587241,0.0897642745 35.1321687,0.0897642745 33.6822289,0.0974583552 C32.4581205,0.107717129 31.2365783,0.120540597 30.0124699,0.153881613 C27.3461205,0.225693033 24.6566747,0.38213934 22.0236867,0.856607648 C19.3496386,1.33620534 16.8603614,2.12100157 14.4326747,3.35718387 C12.0434819,4.57028392 9.85959036,6.15782923 7.96312048,8.05057307 C6.06921687,9.94588161 4.4806988,12.1258711 3.26685542,14.5161655 C2.02991566,16.9423656 1.24463855,19.4301184 0.767313253,22.1050938 C0.289987952,24.739034 0.133445783,27.4242682 0.0615903614,30.0864201 C0.0282289157,31.3097789 0.0128313253,32.5305731 0.00513253012,33.7513672 C-0.00256626506,35.2029838 1.08420217e-19,36.6546003 1.08420217e-19,38.1087816 L1.08420217e-19,233.841064 C1.08420217e-19,235.295246 -0.00256626506,236.744298 0.00513253012,238.198479 C0.0128313253,239.419273 0.0282289157,240.642632 0.0615903614,241.863426 C0.133445783,244.523013 0.289987952,247.210812 0.767313253,249.842188 C1.24463855,252.517163 2.02991566,255.004916 3.26685542,257.43368 C4.4806988,259.82141 6.06921687,262.003964 7.96312048,263.896708 C9.85959036,265.792017 12.0434819,267.379562 14.4326747,268.590097 C16.8603614,269.828844 19.3496386,270.613641 22.0236867,271.095803 C24.6566747,271.565142 27.3461205,271.724153 30.0124699,271.795964 C31.2365783,271.824176 32.4581205,271.842129 33.6822289,271.847258 C35.1321687,271.857517 36.587241,271.857517 38.039747,271.857517 L386.731012,271.857517 C388.180952,271.857517 389.636024,271.857517 391.085964,271.847258 C392.307506,271.842129 393.529048,271.824176 394.758289,271.795964 C397.419506,271.724153 400.108952,271.565142 402.747072,271.095803 C405.418554,270.613641 407.907831,269.828844 410.338084,268.590097 C412.727277,267.379562 414.906036,265.792017 416.805072,263.896708 C418.69641,262.003964 420.284928,259.82141 421.501337,257.43368 C422.740843,255.004916 423.52612,252.517163 424.00088,249.842188 C424.478205,247.210812 424.632181,244.523013 424.704036,241.863426 C424.737398,240.642632 424.752795,239.419273 424.760494,238.198479 C424.770759,236.744298 424.770759,235.295246 424.770759,233.841064 L424.770759,38.1087816 C424.770759,36.6546003 424.770759,35.2029838 424.760494,33.7513672 C424.752795,32.5305731 424.737398,31.3097789 424.704036,30.0864201 C424.632181,27.4242682 424.478205,24.739034 424.00088,22.1050938 C423.52612,19.4301184 422.740843,16.9423656 421.501337,14.5161655 C420.284928,12.1258711 418.69641,9.94588161 416.805072,8.05057307 C414.906036,6.15782923 412.727277,4.57028392 410.338084,3.35718387 C407.907831,2.12100157 405.418554,1.33620534 402.747072,0.856607648 C400.108952,0.38213934 397.419506,0.225693033 394.758289,0.153881613 C393.529048,0.120540597 392.307506,0.107717129 391.085964,0.0974583552 C389.636024,0.0897642745 388.180952,0.0897642745 386.731012,0.0897642745",
    id: "Fill-1",
    fill: "#3C4043"
  }), React__default.createElement("path", {
    d: "M386.731012,9.14826192 L391.021807,9.155956 C392.181759,9.16365008 393.344277,9.17647355 394.511928,9.20981456 C396.54441,9.26367313 398.923337,9.37395495 401.14059,9.77148245 C403.065289,10.1177161 404.682036,10.646043 406.23206,11.4334039 C407.76412,12.210506 409.165301,13.2312541 410.38941,14.4520482 C411.618651,15.6831011 412.640024,17.0859885 413.427867,18.6324987 C414.213145,20.1713148 414.736663,21.776813 415.083108,23.7157213 C415.478313,25.9085343 415.588663,28.2911346 415.642554,30.3351954 C415.675916,31.4867428 415.691313,32.6408549 415.696446,33.8231786 C415.706711,35.2517129 415.706711,36.6776826 415.706711,38.1087816 L415.706711,233.841064 C415.706711,235.272163 415.706711,236.698133 415.696446,238.154879 C415.691313,239.308991 415.675916,240.463103 415.642554,241.61978 C415.588663,243.658711 415.478313,246.041312 415.077976,248.257207 C414.736663,250.170468 414.213145,251.775966 413.422735,253.322477 C412.637458,254.866422 411.618651,256.266745 410.394542,257.490104 C409.162735,258.721157 407.766687,259.736775 406.216663,260.521572 C404.676904,261.306368 403.065289,261.834695 401.158554,262.175799 C398.895108,262.578456 396.418663,262.691302 394.552988,262.740031 C393.380205,262.768243 392.212554,262.783631 391.014108,262.788761 C389.589831,262.799019 388.157855,262.799019 386.731012,262.799019 L38.039747,262.799019 C38.0217831,262.799019 38.0038193,262.799019 37.9832892,262.799019 C36.5744096,262.799019 35.1603976,262.799019 33.7258554,262.788761 C32.5556386,262.783631 31.387988,262.768243 30.2588313,262.742596 C28.3495301,262.691302 25.8705181,262.578456 23.6276024,262.178364 C21.7029036,261.834695 20.0912892,261.306368 18.531,260.511313 C16.9963735,259.734211 15.6003253,258.718592 14.3685181,257.484974 C13.1469759,256.266745 12.1307349,254.868987 11.3454578,253.322477 C10.5576145,251.778531 10.0315301,250.167904 9.68508434,248.23156 C9.28731325,246.018229 9.17696386,243.648453 9.12050602,241.61978 C9.08971084,240.460539 9.07687952,239.298732 9.06918072,238.147185 L9.06404819,234.741272 L9.06404819,37.2111388 L9.06918072,33.8129199 C9.07687952,32.6511137 9.08971084,31.4918722 9.12050602,30.3326307 C9.17696386,28.3013934 9.28731325,25.9290519 9.69021687,23.6977685 C10.0315301,21.7819424 10.5576145,20.1687501 11.3480241,18.6171105 C12.1281687,17.0834238 13.1469759,15.6831011 14.3736506,14.4571776 C15.597759,13.2312541 17.001506,12.2156354 18.5438313,11.4308392 C20.0861566,10.6434783 21.7029036,10.1177161 23.6276024,9.77148245 C25.8448554,9.37395495 28.2237831,9.26367313 30.2613976,9.20981456 C31.4213494,9.17647355 32.5838675,9.16365008 33.7361205,9.155956 L38.039747,9.14826192 L386.731012,9.14826192",
    id: "wihit-fill",
    fill: "#FFFFFE"
  })), React__default.createElement("g", {
    id: "GPay-logo",
    transform: "translate(48.759036, 76.981132)"
  }, React__default.createElement("g", {
    id: "Pay",
    transform: "translate(143.569904, 7.624798)",
    fill: "#3C4043"
  }, React__default.createElement("path", {
    d: "M12.1771332,57.6434717 L12.1771332,96.3774447 L0.0751674892,96.3774447 L0.0751674892,0.762479784 L32.1716854,0.762479784 C39.9139368,0.609983827 47.4306857,3.58365499 52.9179124,9.07350943 C63.8923658,19.4432345 64.5688732,36.9040216 54.2709272,48.1124744 C53.8199223,48.5699623 53.3689173,49.0274501 52.9179124,49.484938 C47.2803507,54.8985445 40.3649417,57.6434717 32.1716854,57.6434717 L12.1771332,57.6434717 Z M12.1771332,12.5046685 L12.1771332,45.901283 L32.4723553,45.901283 C36.9824047,46.053779 41.342119,44.2238275 44.4239861,40.9451644 C50.7380552,34.3115903 50.5877202,23.6368733 44.0481487,17.2320431 C40.9662816,14.182124 36.8320697,12.5046685 32.4723553,12.5046685 L12.1771332,12.5046685 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M89.5244796,28.8217358 C98.4694108,28.8217358 105.535155,31.2616712 110.721712,36.0652938 C115.908268,40.8689164 118.463963,47.5787385 118.463963,56.0422642 L118.463963,96.3774447 L106.88817,96.3774447 L106.88817,87.3039353 L106.361997,87.3039353 C101.325775,94.7762372 94.7110364,98.5123881 86.3674451,98.5123881 C79.3017011,98.5123881 73.2883019,96.3774447 68.5527501,92.107558 C63.8923658,88.1426631 61.2615037,82.2715687 61.4118387,76.0954825 C61.4118387,69.3094124 63.9675333,63.9720539 69.0037551,59.9309111 C74.0399768,55.8897682 80.8050509,53.9073208 89.2238097,53.9073208 C96.4398886,53.9073208 102.302953,55.2797844 106.963337,57.8722156 L106.963337,55.0510404 C106.963337,50.8574016 105.159317,46.8925067 102.002283,44.1475795 C98.7700808,41.2501563 94.6358689,39.6489488 90.351322,39.6489488 C83.586248,39.6489488 78.2493562,42.546372 74.3406468,48.3412183 L63.6668633,41.5551482 C69.3795925,33.0916226 78.0238538,28.8217358 89.5244796,28.8217358 Z M73.8896419,76.3242264 C73.8896419,79.5266415 75.3929916,82.5003127 77.8735188,84.3302642 C80.5795484,86.4652075 83.8869179,87.6089272 87.2694549,87.5326792 C92.3808442,87.5326792 97.266731,85.4739838 100.87477,81.8140809 C104.858647,78.0016819 106.88817,73.5030512 106.88817,68.3181887 C103.129795,65.2682695 97.8680709,63.74331 91.1029969,63.819558 C86.2171101,63.819558 82.0828982,65.0395256 78.7755287,67.4032129 C75.5433266,69.7669003 73.8896419,72.7405714 73.8896419,76.3242264 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), React__default.createElement("polygon", {
    id: "Path",
    points: "184.912023 30.9566792 144.471914 125.122933 131.994111 125.122933 147.027609 92.1838059 120.493485 30.9566792 133.647796 30.9566792 152.815506 77.925434 153.041008 77.925434 171.757713 30.9566792"
  })), React__default.createElement("g", {
    id: "Super-G"
  }, React__default.createElement("path", {
    d: "M106.813002,56.8809919 C106.813002,53.144841 106.512332,49.40869 105.910992,45.7487871 L54.8722671,45.7487871 L54.8722671,66.8694771 L84.1124204,66.8694771 C82.9097406,73.6555472 79.0010311,79.7553854 73.2883019,83.5677844 L73.2883019,97.2924205 L90.7271594,97.2924205 C100.949938,87.7614232 106.813002,73.6555472 106.813002,56.8809919 Z",
    id: "Path",
    fill: "#4285F4"
  }), React__default.createElement("path", {
    d: "M54.8722671,110.559569 C69.45476,110.559569 81.7822282,105.679698 90.7271594,97.2924205 L73.2883019,83.5677844 C68.4024152,86.9226954 62.1635136,88.8288949 54.8722671,88.8288949 C40.7407791,88.8288949 28.7891484,79.1454016 24.5046015,66.1832453 L6.53957156,66.1832453 L6.53957156,80.3653693 C15.7100052,98.893628 34.42671,110.559569 54.8722671,110.559569 Z",
    id: "Path",
    fill: "#34A853"
  }), React__default.createElement("path", {
    d: "M24.5046015,66.1832453 C22.2495768,59.3971752 22.2495768,52.0011213 24.5046015,45.1388032 L24.5046015,31.0329272 L6.53957156,31.0329272 C-1.20267983,46.5112668 -1.20267983,64.8107817 6.53957156,80.2891213 L24.5046015,66.1832453 Z",
    id: "Path",
    fill: "#FBBC04"
  }), React__default.createElement("path", {
    d: "M54.8722671,22.4931536 C62.6145185,22.3406577 70.0560999,25.3143288 75.6184941,30.7279353 L91.1029969,15.0208518 C81.2560558,5.71859838 68.3272477,0.609983827 54.8722671,0.762479784 C34.42671,0.762479784 15.7100052,12.5046685 6.53957156,31.0329272 L24.5046015,45.2150512 C28.7891484,32.1766469 40.7407791,22.4931536 54.8722671,22.4931536 Z",
    id: "Path",
    fill: "#EA4335"
  }))))));
};

var home = function home(_a) {
  var _a$title45 = _a.title,
      title = _a$title45 === void 0 ? '' : _a$title45,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m10 20v-6h4v6h5v-8h3l-10-9-10 9h3v8h5z"
  }));
};

var hotDrink = function hotDrink(_a) {
  var _a$title46 = _a.title,
      title = _a$title46 === void 0 ? '' : _a$title46,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 15 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M4,3.25h6A1.75,1.75,0,0,1,11.74,5v.08l-.58,12a1.74,1.74,0,0,1-1.75,1.67H4.59a1.74,1.74,0,0,1-1.75-1.67l-.58-12A1.76,1.76,0,0,1,3.93,3.25Z",
    style: {
      strokeWidth: '1.5px',
      fillRule: 'evenodd'
    }
  }), React__default.createElement("path", {
    d: "M6,13,8.5,8.5",
    style: {
      fill: 'none',
      strokeWidth: '1.5px',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }
  }), React__default.createElement("rect", {
    x: "1.25",
    y: "1.25",
    width: "11.5",
    height: "3.5",
    rx: "1",
    style: {
      strokeWidth: '1.5px'
    }
  }));
};

var info = function info(_a) {
  var _a$title47 = _a.title,
      title = _a$title47 === void 0 ? '' : _a$title47,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm1 15h-2v-6h2v6zm0-8h-2v-2h2v2z"
  }));
};

var instagram = function instagram(_a) {
  var _a$title48 = _a.title,
      title = _a$title48 === void 0 ? '' : _a$title48,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 3.8018c2.6702 0 2.9864 0.01017 4.0408 0.05828 0.975 0.0445 1.5045 0.20741 1.857 0.34431 0.4667 0.18141 0.7998 0.39815 1.1498 0.74806 0.3499 0.3499 0.5666 0.68307 0.748 1.1498 0.137 0.35242 0.2999 0.88192 0.3444 1.8568 0.0481 1.0545 0.0582 1.3708 0.0582 4.041 0 2.6701-0.0101 2.9864-0.0582 4.0408-0.0445 0.975-0.2074 1.5045-0.3444 1.8569-0.1814 0.4668-0.3981 0.7999-0.748 1.1499-0.3499 0.3499-0.6831 0.5666-1.1498 0.748-0.3525 0.1369-0.882 0.2998-1.857 0.3443-1.0543 0.0481-1.3706 0.0583-4.0408 0.0583-2.6703 0-2.9865-0.0102-4.0408-0.0583-0.975-0.0445-1.5045-0.2074-1.8568-0.3443-0.46678-0.1814-0.79994-0.3981-1.1498-0.748-0.34991-0.35-0.56665-0.6831-0.74802-1.1499-0.13695-0.3524-0.29985-0.8819-0.34435-1.8568-0.04811-1.0545-0.05828-1.3708-0.05828-4.0409 0-2.6702 0.01016-2.9864 0.05828-4.0409 0.04449-0.975 0.2074-1.5045 0.34435-1.8569 0.18137-0.46673 0.3981-0.79989 0.74802-1.1498 0.34992-0.34995 0.68308-0.56666 1.1498-0.74806 0.35237-0.1369 0.88183-0.29981 1.8568-0.34431 1.0545-0.04811 1.3708-0.05828 4.0409-0.05828h-1e-4zm1e-4 -1.8018c2.7158 0 3.0564 0.01151 4.123 0.06018 1.0644 0.04858 1.7913 0.21761 2.4274 0.46483 0.6576 0.25556 1.2153 0.59749 1.7712 1.1534s0.8978 1.1136 1.1534 1.7712c0.2472 0.63611 0.4162 1.363 0.4648 2.4274 0.0487 1.0666 0.0602 1.4071 0.0602 4.123s-0.0115 3.0564-0.0602 4.123c-0.0486 1.0644-0.2176 1.7914-0.4648 2.4274-0.2556 0.6576-0.5975 1.2153-1.1534 1.7712-0.556 0.5559-1.1136 0.8978-1.7712 1.1534-0.6361 0.2472-1.363 0.4163-2.4274 0.4649-1.0666 0.0486-1.4071 0.0601-4.123 0.0601-2.7159 0-3.0564-0.0115-4.123-0.0601-1.0644-0.0486-1.7913-0.2176-2.4274-0.4649-0.65759-0.2555-1.2152-0.5975-1.7712-1.1534-0.55593-0.5559-0.89783-1.1137-1.1534-1.7712-0.24722-0.6361-0.41624-1.363-0.46483-2.4274-0.04867-1.0666-0.06014-1.4071-0.06014-4.123 0-2.7158 0.01147-3.0564 0.06014-4.123 0.04859-1.0644 0.21761-1.7913 0.46483-2.4274 0.25556-0.65759 0.59749-1.2152 1.1534-1.7712 0.55593-0.55593 1.1136-0.89784 1.7712-1.1534 0.63612-0.24722 1.363-0.41624 2.4274-0.46483 1.0666-0.04867 1.4071-0.06018 4.123-0.06018zm0 4.8648c-2.8361 0-5.1352 2.2991-5.1352 5.1352 0 2.8361 2.2991 5.1352 5.1352 5.1352 2.8361 0 5.1352-2.2991 5.1352-5.1352 0-2.8361-2.2991-5.1352-5.1352-5.1352zm0 8.4684c-1.8409 0-3.3334-1.4924-3.3334-3.3334 0-1.8409 1.4925-3.3333 3.3334-3.3333s3.3333 1.4924 3.3333 3.3333c0 1.841-1.4924 3.3334-3.3333 3.3334zm6.538-8.6717c0-0.66275-0.5372-1.2-1.2-1.2s-1.2 0.53724-1.2 1.2c0 0.66275 0.5373 1.2 1.2 1.2s1.2-0.53728 1.2-1.2z",
    fillRule: "evenodd"
  }));
};

var kidsMeal = function kidsMeal(_a) {
  var _a$title49 = _a.title,
      title = _a$title49 === void 0 ? '' : _a$title49,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 65 52"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M33.9 7.5c.1-.1.3-.2.5-.2.6-.1 1.2.3 1.3.9v.2c0 .5-.4.9-.9 1-.6.1-1.2-.3-1.3-.9-.1-.4.1-.8.4-1m4.5 6.3c1.3-1.5.3-3-.5-3.9l2.2-2.4-5.7-2.2c-.2-1.4-1-3.7-3.2-3.6-.7 0-1.3.2-1.7.5-.1-1-.6-1.8-1.5-2.1-1.3-.5-2.8.3-3.4 1.7 0 0 0 .1-.1.1-.1.3-.2.6-.2.8 0 .5 0 .9.2 1.3.3.9 1 1.8 2.5 2.3.3.1.6.2.9.2h1.5l-4.6 14.7c-.5 1.1-1.8 3.9-3.6 5.4-3.3 2.9-5.5.3-5.5.3-3.7-4.2 6.7-11.1.6-17.9-4-4.5-11.4-2-16.3 1.7L3 17h.1c3-2.7 5.3 0 5.3 0 3.5 3.9-3.6 9.1-3 15.5V33.3c.7 3.8 4.8 12.2 14.9 13.1l.5 5.5h3.4l.5-5.6c.5-.1 1.1-.2 1.6-.3 10.2-2 12.6-9 12.6-15.4 0-2-1.9-13-2.5-16.3.8.2 1.4.1 2-.5"
  }), React__default.createElement("path", {
    d: "M61.4 22.6c.4-.1.7.2.8.7v.1c0 .4-.2.7-.5.7-.4.1-.7-.2-.8-.7 0-.3.1-.6.3-.7 0 0 .1-.1.2-.1zm2.2 1.7l1.4-1.5-3.6-1.4c-.1-.9-.6-2.3-2-2.3-.4 0-.8.1-1 .3 0-.6-.4-1.1-.9-1.4-.8-.3-1.7.2-2.1 1.1v.1c-.1.2-.1.3-.1.5 0 .3 0 .6.1.8.2.6.6 1.2 1.5 1.5.2.1.4.1.6.1h.9l-2.9 9.3c-.3.7-1.1 2.4-2.2 3.4-2 1.8-3.4.2-3.4.2-2.3-2.7 4.2-7 .4-11.3-2.7-2.8-7.2-1.2-10.3 1.2l1.9 4c1.9-1.7 3.3 0 3.3 0 2.2 2.4-2.3 5.8-1.9 9.8v.6c.5 2.4 3 7.8 9.3 8.3L53 51h2.1l.3-3.6c.3 0 .7-.1 1-.2 6.4-1.2 7.9-5.7 7.9-9.8 0-1.3-1.2-8.2-1.6-10.3.4.1.8 0 1.1-.4 1-.9.4-1.9-.2-2.4z"
  }));
};

var kioskCard = function kioskCard(_a) {
  var _a$title50 = _a.title,
      title = _a$title50 === void 0 ? '' : _a$title50,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 84 80",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    transform: "translate(-338.000000, -1111.000000)"
  }, React__default.createElement("g", {
    transform: "translate(338.000000, 1111.000000)"
  }, React__default.createElement("path", {
    d: "M49,44V33h28.5c3.6,0,6.5,3.1,6.5,6.9V44H49z M49,72V46h35v19.5c0,3.6-2.9,6.5-6.5,6.5\n\t\t\t\tH49z M75,56.4h-7.8c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3H75c0.7,0,1.3-0.6,1.3-1.3C76.2,57,75.7,56.4,75,56.4z M75,51.2\n\t\t\t\tH54.3c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3H75c0.7,0,1.3-0.6,1.3-1.3S75.7,51.2,75,51.2z"
  }), React__default.createElement("path", {
    d: "M0,66.2V13.8V8.6C0,3.9,3.7,0,8.2,0h29.6C42.3,0,46,3.9,46,8.6v5.2v52.3v5.2c0,4.8-3.7,8.6-8.2,8.6H8.2\n\t\t\t\tC3.7,80,0,76.1,0,71.4V66.2z M23,74.8c1.8,0,3.3-1.5,3.3-3.5s-1.5-3.5-3.3-3.5s-3.3,1.5-3.3,3.5S21.2,74.8,23,74.8z M14.8,6.9\n\t\t\t\tc-0.9,0-1.6,0.8-1.6,1.7s0.7,1.7,1.6,1.7h16.4c0.9,0,1.6-0.8,1.6-1.7s-0.7-1.7-1.6-1.7H14.8z M23,38.7c-2.8,0-5.2-2.3-5.2-5.2\n\t\t\t\tc0-2.9,2.3-5.2,5.2-5.2c2.8,0,5.2,2.3,5.2,5.2c0,0.9,0.7,1.7,1.6,1.7c0.9,0,1.6-0.7,1.6-1.7c0-4.1-2.9-7.6-6.8-8.4V22\n\t\t\t\tc0-0.9-0.7-1.7-1.6-1.7s-1.6,0.7-1.6,1.7v3.1c-3.9,0.8-6.8,4.2-6.8,8.4c0,4.7,3.8,8.5,8.4,8.5c2.8,0,5.2,2.3,5.2,5.2\n\t\t\t\tc0,2.9-2.3,5.2-5.2,5.2c-2.8,0-5.2-2.3-5.2-5.2c0-0.9-0.7-1.7-1.6-1.7c-0.9,0-1.6,0.7-1.6,1.7c0,4.1,2.9,7.6,6.8,8.4v3.1\n\t\t\t\tc0,0.9,0.7,1.7,1.6,1.7s1.6-0.7,1.6-1.7v-3.1c3.9-0.8,6.8-4.2,6.8-8.4C31.4,42.5,27.7,38.7,23,38.7z"
  }))));
};

var language = function language(_a) {
  var _a$title51 = _a.title,
      title = _a$title51 === void 0 ? '' : _a$title51,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm6.93 6h-2.95c-0.32-1.25-0.78-2.45-1.38-3.56 1.84 0.63 3.37 1.91 4.33 3.56zm-6.92-3.96c0.83 1.2 1.48 2.53 1.91 3.96h-3.82c0.43-1.43 1.08-2.76 1.91-3.96zm-7.74 9.96c-0.16-0.64-0.26-1.31-0.26-2s0.1-1.36 0.26-2h3.38c-0.08 0.66-0.14 1.32-0.14 2s0.06 1.34 0.14 2h-3.38zm0.82 2h2.95c0.32 1.25 0.78 2.45 1.38 3.56-1.84-0.63-3.37-1.9-4.33-3.56zm2.95-8h-2.95c0.96-1.66 2.49-2.93 4.33-3.56-0.6 1.11-1.06 2.31-1.38 3.56zm3.97 11.96c-0.83-1.2-1.48-2.53-1.91-3.96h3.82c-0.43 1.43-1.08 2.76-1.91 3.96zm2.34-5.96h-4.68c-0.09-0.66-0.16-1.32-0.16-2s0.07-1.35 0.16-2h4.68c0.09 0.65 0.16 1.32 0.16 2s-0.07 1.34-0.16 2zm0.25 5.56c0.6-1.11 1.06-2.31 1.38-3.56h2.95c-0.96 1.65-2.49 2.93-4.33 3.56zm1.77-5.56c0.08-0.66 0.14-1.32 0.14-2s-0.06-1.34-0.14-2h3.38c0.16 0.64 0.26 1.31 0.26 2s-0.1 1.36-0.26 2h-3.38z"
  }));
};

var list = function list(_a) {
  var _a$title52 = _a.title,
      title = _a$title52 === void 0 ? '' : _a$title52,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M2 12.6667H4.22222V10.4444H2V12.6667ZM2 17.1111H4.22222V14.8889H2V17.1111ZM2 8.22222H4.22222V6H2V8.22222ZM6.44444 12.6667H22V10.4444H6.44444V12.6667ZM6.44444 17.1111H22V14.8889H6.44444V17.1111ZM6.44444 6V8.22222H22V6H6.44444ZM2 12.6667H4.22222V10.4444H2V12.6667ZM2 17.1111H4.22222V14.8889H2V17.1111ZM2 8.22222H4.22222V6H2V8.22222ZM6.44444 12.6667H22V10.4444H6.44444V12.6667ZM6.44444 17.1111H22V14.8889H6.44444V17.1111ZM6.44444 6V8.22222H22V6H6.44444Z"
  }));
};

var location = function location(_a) {
  var _a$title53 = _a.title,
      title = _a$title53 === void 0 ? '' : _a$title53,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
  }));
};

var lock = function lock(_a) {
  var _a$title54 = _a.title,
      title = _a$title54 === void 0 ? '' : _a$title54,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m18 8h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zm-6 9c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zm3.1-9h-6.2v-2c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"
  }));
};

var lockUnlocked = function lockUnlocked(_a) {
  var _a$title55 = _a.title,
      title = _a$title55 === void 0 ? '' : _a$title55,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 17c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2zm6-9h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-9.1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zm0 12h-12v-10h12v10z"
  }));
};

var StyledRect = styled.rect(_templateObject());

var loyaltyCard = function loyaltyCard(_a) {
  var _a$title56 = _a.title,
      title = _a$title56 === void 0 ? '' : _a$title56,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    width: "343",
    height: "261",
    viewBox: "0 0 343 261"
  }, props), React__default.createElement("title", null, title), React__default.createElement("defs", null, React__default.createElement("filter", {
    x: "-8.6%",
    y: "-13.6%",
    width: "117.2%",
    height: "126.7%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, React__default.createElement("feOffset", {
    dy: "6",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), React__default.createElement("feGaussianBlur", {
    stdDeviation: "3",
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), React__default.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), React__default.createElement("feMerge", null, React__default.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), React__default.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), React__default.createElement("filter", {
    x: "-1.3%",
    y: "-2.1%",
    width: "102.6%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, React__default.createElement("feOffset", {
    dy: "2",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), React__default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.604937287   0 0 0 0 0.0722277554   0 0 0 0 0.159625413  0 0 0 1 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), React__default.createElement("feMerge", null, React__default.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), React__default.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), React__default.createElement("path", {
    d: "M11.74 0A11.74 11.74 0 0 0 0 11.68v164.86c0 6.43 5.28 11.68 11.74 11.68H288.6c6.45 0 11.73-5.25 11.73-11.68V11.68C300.33 5.26 295.05 0 288.6 0H11.74z",
    id: "c"
  }), React__default.createElement("linearGradient", {
    x1: "6.68%",
    y1: "33.27%",
    x2: "97.51%",
    y2: "67.81%",
    id: "d"
  }, React__default.createElement("stop", {
    stopColor: "#AB0F34",
    stopOpacity: ".15",
    offset: "0%"
  }), React__default.createElement("stop", {
    stopColor: "#8F0B26",
    stopOpacity: "0",
    offset: "40.55%"
  }), React__default.createElement("stop", {
    stopColor: "#830920",
    stopOpacity: "0",
    offset: "65.23%"
  }), React__default.createElement("stop", {
    stopColor: "#49030E",
    stopOpacity: ".15",
    offset: "100%"
  }))), React__default.createElement("g", {
    filter: "url(#a)",
    transform: "rotate(-13 288.26 17.84)",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    filter: "url(#b)"
  }, React__default.createElement("use", {
    fill: "#C8102E",
    xlinkHref: "#c",
    transform: "translate(.58 .34)"
  }), React__default.createElement("g", {
    fill: "white"
  }, React__default.createElement("path", {
    d: "M144.48 17.48v-1.22h-.4a.27.27 0 0 1-.27-.22l-.3-1.3h-11.3l-.28 1.3a.28.28 0 0 1-.28.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.77c0 .16-.12.28-.28.28h-13.79z"
  }), React__default.createElement("path", {
    d: "M142.43 33.02h-9.12a.44.44 0 0 1-.45-.4L131.5 17.8l.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M198.83 17.48v-1.22h-.4a.27.27 0 0 1-.27-.22l-.3-1.3h-11.3l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.12-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.14 0 .25.1.28.22l.29 1.3h.46c.15 0 .28.13.28.28v1.77c0 .16-.13.28-.28.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M196.77 33.02h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.56-.05 1.35 14.73h8.92l1.36-14.73.56.05-1.37 14.83a.44.44 0 0 1-.45.4M253.32 17.48v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.52.55a.28.28 0 0 1-.27-.28v-1.77c0-.15.12-.28.27-.28h.47l.29-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.77c0 .16-.12.28-.27.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M251.26 33.02h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M219.41 14.48a9.16 9.16 0 0 0-9.18 9.12 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M218.47 17.94a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.4-.04.1.1.13.27.03.4l-.56.65a.27.27 0 0 1-.2.1M220.88 31.2a.28.28 0 0 1-.22-.46l.56-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.66a.27.27 0 0 1-.21.1M226.96 27.22c-.01-.05 0-.1.02-.16a.27.27 0 0 1 .35-.1l.69.32c.12.05.17.2.1.31a.27.27 0 0 1-.34.1l-.7-.32a.22.22 0 0 1-.12-.15M223.43 17.23a.28.28 0 0 1-.22-.45l.56-.66c.1-.12.27-.13.39-.03s.13.27.03.38l-.55.66a.27.27 0 0 1-.21.1M217.03 19.43a.3.3 0 0 1-.09-.02l-1.1-.38a.28.28 0 0 1-.18-.36c.06-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.54M216.9 31.06a.3.3 0 0 1-.09-.02l-1.1-.38a.28.28 0 0 1-.17-.36c.05-.14.2-.21.35-.17l1.1.39a.28.28 0 0 1-.09.54M212.44 21.02a.28.28 0 0 1-.18-.48l.88-.77c.12-.1.3-.1.4.02.1.12.09.3-.03.4l-.88.76a.29.29 0 0 1-.19.07M214.99 22.5a.28.28 0 0 1-.28-.27v-1.49c0-.15.12-.27.28-.27.15 0 .27.12.27.27v1.49c0 .15-.12.28-.27.28M218.85 32.14a.28.28 0 0 1-.27-.27v-1.49a.28.28 0 0 1 .55 0v1.49c0 .15-.12.27-.28.27M211.5 24.15a.28.28 0 0 1-.17-.5l1.38-1.09a.28.28 0 1 1 .35.44l-1.38 1.1a.28.28 0 0 1-.18.05M214.99 25.31a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.11-.1.29-.1.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M226.82 26.2a.28.28 0 0 1-.2-.09l-1-.98a.27.27 0 0 1 0-.4c.11-.1.29-.1.4 0l1 1c.1.1.1.28 0 .38a.28.28 0 0 1-.2.09M212.44 26.74c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.05c.06-.14.22-.2.36-.15.14.06.21.23.15.37l-.44 1.04a.28.28 0 0 1-.26.17M214.99 27.4a.28.28 0 0 1-.05-.55l1.49-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28H215M213.94 29.49a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.27.28M223.42 30.59a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .16-.13.28-.28.28M226.51 22.71c-.03 0-.07 0-.1-.02a.28.28 0 0 1-.16-.36l.45-1.05c.06-.14.22-.2.36-.14.14.06.2.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M227.73 24.62a.27.27 0 0 1-.27-.22.28.28 0 0 1 .22-.33l1.5-.27c.14-.03.29.07.32.22.02.15-.07.3-.23.32l-1.49.28h-.05M224.27 24.48a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M217.03 29.49a.28.28 0 0 1-.18-.49l1.05-.88c.12-.1.3-.08.4.04.1.11.08.29-.04.38l-1.05.88a.28.28 0 0 1-.18.07M219.41 29.27a.28.28 0 0 1-.1-.54l1.83-.66c.15-.05.3.03.36.17.05.14-.03.3-.17.35l-1.82.66a.3.3 0 0 1-.1.02M222.61 27.26l-.1-.01a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .35-.17c.15.05.22.21.17.36l-.39 1.04a.28.28 0 0 1-.26.18M221.76 19.88c-.03 0-.06 0-.1-.02a.27.27 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .36-.16c.14.05.21.21.16.35l-.39 1.05a.28.28 0 0 1-.26.18M225.24 28.1h-.07l-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33c.15.04.24.2.2.34a.28.28 0 0 1-.27.2M220.32 19.48h-.05l-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.23l1.35.25a.28.28 0 0 1-.05.55M226.03 19.36h-.05l-1.36-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.23l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M216.48 17.17a.28.28 0 0 1-.28-.27v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.13.27-.28.27M213.94 19.36a.28.28 0 0 1-.28-.28v-1.36a.28.28 0 0 1 .55 0v1.36c0 .15-.12.28-.27.28M220.57 17.61a.28.28 0 0 1-.26-.38l.56-1.4c.05-.15.21-.22.36-.17.14.06.21.22.15.36l-.55 1.41a.28.28 0 0 1-.26.18M223.06 21.76a.28.28 0 0 1-.27-.21.28.28 0 0 1 .2-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.06M219.41 21.4a2.39 2.39 0 0 0-2.39 2.37 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M165.01 14.48a9.16 9.16 0 0 0-9.18 9.12 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M160.78 32.3c-.04 0-.09-.02-.13-.04a.45.45 0 0 1-.22-.32c-.05-.33.17-.76.7-1.32.53-.56 1.37-.35 2.26-.12 1.03.26 2.09.53 2.87-.22 1.3-1.26 2.17-1.28 3.08-1.3.26 0 .54 0 .83-.04.45-.06.84-.6.92-1.3.08-.72-.16-1.62-1.09-1.96-.46-.17-.73-.43-.81-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.73.9-1.01.11-.16.15-.29.13-.38-.07-.25-.57-.5-1.05-.74a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.59-.28-.78.26-.86 2.41-1.32 3.07-1.44.15-.03.3.07.32.23.03.15-.07.29-.22.32-1.19.21-2.52.68-2.63 1.05-.02.05.02.13.12.22.38.35.9.61 1.36.84.66.32 1.22.6 1.35 1.09.06.26 0 .54-.21.83-.23.33-.58.7-.96 1.08-.64.67-1.52 1.58-1.41 2.06.03.15.19.28.47.38 1.23.46 1.54 1.66 1.44 2.55-.11.97-.68 1.69-1.4 1.78-.32.04-.6.04-.89.05-.87.02-1.56.03-2.7 1.14-1.01.96-2.33.62-3.4.35-.76-.2-1.41-.36-1.71-.03-.5.52-.55.76-.56.82a.27.27 0 0 1-.2.47z"
  }), React__default.createElement("path", {
    d: "M165.01 21.4a2.39 2.39 0 0 0-2.39 2.37 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M273.9 14.48a9.16 9.16 0 0 0-9.18 9.12 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M269.67 32.3c-.05 0-.1-.02-.13-.04a.45.45 0 0 1-.22-.32c-.06-.33.17-.76.7-1.32.52-.56 1.37-.35 2.26-.12 1.02.26 2.08.53 2.86-.22 1.31-1.26 2.18-1.28 3.09-1.3.26 0 .53 0 .83-.04.45-.06.83-.6.92-1.3.08-.72-.16-1.62-1.1-1.96-.45-.17-.73-.43-.8-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.73.9-1.01.1-.16.15-.29.13-.38-.07-.25-.57-.5-1.06-.74a6.03 6.03 0 0 1-1.5-.93c-.32-.3-.32-.59-.27-.78.26-.86 2.41-1.32 3.06-1.44.15-.03.3.07.33.23.03.15-.07.29-.23.32-1.18.21-2.52.68-2.62 1.05-.02.05.02.13.11.22.38.35.9.61 1.37.84.65.32 1.22.6 1.34 1.09.07.26 0 .54-.2.83-.23.33-.59.7-.96 1.08-.65.67-1.53 1.58-1.42 2.06.04.15.2.28.47.38 1.24.46 1.55 1.66 1.45 2.55-.12.97-.68 1.69-1.4 1.78-.32.04-.6.04-.89.05-.87.02-1.56.03-2.71 1.14-1 .96-2.33.62-3.4.35-.75-.2-1.4-.36-1.7-.03-.5.52-.56.76-.56.82a.27.27 0 0 1-.2.47z"
  }), React__default.createElement("path", {
    d: "M273.9 21.4a2.39 2.39 0 0 0-2.4 2.37 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M144.48 75.07v-1.23h-.4a.27.27 0 0 1-.27-.21l-.3-1.3h-11.3l-.28 1.3a.28.28 0 0 1-.28.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.77c0 .15-.12.28-.28.28h-13.79z"
  }), React__default.createElement("path", {
    d: "M142.43 90.61h-9.12a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M198.83 75.07v-1.23h-.4a.27.27 0 0 1-.27-.21l-.3-1.3h-11.3l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.12-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.14 0 .25.1.28.22l.29 1.3h.46c.15 0 .28.13.28.28v1.77c0 .15-.13.28-.28.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M196.77 90.61h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.56-.05 1.35 14.73h8.92l1.36-14.73.56.05-1.37 14.83a.44.44 0 0 1-.45.4M253.32 75.07v-1.23h-.4a.27.27 0 0 1-.28-.21l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.52.55a.28.28 0 0 1-.27-.28v-1.77c0-.15.12-.28.27-.28h.47l.29-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.77c0 .15-.12.28-.27.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M251.26 90.61h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M219.41 72.06a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M218.47 75.53a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.14.4-.04.1.1.13.27.03.39l-.56.66a.27.27 0 0 1-.2.1M220.88 88.78a.28.28 0 0 1-.22-.45l.56-.66c.1-.12.27-.13.39-.03s.13.27.03.39l-.55.65a.27.27 0 0 1-.21.1M226.96 84.8c-.01-.05 0-.1.02-.15a.27.27 0 0 1 .35-.1l.69.32c.12.05.17.2.1.3a.27.27 0 0 1-.34.11l-.7-.32a.22.22 0 0 1-.12-.15M223.43 74.82a.28.28 0 0 1-.22-.45l.56-.66c.1-.12.27-.13.39-.04.12.1.13.28.03.4l-.55.65a.27.27 0 0 1-.21.1M217.03 77.01a.3.3 0 0 1-.09-.01l-1.1-.39a.28.28 0 0 1-.18-.35c.06-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.53M216.9 88.65a.3.3 0 0 1-.09-.02l-1.1-.38a.28.28 0 0 1-.17-.36c.05-.14.2-.21.35-.17l1.1.39a.28.28 0 0 1-.09.54M212.44 78.6a.28.28 0 0 1-.2-.08.28.28 0 0 1 .02-.4l.88-.77c.12-.1.3-.08.4.03.1.12.09.3-.03.4l-.88.76a.29.29 0 0 1-.19.07M214.99 80.1a.28.28 0 0 1-.28-.28v-1.49a.28.28 0 0 1 .55 0v1.49c0 .15-.12.27-.27.27M218.85 89.73a.28.28 0 0 1-.27-.27v-1.49a.28.28 0 0 1 .55 0v1.49c0 .15-.12.27-.28.27M211.5 81.74a.28.28 0 0 1-.17-.5l1.38-1.09a.28.28 0 1 1 .35.43l-1.38 1.1a.28.28 0 0 1-.18.06M214.99 82.9a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M226.82 83.78a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.39c.11-.1.29-.1.4 0l1 1c.1.1.1.28 0 .38a.28.28 0 0 1-.2.08M212.44 84.33c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.37l.44-1.04c.06-.14.22-.2.36-.15.14.06.21.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M214.99 84.99a.28.28 0 0 1-.05-.55l1.49-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.27H215M213.94 87.08a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.27.28M223.42 88.18a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M226.51 80.3c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.16-.36l.45-1.05c.06-.14.22-.2.36-.14.14.05.2.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M227.73 82.21a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.29.07.32.22.02.15-.07.3-.23.32l-1.49.28h-.05M224.27 82.07a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M217.03 87.08a.28.28 0 0 1-.18-.49l1.05-.88c.12-.1.3-.08.4.03.1.12.08.3-.04.4l-1.05.87a.28.28 0 0 1-.18.07M219.41 86.86a.28.28 0 0 1-.1-.54l1.83-.66c.15-.05.3.02.36.17.05.14-.03.3-.17.35l-1.82.66a.3.3 0 0 1-.1.02M222.61 84.85c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .35-.16c.15.05.22.21.17.35l-.39 1.05a.28.28 0 0 1-.26.18M221.76 77.47c-.03 0-.06 0-.1-.02a.27.27 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .36-.16c.14.05.21.2.16.35l-.39 1.05a.28.28 0 0 1-.26.18M225.24 85.7l-.07-.01-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33c.15.04.24.2.2.34a.28.28 0 0 1-.27.2M220.32 77.07h-.05l-1.35-.25a.28.28 0 1 1 .1-.55l1.35.25a.28.28 0 0 1-.05.55M226.03 76.95h-.05l-1.36-.26a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M216.48 74.76a.28.28 0 0 1-.28-.28v-.97a.28.28 0 0 1 .56 0v.97c0 .16-.13.28-.28.28M213.94 76.94a.28.28 0 0 1-.28-.27V75.3a.28.28 0 0 1 .55 0v1.36c0 .15-.12.27-.27.27M220.57 75.2a.28.28 0 0 1-.26-.38l.56-1.41c.05-.14.21-.2.36-.16.14.06.21.22.15.36l-.55 1.41a.28.28 0 0 1-.26.18M223.06 79.35a.28.28 0 0 1-.27-.21.28.28 0 0 1 .2-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.06M219.41 78.98a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M165.01 72.06a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M160.78 89.88c-.04 0-.09 0-.13-.03a.45.45 0 0 1-.22-.33c-.05-.32.17-.75.7-1.31.53-.57 1.37-.35 2.26-.13 1.03.27 2.09.54 2.87-.21 1.3-1.26 2.17-1.28 3.08-1.3.26 0 .54 0 .83-.04.45-.06.84-.6.92-1.3.08-.72-.16-1.62-1.09-1.96-.46-.17-.73-.43-.81-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.73.9-1.01.11-.16.15-.29.13-.39-.07-.25-.57-.5-1.05-.73a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.28-.78.26-.87 2.41-1.32 3.07-1.44.15-.03.3.07.32.22.03.15-.07.3-.22.32-1.19.22-2.52.7-2.63 1.06-.02.05.02.13.12.22.38.35.9.6 1.36.84.66.32 1.22.6 1.35 1.08.06.27 0 .55-.21.84-.23.33-.58.7-.96 1.08-.64.66-1.52 1.58-1.41 2.06.03.15.19.28.47.38 1.23.45 1.54 1.65 1.44 2.54-.11.98-.68 1.7-1.4 1.79-.32.03-.6.04-.89.05-.87.01-1.56.03-2.7 1.14-1.01.96-2.33.62-3.4.35-.76-.2-1.41-.36-1.71-.04-.5.53-.55.77-.56.83a.27.27 0 0 1-.2.47z"
  }), React__default.createElement("path", {
    d: "M165.01 78.98a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M273.9 72.06a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M269.67 89.88c-.05 0-.1 0-.13-.03a.45.45 0 0 1-.22-.33c-.06-.32.17-.75.7-1.31.52-.57 1.37-.35 2.26-.13 1.02.27 2.08.54 2.86-.21 1.31-1.26 2.18-1.28 3.09-1.3.26 0 .53 0 .83-.04.45-.06.83-.6.92-1.3.08-.72-.16-1.62-1.1-1.96-.45-.17-.73-.43-.8-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.73.9-1.01.1-.16.15-.29.13-.39-.07-.25-.57-.5-1.06-.73a6.03 6.03 0 0 1-1.5-.93c-.32-.3-.32-.6-.27-.78.26-.87 2.41-1.32 3.06-1.44.15-.03.3.07.33.22.03.15-.07.3-.23.32-1.18.22-2.52.7-2.62 1.06-.02.05.02.13.11.22.38.35.9.6 1.37.84.65.32 1.22.6 1.34 1.08.07.27 0 .55-.2.84-.23.33-.59.7-.96 1.08-.65.66-1.53 1.58-1.42 2.06.04.15.2.28.47.38 1.24.45 1.55 1.65 1.45 2.54-.12.98-.68 1.7-1.4 1.79-.32.03-.6.04-.89.05-.87.01-1.56.03-2.71 1.14-1 .96-2.33.62-3.4.35-.75-.2-1.4-.36-1.7-.04-.5.53-.56.77-.56.83a.27.27 0 0 1-.2.47z"
  }), React__default.createElement("path", {
    d: "M273.9 78.98a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M144.48 132.1v-1.22h-.4a.27.27 0 0 1-.27-.22l-.3-1.3h-11.3l-.28 1.3a.28.28 0 0 1-.28.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.45c.16 0 .28.13.28.28v1.78c0 .15-.12.27-.28.27h-13.79z"
  }), React__default.createElement("path", {
    d: "M142.43 147.65h-9.12a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.82a.44.44 0 0 1-.44.4M198.83 132.1v-1.22h-.4a.27.27 0 0 1-.27-.22l-.3-1.3h-11.3l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.12-.27.28-.27h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.14 0 .25.09.28.21l.29 1.3h.46c.15 0 .28.13.28.28v1.78c0 .15-.13.27-.28.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M196.77 147.65h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.56-.05 1.35 14.73h8.92l1.36-14.73.56.05-1.37 14.82a.44.44 0 0 1-.45.4M253.32 132.1v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.52.55a.28.28 0 0 1-.27-.27v-1.78c0-.15.12-.27.27-.27h.47l.29-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.46c.15 0 .27.13.27.28v1.78c0 .15-.12.27-.27.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M251.26 147.65h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.82a.44.44 0 0 1-.44.4M219.41 129.1a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.12c5.06 0 9.18-4.09 9.18-9.12a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M218.47 132.56a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.27-.13.4-.03.1.1.13.27.03.39l-.56.65a.27.27 0 0 1-.2.1M220.88 145.82a.28.28 0 0 1-.22-.45l.56-.66c.1-.12.27-.14.39-.04s.13.27.03.4l-.55.65a.27.27 0 0 1-.21.1M226.96 141.84c-.01-.05 0-.1.02-.16a.27.27 0 0 1 .35-.1l.69.32c.12.06.17.2.1.31a.27.27 0 0 1-.34.1l-.7-.31a.22.22 0 0 1-.12-.16M223.43 131.86a.28.28 0 0 1-.22-.46l.56-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.66a.27.27 0 0 1-.21.1M217.03 134.05a.3.3 0 0 1-.09-.02l-1.1-.38a.28.28 0 0 1-.18-.35c.06-.15.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M216.9 145.68l-.09-.01-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.22.35-.17l1.1.38a.28.28 0 0 1-.09.54M212.44 135.64a.28.28 0 0 1-.2-.09.28.28 0 0 1 .02-.4l.88-.76c.12-.1.3-.09.4.03.1.11.09.29-.03.39l-.88.77a.29.29 0 0 1-.19.06M214.99 137.13a.28.28 0 0 1-.28-.28v-1.48a.28.28 0 0 1 .55 0v1.48c0 .16-.12.28-.27.28M218.85 146.77a.28.28 0 0 1-.27-.28v-1.48a.28.28 0 0 1 .55 0v1.48c0 .15-.12.28-.28.28M211.5 138.78a.28.28 0 0 1-.17-.5l1.38-1.1a.28.28 0 1 1 .35.44l-1.38 1.1a.28.28 0 0 1-.18.06M214.99 139.93a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.39c.11-.1.29-.1.4 0l1 1c.1.1.1.27 0 .38a.28.28 0 0 1-.2.08M226.82 140.82a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M212.44 141.36c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.04c.06-.14.22-.21.36-.15.14.06.21.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M214.99 142.02a.28.28 0 0 1-.05-.54l1.49-.28c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28H215M213.94 144.11a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.27.27M223.42 145.21a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M226.51 137.33c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.16-.36l.45-1.04a.27.27 0 1 1 .51.21l-.44 1.05a.28.28 0 0 1-.26.16M227.73 139.25a.27.27 0 0 1-.27-.23.28.28 0 0 1 .22-.32l1.5-.28c.14-.02.29.07.32.22.02.15-.07.3-.23.33l-1.49.27h-.05M224.27 139.1a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M217.03 144.11a.28.28 0 0 1-.18-.49l1.05-.87c.12-.1.3-.09.4.03.1.12.08.29-.04.39l-1.05.88a.28.28 0 0 1-.18.06M219.41 143.9a.28.28 0 0 1-.1-.54l1.83-.66c.15-.05.3.02.36.16.05.15-.03.3-.17.36l-1.82.66a.3.3 0 0 1-.1.01M222.61 141.89c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .35-.16c.15.05.22.2.17.35l-.39 1.05a.28.28 0 0 1-.26.18M221.76 134.5l-.1-.01a.27.27 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .36-.17c.14.06.21.21.16.36l-.39 1.04a.28.28 0 0 1-.26.18M225.24 142.73h-.07l-1.27-.34a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.34c.15.04.24.19.2.33a.28.28 0 0 1-.27.21M220.32 134.1h-.05l-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.22l1.35.25a.28.28 0 0 1-.05.54M226.03 133.98h-.05l-1.36-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.24c.15.03.25.18.22.33a.28.28 0 0 1-.27.22M216.48 131.8a.28.28 0 0 1-.28-.28v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.13.28-.28.28M213.94 133.98a.28.28 0 0 1-.28-.28v-1.36a.28.28 0 0 1 .55 0v1.36c0 .16-.12.28-.27.28M220.57 132.23a.28.28 0 0 1-.26-.38l.56-1.4c.05-.15.21-.21.36-.16.14.05.21.21.15.36l-.55 1.4a.28.28 0 0 1-.26.18M223.06 136.39a.28.28 0 0 1-.27-.22.28.28 0 0 1 .2-.33l1.75-.38c.15-.04.3.06.33.2.03.15-.06.3-.21.34l-1.74.38h-.06M219.41 136.01a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M165.01 129.1a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.12c5.06 0 9.18-4.09 9.18-9.12a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M160.78 146.91c-.04 0-.09 0-.13-.03a.45.45 0 0 1-.22-.32c-.05-.32.17-.75.7-1.32.53-.56 1.37-.35 2.26-.12 1.03.26 2.09.53 2.87-.22 1.3-1.25 2.17-1.27 3.08-1.29.26 0 .54-.01.83-.05.45-.05.84-.6.92-1.3.08-.72-.16-1.62-1.09-1.96-.46-.17-.73-.43-.81-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.72.9-1 .11-.16.15-.3.13-.4-.07-.24-.57-.49-1.05-.72a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.28-.79.26-.86 2.41-1.32 3.07-1.43.15-.03.3.07.32.22.03.15-.07.3-.22.32-1.19.22-2.52.69-2.63 1.05-.02.06.02.13.12.22.38.36.9.61 1.36.84.66.32 1.22.6 1.35 1.09.06.26 0 .54-.21.84-.23.32-.58.69-.96 1.07-.64.67-1.52 1.58-1.41 2.06.03.15.19.28.47.38 1.23.46 1.54 1.66 1.44 2.55-.11.98-.68 1.7-1.4 1.78-.32.04-.6.05-.89.05-.87.02-1.56.03-2.7 1.14-1.01.96-2.33.63-3.4.35-.76-.19-1.41-.35-1.71-.03-.5.52-.55.76-.56.83a.27.27 0 0 1-.2.46z"
  }), React__default.createElement("path", {
    d: "M165.01 136.01a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M35.93 132.1v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3H23.67l-.3 1.3a.28.28 0 0 1-.26.22h-.4v1.22h13.23zm-13.52.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.45c.16 0 .28.13.28.28v1.78c0 .15-.12.27-.28.27H22.41z"
  }), React__default.createElement("path", {
    d: "M33.87 147.65h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.82a.44.44 0 0 1-.44.4M90.27 132.1v-1.22h-.4a.27.27 0 0 1-.27-.22l-.3-1.3H78l-.28 1.3a.28.28 0 0 1-.28.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.45c.16 0 .28.13.28.28v1.78c0 .15-.12.27-.28.27H76.76z"
  }), React__default.createElement("path", {
    d: "M88.22 147.65H79.1a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.82a.44.44 0 0 1-.44.4M110.85 129.1a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.12c5.06 0 9.18-4.09 9.18-9.12a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M109.91 132.56a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.28-.13.4-.03.11.1.13.27.03.39l-.55.65a.27.27 0 0 1-.22.1M112.32 145.82a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.14.4-.04.1.1.12.27.03.4l-.56.65a.28.28 0 0 1-.21.1M118.4 141.84c-.01-.05 0-.1.02-.16a.27.27 0 0 1 .35-.1l.69.32c.12.06.17.2.1.31a.27.27 0 0 1-.34.1l-.7-.31a.22.22 0 0 1-.12-.16M114.87 131.86a.28.28 0 0 1-.21-.46l.55-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.66a.27.27 0 0 1-.21.1M108.48 134.05a.3.3 0 0 1-.1-.02l-1.1-.38a.28.28 0 0 1-.17-.35c.05-.15.2-.22.35-.17l1.1.38a.28.28 0 0 1-.08.54M108.35 145.68l-.1-.01-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.22.35-.17l1.1.38a.28.28 0 0 1-.08.54M103.88 135.64a.28.28 0 0 1-.18-.49l.89-.76c.11-.1.29-.09.39.03.1.11.09.29-.03.39l-.88.77a.29.29 0 0 1-.19.06M106.43 137.13a.28.28 0 0 1-.28-.28v-1.48a.28.28 0 0 1 .56 0v1.48c0 .16-.13.28-.28.28M110.3 146.77a.28.28 0 0 1-.28-.28v-1.48a.28.28 0 0 1 .56 0v1.48c0 .15-.13.28-.28.28M102.94 138.78a.28.28 0 0 1-.17-.5l1.38-1.1a.28.28 0 1 1 .35.44l-1.38 1.1a.28.28 0 0 1-.18.06M106.43 139.93a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.39c.12-.1.3-.1.4 0l1 1c.1.1.1.27 0 .38a.28.28 0 0 1-.2.08M118.26 140.82a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M103.88 141.36c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.04a.27.27 0 1 1 .51.21l-.44 1.04a.28.28 0 0 1-.26.17M106.43 142.02a.28.28 0 0 1-.05-.54l1.5-.28c.14-.03.29.07.32.22.02.15-.08.3-.23.32l-1.49.28h-.05M105.38 144.11a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M114.86 145.21a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M117.95 137.33c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.04a.27.27 0 1 1 .51.21l-.44 1.05a.28.28 0 0 1-.26.16M119.17 139.25a.27.27 0 0 1-.27-.23.28.28 0 0 1 .22-.32l1.5-.28c.14-.02.3.07.32.22.03.15-.07.3-.22.33l-1.5.27h-.05M115.71 139.1a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M108.48 144.11a.28.28 0 0 1-.18-.49l1.05-.87c.11-.1.29-.09.39.03.1.12.08.29-.04.39l-1.05.88a.28.28 0 0 1-.17.06M110.85 143.9a.28.28 0 0 1-.26-.19.28.28 0 0 1 .17-.35l1.82-.66c.15-.05.3.02.36.16.05.15-.02.3-.17.36l-1.82.66a.28.28 0 0 1-.1.01M114.05 141.89c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.36l.4-1.04a.28.28 0 0 1 .35-.16c.14.05.21.2.16.35l-.39 1.05a.28.28 0 0 1-.26.18M113.2 134.5l-.1-.01a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .52.19l-.39 1.04a.28.28 0 0 1-.26.18M116.68 142.73h-.07l-1.27-.34a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.34a.28.28 0 0 1-.07.54M111.77 134.1h-.06l-1.35-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.25a.28.28 0 0 1-.05.54M117.47 133.98h-.05l-1.36-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.24c.15.03.25.18.22.33a.28.28 0 0 1-.27.22M107.92 131.8a.28.28 0 0 1-.28-.28v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.12.28-.28.28M105.38 133.98a.28.28 0 0 1-.28-.28v-1.36a.28.28 0 0 1 .56 0v1.36c0 .16-.13.28-.28.28M112.01 132.23a.28.28 0 0 1-.26-.38l.56-1.4c.05-.15.22-.21.36-.16.14.05.21.21.16.36l-.56 1.4a.28.28 0 0 1-.26.18M114.5 136.39a.28.28 0 0 1-.27-.22.28.28 0 0 1 .2-.33l1.75-.38c.15-.04.3.06.33.2.04.15-.06.3-.2.34l-1.75.38h-.06M110.85 136.01a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M56.45 129.1a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.12c5.06 0 9.18-4.09 9.18-9.12a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M52.22 146.91c-.04 0-.09 0-.13-.03a.45.45 0 0 1-.21-.32c-.06-.32.17-.75.7-1.32.52-.56 1.36-.35 2.25-.12 1.03.26 2.09.53 2.87-.22 1.3-1.25 2.17-1.27 3.09-1.29.26 0 .53-.01.83-.05.44-.05.83-.6.91-1.3.09-.72-.16-1.62-1.09-1.96-.46-.17-.73-.43-.81-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.72.9-1 .11-.16.16-.3.13-.4-.06-.24-.56-.49-1.05-.72a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.27-.79.25-.86 2.4-1.32 3.06-1.43.15-.03.3.07.32.22.03.15-.07.3-.22.32-1.18.22-2.52.69-2.63 1.05-.02.06.02.13.12.22.38.36.9.61 1.37.84.65.32 1.21.6 1.34 1.09.07.26 0 .54-.21.84-.23.32-.58.69-.96 1.07-.64.67-1.52 1.58-1.4 2.06.03.15.18.28.46.38 1.23.46 1.55 1.66 1.44 2.55-.11.98-.67 1.7-1.4 1.78-.31.04-.6.05-.88.05-.87.02-1.56.03-2.72 1.14-1 .96-2.32.63-3.38.35-.76-.19-1.42-.35-1.72-.03-.5.52-.55.76-.56.83.09.08.1.2.05.32a.28.28 0 0 1-.25.14z"
  }), React__default.createElement("path", {
    d: "M56.45 136.01a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M35.93 75.07v-1.23h-.4a.27.27 0 0 1-.28-.21l-.3-1.3H23.67l-.3 1.3a.28.28 0 0 1-.26.21h-.4v1.23h13.23zm-13.52.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.77c0 .15-.12.28-.28.28H22.41z"
  }), React__default.createElement("path", {
    d: "M33.87 90.61h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M90.27 75.07v-1.23h-.4a.27.27 0 0 1-.27-.21l-.3-1.3H78l-.28 1.3a.28.28 0 0 1-.28.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.77c0 .15-.12.28-.28.28H76.76z"
  }), React__default.createElement("path", {
    d: "M88.22 90.61H79.1a.44.44 0 0 1-.45-.4L77.3 75.38l.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M110.85 72.06a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M109.91 75.53a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.28-.14.4-.04.11.1.13.27.03.39l-.55.66a.27.27 0 0 1-.22.1M112.32 88.78a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.4-.03.1.1.12.27.03.39l-.56.65a.28.28 0 0 1-.21.1M118.4 84.8c-.01-.05 0-.1.02-.15a.27.27 0 0 1 .35-.1l.69.32c.12.05.17.2.1.3a.27.27 0 0 1-.34.11l-.7-.32a.22.22 0 0 1-.12-.15M114.87 74.82a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.39-.04.12.1.13.28.03.4l-.55.65a.27.27 0 0 1-.21.1M108.48 77.01a.3.3 0 0 1-.1-.01l-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.21.35-.17l1.1.39a.28.28 0 0 1-.08.53M108.35 88.65a.3.3 0 0 1-.1-.02l-1.1-.38a.28.28 0 0 1-.17-.36c.05-.14.2-.21.35-.17l1.1.39a.28.28 0 0 1-.08.54M103.88 78.6a.28.28 0 0 1-.18-.49l.89-.76c.11-.1.29-.08.39.03.1.12.09.3-.03.4l-.88.76a.29.29 0 0 1-.19.07M106.43 80.1a.28.28 0 0 1-.28-.28v-1.49a.28.28 0 0 1 .56 0v1.49c0 .15-.13.27-.28.27M110.3 89.73a.28.28 0 0 1-.28-.27v-1.49a.28.28 0 0 1 .56 0v1.49c0 .15-.13.27-.28.27M102.94 81.74a.28.28 0 0 1-.17-.5l1.38-1.09a.28.28 0 1 1 .35.43l-1.38 1.1a.28.28 0 0 1-.18.06M106.43 82.9a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.12-.11.3-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M118.26 83.78a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.39c.11-.1.29-.1.4 0l1 1c.1.1.1.28 0 .38a.28.28 0 0 1-.2.08M103.88 84.33c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.37l.44-1.04c.06-.14.22-.2.36-.15.15.06.21.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M106.43 84.99a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.29.07.32.22.02.15-.08.3-.23.32l-1.49.27h-.05M105.38 87.08a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M114.86 88.18a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M117.95 80.3c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.05c.06-.14.22-.2.36-.14.15.05.21.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M119.17 82.21a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.05M115.71 82.07a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M108.48 87.08a.28.28 0 0 1-.18-.49l1.05-.88c.11-.1.29-.08.39.03.1.12.08.3-.04.4l-1.05.87a.28.28 0 0 1-.17.07M110.85 86.86a.28.28 0 0 1-.26-.18.28.28 0 0 1 .17-.36l1.82-.66c.15-.05.3.02.36.17.05.14-.02.3-.17.35l-1.82.66a.28.28 0 0 1-.1.02M114.05 84.85c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.4-1.05a.28.28 0 0 1 .35-.16c.14.05.21.21.16.35l-.39 1.05a.28.28 0 0 1-.26.18M113.2 77.47c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .52.2l-.39 1.04a.28.28 0 0 1-.26.18M116.68 85.7l-.07-.01-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33a.28.28 0 0 1-.07.55M111.77 77.07h-.06l-1.35-.25a.28.28 0 1 1 .1-.55l1.36.25a.28.28 0 0 1-.05.55M117.47 76.95h-.05l-1.36-.26a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M107.92 74.76a.28.28 0 0 1-.28-.28v-.97a.28.28 0 0 1 .56 0v.97c0 .16-.12.28-.28.28M105.38 76.94a.28.28 0 0 1-.28-.27V75.3a.28.28 0 0 1 .56 0v1.36c0 .15-.13.27-.28.27M112.01 75.2a.28.28 0 0 1-.26-.38l.56-1.41c.05-.14.22-.2.36-.16.14.06.21.22.16.36l-.56 1.41a.28.28 0 0 1-.26.18M114.5 79.35a.28.28 0 0 1-.27-.21.28.28 0 0 1 .2-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.06M110.85 78.98a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M56.45 72.06a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M52.22 89.88c-.04 0-.09 0-.13-.03a.45.45 0 0 1-.21-.33c-.06-.32.17-.75.7-1.31.52-.57 1.36-.35 2.25-.13 1.03.27 2.09.54 2.87-.21 1.3-1.26 2.17-1.28 3.09-1.3.26 0 .53 0 .83-.04.44-.06.83-.6.91-1.3.09-.72-.16-1.62-1.09-1.96-.46-.17-.73-.43-.81-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.73.9-1.01.11-.16.16-.29.13-.39-.06-.25-.56-.5-1.05-.73a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.27-.78.25-.87 2.4-1.32 3.06-1.44.15-.03.3.07.32.22.03.15-.07.3-.22.32-1.18.22-2.52.7-2.63 1.06-.02.05.02.13.12.22.38.35.9.6 1.37.84.65.32 1.21.6 1.34 1.08.07.27 0 .55-.21.84-.23.33-.58.7-.96 1.08-.64.66-1.52 1.58-1.4 2.06.03.15.18.28.46.38 1.23.45 1.55 1.65 1.44 2.54-.11.98-.67 1.7-1.4 1.79-.31.03-.6.04-.88.05-.87.01-1.56.03-2.72 1.14-1 .96-2.32.62-3.38.35-.76-.2-1.42-.36-1.72-.04-.5.53-.55.77-.56.83.09.08.1.21.05.32a.28.28 0 0 1-.25.15z"
  }), React__default.createElement("path", {
    d: "M56.45 78.98a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M171.63 45.85v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.12-.27.28-.27h.46l.3-1.31a.28.28 0 0 1 .26-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.78c0 .15-.12.27-.27.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M169.57 61.4h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.72h8.92l1.36-14.72.55.05-1.37 14.82a.44.44 0 0 1-.44.4M226.03 45.85v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.52.55a.28.28 0 0 1-.27-.27v-1.78c0-.15.12-.27.27-.27h.47l.29-1.31a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.78c0 .15-.12.27-.27.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M223.97 61.4h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.72h8.92l1.36-14.72.55.05-1.37 14.82a.44.44 0 0 1-.44.4M280.51 45.85v-1.22h-.4a.28.28 0 0 1-.27-.22l-.3-1.3h-11.29l-.3 1.3a.28.28 0 0 1-.26.22h-.41v1.22h13.23zm-13.5.55a.28.28 0 0 1-.29-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.31a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.78c0 .15-.12.27-.28.27H267z"
  }), React__default.createElement("path", {
    d: "M278.46 61.4h-9.12a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.72h8.92l1.36-14.72.55.05-1.37 14.82a.44.44 0 0 1-.44.4M246.7 42.85a9.16 9.16 0 0 0-9.18 9.12 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M245.76 46.31a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.4-.04.1.1.13.28.03.4l-.56.65a.28.28 0 0 1-.2.1M248.17 59.57a.28.28 0 0 1-.21-.46l.55-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.66a.27.27 0 0 1-.21.1M254.25 55.59c-.01-.05 0-.1.02-.16a.27.27 0 0 1 .35-.1l.69.32c.12.06.17.2.1.31a.27.27 0 0 1-.34.1l-.7-.32a.22.22 0 0 1-.12-.15M250.72 45.6a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.39-.03s.13.27.03.39l-.55.66a.28.28 0 0 1-.21.1M244.32 47.8a.3.3 0 0 1-.09-.02l-1.1-.38a.28.28 0 0 1-.18-.36c.06-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.54M244.2 59.43a.3.3 0 0 1-.1-.02l-1.1-.38a.28.28 0 0 1-.17-.35c.05-.15.2-.22.35-.17l1.1.38a.28.28 0 0 1-.09.54M239.73 49.4a.28.28 0 0 1-.18-.5l.88-.76c.12-.1.3-.09.4.02.1.12.09.3-.03.4l-.88.76a.28.28 0 0 1-.19.07M242.28 50.88a.28.28 0 0 1-.28-.28v-1.49c0-.15.12-.27.28-.27.15 0 .27.12.27.27v1.49c0 .15-.12.28-.27.28M246.15 60.51a.28.28 0 0 1-.28-.27v-1.49c0-.15.12-.27.28-.27.15 0 .27.12.27.27v1.49c0 .15-.12.27-.27.27M238.8 52.53a.28.28 0 0 1-.17-.5l1.37-1.1a.28.28 0 1 1 .35.44l-1.38 1.1a.28.28 0 0 1-.18.06M242.28 53.68a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.4c.11-.1.29-.1.4 0l1 1a.28.28 0 0 1-.2.47M254.1 54.57a.28.28 0 0 1-.2-.08l-.99-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M239.73 55.11c-.03 0-.07 0-.1-.02a.28.28 0 0 1-.15-.36l.44-1.05c.06-.14.22-.2.36-.14.14.05.21.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M242.28 55.77a.28.28 0 0 1-.05-.55l1.49-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.04M241.23 57.86a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .16-.12.28-.27.28M250.7 58.96a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .16-.13.28-.28.28M253.8 51.08c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.04c.06-.14.22-.21.36-.15.14.06.21.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M255.02 53a.28.28 0 0 1-.05-.55l1.5-.28c.14-.03.29.07.32.22.02.15-.07.3-.23.32l-1.49.28h-.05M251.56 52.85a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M244.32 57.86a.28.28 0 0 1-.18-.49l1.06-.88c.11-.1.29-.08.39.04.1.11.08.29-.04.39l-1.05.87a.28.28 0 0 1-.18.07M246.7 57.64a.28.28 0 0 1-.1-.54l1.83-.66c.15-.04.3.03.36.17.05.14-.03.3-.17.35l-1.82.67a.3.3 0 0 1-.1.01M249.9 55.63l-.1-.01a.27.27 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .36-.17c.14.06.21.22.16.36l-.39 1.04a.28.28 0 0 1-.26.18M249.05 48.25c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .36-.16c.14.05.21.21.16.36l-.39 1.04a.28.28 0 0 1-.26.18M252.53 56.48l-.07-.01-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33a.28.28 0 0 1-.07.55M247.61 47.85h-.05l-1.35-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.35.24c.15.03.25.17.23.32a.28.28 0 0 1-.28.23M253.32 47.73h-.05l-1.36-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.23l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M243.77 45.54a.28.28 0 0 1-.28-.27v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.13.27-.28.27M241.23 47.73a.28.28 0 0 1-.28-.28V46.1a.28.28 0 0 1 .55 0v1.36c0 .15-.12.28-.27.28M247.86 45.98a.28.28 0 0 1-.26-.38l.56-1.4c.05-.15.21-.22.36-.17.14.06.21.22.15.36l-.55 1.42a.28.28 0 0 1-.26.17M250.35 50.13a.28.28 0 0 1-.27-.21.28.28 0 0 1 .2-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.06M246.7 49.76a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M192.21 42.85a9.16 9.16 0 0 0-9.17 9.12 9.16 9.16 0 0 0 9.17 9.13c5.07 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M187.98 60.66c-.04 0-.08 0-.12-.03a.45.45 0 0 1-.22-.32c-.06-.33.17-.76.7-1.32.52-.56 1.36-.35 2.25-.12 1.03.26 2.09.53 2.87-.22 1.3-1.26 2.17-1.27 3.09-1.3.26 0 .53 0 .83-.04.45-.05.83-.6.91-1.3.09-.72-.15-1.62-1.08-1.96-.47-.17-.74-.43-.82-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.72.9-1.01.11-.16.16-.29.13-.38-.06-.25-.56-.5-1.05-.74a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.59-.27-.78.25-.86 2.4-1.32 3.06-1.44.15-.02.3.08.33.23.02.15-.08.29-.23.32-1.18.21-2.52.69-2.63 1.05-.02.06.02.13.12.22.38.35.9.61 1.37.84.65.32 1.21.6 1.34 1.09.07.26 0 .54-.21.84-.23.32-.58.68-.96 1.07-.64.67-1.52 1.58-1.4 2.06.03.15.18.28.46.38 1.23.46 1.55 1.66 1.44 2.55-.11.97-.67 1.69-1.4 1.78-.31.04-.6.04-.88.05-.87.02-1.56.03-2.71 1.14-1 .96-2.33.62-3.4.35-.75-.2-1.4-.36-1.71-.03-.49.52-.55.76-.56.82.09.09.1.22.05.33a.28.28 0 0 1-.25.14z"
  }), React__default.createElement("path", {
    d: "M192.21 49.76a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M137.87 42.85a9.16 9.16 0 0 0-9.18 9.12 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.12m0 18.8a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M136.93 46.31a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.39-.04.11.1.13.28.03.4l-.55.65a.28.28 0 0 1-.21.1M139.33 59.57a.28.28 0 0 1-.2-.46l.54-.66c.1-.11.28-.13.4-.03.11.1.13.27.03.39l-.55.66a.27.27 0 0 1-.22.1M145.41 55.59c0-.05 0-.1.03-.16a.27.27 0 0 1 .34-.1l.7.32c.12.06.16.2.1.31a.27.27 0 0 1-.35.1l-.69-.32a.22.22 0 0 1-.13-.15M141.88 45.6a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.28-.13.4-.03.11.1.13.27.03.39l-.55.66a.28.28 0 0 1-.22.1M135.49 47.8a.3.3 0 0 1-.1-.02l-1.1-.38a.28.28 0 0 1-.17-.36c.05-.14.2-.21.35-.17l1.11.39a.28.28 0 0 1-.1.54M135.36 59.43a.3.3 0 0 1-.1-.02l-1.1-.38a.28.28 0 0 1-.17-.35c.05-.15.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M130.9 49.4a.28.28 0 0 1-.18-.5l.88-.76c.12-.1.29-.09.4.02.1.12.08.3-.03.4l-.89.76a.28.28 0 0 1-.18.07M133.44 50.88a.28.28 0 0 1-.28-.28v-1.49c0-.15.13-.27.28-.27.16 0 .28.12.28.27v1.49c0 .15-.12.28-.28.28M137.31 60.51a.28.28 0 0 1-.28-.27v-1.49c0-.15.13-.27.28-.27.15 0 .28.12.28.27v1.49c0 .15-.13.27-.28.27M129.96 52.53a.28.28 0 0 1-.17-.5l1.38-1.1a.28.28 0 1 1 .34.44l-1.38 1.1a.28.28 0 0 1-.17.06M133.44 53.68a.28.28 0 0 1-.2-.08l-.99-.99a.27.27 0 0 1 0-.4c.1-.1.29-.1.4 0l.99 1a.28.28 0 0 1-.2.47M145.27 54.57a.28.28 0 0 1-.2-.08l-.99-1a.27.27 0 0 1 0-.38c.1-.11.28-.11.4 0l.99.99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M130.9 55.11c-.04 0-.07 0-.1-.02a.28.28 0 0 1-.16-.36l.44-1.05c.06-.14.23-.2.37-.14.14.05.2.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M133.44 55.77a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.05M132.4 57.86a.28.28 0 0 1-.29-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .16-.12.28-.28.28M141.87 58.96a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .16-.12.28-.28.28M144.97 51.08c-.04 0-.08 0-.11-.02a.27.27 0 0 1-.15-.36l.44-1.04c.06-.14.22-.21.37-.15.14.06.2.22.14.36l-.44 1.04a.28.28 0 0 1-.25.17M146.19 53a.28.28 0 0 1-.05-.55l1.49-.28c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.04M142.72 52.85a.28.28 0 0 1-.27-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.28.27M135.49 57.86a.28.28 0 0 1-.18-.49l1.05-.88c.12-.1.3-.08.4.04.1.11.07.29-.04.39l-1.05.87a.28.28 0 0 1-.18.07M137.87 57.64a.28.28 0 0 1-.1-.54l1.83-.66c.14-.04.3.03.35.17.05.14-.02.3-.16.35l-1.83.67a.3.3 0 0 1-.1.01M141.07 55.63l-.1-.01a.27.27 0 0 1-.16-.36l.38-1.04a.28.28 0 0 1 .36-.17c.14.06.22.22.16.36l-.38 1.04a.28.28 0 0 1-.26.18M140.22 48.25c-.04 0-.07 0-.1-.02a.28.28 0 0 1-.16-.35l.38-1.05a.28.28 0 0 1 .52.2l-.38 1.04a.28.28 0 0 1-.26.18M143.7 56.48l-.07-.01-1.28-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.28.33a.28.28 0 0 1-.07.55M138.78 47.85h-.05l-1.36-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.24c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M144.48 47.73h-.05l-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.23l1.35.25c.15.03.25.17.23.32a.28.28 0 0 1-.28.23M134.94 45.54a.28.28 0 0 1-.28-.27v-.98a.28.28 0 0 1 .55 0v.98c0 .15-.12.27-.27.27M132.4 47.73a.28.28 0 0 1-.29-.28V46.1a.28.28 0 0 1 .56 0v1.36c0 .15-.12.28-.28.28M139.03 45.98a.28.28 0 0 1-.26-.38l.55-1.4c.06-.15.22-.22.36-.17.15.06.22.22.16.36l-.55 1.42a.28.28 0 0 1-.26.17M141.51 50.13a.28.28 0 0 1-.27-.21.28.28 0 0 1 .21-.33l1.74-.39c.16-.03.3.06.34.21.03.15-.06.3-.22.33l-1.74.39h-.06M137.87 49.76a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M171.63 103.47v-1.23h-.4a.27.27 0 0 1-.28-.21l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.12-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.77c0 .15-.12.28-.27.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M169.57 119.01h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M226.03 103.47v-1.23h-.4a.27.27 0 0 1-.28-.21l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.52.55a.28.28 0 0 1-.27-.28v-1.77c0-.15.12-.28.27-.28h.47l.29-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.46c.15 0 .27.13.27.28v1.77c0 .15-.12.28-.27.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M223.97 119.01h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M280.51 103.47v-1.23h-.4a.28.28 0 0 1-.27-.21l-.3-1.3h-11.29l-.3 1.3a.28.28 0 0 1-.26.21h-.41v1.23h13.23zm-13.5.55a.28.28 0 0 1-.29-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.1.27.22l.3 1.3h.45c.16 0 .28.13.28.28v1.77c0 .15-.12.28-.28.28H267z"
  }), React__default.createElement("path", {
    d: "M278.46 119.01h-9.12a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M246.7 100.46a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M245.76 103.93a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.14.4-.04.1.1.13.27.03.4l-.56.65a.28.28 0 0 1-.2.1M248.17 117.18a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.39-.04.12.1.13.28.03.4l-.55.65a.27.27 0 0 1-.21.1M254.25 113.2c-.01-.05 0-.1.02-.15a.27.27 0 0 1 .35-.1l.69.32c.12.05.17.2.1.3a.27.27 0 0 1-.34.11l-.7-.32a.22.22 0 0 1-.12-.15M250.72 103.22a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.13.39-.04.12.1.13.27.03.4l-.55.65a.28.28 0 0 1-.21.1M244.32 105.41a.3.3 0 0 1-.09-.01l-1.1-.39a.28.28 0 0 1-.18-.35c.06-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.53M244.2 117.05a.3.3 0 0 1-.1-.02l-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.21.35-.17l1.1.39a.28.28 0 0 1-.09.54M239.73 107a.28.28 0 0 1-.18-.48l.88-.77c.12-.1.3-.08.4.03.1.12.09.3-.03.4l-.88.76a.28.28 0 0 1-.19.07M242.28 108.5a.28.28 0 0 1-.28-.28v-1.49c0-.15.12-.27.28-.27.15 0 .27.12.27.27v1.49c0 .15-.12.27-.27.27M246.15 118.13a.28.28 0 0 1-.28-.28v-1.48c0-.15.12-.28.28-.28.15 0 .27.13.27.28v1.48c0 .16-.12.28-.27.28M238.8 110.14a.28.28 0 0 1-.17-.5l1.37-1.09a.28.28 0 1 1 .35.43l-1.38 1.1a.28.28 0 0 1-.18.06M242.28 111.3a.28.28 0 0 1-.2-.08l-1-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M254.1 112.18a.28.28 0 0 1-.2-.08l-.99-.99a.27.27 0 0 1 0-.39c.11-.1.29-.1.4 0l1 1a.28.28 0 0 1-.2.46M239.73 112.73c-.03 0-.07 0-.1-.02a.28.28 0 0 1-.15-.37l.44-1.04c.06-.14.22-.2.36-.15.14.06.21.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M242.28 113.39a.28.28 0 0 1-.05-.55l1.49-.28c.15-.02.3.08.32.23.03.15-.07.3-.22.32l-1.5.27h-.04M241.23 115.48a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.27.28M250.7 116.58a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M253.8 108.7c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.05c.06-.14.22-.2.36-.15.14.06.21.22.15.37l-.44 1.04a.28.28 0 0 1-.26.17M255.02 110.61a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.29.07.32.22.02.15-.07.3-.23.32l-1.49.28h-.05M251.56 110.47a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M244.32 115.48a.28.28 0 0 1-.18-.49l1.06-.88c.11-.1.29-.08.39.03.1.12.08.3-.04.4l-1.05.87a.28.28 0 0 1-.18.07M246.7 115.26a.28.28 0 0 1-.1-.54l1.83-.66c.15-.05.3.02.36.17.05.14-.03.3-.17.35l-1.82.66a.3.3 0 0 1-.1.02M249.9 113.25c-.03 0-.06 0-.1-.02a.27.27 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .36-.16c.14.05.21.21.16.35l-.39 1.05a.28.28 0 0 1-.26.18M249.05 105.87c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .52.2l-.39 1.04a.28.28 0 0 1-.26.18M252.53 114.1l-.07-.01-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33a.28.28 0 0 1-.07.55M247.61 105.47h-.05l-1.35-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.23l1.35.25c.15.03.25.17.23.32a.28.28 0 0 1-.28.23M253.32 105.35h-.05l-1.36-.26a.28.28 0 1 1 .1-.54l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M243.77 103.16a.28.28 0 0 1-.28-.28v-.97a.28.28 0 0 1 .56 0v.97c0 .16-.13.28-.28.28M241.23 105.34a.28.28 0 0 1-.28-.27v-1.36a.28.28 0 0 1 .55 0v1.36c0 .15-.12.27-.27.27M247.86 103.6a.28.28 0 0 1-.26-.38l.56-1.41c.05-.14.21-.21.36-.16.14.06.21.22.15.36l-.55 1.41a.28.28 0 0 1-.26.18M250.35 107.75a.28.28 0 0 1-.27-.21.28.28 0 0 1 .2-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.06M246.7 107.38a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M192.21 100.46a9.16 9.16 0 0 0-9.17 9.13 9.16 9.16 0 0 0 9.17 9.13c5.07 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.73-9.68 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M187.98 118.28l-.12-.03a.45.45 0 0 1-.22-.33c-.06-.32.17-.75.7-1.31.52-.57 1.36-.35 2.25-.13 1.03.27 2.09.54 2.87-.21 1.3-1.26 2.17-1.28 3.09-1.3.26 0 .53 0 .83-.04.45-.06.83-.6.91-1.3.09-.72-.15-1.62-1.08-1.96-.47-.17-.74-.44-.82-.78-.18-.77.7-1.68 1.55-2.56.36-.38.7-.73.9-1.01.11-.16.16-.29.13-.39-.06-.25-.56-.5-1.05-.73a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.27-.78.25-.87 2.4-1.32 3.06-1.44.15-.03.3.07.33.22.02.15-.08.3-.23.32-1.18.22-2.52.7-2.63 1.06-.02.05.02.13.12.22.38.35.9.6 1.37.84.65.32 1.21.6 1.34 1.08.07.27 0 .55-.21.84-.23.32-.58.7-.96 1.08-.64.66-1.52 1.58-1.4 2.06.03.15.18.28.46.38 1.23.45 1.55 1.65 1.44 2.54-.11.98-.67 1.7-1.4 1.79-.31.03-.6.04-.88.05-.87.01-1.56.03-2.71 1.13-1 .97-2.33.63-3.4.36-.75-.2-1.4-.36-1.71-.04-.49.53-.55.77-.56.83.09.08.1.21.05.32a.28.28 0 0 1-.25.15z"
  }), React__default.createElement("path", {
    d: "M192.21 107.38a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M137.87 100.46a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M136.93 103.93a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.27-.14.39-.04.11.1.13.27.03.4l-.55.65a.28.28 0 0 1-.21.1M139.33 117.18a.28.28 0 0 1-.2-.45l.54-.66c.1-.12.28-.13.4-.04.11.1.13.28.03.4l-.55.65a.27.27 0 0 1-.22.1M145.41 113.2c0-.05 0-.1.03-.15a.27.27 0 0 1 .34-.1l.7.32c.12.05.16.2.1.3a.27.27 0 0 1-.35.11l-.69-.32a.22.22 0 0 1-.13-.15M141.88 103.22a.28.28 0 0 1-.21-.45l.55-.66c.1-.12.28-.13.4-.04.11.1.13.27.03.4l-.55.65a.28.28 0 0 1-.22.1M135.49 105.41a.3.3 0 0 1-.1-.01l-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.21.35-.17l1.11.39a.28.28 0 0 1-.1.53M135.36 117.05a.3.3 0 0 1-.1-.02l-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.54M130.9 107a.28.28 0 0 1-.18-.48l.88-.77c.12-.1.29-.08.4.03.1.12.08.3-.03.4l-.89.76a.28.28 0 0 1-.18.07M133.44 108.5a.28.28 0 0 1-.28-.28v-1.49c0-.15.13-.27.28-.27.16 0 .28.12.28.27v1.49c0 .15-.12.27-.28.27M137.31 118.13a.28.28 0 0 1-.28-.28v-1.48c0-.15.13-.28.28-.28.15 0 .28.13.28.28v1.48c0 .16-.13.28-.28.28M129.96 110.14a.28.28 0 0 1-.17-.5l1.38-1.09a.28.28 0 1 1 .34.43l-1.38 1.1a.28.28 0 0 1-.17.06M133.44 111.3a.28.28 0 0 1-.2-.08l-.99-1a.27.27 0 0 1 0-.38c.1-.11.29-.11.4 0l.99.99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M145.27 112.18a.28.28 0 0 1-.2-.08l-.99-.99a.27.27 0 0 1 0-.39c.1-.1.28-.1.4 0l.99 1a.28.28 0 0 1-.2.46M130.9 112.73c-.04 0-.07 0-.1-.02a.28.28 0 0 1-.16-.37l.44-1.04c.06-.14.23-.2.37-.15.14.06.2.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M133.44 113.39a.28.28 0 0 1-.05-.55l1.5-.28c.14-.02.3.08.32.23.03.15-.07.3-.22.32l-1.5.27h-.05M132.4 115.48a.28.28 0 0 1-.29-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.12.28-.28.28M141.87 116.58a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.28.28M144.97 108.7c-.04 0-.08 0-.11-.02a.27.27 0 0 1-.15-.36l.44-1.05c.06-.14.22-.2.37-.15.14.06.2.22.14.37l-.44 1.04a.28.28 0 0 1-.25.17M146.19 110.61a.28.28 0 0 1-.05-.55l1.49-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.04M142.72 110.47a.28.28 0 0 1-.27-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.28.27M135.49 115.48a.28.28 0 0 1-.18-.49l1.05-.88c.12-.1.3-.08.4.03.1.12.07.3-.04.4l-1.05.87a.28.28 0 0 1-.18.07M137.87 115.26a.28.28 0 0 1-.1-.54l1.83-.66c.14-.05.3.02.35.17.05.14-.02.3-.16.35l-1.83.66a.3.3 0 0 1-.1.02M141.07 113.25c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.16-.35l.38-1.05a.28.28 0 0 1 .36-.16c.14.05.22.21.16.35l-.38 1.05a.28.28 0 0 1-.26.18M140.22 105.87c-.04 0-.07 0-.1-.02a.28.28 0 0 1-.16-.35l.38-1.05a.28.28 0 0 1 .52.2l-.38 1.04a.28.28 0 0 1-.26.18M143.7 114.1l-.07-.01-1.28-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.28.33a.28.28 0 0 1-.07.55M138.78 105.47h-.05l-1.36-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.23l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M144.48 105.35h-.05l-1.35-.26a.28.28 0 1 1 .1-.54l1.35.25c.15.03.25.17.23.32a.28.28 0 0 1-.28.23M134.94 103.16a.28.28 0 0 1-.28-.28v-.97a.28.28 0 0 1 .55 0v.97c0 .16-.12.28-.27.28M132.4 105.34a.28.28 0 0 1-.29-.27v-1.36a.28.28 0 0 1 .56 0v1.36c0 .15-.12.27-.28.27M139.03 103.6a.28.28 0 0 1-.26-.38l.55-1.41c.06-.14.22-.21.36-.16.15.06.22.22.16.36l-.55 1.41a.28.28 0 0 1-.26.18M141.51 107.75a.28.28 0 0 1-.27-.21.28.28 0 0 1 .21-.33l1.74-.39c.16-.03.3.06.34.21.03.15-.06.3-.22.33l-1.74.39h-.06M137.87 107.38a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M63.07 103.47v-1.23h-.4a.27.27 0 0 1-.28-.21l-.29-1.3H50.8l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.13-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.13 0 .25.1.27.22l.3 1.3h.46c.15 0 .28.13.28.28v1.77c0 .15-.13.28-.28.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M61.01 119.01H51.9a.44.44 0 0 1-.44-.4l-1.37-14.83.56-.05 1.35 14.73h8.92l1.36-14.73.55.05-1.36 14.83a.44.44 0 0 1-.45.4M117.47 103.47v-1.23h-.4a.28.28 0 0 1-.28-.21l-.29-1.3h-11.3l-.29 1.3a.28.28 0 0 1-.27.21h-.4v1.23h13.23zm-13.51.55a.28.28 0 0 1-.28-.28v-1.77c0-.15.12-.28.28-.28h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.13 0 .25.1.27.22l.3 1.3h.46c.15 0 .28.13.28.28v1.77c0 .15-.13.28-.28.28h-13.8z"
  }), React__default.createElement("path", {
    d: "M115.41 119.01h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.36 14.83a.44.44 0 0 1-.45.4M83.66 100.46a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M79.43 118.28c-.05 0-.1-.01-.13-.03a.45.45 0 0 1-.22-.33c-.06-.32.17-.75.7-1.31.52-.57 1.37-.35 2.26-.13 1.02.27 2.08.54 2.86-.21 1.31-1.26 2.17-1.28 3.09-1.3.26 0 .53 0 .83-.04.45-.06.83-.6.91-1.3.09-.72-.15-1.62-1.08-1.96-.46-.17-.74-.44-.82-.78-.18-.77.7-1.68 1.56-2.56.36-.38.7-.73.9-1.01.1-.16.15-.29.12-.39-.06-.25-.56-.5-1.05-.73a6.02 6.02 0 0 1-1.5-.93c-.32-.3-.33-.6-.27-.78.26-.87 2.41-1.32 3.06-1.44.15-.03.3.07.33.22.03.15-.08.3-.23.32-1.18.22-2.52.7-2.63 1.06-.01.05.03.13.12.22.38.35.9.6 1.37.84.65.32 1.22.6 1.34 1.08.07.27 0 .55-.2.84-.23.32-.59.7-.96 1.08-.65.66-1.53 1.58-1.42 2.06.04.15.2.28.47.38 1.23.45 1.55 1.65 1.45 2.54-.12.98-.68 1.7-1.4 1.79-.32.03-.61.04-.89.05-.87.01-1.56.03-2.71 1.13-1 .97-2.33.63-3.4.36-.75-.2-1.4-.36-1.7-.04-.5.53-.56.77-.56.83a.27.27 0 0 1-.2.47z"
  }), React__default.createElement("path", {
    d: "M83.66 107.38a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M29.3 100.46a9.16 9.16 0 0 0-9.17 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.81a9.72 9.72 0 0 1-9.74-9.68 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M28.37 103.93a.28.28 0 0 1-.21-.45l.55-.66a.28.28 0 0 1 .43.35l-.56.66a.27.27 0 0 1-.21.1M30.78 117.18a.28.28 0 0 1-.22-.45l.56-.66c.1-.12.27-.13.39-.04.12.1.13.28.03.4l-.55.65a.27.27 0 0 1-.21.1M36.86 113.2c-.02-.05 0-.1.02-.15a.27.27 0 0 1 .34-.1l.7.32c.12.05.16.2.1.3a.27.27 0 0 1-.35.11l-.69-.32a.22.22 0 0 1-.12-.15M33.33 103.22a.28.28 0 0 1-.21-.45l.54-.66c.1-.12.28-.13.4-.04.11.1.13.27.03.4l-.55.65a.27.27 0 0 1-.21.1M26.93 105.41a.3.3 0 0 1-.09-.01l-1.1-.39a.28.28 0 0 1-.18-.35c.05-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.53M26.8 117.05a.3.3 0 0 1-.09-.02l-1.1-.39a.28.28 0 0 1-.18-.35c.05-.14.21-.21.36-.17l1.1.39a.28.28 0 0 1-.09.54M22.34 107a.28.28 0 0 1-.18-.48l.88-.77c.12-.1.3-.08.4.03.1.12.08.3-.03.4l-.89.76a.28.28 0 0 1-.18.07M24.88 108.5a.28.28 0 0 1-.27-.28v-1.49c0-.15.12-.27.27-.27.16 0 .28.12.28.27v1.49c0 .15-.12.27-.28.27M28.75 118.13a.28.28 0 0 1-.27-.28v-1.48c0-.15.12-.28.27-.28.16 0 .28.13.28.28v1.48c0 .16-.12.28-.28.28M21.4 110.14a.28.28 0 0 1-.17-.5l1.38-1.09a.28.28 0 1 1 .35.43l-1.39 1.1a.28.28 0 0 1-.17.06M24.88 111.3a.28.28 0 0 1-.2-.08l-.99-1a.28.28 0 1 1 .4-.38l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M36.71 112.18a.28.28 0 0 1-.2-.08l-.99-.99a.28.28 0 1 1 .4-.39l.99 1a.28.28 0 0 1-.2.46M22.34 112.73c-.04 0-.07 0-.1-.02a.27.27 0 0 1-.16-.37l.45-1.04c.06-.14.22-.2.36-.15.14.06.2.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M24.88 113.39a.28.28 0 0 1-.05-.55l1.5-.28c.15-.02.3.08.32.23.03.15-.07.3-.22.32l-1.5.27h-.05M23.83 115.48a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.28.28M33.32 116.58a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.27.28M36.4 108.7c-.03 0-.06 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.05a.28.28 0 0 1 .52.22l-.44 1.04a.28.28 0 0 1-.26.17M37.63 110.61a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.29.07.32.22.02.15-.08.3-.23.32l-1.49.28h-.05M34.17 110.47a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.27.27M26.93 115.48a.28.28 0 0 1-.18-.49l1.05-.88c.12-.1.3-.08.4.03.1.12.08.3-.04.4l-1.05.87a.28.28 0 0 1-.18.07M29.3 115.26a.28.28 0 0 1-.09-.54l1.83-.66c.14-.05.3.02.35.17.06.14-.02.3-.16.35l-1.83.66a.3.3 0 0 1-.1.02M32.51 113.25c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .35-.16c.15.05.22.21.17.35l-.39 1.05a.28.28 0 0 1-.26.18M31.66 105.87c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.35l.39-1.05a.28.28 0 0 1 .52.2l-.39 1.04a.28.28 0 0 1-.26.18M35.14 114.1l-.07-.01-1.27-.33a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.33c.15.04.24.2.2.34a.28.28 0 0 1-.27.2M30.22 105.47h-.05l-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.23l1.35.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M35.93 105.35h-.06l-1.35-.26a.28.28 0 1 1 .1-.54l1.35.25c.16.03.26.17.23.32a.28.28 0 0 1-.27.23M26.38 103.16a.28.28 0 0 1-.28-.28v-.97a.28.28 0 0 1 .56 0v.97c0 .16-.13.28-.28.28M23.83 105.34a.28.28 0 0 1-.27-.27v-1.36a.28.28 0 0 1 .55 0v1.36c0 .15-.12.27-.28.27M30.47 103.6a.28.28 0 0 1-.26-.38l.55-1.41c.06-.14.22-.21.36-.16.15.06.22.22.16.36l-.55 1.41a.28.28 0 0 1-.26.18M32.95 107.75a.28.28 0 0 1-.27-.21.28.28 0 0 1 .21-.33l1.75-.39a.28.28 0 1 1 .12.54l-1.74.39h-.07M29.3 107.38a2.39 2.39 0 0 0-2.38 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.8 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M171.63 160.35v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.12-.27.28-.27h.46l.3-1.3a.27.27 0 0 1 .26-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.46c.15 0 .27.13.27.28v1.78c0 .15-.12.27-.27.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M169.57 175.9h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M226.03 160.35v-1.22h-.4a.27.27 0 0 1-.28-.22l-.3-1.3h-11.29l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.52.55a.28.28 0 0 1-.27-.27v-1.78c0-.15.12-.27.27-.27h.47l.29-1.3a.28.28 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.46c.15 0 .27.13.27.28v1.78c0 .15-.12.27-.27.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M223.97 175.9h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M280.51 160.35v-1.22h-.4a.28.28 0 0 1-.27-.22l-.3-1.3h-11.29l-.3 1.3a.28.28 0 0 1-.26.22h-.41v1.22h13.23zm-13.5.55a.28.28 0 0 1-.29-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.3a.27.27 0 0 1 .27-.22h11.74c.13 0 .24.09.27.21l.3 1.3h.45c.16 0 .28.13.28.28v1.78c0 .15-.12.27-.28.27H267z"
  }), React__default.createElement("path", {
    d: "M278.46 175.9h-9.12a.44.44 0 0 1-.45-.4l-1.36-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.37 14.83a.44.44 0 0 1-.44.4M246.7 157.35a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M245.76 160.81a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.27-.13.4-.03.1.1.13.27.03.39l-.56.65a.28.28 0 0 1-.2.1M248.17 174.07a.28.28 0 0 1-.21-.45l.55-.66a.28.28 0 0 1 .43.35l-.56.66a.27.27 0 0 1-.21.1M254.25 170.1c-.01-.06 0-.12.02-.17a.27.27 0 0 1 .35-.1l.69.32c.12.06.17.2.1.31a.27.27 0 0 1-.34.1l-.7-.31a.22.22 0 0 1-.12-.16M250.72 160.1a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.66a.28.28 0 0 1-.21.1M244.32 162.3a.3.3 0 0 1-.09-.01l-1.1-.39a.28.28 0 0 1-.18-.35c.06-.15.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M244.2 173.93l-.1-.01-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.2-.22.35-.17l1.1.38a.28.28 0 0 1-.09.54M239.73 163.9a.28.28 0 0 1-.18-.48l.88-.78c.12-.1.3-.09.4.03.1.11.09.29-.03.39l-.88.77a.28.28 0 0 1-.19.06M242.28 165.38a.28.28 0 0 1-.28-.28v-1.48a.28.28 0 0 1 .55 0v1.48c0 .16-.12.28-.27.28M246.15 175.02a.28.28 0 0 1-.28-.28v-1.48c0-.16.12-.28.28-.28.15 0 .27.12.27.28v1.48c0 .15-.12.28-.27.28M238.8 167.03a.28.28 0 0 1-.17-.5l1.37-1.1c.12-.09.3-.07.4.05.09.12.07.3-.05.39l-1.38 1.1a.28.28 0 0 1-.18.06M242.28 168.18a.28.28 0 0 1-.2-.08l-1-.99a.27.27 0 0 1 0-.39c.11-.1.29-.1.4 0l1 1c.1.1.1.27 0 .38a.28.28 0 0 1-.2.08M254.1 169.07a.28.28 0 0 1-.2-.08l-.99-1a.27.27 0 0 1 0-.38c.11-.11.29-.11.4 0l1 .99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M239.73 169.61c-.03 0-.07 0-.1-.02a.27.27 0 0 1-.15-.36l.44-1.04c.06-.14.22-.21.36-.15.14.06.21.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M242.28 170.27a.28.28 0 0 1-.05-.55l1.49-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.04M241.23 172.36a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.27.27M250.7 173.46a.28.28 0 0 1-.27-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.27-.28.27M253.8 165.59c-.03 0-.07-.01-.1-.03a.27.27 0 0 1-.15-.36l.44-1.04a.28.28 0 0 1 .5.21l-.43 1.05a.28.28 0 0 1-.26.17M255.02 167.5a.28.28 0 0 1-.05-.55l1.5-.28c.14-.02.29.08.32.22.02.15-.07.3-.23.33l-1.49.27h-.05M251.56 167.36a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.13.28-.28.28M244.32 172.36a.28.28 0 0 1-.18-.49l1.06-.87c.11-.1.29-.09.39.03.1.12.08.3-.04.39l-1.05.88a.29.29 0 0 1-.18.06M246.7 172.14a.28.28 0 0 1-.1-.54l1.83-.65c.15-.05.3.02.36.16.05.15-.03.3-.17.36l-1.82.66a.3.3 0 0 1-.1.01M249.9 170.14c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .36-.16c.14.05.21.2.16.35l-.39 1.05a.28.28 0 0 1-.26.18M249.05 162.75l-.1-.01a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .36-.17c.14.06.21.21.16.36l-.39 1.04a.28.28 0 0 1-.26.18M252.53 170.98h-.07l-1.27-.34a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.34a.28.28 0 0 1-.07.54M247.61 162.36l-.05-.01-1.35-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.35.25c.15.03.25.17.23.32a.28.28 0 0 1-.28.23M253.32 162.23h-.05l-1.36-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.24a.28.28 0 0 1-.05.55M243.77 160.05a.28.28 0 0 1-.28-.28v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.13.28-.28.28M241.23 162.23a.28.28 0 0 1-.28-.28v-1.36a.28.28 0 0 1 .55 0v1.36c0 .16-.12.28-.27.28M247.86 160.48a.28.28 0 0 1-.26-.38l.56-1.4c.05-.15.21-.21.36-.16.14.05.21.21.15.36l-.55 1.4a.28.28 0 0 1-.26.18M250.35 164.64a.28.28 0 0 1-.27-.22.28.28 0 0 1 .2-.33l1.75-.38c.15-.04.3.06.33.2.03.16-.06.3-.21.34l-1.74.38h-.06M246.7 164.26a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.39-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M192.21 157.35a9.16 9.16 0 0 0-9.17 9.13 9.16 9.16 0 0 0 9.17 9.13c5.07 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.73-9.67 9.72 9.72 0 0 1 9.73-9.68 9.72 9.72 0 0 1 9.74 9.68 9.72 9.72 0 0 1-9.74 9.68"
  }), React__default.createElement("path", {
    d: "M187.98 175.17a.27.27 0 0 1-.12-.04.45.45 0 0 1-.22-.32c-.06-.32.17-.75.7-1.32.52-.56 1.36-.35 2.25-.12 1.03.26 2.09.53 2.87-.22 1.3-1.25 2.17-1.27 3.09-1.29.26 0 .53-.01.83-.05.45-.05.83-.6.91-1.3.09-.72-.15-1.62-1.08-1.96-.47-.17-.74-.43-.82-.77-.18-.78.7-1.69 1.55-2.57.36-.37.7-.72.9-1 .11-.16.16-.3.13-.4-.06-.24-.56-.49-1.05-.72a6.03 6.03 0 0 1-1.5-.93c-.33-.3-.33-.6-.27-.78.25-.87 2.4-1.32 3.06-1.44.15-.03.3.07.33.22.02.15-.08.3-.23.32-1.18.22-2.52.69-2.63 1.05-.02.06.02.13.12.22.38.36.9.61 1.37.84.65.32 1.21.6 1.34 1.1.07.25 0 .53-.21.83-.23.32-.58.69-.96 1.08-.64.66-1.52 1.57-1.4 2.05.03.15.18.28.46.38 1.23.46 1.55 1.66 1.44 2.55-.11.98-.67 1.7-1.4 1.78-.31.04-.6.05-.88.05-.87.02-1.56.03-2.71 1.14-1 .97-2.33.63-3.4.35-.75-.19-1.4-.35-1.71-.03-.49.52-.55.76-.56.83.09.08.1.21.05.32a.28.28 0 0 1-.25.15z"
  }), React__default.createElement("path", {
    d: "M192.21 164.26a2.39 2.39 0 0 0-2.39 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.6 0 2.8 2.8 0 0 1-2.8 2.8M137.87 157.35a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.74-9.67 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M136.93 160.81a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.27-.13.39-.03.11.1.13.27.03.39l-.55.65a.28.28 0 0 1-.21.1M139.33 174.07a.28.28 0 0 1-.2-.45l.54-.66c.1-.12.28-.14.4-.04.11.1.13.27.03.39l-.55.66a.27.27 0 0 1-.22.1M145.41 170.1c0-.06 0-.12.03-.17a.27.27 0 0 1 .34-.1l.7.32c.12.06.16.2.1.31a.27.27 0 0 1-.35.1l-.69-.31a.22.22 0 0 1-.13-.16M141.88 160.1a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.28-.13.4-.03.11.1.13.27.03.39l-.55.66a.28.28 0 0 1-.22.1M135.49 162.3a.3.3 0 0 1-.1-.01l-1.1-.39a.28.28 0 0 1-.17-.35c.05-.15.2-.22.35-.17l1.11.38a.28.28 0 0 1-.1.54M135.36 173.93l-.1-.01-1.1-.39a.28.28 0 0 1-.17-.35c.05-.14.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M130.9 163.9a.28.28 0 0 1-.18-.48l.88-.78c.12-.1.29-.09.4.03.1.11.08.29-.03.39l-.89.77a.28.28 0 0 1-.18.06M133.44 165.38a.28.28 0 0 1-.28-.28v-1.48a.28.28 0 0 1 .56 0v1.48c0 .16-.12.28-.28.28M137.31 175.02a.28.28 0 0 1-.28-.28v-1.48c0-.16.13-.28.28-.28.15 0 .28.12.28.28v1.48c0 .15-.13.28-.28.28M129.96 167.03a.28.28 0 0 1-.17-.5l1.38-1.1c.12-.09.3-.07.39.05.1.12.07.3-.05.39l-1.38 1.1a.28.28 0 0 1-.17.06M133.44 168.18a.28.28 0 0 1-.2-.08l-.99-.99a.27.27 0 0 1 0-.39c.1-.1.29-.1.4 0l.99 1c.1.1.1.27 0 .38a.28.28 0 0 1-.2.08M145.27 169.07a.28.28 0 0 1-.2-.08l-.99-1a.27.27 0 0 1 0-.38c.1-.11.28-.11.4 0l.99.99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M130.9 169.61c-.04 0-.07 0-.1-.02a.28.28 0 0 1-.16-.36l.44-1.04c.06-.14.23-.21.37-.15.14.06.2.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M133.44 170.27a.28.28 0 0 1-.05-.55l1.5-.27c.14-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.05M132.4 172.36a.28.28 0 0 1-.29-.27v-.88a.28.28 0 0 1 .56 0v.88c0 .15-.12.27-.28.27M141.87 173.46a.28.28 0 0 1-.27-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.28.27M144.97 165.59c-.04 0-.08-.01-.11-.03a.27.27 0 0 1-.15-.36l.44-1.04a.28.28 0 0 1 .51.21l-.44 1.05a.28.28 0 0 1-.25.17M146.19 167.5a.28.28 0 0 1-.05-.55l1.49-.28c.15-.02.3.08.32.22.03.15-.07.3-.22.33l-1.5.27h-.04M142.72 167.36a.28.28 0 0 1-.27-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.28.28M135.49 172.36a.28.28 0 0 1-.18-.49l1.05-.87c.12-.1.3-.09.4.03.1.12.07.3-.04.39l-1.05.88a.29.29 0 0 1-.18.06M137.87 172.14a.28.28 0 0 1-.1-.54l1.83-.65c.14-.05.3.02.35.16.05.15-.02.3-.16.36l-1.83.66a.3.3 0 0 1-.1.01M141.07 170.14c-.03 0-.07 0-.1-.02a.28.28 0 0 1-.16-.36l.38-1.04a.28.28 0 0 1 .36-.16c.14.05.22.2.16.35l-.38 1.05a.28.28 0 0 1-.26.18M140.22 162.75l-.1-.01a.28.28 0 0 1-.16-.36l.38-1.04a.28.28 0 0 1 .36-.17c.14.06.22.21.16.36l-.38 1.04a.28.28 0 0 1-.26.18M143.7 170.98h-.07l-1.28-.34a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.28.34a.28.28 0 0 1-.07.54M138.78 162.36l-.05-.01-1.36-.25a.27.27 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.36.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M144.48 162.23h-.05l-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.22l1.35.24a.28.28 0 0 1-.05.55M134.94 160.05a.28.28 0 0 1-.28-.28v-.98a.28.28 0 0 1 .55 0v.98c0 .15-.12.28-.27.28M132.4 162.23a.28.28 0 0 1-.29-.28v-1.36a.28.28 0 0 1 .56 0v1.36c0 .16-.12.28-.28.28M139.03 160.48a.28.28 0 0 1-.26-.38l.55-1.4c.06-.15.22-.21.36-.16.15.05.22.21.16.36l-.55 1.4a.28.28 0 0 1-.26.18M141.51 164.64a.28.28 0 0 1-.27-.22.28.28 0 0 1 .21-.33l1.74-.38c.16-.04.3.06.34.2.03.16-.06.3-.22.34l-1.74.38h-.06M137.87 164.26a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M63.07 160.35v-1.22h-.4a.27.27 0 0 1-.28-.22l-.29-1.3H50.8l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.13-.27.28-.27h.46l.3-1.3a.27.27 0 0 1 .26-.22h11.74c.13 0 .25.09.27.21l.3 1.3h.46c.15 0 .28.13.28.28v1.78c0 .15-.13.27-.28.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M61.01 175.9H51.9a.44.44 0 0 1-.44-.4l-1.37-14.83.56-.05 1.35 14.73h8.92l1.36-14.73.55.05-1.36 14.83a.44.44 0 0 1-.45.4M117.47 160.35v-1.22h-.4a.28.28 0 0 1-.28-.22l-.29-1.3h-11.3l-.29 1.3a.28.28 0 0 1-.27.22h-.4v1.22h13.23zm-13.51.55a.28.28 0 0 1-.28-.27v-1.78c0-.15.12-.27.28-.27h.46l.3-1.3a.28.28 0 0 1 .26-.22h11.74c.13 0 .25.09.27.21l.3 1.3h.46c.15 0 .28.13.28.28v1.78c0 .15-.13.27-.28.27h-13.8z"
  }), React__default.createElement("path", {
    d: "M115.41 175.9h-9.12a.44.44 0 0 1-.44-.4l-1.37-14.83.55-.05 1.36 14.73h8.92l1.36-14.73.55.05-1.36 14.83a.44.44 0 0 1-.45.4M83.66 157.35a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.74-9.67 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M79.43 175.17a.28.28 0 0 1-.13-.04.45.45 0 0 1-.22-.32c-.06-.32.17-.75.7-1.32.52-.56 1.37-.35 2.26-.12 1.02.26 2.08.53 2.86-.22 1.31-1.25 2.17-1.27 3.09-1.29.26 0 .53-.01.83-.05.45-.05.83-.6.91-1.3.09-.72-.15-1.62-1.08-1.96-.46-.17-.74-.43-.82-.77-.18-.78.7-1.69 1.56-2.57.36-.37.7-.72.9-1 .1-.16.15-.3.12-.4-.06-.24-.56-.49-1.05-.72a6.02 6.02 0 0 1-1.5-.93c-.32-.3-.33-.6-.27-.78.26-.87 2.41-1.32 3.06-1.44.15-.03.3.07.33.22.03.15-.08.3-.23.32-1.18.22-2.52.69-2.63 1.05-.01.06.03.13.12.22.38.36.9.61 1.37.84.65.32 1.22.6 1.34 1.1.07.25 0 .53-.2.83-.23.32-.59.69-.96 1.08-.65.66-1.53 1.57-1.42 2.05.04.15.2.28.47.38 1.23.46 1.55 1.66 1.45 2.55-.12.98-.68 1.7-1.4 1.78-.32.04-.61.05-.89.05-.87.02-1.56.03-2.71 1.14-1 .97-2.33.63-3.4.35-.75-.19-1.4-.35-1.7-.03-.5.52-.56.76-.56.83.08.08.1.21.04.32a.28.28 0 0 1-.24.15z"
  }), React__default.createElement("path", {
    d: "M83.66 164.26a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M29.3 157.35a9.16 9.16 0 0 0-9.17 9.13 9.17 9.17 0 0 0 9.18 9.13c5.06 0 9.18-4.1 9.18-9.13a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.74-9.67 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M28.37 160.81a.28.28 0 0 1-.21-.45l.55-.66c.1-.11.27-.13.39-.03s.13.27.03.39l-.55.65a.27.27 0 0 1-.21.1M30.78 174.07a.28.28 0 0 1-.22-.45l.56-.66a.28.28 0 0 1 .43.35l-.56.66a.27.27 0 0 1-.21.1M36.86 170.1c-.02-.06 0-.12.02-.17a.27.27 0 0 1 .34-.1l.7.32c.12.06.16.2.1.31a.27.27 0 0 1-.35.1l-.69-.31a.22.22 0 0 1-.12-.16M33.33 160.1a.28.28 0 0 1-.21-.45l.54-.66c.1-.11.28-.13.4-.03.11.1.13.27.03.39l-.55.66a.27.27 0 0 1-.21.1M26.93 162.3a.3.3 0 0 1-.09-.01l-1.1-.39a.28.28 0 0 1-.18-.35c.05-.15.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M26.8 173.93l-.09-.01-1.1-.39a.28.28 0 0 1-.18-.35c.05-.14.21-.22.36-.17l1.1.38a.28.28 0 0 1-.09.54M22.34 163.9a.28.28 0 0 1-.18-.48l.88-.78c.12-.1.3-.09.4.03.1.11.08.29-.03.39l-.89.77a.28.28 0 0 1-.18.06M24.88 165.38a.28.28 0 0 1-.27-.28v-1.48a.28.28 0 0 1 .55 0v1.48c0 .16-.12.28-.28.28M28.75 175.02a.28.28 0 0 1-.27-.28v-1.48c0-.16.12-.28.27-.28.16 0 .28.12.28.28v1.48c0 .15-.12.28-.28.28M21.4 167.03a.28.28 0 0 1-.17-.5l1.38-1.1c.12-.09.3-.07.39.05.1.12.08.3-.04.39l-1.39 1.1a.28.28 0 0 1-.17.06M24.88 168.18a.28.28 0 0 1-.2-.08l-.99-.99a.28.28 0 1 1 .4-.39l1 1c.1.1.1.27 0 .38a.28.28 0 0 1-.2.08M36.71 169.07a.28.28 0 0 1-.2-.08l-.99-1a.28.28 0 1 1 .4-.38l.99.99c.1.1.1.28 0 .39a.28.28 0 0 1-.2.08M22.34 169.61c-.04 0-.07 0-.1-.02a.27.27 0 0 1-.16-.36l.45-1.04c.06-.14.22-.21.36-.15.14.06.2.22.15.36l-.44 1.04a.28.28 0 0 1-.26.17M24.88 170.27a.28.28 0 0 1-.05-.55l1.5-.27c.15-.03.3.07.32.22.03.15-.07.3-.22.32l-1.5.28h-.05M23.83 172.36a.28.28 0 0 1-.27-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.28.27M33.32 173.46a.28.28 0 0 1-.28-.27v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.27-.27.27M36.4 165.59l-.1-.03a.27.27 0 0 1-.15-.36l.44-1.04c.07-.14.23-.21.37-.15.14.06.2.22.15.36l-.44 1.05a.28.28 0 0 1-.26.17M37.63 167.5a.28.28 0 0 1-.05-.55l1.5-.28c.14-.02.29.08.32.22.02.15-.08.3-.23.33l-1.49.27h-.05M34.17 167.36a.28.28 0 0 1-.28-.28v-.88a.28.28 0 0 1 .55 0v.88c0 .15-.12.28-.27.28M26.93 172.36a.28.28 0 0 1-.18-.49l1.05-.87c.12-.1.3-.09.4.03.1.12.08.3-.04.39l-1.05.88a.29.29 0 0 1-.18.06M29.3 172.14a.28.28 0 0 1-.09-.53l1.83-.66c.14-.05.3.02.35.16.06.15-.02.3-.16.36l-1.83.66a.3.3 0 0 1-.1.01M32.51 170.14c-.03 0-.06 0-.1-.02a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .35-.16c.15.05.22.2.17.35l-.39 1.05a.28.28 0 0 1-.26.18M31.66 162.75l-.1-.01a.28.28 0 0 1-.16-.36l.39-1.04a.28.28 0 0 1 .35-.17c.15.06.22.21.17.36l-.39 1.04a.28.28 0 0 1-.26.18M35.14 170.98h-.07l-1.27-.34a.28.28 0 0 1-.2-.34.28.28 0 0 1 .34-.2l1.27.34c.15.04.24.19.2.34a.28.28 0 0 1-.27.2M30.22 162.36l-.05-.01-1.35-.25a.28.28 0 0 1-.23-.32.27.27 0 0 1 .33-.22l1.35.25c.15.03.25.17.22.32a.28.28 0 0 1-.27.23M35.93 162.23h-.06l-1.35-.25a.28.28 0 0 1-.22-.32.27.27 0 0 1 .32-.22l1.35.24a.28.28 0 0 1-.04.55M26.38 160.05a.28.28 0 0 1-.28-.28v-.98a.28.28 0 0 1 .56 0v.98c0 .15-.13.28-.28.28M23.83 162.23a.28.28 0 0 1-.27-.28v-1.36a.28.28 0 0 1 .55 0v1.36c0 .16-.12.28-.28.28M30.47 160.48a.28.28 0 0 1-.26-.38l.55-1.4c.06-.15.22-.21.36-.16.15.05.22.21.16.36l-.55 1.4a.28.28 0 0 1-.26.18M32.95 164.64a.28.28 0 0 1-.27-.22.28.28 0 0 1 .21-.33l1.75-.38c.15-.04.3.06.33.2.03.16-.06.3-.21.34l-1.74.38h-.07M29.3 164.26a2.39 2.39 0 0 0-2.38 2.38 2.39 2.39 0 0 0 4.78 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8M273.9 129.1a9.16 9.16 0 0 0-9.18 9.13 9.16 9.16 0 0 0 9.18 9.12c5.06 0 9.18-4.09 9.18-9.12a9.16 9.16 0 0 0-9.18-9.13m0 18.8a9.72 9.72 0 0 1-9.74-9.67 9.72 9.72 0 0 1 9.74-9.68 9.72 9.72 0 0 1 9.73 9.68 9.72 9.72 0 0 1-9.73 9.68"
  }), React__default.createElement("path", {
    d: "M269.67 146.91c-.05 0-.1 0-.13-.03a.45.45 0 0 1-.22-.32c-.06-.32.17-.75.7-1.32.52-.56 1.37-.35 2.26-.12 1.02.26 2.08.53 2.86-.22 1.31-1.25 2.18-1.27 3.09-1.29.26 0 .53-.01.83-.05.45-.05.83-.6.92-1.3.08-.72-.16-1.62-1.1-1.96-.45-.17-.73-.43-.8-.78-.18-.77.7-1.68 1.55-2.56.36-.37.7-.72.9-1 .1-.16.15-.3.13-.4-.07-.24-.57-.49-1.06-.72a6.03 6.03 0 0 1-1.5-.93c-.32-.3-.32-.6-.27-.79.26-.86 2.41-1.32 3.06-1.43.15-.03.3.07.33.22.03.15-.07.3-.23.32-1.18.22-2.52.69-2.62 1.05-.02.06.02.13.11.22.38.36.9.61 1.37.84.65.32 1.22.6 1.34 1.09.07.26 0 .54-.2.84-.23.32-.59.69-.96 1.07-.65.67-1.53 1.58-1.42 2.06.04.15.2.28.47.38 1.24.46 1.55 1.66 1.45 2.55-.12.98-.68 1.7-1.4 1.78-.32.04-.6.05-.89.05-.87.02-1.56.03-2.71 1.14-1 .96-2.33.63-3.4.35-.75-.19-1.4-.35-1.7-.03-.5.52-.56.76-.56.83a.27.27 0 0 1-.2.46z"
  }), React__default.createElement("path", {
    d: "M273.9 136.01a2.39 2.39 0 0 0-2.4 2.38 2.39 2.39 0 0 0 4.79 0 2.39 2.39 0 0 0-2.4-2.38m0 5.17a2.8 2.8 0 0 1-2.8-2.79 2.8 2.8 0 0 1 5.61 0 2.8 2.8 0 0 1-2.8 2.8"
  })), React__default.createElement("g", {
    fill: "white"
  }, React__default.createElement("path", {
    d: "M94.26 35.73h21.65v-1.4H94.26zM46.89 34.38l-23.04-.08v1.32l23.03.07zM24.98 62.2h90.1v-1.39h-90.1zM27.27 47.97h2.1c1.46 0 2.1-.87 2.1-1.75s-.66-1.82-2-1.82h-2.2v3.57zm.65 2.37h-.65v4.64h-3.31v-13.2h5.95c3.37 0 4.89 2.18 4.89 4.37 0 1.85-1.08 3.48-3.42 4.02l3.76 4.8h-3.86l-3.36-4.63zM45.88 52.37V55H36.8V41.8h8.9v2.62h-5.74v2.72H45v2.7h-5.03v2.53zM65.58 41.86L61 55.06H58.6l-1.8-6.7-1.74 6.7h-2.41l-4.54-13.2h3.3l2.5 7.89 1.66-6.01h2.52l1.65 6.05 2.48-7.93zM71.94 49.43l-1.52-4.62-1.5 4.62h3.02zm.86 2.6h-4.72l-1 3.07H63.8l4.98-13.2h3.34l4.95 13.2h-3.26l-1.01-3.07zM82.06 47.94h2.11c1.46 0 2.09-.86 2.09-1.74s-.65-1.82-2-1.82h-2.2v3.56zm.66 2.38h-.66v4.63h-3.3v-13.2h5.94c3.37 0 4.89 2.2 4.89 4.37 0 1.86-1.07 3.49-3.42 4.03l3.76 4.8h-3.86l-3.35-4.63zM96.86 52.37c2.09 0 3.16-1.9 3.16-3.95 0-2.07-1.07-4-3.16-4h-2.33v7.95h2.33zM91.35 41.8h5.5c4.04 0 6.37 2.87 6.37 6.62 0 3.74-2.33 6.57-6.36 6.57h-5.51V41.8zM104.31 51.32h3.06c0 .87.85 1.53 1.9 1.53 1 0 1.75-.45 1.75-1.33 0-.53-.3-1.02-1.48-1.42l-1.6-.49c-2.95-.8-3.51-2.63-3.51-3.9 0-2.44 2.06-4.1 4.72-4.1 2.57 0 4.53 1.56 4.53 4.2h-3.05c0-.81-.48-1.5-1.53-1.5-.96 0-1.58.59-1.58 1.33 0 .28.08.89 1.32 1.24l1.4.43c1.9.6 3.85 1.6 3.85 4.05 0 2.9-2.49 4.15-4.94 4.15-2.85 0-4.84-1.7-4.84-4.19M63.84 19.87c-.09 0-.18 0-.27.02a1.92 1.92 0 0 0-1.6 1.99 1.55 1.55 0 0 0 1.84 1.46 1.92 1.92 0 0 0 1.6-1.99 1.55 1.55 0 0 0-1.57-1.48M89.4 35.3a.65.65 0 0 1-.66-.68c0-.37.29-.67.66-.67.38 0 .65.31.65.69 0 .37-.28.66-.65.66m0-1.52a.85.85 0 0 0-.87.84c0 .47.38.85.86.86a.85.85 0 1 0 .01-1.7"
  }), React__default.createElement("path", {
    d: "M89.46 34.64h-.12v-.27l.15-.01c.16 0 .24.06.24.14 0 .1-.12.14-.27.14m.32.08v-.01c.13-.04.23-.12.23-.23 0-.1-.04-.17-.1-.21a.83.83 0 0 0-.4-.07c-.19 0-.33 0-.44.02v.97h.26v-.39h.13c.14 0 .21.05.23.16.04.11.05.2.09.23h.28l-.08-.24c-.03-.13-.1-.2-.2-.23M88.03 26.74l.14-.12c.32-.25.45-.33.43-.6-.01-.17-.13-.26-.34-.47l-.3-.28c-.2-.2-.3-.24-.46-.23-.24.02-.55.21-.82.42-.36.28-.9.75-1.26 1.1a36.15 36.15 0 0 0-3.74 4.23c-1.46 1.87-2.11 2.56-2.61 2.7-.32.1-.73.03-.54-.91l.13-.42c.56-1.81 1.27-3.18 1.81-4.16.4-.74.24-.94-.21-1.26l-.73-.51c-.3-.2-.55-.24-.8-.16a.73.73 0 0 0-.24.11l-.01.02-.23.18a63.99 63.99 0 0 0-5.02 5.2c.92-2.46 1.42-3.53 1.76-4.28.3-.65.22-.84-.14-1.08-.25-.18-.52-.36-.95-.63-.39-.25-.7-.17-.97.07-.94.85-3.7 3.56-5.57 5.66.93-2.14 1.73-3.98 2.02-4.58.27-.58.31-.85-.14-1.19-.35-.25-.66-.45-.99-.65-.59-.37-.82-.12-1.06.25l-.4.64c-2.62 4.37-4.75 6.79-5.6 7.07-.36.11-.53.03-.61-.05-.3-.3-.03-1.13.1-1.47.45-1.21 1.33-3.14 2.23-4.98.34-.7.24-.91-.24-1.26-.3-.22-.58-.39-.94-.61-.54-.34-.86-.17-1.17.46-.73 1.5-2.58 5.3-2.93 7.38-.26 1.57.41 2.27 1.31 2.48.68.15 1.45-.03 1.88-.24.96-.44 2.3-1.57 4.1-4.1-.34.9-.72 1.93-.92 2.58-.22.73-.1.93.34 1.21l.58.37c.3.19.74.38 1.14-.1.53-.62 3.38-4.07 5.63-6.18a66.38 66.38 0 0 0-1.66 4.73c-.17.58-.03.78.45 1.1l.72.47c.17.1.65.33 1.07-.17.41-.48 2.79-3.47 4.72-5.35l-.16.35c-.68 1.5-1.06 2.7-1.17 3.51-.09.74-.02 1.9 1.25 2.26.5.15 1.23.12 1.94-.16 1.42-.55 2.3-1.83 4.15-4.25.47-.6.98-1.23 1.47-1.8-.04.78.2 1.58.72 2.54.4.75.54 1.36.39 1.87-.22.7-.9.74-1.1.74-.57.01-.97-.4-1.08-1.08-.08-.55-.15-.7-.42-.72-.1 0-.22.05-.36.15-.1.08-.31.26-.48.48-.37.47-.3.95-.08 1.35.46.82 1.43 1.12 2.6 1.1 2.06-.01 3.26-1.06 3.51-2.9.04-.28.1-.8-.18-1.64-.21-.66-.69-1.54-.85-1.9-.48-1.06.24-1.76.89-2.3"
  }), React__default.createElement("path", {
    d: "M69.83 17.67c.45-.01.78-.25.58-.73-.2-.48-.22-.47-.41-.9-.2-.44-.45-.46-1.08-.45-7.5.1-17.25.9-19.31 1.1-.95.09-.78.6-.61 1.09.09.27.04.1.21.54.21.54.3.87 1.23.74.74-.1 4.16-.4 6.77-.65-.68 1.44-1.46 3-3.05 6.37-.91 1.95-1.99 4.56-3.68 8.15-.18.37-.37.84.21 1.22.48.3.8.5 1.4.83.6.34.94.13 1.16-.35.51-1.13 5.93-13.55 7.24-16.45 3.04-.2 6.14-.4 9.34-.5"
  }))), React__default.createElement(StyledRect, {
    fill: "url(#d)",
    x: ".83",
    y: "1.65",
    width: "300.17",
    height: "189.35",
    rx: "14"
  })));
};

var map = function map(_a) {
  var _a$title57 = _a.title,
      title = _a$title57 === void 0 ? '' : _a$title57,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m21.444 2-0.1777 0.03333-5.9334 2.3-6.6666-2.3333-6.2667 2.1111c-0.23333 0.07778-0.4 0.27778-0.4 0.53333v16.8c0 0.3112 0.24444 0.5556 0.55556 0.5556l0.17777-0.0333 5.9333-2.3 6.6666 2.3333 6.2667-2.1111c0.2333-0.0778 0.4-0.2778 0.4-0.5333v-16.8c0-0.31112-0.2444-0.55556-0.5556-0.55556zm-11.667 2.7444 4.4444 1.5556v12.956l-4.4444-1.5556v-12.956zm-5.5556 1.1 3.3333-1.1222v13l-3.3333 1.2889v-13.167zm15.556 12.311-3.3334 1.1222v-12.989l3.3334-1.2889v13.156z"
  }));
};

var mapleLeaf = function mapleLeaf(_a) {
  var _a$title58 = _a.title,
      title = _a$title58 === void 0 ? '' : _a$title58,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 25.8 26.31"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12.9 26.31l-.39-.48c-.63-.78-1.68-1-3.19-.81l-.58.1v-1.57H4.6l2.33-2.44C5.6 20 3.49 18.35.59 16L0 15.58l.66-.37C2.79 14 2.31 12.76 1.64 11l-.56-1.53 1.13.53c1.33.66 2.37.84 3.08.52A2.24 2.24 0 0 0 6.43 9l.26-1 1.75 2.19c-.12-1.71-.22-3.7-.31-5.91v-.82l.74.35a2.13 2.13 0 0 0 1.71.19 4.14 4.14 0 0 0 1.85-2.62L12.9 0l.47 1.35A4.14 4.14 0 0 0 15.22 4 2.13 2.13 0 0 0 17 3.83l.74-.35v.82c-.09 2.21-.19 4.2-.31 5.91L19.1 8l.27.94a2.24 2.24 0 0 0 1.14 1.59c.71.32 1.74.14 3.08-.52l1.13-.56-.56 1.55c-.67 1.77-1.15 3 1 4.22l.66.37-.59.46c-2.9 2.31-5 4-6.34 5.07l2.33 2.44h-4.16v1.57l-.58-.1c-1.51-.24-2.56 0-3.19.81zm-2.6-2.37a3.81 3.81 0 0 1 2.6.86 4.05 4.05 0 0 1 3.16-.8v-1.45h2.81L17.4 21l.42-.34c1.2-1 3.28-2.63 6.22-5-1.82-1.3-1.57-2.89-1.09-4.31a3.84 3.84 0 0 1-2.84.08 2.83 2.83 0 0 1-1.37-1.38l-2.62 3.35.13-1.64c.15-1.87.28-4.14.39-6.76a2.78 2.78 0 0 1-1.81-.11 4 4 0 0 1-1.93-2.07A4 4 0 0 1 11 4.89 2.78 2.78 0 0 1 9.16 5c.11 2.62.24 4.89.39 6.76l.13 1.64-2.62-3.31a2.83 2.83 0 0 1-1.37 1.38 3.84 3.84 0 0 1-2.84-.08c.48 1.42.73 3-1.09 4.31 2.94 2.34 5 4 6.22 5l.42.3-1.47 1.55h2.81V24z"
  }));
};

var mapleLeafFilled = function mapleLeafFilled(_a) {
  var _a$title59 = _a.title,
      title = _a$title59 === void 0 ? '' : _a$title59,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12 0c.946 2.714 2.37 3.634 4.27 2.76a194.698 194.698 0 0 1-.422 7.52l2.142-2.707c.633 2.234 2.274 2.695 4.925 1.383-.695 1.885-1.585 3.71 1.085 5.178a742.943 742.943 0 0 0-6.76 5.407l1.892 1.989h-3.475v1.481c-1.687-.268-2.906.062-3.657.989-.751-.927-1.97-1.257-3.657-.989V21.53H4.868l1.893-1.989A742.943 742.943 0 0 0 0 14.134c2.67-1.467 1.78-3.293 1.085-5.178 2.65 1.312 4.292.85 4.925-1.383l2.142 2.706A194.698 194.698 0 0 1 7.73 2.76C9.63 3.634 11.054 2.714 12 0z"
  }));
};

var mastercard = function mastercard(_a) {
  var _a$title60 = _a.title,
      title = _a$title60 === void 0 ? '' : _a$title60,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 32 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "icon-/-card-/-mastercard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: "0",
    y: "0",
    width: "32",
    height: "20",
    rx: "2"
  }), React__default.createElement("path", {
    d: "M10.8721385,16.6265846 C10.8721385,16.3681231 11.0413692,16.1558154 11.3181385,16.1558154 C11.5827538,16.1558154 11.7612154,16.3590462 11.7612154,16.6265846 C11.7612154,16.8942769 11.5827538,17.0973538 11.3181385,17.0973538 C11.0413692,17.0973538 10.8721385,16.8850462 10.8721385,16.6265846 L10.8721385,16.6265846 Z M12.0627538,16.6265846 L12.0627538,15.8913538 L11.7427538,15.8913538 L11.7427538,16.0698154 C11.6412154,15.9375077 11.4873692,15.8544308 11.2781385,15.8544308 C10.8659846,15.8544308 10.5429077,16.1775077 10.5429077,16.6265846 C10.5429077,17.0758154 10.8659846,17.3988923 11.2781385,17.3988923 C11.4873692,17.3988923 11.6412154,17.3156615 11.7427538,17.1835077 L11.7427538,17.3619692 L12.0627538,17.3619692 L12.0627538,16.6265846 Z M22.8673692,16.6265846 C22.8673692,16.3681231 23.0366,16.1558154 23.3135231,16.1558154 C23.5779846,16.1558154 23.7566,16.3590462 23.7566,16.6265846 C23.7566,16.8942769 23.5779846,17.0973538 23.3135231,17.0973538 C23.0366,17.0973538 22.8673692,16.8850462 22.8673692,16.6265846 L22.8673692,16.6265846 Z M24.0579846,16.6265846 L24.0579846,15.3007385 L23.7379846,15.3007385 L23.7379846,16.0698154 C23.6364462,15.9375077 23.4826,15.8544308 23.2735231,15.8544308 C22.8612154,15.8544308 22.5382923,16.1775077 22.5382923,16.6265846 C22.5382923,17.0758154 22.8612154,17.3988923 23.2735231,17.3988923 C23.4826,17.3988923 23.6364462,17.3156615 23.7379846,17.1835077 L23.7379846,17.3619692 L24.0579846,17.3619692 L24.0579846,16.6265846 Z M16.0313692,16.1405846 C16.2375231,16.1405846 16.3698308,16.2698154 16.4036769,16.4973538 L15.6407538,16.4973538 C15.6744462,16.2850462 15.8036769,16.1405846 16.0313692,16.1405846 L16.0313692,16.1405846 Z M16.0375231,15.8544308 C15.6067538,15.8544308 15.3053692,16.1682769 15.3053692,16.6265846 C15.3053692,17.0942769 15.6190615,17.3988923 16.0590615,17.3988923 C16.2806,17.3988923 16.4836769,17.3435077 16.6619846,17.1927385 L16.5052154,16.9558154 C16.3821385,17.0542769 16.2252154,17.1096615 16.0775231,17.1096615 C15.8713692,17.1096615 15.6836769,17.0142769 15.6376769,16.7496615 L16.7298308,16.7496615 C16.7327538,16.7096615 16.7359846,16.6696615 16.7359846,16.6265846 C16.7327538,16.1682769 16.4496769,15.8544308 16.0375231,15.8544308 L16.0375231,15.8544308 Z M19.8984462,16.6265846 C19.8984462,16.3681231 20.0678308,16.1558154 20.3447538,16.1558154 C20.6093692,16.1558154 20.7876769,16.3590462 20.7876769,16.6265846 C20.7876769,16.8942769 20.6093692,17.0973538 20.3447538,17.0973538 C20.0678308,17.0973538 19.8984462,16.8850462 19.8984462,16.6265846 L19.8984462,16.6265846 Z M21.0892154,16.6265846 L21.0892154,15.8913538 L20.7692154,15.8913538 L20.7692154,16.0698154 C20.6676769,15.9375077 20.5138308,15.8544308 20.3046,15.8544308 C19.8922923,15.8544308 19.5693692,16.1775077 19.5693692,16.6265846 C19.5693692,17.0758154 19.8922923,17.3988923 20.3046,17.3988923 C20.5138308,17.3988923 20.6676769,17.3156615 20.7692154,17.1835077 L20.7692154,17.3619692 L21.0892154,17.3619692 L21.0892154,16.6265846 Z M18.0926,16.6265846 C18.0926,17.0727385 18.4035231,17.3988923 18.8772154,17.3988923 C19.0986,17.3988923 19.2462923,17.3496615 19.4062923,17.2235077 L19.2524462,16.9650462 C19.1326,17.0512 19.0064462,17.0973538 18.8679846,17.0973538 C18.6126,17.0942769 18.4249077,16.9096615 18.4249077,16.6265846 C18.4249077,16.3436615 18.6126,16.1590462 18.8679846,16.1558154 C19.0064462,16.1558154 19.1326,16.2019692 19.2524462,16.2882769 L19.4062923,16.0298154 C19.2462923,15.9036615 19.0986,15.8544308 18.8772154,15.8544308 C18.4035231,15.8544308 18.0926,16.1805846 18.0926,16.6265846 L18.0926,16.6265846 Z M22.2152154,15.8544308 C22.0306,15.8544308 21.9106,15.9405846 21.8275231,16.0698154 L21.8275231,15.8913538 L21.5106,15.8913538 L21.5106,17.3619692 L21.8306,17.3619692 L21.8306,16.5375077 C21.8306,16.2944308 21.9352154,16.1590462 22.1444462,16.1590462 C22.2090615,16.1590462 22.2766,16.1682769 22.3444462,16.1959692 L22.4427538,15.8944308 C22.3721385,15.8668923 22.2798308,15.8544308 22.2152154,15.8544308 L22.2152154,15.8544308 Z M13.6441385,16.0081231 C13.4902923,15.9067385 13.2779846,15.8544308 13.0441385,15.8544308 C12.6718308,15.8544308 12.4319846,16.0328923 12.4319846,16.3252 C12.4319846,16.5652 12.6102923,16.7128923 12.9395231,16.7588923 L13.0902923,16.7804308 C13.2656769,16.8050462 13.3487538,16.8512 13.3487538,16.9342769 C13.3487538,17.0481231 13.2316769,17.1127385 13.0133692,17.1127385 C12.7918308,17.1127385 12.6318308,17.0419692 12.5241385,16.9588923 L12.3733692,17.2081231 C12.5487538,17.3372 12.7702923,17.3988923 13.0102923,17.3988923 C13.4347538,17.3988923 13.6809077,17.1988923 13.6809077,16.9188923 C13.6809077,16.6605846 13.4872154,16.5252 13.1672154,16.4788923 L13.0164462,16.4573538 C12.8779846,16.4388923 12.7672154,16.4113538 12.7672154,16.3128923 C12.7672154,16.2052 12.8718308,16.1405846 13.0472154,16.1405846 C13.2347538,16.1405846 13.4164462,16.2113538 13.5056769,16.2667385 L13.6441385,16.0081231 Z M17.7695231,15.8544308 C17.5850615,15.8544308 17.4650615,15.9405846 17.3819846,16.0698154 L17.3819846,15.8913538 L17.0650615,15.8913538 L17.0650615,17.3619692 L17.3849077,17.3619692 L17.3849077,16.5375077 C17.3849077,16.2944308 17.4896769,16.1590462 17.6989077,16.1590462 C17.7633692,16.1590462 17.8312154,16.1682769 17.8987538,16.1959692 L17.9972154,15.8944308 C17.9264462,15.8668923 17.8341385,15.8544308 17.7695231,15.8544308 L17.7695231,15.8544308 Z M15.0407538,15.8913538 L14.5178308,15.8913538 L14.5178308,15.4452 L14.1947538,15.4452 L14.1947538,15.8913538 L13.8962923,15.8913538 L13.8962923,16.1836615 L14.1947538,16.1836615 L14.1947538,16.8542769 C14.1947538,17.1958154 14.3270615,17.3988923 14.7055231,17.3988923 C14.8438308,17.3988923 15.0038308,17.3556615 15.1053692,17.2850462 L15.0130615,17.0112 C14.9176769,17.0665846 14.8130615,17.0942769 14.7299846,17.0942769 C14.5701385,17.0942769 14.5178308,16.9958154 14.5178308,16.8481231 L14.5178308,16.1836615 L15.0407538,16.1836615 L15.0407538,15.8913538 Z M10.2598308,17.3619692 L10.2598308,16.4388923 C10.2598308,16.0913538 10.0384462,15.8575077 9.68152308,15.8544308 C9.49383077,15.8513538 9.29998462,15.9098154 9.1646,16.1159692 C9.06306154,15.9528923 8.90321538,15.8544308 8.6786,15.8544308 C8.52167692,15.8544308 8.36783077,15.9005846 8.24783077,16.0728923 L8.24783077,15.8913538 L7.92783077,15.8913538 L7.92783077,17.3619692 L8.25090769,17.3619692 L8.25090769,16.5465846 C8.25090769,16.2912 8.39244615,16.1558154 8.61090769,16.1558154 C8.82321538,16.1558154 8.93075385,16.2944308 8.93075385,16.5435077 L8.93075385,17.3619692 L9.25383077,17.3619692 L9.25383077,16.5465846 C9.25383077,16.2912 9.40152308,16.1558154 9.61383077,16.1558154 C9.83229231,16.1558154 9.93675385,16.2944308 9.93675385,16.5435077 L9.93675385,17.3619692 L10.2598308,17.3619692 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), React__default.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF5F00",
    points: "13.5376923 13.3928615 18.3838462 13.3928615 18.3838462 4.68424615 13.5376923 4.68424615"
  }), React__default.createElement("path", {
    d: "M13.8454,9.03846154 C13.8454,7.27169231 14.6726308,5.69830769 15.9607846,4.68415385 C15.0186308,3.94246154 13.8300154,3.5 12.5380154,3.5 C9.47955385,3.5 7.00001538,5.97969231 7.00001538,9.03846154 C7.00001538,12.0972308 9.47955385,14.5769231 12.5380154,14.5769231 C13.8300154,14.5769231 15.0186308,14.1344615 15.9607846,13.3927692 C14.6726308,12.3786154 13.8454,10.8052308 13.8454,9.03846154",
    id: "Fill-6",
    fill: "#EB001B"
  }), React__default.createElement("path", {
    d: "M24.9216462,9.03846154 C24.9216462,12.0972308 22.4421077,14.5769231 19.3834923,14.5769231 C18.0914923,14.5769231 16.9028769,14.1344615 15.9607231,13.3927692 C17.2490308,12.3786154 18.0761077,10.8052308 18.0761077,9.03846154 C18.0761077,7.27169231 17.2490308,5.69830769 15.9607231,4.68415385 C16.9028769,3.94246154 18.0914923,3.5 19.3834923,3.5 C22.4421077,3.5 24.9216462,5.97969231 24.9216462,9.03846154",
    id: "Fill-7",
    fill: "#F79E1B"
  })));
};

var menu = function menu(_a) {
  var _a$title61 = _a.title,
      title = _a$title61 === void 0 ? '' : _a$title61,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
  }));
};

var mobile = function mobile(_a) {
  var _a$title62 = _a.title,
      title = _a$title62 === void 0 ? '' : _a$title62,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z"
  }));
};

var mobileNavHomePLK = function mobileNavHomePLK(_a) {
  var _a$title63 = _a.title,
      title = _a$title63 === void 0 ? '' : _a$title63,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M11.364 11.513s3.735-1.16 2.902-3.64c-.956-2.836-4.493-1.121-4.493-1.121l-.032.015 1.616 4.74.007.006zm1.408 4.431l1.995 5.854L9.102 24 3.972 8.956l-1.826.71L0 3.367l.516-.197 1.75-.682c5.29-2.02 15.668-5.587 18.54 2.937 2.29 6.83-7.967 10.468-7.967 10.468l-.067.05z",
    fillRule: "evenodd"
  }));
};

var mobileNavHomeBK = function mobileNavHomeBK(_a) {
  var _a$title64 = _a.title,
      title = _a$title64 === void 0 ? '' : _a$title64,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 17 19"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M15.987 18.906c0-.057-2.786.078-3.022.086-.404.017-.812.004-1.216-.01-.753-.031-1.516-.018-2.265-.014-.58.003-1.153-.06-1.731-.038-1.325.049-2.643-.027-3.968-.027-.591.002-1.267 0-1.855.003-.652.005-1.243.067-1.895 0-.03-.003-.049-1.764-.023-1.922.02-.13.113-1.936.023-1.938 1.54.072 3.101.038 4.646.046 1.726.01 3.452.002 5.175-.069 2.044-.088 4.088.111 6.13.023-.054.001-.024 2.15-.022 2.336.001.188.004.373.023.562.03.32 0 .641 0 .962M16 3.15c0 .04-6.553.793-6.712.781-2.437-.172-.884-.003-3.328 0-.368 0-5.956-.037-5.96.058V.027c0-.084 8.092.058 8.827.058 1.165 0 2.327-.006 3.491.032C12.562.124 16 .128 16 .193V3.15zM5.787 9.462c1.97-.193 3.918-.41 4.297-.448 1.724-.176 3.458-.34 5.186-.485.088-.007 1.667-.136 1.667-.14a24.905 24.905 0 00-.215-1.958c-.034-.24-.017-.49-.028-.732-.006-.134.034-1.671-.043-1.685-.031-.007-7.767.74-8.388.81-.603.068-7.253.663-7.263.501l.268 4.094c.542-.006 2.557.016 4.519.043M16 13.949c-.99 0-2.029.013-3.014.042-1.624.044-3.444-.084-5.135-.147-.638-.024-7.8.136-7.807.105-.108-.658.019-1.296.006-1.946-.003-.206-.035-.42-.04-.627-.006-.285.034-.55.034-.838v-.534c0-.027 8.326.08 9.02.08h.338a45.8 45.8 0 012.51.048c.878.048 1.761-.128 2.635-.128H16v3.945z"
  })));
};

var mobileNavHomeTH = function mobileNavHomeTH(_a) {
  var _a$title65 = _a.title,
      title = _a$title65 === void 0 ? '' : _a$title65,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0  0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M12 0c.946 2.714 2.37 3.634 4.27 2.76a194.698 194.698 0 0 1-.422 7.52l2.142-2.707c.633 2.234 2.274 2.695 4.925 1.383-.695 1.885-1.585 3.71 1.085 5.178a742.943 742.943 0 0 0-6.76 5.407l1.892 1.989h-3.475v1.481c-1.687-.268-2.906.062-3.657.989-.751-.927-1.97-1.257-3.657-.989V21.53H4.868l1.893-1.989A742.943 742.943 0 0 0 0 14.134c2.67-1.467 1.78-3.293 1.085-5.178 2.65 1.312 4.292.85 4.925-1.383l2.142 2.706A194.698 194.698 0 0 1 7.73 2.76C9.63 3.634 11.054 2.714 12 0z"
  }));
};

var WhatsNewIcon = function WhatsNewIcon(_a) {
  var _a$title66 = _a.title,
      title = _a$title66 === void 0 ? "What's New" : _a$title66,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 67 67"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M33.5 61.9l-7.34 4.706a2 2 0 0 1-2.856-.766L19.3 58.095l-8.71.405a2 2 0 0 1-2.09-2.09l.405-8.71-7.745-4.004a2 2 0 0 1-.766-2.856L5.1 33.5.394 26.16a2 2 0 0 1 .766-2.856L8.905 19.3 8.5 10.59a2 2 0 0 1 2.09-2.09l8.71.405 4.004-7.745A2 2 0 0 1 26.16.394L33.5 5.1 40.84.394a2 2 0 0 1 2.856.766L47.7 8.905l8.71-.405a2 2 0 0 1 2.09 2.09l-.405 8.71 7.745 4.004a2 2 0 0 1 .766 2.856L61.9 33.5l4.706 7.34a2 2 0 0 1-.766 2.856L58.095 47.7l.405 8.71a2 2 0 0 1-2.09 2.09l-8.71-.405-4.004 7.745a2 2 0 0 1-2.856.766L33.5 61.9zM21.442 28.33c-.086.02-.119.073-.099.16l1.54 6.666-4.782-5.94a.181.181 0 0 0-.196-.069l-2.465.57c-.086.02-.119.072-.1.158l3.406 14.748c.02.086.072.119.158.099l2.358-.544c.086-.02.119-.073.099-.159l-1.54-6.666 4.76 5.945c.032.038.09.093.197.068l2.486-.574c.086-.02.119-.073.1-.158l-3.406-14.749c-.02-.085-.072-.118-.158-.098l-2.358.544zm15.791 9.722c-.02-.086-.072-.119-.158-.1l-4.587 1.06-1.05-4.545 3.988-.92c.085-.02.118-.073.099-.158l-.505-2.187c-.02-.086-.073-.119-.159-.099l-3.987.92-.722-3.129 4.587-1.059c.086-.02.119-.073.1-.158l-.506-2.187c-.02-.086-.072-.119-.158-.099l-7.974 1.841c-.086.02-.119.073-.1.159l3.406 14.748c.02.085.072.118.158.099l7.974-1.841c.086-.02.119-.073.1-.159l-.506-2.186zm4.402-14.383c-.065.015-.081.041-.083.132l.262 7.097-2.98-6.447c-.04-.08-.072-.119-.179-.094l-3.28.757c-.15.035-.13.12-.11.206l6.642 14.001c.036.06.062.076.127.061l2.229-.515c.064-.015.08-.04.087-.11l-.119-6.972 2.949 6.319c.036.059.063.075.127.06l2.23-.514c.064-.015.08-.041.087-.11l-.168-15.496c-.02-.086-.04-.171-.19-.137l-2.358.545c-.064.014-.102.046-.099.158l.278 7.07-2.984-6.468c-.041-.08-.067-.097-.153-.077l-2.315.534z",
    fillRule: "evenodd"
  }));
};

var next = function next(_a) {
  var _a$title67 = _a.title,
      title = _a$title67 === void 0 ? '' : _a$title67,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M7.5 20.23L9.30459 22L19.5 12L9.30459 2L7.5 3.77L15.8908 12L7.5 20.23Z"
  }));
};

var offer = function offer(_a) {
  var _a$title68 = _a.title,
      title = _a$title68 === void 0 ? '' : _a$title68,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m21.41 11.58-9-9c-0.36-0.36-0.86-0.58-1.41-0.58h-7c-1.1 0-2 0.9-2 2v7c0 0.55 0.22 1.05 0.59 1.42l9 9c0.36 0.36 0.86 0.58 1.41 0.58s1.05-0.22 1.41-0.59l7-7c0.37-0.36 0.59-0.86 0.59-1.41s-0.23-1.06-0.59-1.42zm-15.91-4.58c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5z"
  }));
};

var order = function order(_a) {
  var _a$title69 = _a.title,
      title = _a$title69 === void 0 ? '' : _a$title69,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 28 29"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M21.575 28.2375H23.65C24.7 28.2375 25.5625 27.4375 25.6875 26.4125L27.75 5.8125H21.5V0.75H19.0375V5.8125H12.825L13.2 8.7375C15.3375 9.325 17.3375 10.3875 18.5375 11.5625C20.3375 13.3375 21.575 15.175 21.575 18.175V28.2375ZM0.25 26.9875V25.75H19.0375V26.9875C19.0375 27.675 18.475 28.2375 17.775 28.2375H1.5125C0.8125 28.2375 0.25 27.675 0.25 26.9875ZM19.0375 18.2375C19.0375 8.2375 0.25 8.2375 0.25 18.2375H19.0375ZM0.275 20.75H19.025V23.25H0.275V20.75Z"
  })));
};

var paymentCard = function paymentCard(_a) {
  var _a$title70 = _a.title,
      title = _a$title70 === void 0 ? '' : _a$title70,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m20 4h-16c-1.11 0-1.99 0.89-1.99 2l-0.01 12c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2v-12c0-1.11-0.89-2-2-2zm0 14h-16v-6h16v6zm0-10h-16v-2h16v2z"
  }));
};

var paymentCash = function paymentCash(_a) {
  var _a$title71 = _a.title,
      title = _a$title71 === void 0 ? '' : _a$title71,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m19 14v-8c0-1.1-0.9-2-2-2h-14c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-0.9 2-2 2h-17v-2h17v-11h2z"
  }));
};

var paypal = function paypal(_a) {
  var _a$title72 = _a.title,
      title = _a$title72 === void 0 ? '' : _a$title72,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 16.95 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    fill: "#8C8C8C",
    d: "M15.28 5.08c0 .12 0 .24-.07.37-.82 4.2-3.62 5.66-7.21 5.66H6.18a.87.87 0 0 0-.87.75l-.94 5.92-.26 1.68a.46.46 0 0 0 .46.54H7.8a.78.78 0 0 0 .77-.66v-.16l.61-3.87v-.21a.78.78 0 0 1 .77-.66h.48c3.14 0 5.59-1.27 6.31-4.95a4.24 4.24 0 0 0-.65-3.73 3.33 3.33 0 0 0-.81-.68z"
  }), React__default.createElement("path", {
    fill: "#212121",
    d: "M14.42 4.74l-.42-.1-.41-.08A10.1 10.1 0 0 0 12 4.45H7.14a.8.8 0 0 0-.34.07.79.79 0 0 0-.43.58l-1 6.57v.19a.87.87 0 0 1 .87-.75H8c3.59 0 6.39-1.46 7.21-5.66 0-.13 0-.25.07-.37a4.61 4.61 0 0 0-.68-.28z"
  }), React__default.createElement("path", {
    fill: "#2F2F2F",
    d: "M6.37 5.1a.79.79 0 0 1 .43-.58.8.8 0 0 1 .34-.07H12a10.1 10.1 0 0 1 1.61.11l.41.08.39.1.18.06a4.61 4.61 0 0 1 .68.28 4 4 0 0 0-.85-3.57C13.51.45 11.83 0 9.69 0H3.47a.88.88 0 0 0-.87.75L0 17.16a.53.53 0 0 0 .52.62h3.85l1-6.11z"
  }));
};

var plkRewards = function plkRewards(_a) {
  var _a$title73 = _a.title,
      title = _a$title73 === void 0 ? '' : _a$title73,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m15.36 7.4582c-1.254-0.21758-3.0621-0.11277-3.697-0.02734l0.2222 2.4783 0.6256-0.04163 0.5223 7.764 2.4097-0.1665-0.1138-1.9046c3.4387-0.4943 3.9326-2.6354 3.8672-4.2741-0.0934-2.3241-1.7368-3.4638-3.8362-3.8281zm-0.2223 5.7449-0.1965-3.294c1.3858 0.06245 1.8504 0.89985 1.8781 1.5946 0.0364 0.9132-0.3219 1.6092-1.6816 1.6994z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), React__default.createElement("path", {
    d: "m21.978 11.977c0.2929 5.0777-2.3625 8.7184-5.6739 9.3243-0.7327 0.134-2.2651 0.1322-2.8899 0.1211-0.4604-0.0081-0.9234-0.0778-1.3812-0.2042-0.1771 0.0615-0.3326 0.1137-0.4506 0.1525-2.925 0.9613-6.9594-0.8917-8.726-4.7955-1.518-3.3545-0.96674-7.0634 1.2493-8.9857 0.39993-0.34693 1.9443-1.6278 3.2023-2.0115 0.3441-0.10496 0.69651-0.17279 1.0536-0.20516 0.62736-0.64591 1.3558-1.1529 2.1626-1.4806 0.5473-0.2223 2.4483-0.94661 3.9135-0.88877 3.7328 0.14734 7.2498 3.9383 7.5403 8.9735zm-14.867-4.8981c-0.91662 1.6644-1.3625 3.7586-1.1582 5.963 0.24048 2.5943 1.3831 4.7998 2.9206 6.2963-1.5929-0.7338-3.002-2.1543-3.7987-4.001-1.4259-3.3053-0.5976-6.7937 2.0363-8.2583zm8.9004 12.779c3.2189-0.4815 5.3214-4.304 4.696-8.5377-0.6254-4.2338-3.7418-7.2756-6.9607-6.794-3.2189 0.48152-5.3214 4.304-4.696 8.5377 0.62539 4.2338 3.7418 7.2756 6.9607 6.794z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

var popeyesLogo = function popeyesLogo(_a) {
  var _a$title74 = _a.title,
      title = _a$title74 === void 0 ? '' : _a$title74,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 576 90.73"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M683.09 331.12a5.45 5.45 0 105.47 5.43 5.42 5.42 0 00-5.47-5.43zm0 10.09a4.65 4.65 0 114.47-4.66 4.48 4.48 0 01-4.47 4.66z",
    transform: "translate(-112.56 -251.75)"
  }), React__default.createElement("path", {
    d: "M685.73 335.29c0-1.41-.91-1.9-2.52-1.9h-2.41v6.42h1.25v-2.75h.81l1.58 2.75h1.31L684 337a1.6 1.6 0 001.73-1.71zm-3.68.78v-1.69h1.08c.6 0 1.32.1 1.32.81s-.54.88-1.25.88z",
    transform: "translate(-112.56 -251.75)"
  }), React__default.createElement("path", {
    d: "M365.19 89.62h27.83V66.09L425.6 4.34h-29.56l-16.76 36.12-16.05-36.12h-29.01l30.97 61.71v23.57z"
  }), React__default.createElement("path", {
    d: "M146.78 251.88c-10-.47-27 .46-34.22 1l.58 21.59 6.94-.44v67.25h26.73v-16.8c39.08-1.87 48.21-22.71 48.21-37.41-.02-20.85-17.02-33.72-48.24-35.19zm0 51.63v-29.38c17 .8 21.13 8.09 21.13 14 .03 8.46-5.62 15.06-21.1 15.38zM571.13 253c-25.81 0-43.68 18.73-43.68 44.53s17.23 45 46.18 45c12.06 0 22.55-2.63 31.34-8.59l-9.62-19.78a36.88 36.88 0 01-20.59 6.24c-10.66 0-17.34-5.09-19.94-13.92h56.85a71.35 71.35 0 00.89-12c-.16-18.38-9.84-41.48-41.43-41.48zm-16.58 35.41c2.08-8.6 7.56-14.47 16.67-14.47 8.68 0 15 5.16 15.68 14.47zM320.3 252.77c-9.88-.47-26.71.45-33.88 1l.57 21.37 6.87-.43v66.58h26.47v-16.65c38.69-1.84 47.73-22.47 47.73-37 0-20.64-16.83-33.42-47.76-34.87zm0 51.11v-29.09c16.87.8 20.92 8 20.92 13.89.03 8.32-5.56 14.89-20.89 15.2zM659.25 290.62c-4.77-1.92-10.51-4.05-14.25-5.75s-5-3.32-5-5.84c0-3.34 3.46-5.16 7.85-5.16 6.73 0 12 3.1 16.72 8.16l14.82-15.42c-6.36-8.56-17.27-14-31.2-14-18.86 0-33.59 9.11-33.59 27.06 0 14.18 6.83 21 20.1 26.73 3.77 1.63 8.8 3.08 12.57 4.68 3.3 1.4 5.37 2.88 5.37 5.59 0 2.5-2.2 4.54-8.57 4.54-5.88 0-14.33-2.36-20.49-6.36l-9 18.46c8.57 6.2 18.94 8.75 29.53 8.75 16.45 0 34.08-7.12 34.08-26.28.04-14.37-9.19-21.22-18.94-25.16zM242.34 253.49c-24.56 0-45 18.23-45 44.1s20.43 44.09 45 44.09 45-18.23 45-44.09-20.45-44.1-45-44.1zm.2 64.53c-11.93 0-19.5-9.17-19.5-20.6s7.57-20.61 19.5-20.61S262 286 262 297.42 254.47 318 242.54 318zM413.89 253c-25.81 0-43.68 18.73-43.68 44.53s16.83 45 46.42 45c13.23 0 24.8-3.21 34.08-10.42L440.28 313a38.5 38.5 0 01-22.52 7.38c-11.14 0-17.71-5.09-20.23-13.92h56.92a71.65 71.65 0 00.87-12c-.16-18.36-9.83-41.46-41.43-41.46zm-16.58 35.41c2.08-8.6 7.56-14.47 16.67-14.47 8.68 0 15 5.07 15.68 14.47z",
    transform: "translate(-112.56 -251.75)"
  }));
};

var previous = function previous(_a) {
  var _a$title75 = _a.title,
      title = _a$title75 === void 0 ? '' : _a$title75,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M17 20.23L15.1954 22L5 12L15.1954 2L17 3.77L8.60918 12L17 20.23Z"
  }));
};

var profile = function profile(_a) {
  var _a$title76 = _a.title,
      title = _a$title76 === void 0 ? '' : _a$title76,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 22 21"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "Profile-icon",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "Profile"
  }, React__default.createElement("path", {
    d: "M16,5 C16,7.8 13.8,10 11,10 C8.2,10 6,7.8 6,5 C6,2.2 8.2,0 11,0 C13.8,0 16,2.2 16,5 Z M0,17.1 L0,20.8 L22,20.8 L22,17.1 C22,14.2 19.3,11.8 15.9,11.8 L6.1,11.8 C2.7,11.8 0,14.2 0,17.1 Z",
    id: "Shape"
  }))));
};

var profileTH = function profileTH(_a) {
  var _a$title77 = _a.title,
      title = _a$title77 === void 0 ? '' : _a$title77,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 22 22.4"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M10 9.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm-8.5 12a.5.5 0 1 1-1 0V17A5.5 5.5 0 0 1 6 11.5h8a5.5 5.5 0 0 1 5.5 5.5v3.5a.5.5 0 1 1-1 0V17a4.5 4.5 0 0 0-4.5-4.5H6A4.5 4.5 0 0 0 1.5 17v3.5z"
  }));
};

var qr = function qr(_a) {
  var _a$title78 = _a.title,
      title = _a$title78 === void 0 ? '' : _a$title78,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m3 11h8v-8h-8v8zm2-6h4v4h-4v-4zm-2 16h8v-8h-8v8zm2-6h4v4h-4v-4zm8-4v-8h8v8h-8zm2-2h4v-4h-4v4zm6 10h-2v-2h2v-2h-2v-2h-2v2h-2v-2h-2v2h2v2h-2v2h2v2h2v-2h2v2h2v-2zm-4-2h2v-2h-2v2zm0 0v2h-2v-2h2z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

var mobileRaggedEdge = function mobileRaggedEdge(_a) {
  var _a$title79 = _a.title,
      title = _a$title79 === void 0 ? '' : _a$title79,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    width: "100%",
    viewBox: "0 0 414 13"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M0 4.2h22c9 0 17.9 0 26.9-.1 7.9 0 16.2-.6 24.1-.6 1.6 0 3.2 0 4.8.1 15 .5 30.1 2.8 45.3 2.8 5.6 0 11.3-.3 16.9-1.1 5.2-.7 9.1-2.1 14.7-2.5 2.2-.2 18.6.2 24.1.5 14.2.8 27.5 2.2 41.9 2.2 3.1 0 6.3-.1 9.5-.2 13-.6 25.8-1.8 39-2.2 15-.5 29.8-1.1 44.8-1.3 1.9.2 3.8.4 5.8.4h.6c2 0 4-.2 5.9-.4 4.4.1 8.8.3 13.2.4 6.9.3 13.7.5 20.6.5 7.9 0 15.7-.4 23.4-1.5 2.9-.4 5.9-.8 8.8-1.2H414v13H0V4.2z",
    fillRule: "evenodd"
  }));
};

var desktopRaggedEdge = function desktopRaggedEdge(_a) {
  var _a$title80 = _a.title,
      title = _a$title80 === void 0 ? '' : _a$title80,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    width: "100%",
    viewBox: "0 0 1440 13"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M0 13v-2.7h18.9c6.6 0 13.2.1 19.9.1 6.7.1 13.4.1 20 .1 11.2 0 22.4-.2 33.4-.7 2.1-.1 4.2-.2 6.4-.2 2.1 0 4.3 0 6.4.1 2.1 0 4.3.1 6.4.1 1.9 0 3.8 0 5.7-.1 6.9-.3 13.4-1.3 20.6-1.4h.9c3.7 0 7.1.1 10.8.2h1.1c2 0 3.8-.1 5.5-.1 1.8-.1 3.5-.1 5.4-.1 1.5 0 3 0 4.7.2 3.6.3 6.8.4 10 .4 3.5 0 7-.2 10.8-.5 5.4-.1 10.7-.2 16.1-.5 3.2.2 6.4.4 10.1.4 3.8.1 7.3-.1 11.1.2 2.7.2 5.6 1 8.3 1.2.6 0 1.2.1 1.8.1 4.5 0 8.4-.9 12.6-1.4 2.9-.3 5.7-.4 8.4-.4 7.8 0 15.2.9 23.2 1h.3c.5 0 1 0 1.5-.1 3.7.2 7.4.3 11.2.4h1.8c13.3 0 26.2-1.6 39.3-2.3.4 0 .8 0 1.2-.1h1.2c3.4 0 6.7 0 9.7-.3h2.1c3.9 0 7.8 0 11.6.1 3.9.1 7.8.1 11.7.1h2.1c12.5-.1 25.1-.2 37.6-.2 9.2 0 18.3.1 27.4.4h.7c2.3.4 4.5.7 7.4.7h.7c2.4 0 4.1-.2 6-.4 4.5.1 9.1.1 13.8.1 13 0 26.1-.3 38.3-.9 9.3-.4 18.5-.7 27.8-.9 3.2.1 6.6.2 9.9.2 4.6 0 9.4-.1 14.1-.2 15.9.2 31.7.8 47.4 1.7 9.7.6 19.4.7 29.1.7 9.6 0 19.2-.2 28.9-.4 21.3-.5 42.8 0 64.1-1.3 4.4-.3 8.7-.4 13-.4 3.7 0 7.4.1 11.1.1 3.7.1 7.4.1 11.2.1h4.6c22.6-.4 45.2-1.1 67.9-1.5h.5c2.9.2 5.7.5 8.6.7 1.2.1 2.2.1 3.1.1 2.6 0 3.9-.3 7.1-.8.7-.1 1.5-.2 2.2-.3 8.5-.1 17.1-.1 25.7-.1H927l99.1-.3h22c8.9 0 17.9 0 26.9-.1 7.9 0 16.2-.6 24.1-.6 1.6 0 3.2 0 4.8.1 15 .5 30.1 2.8 45.3 2.8 5.6 0 11.3-.3 16.9-1.1 5.2-.7 9.1-2.1 14.7-2.5 2.2-.2 4.5-.2 6.8-.2 5.8 0 11.8.4 17.3.7 14.2.8 27.5 2.2 41.9 2.2 3.1 0 6.3-.1 9.5-.2 13-.6 25.8-1.8 39-2.2 15-.5 29.7-1.1 44.8-1.3 1.9.2 3.8.4 5.8.4h.6c2 0 4-.2 5.9-.4 4.4.1 8.8.3 13.2.4 6.9.3 13.7.5 20.5.5 7.9 0 15.7-.4 23.4-1.5 2.9-.4 5.9-.8 8.8-1.2h21.7l-.3 13H0z",
    fillRule: "evenodd"
  }));
};

var refresh = function refresh(_a) {
  var _a$title81 = _a.title,
      title = _a$title81 === void 0 ? '' : _a$title81,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m17.65 6.35c-1.45-1.45-3.44-2.35-5.65-2.35-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-0.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14 0.69 4.22 1.78l-3.22 3.22h7v-7l-2.35 2.35z"
  }));
};

var remove = function remove(_a) {
  var _a$title82 = _a.title,
      title = _a$title82 === void 0 ? '' : _a$title82,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M19 13H5V11H19V13Z"
  }));
};

var restaurant = function restaurant(_a) {
  var _a$title83 = _a.title,
      title = _a$title83 === void 0 ? '' : _a$title83,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M11 9H9V2H7V9H5V2H3V9C3 11.12 4.66 12.84 6.75 12.97V22H9.25V12.97C11.34 12.84 13 11.12 13 9V2H11V9ZM16 6V14H18.5V22H21V2C18.24 2 16 4.24 16 6Z"
  }));
};

var sadFace = function sadFace(_a) {
  var _a$title84 = _a.title,
      title = _a$title84 === void 0 ? '' : _a$title84,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 99"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#ECECEC",
    d: "M98 51.000238C98 77.5100489 76.0617469 99 49 99 21.9377672 99 0 77.5100489 0 51.000238 0 24.4904271 21.9377672 3 49 3c27.0617469 0 49 21.4904271 49 48.000238"
  }), React__default.createElement("path", {
    fill: "white",
    strokeWidth: "3",
    d: "M94.8462416 47.6500099c0 25.2379113-20.5606337 45.6968078-45.9230297 45.6968078-25.3628515 0-45.92302972-20.4588965-45.92302972-45.6968078 0-25.2379114 20.56017822-45.69726113 45.92302972-45.69726113 25.362396 0 45.9230297 20.45934973 45.9230297 45.69726113"
  }), React__default.createElement("path", {
    d: "M91.0692772 29.4798739c1.4833862 4.411468 2.2886139 9.1324729 2.2886139 14.0406502 0 24.4198818-19.8938614 44.2157439-44.4346337 44.2157439S4.48816832 67.9404059 4.48816832 43.5205241c0-4.9081773.80522772-9.6291822 2.2890693-14.0406502-2.42798019 5.569399-3.7770099 11.7125517-3.7770099 18.1702266 0 25.2374581 20.56017818 45.6968079 45.92302968 45.6968079 25.3623961 0 45.9230297-20.4593498 45.9230297-45.6968079 0-6.4576749-1.3490297-12.6008276-3.7770099-18.1702266"
  }), React__default.createElement("path", {
    d: "M38 36.5c0 1.9330083-1.5669917 3.5-3.5 3.5S31 38.4330083 31 36.5s1.5669917-3.5 3.5-3.5 3.5 1.5669917 3.5 3.5M66 36.5c0 1.9330083-1.5668685 3.5-3.4997248 3.5C60.5674188 40 59 38.4330083 59 36.5s1.5674188-3.5 3.5002752-3.5C64.4331315 33 66 34.5669917 66 36.5M68.4602317 59.6228808c-.067406.3621084-.3839406.6009458-.723703.5515468-1.4291881-.2062069-2.9025544-.329931-4.3567921-.4006306-1.6664752-.0802167-3.3356831-.0888275-4.9998812-.0253793-3.3265742.1341478-6.6399405.5275271-9.8745148 1.2589951-3.2341188.7233104-6.3967327 1.7597833-9.3894654 3.1674286-2.466693 1.1316453-4.7990297 2.5474483-6.9783366 4.1726305-.790198.5891626-1.8700594.399271-2.4320792-.4400591-.5943564-.8887291-.3693663-2.1413793.4991683-2.7124138 2.4762574-1.6283547 5.0850495-2.9983842 7.7890297-4.0452808 3.2782971-1.3029556 6.6713664-2.1830739 10.0867525-2.7273694 3.4167525-.5515468 6.8626535-.7423449 10.2894257-.6662069 1.7133862.0416946 3.4231288.1577143 5.1260396.3466995 1.4929505.1676847 2.9640397.3806896 4.4528911.6915862.3529703.0738719.5825149.4486699.5114654.8284532"
  })));
};

var sandwiches = function sandwiches(_a) {
  var _a$title85 = _a.title,
      title = _a$title85 === void 0 ? '' : _a$title85,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 67 46"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M6.303 37.327V34h54v3.327c0 4.752-3.824 8.673-8.459 8.673H14.762c-4.635 0-8.459-3.92-8.459-8.673zM3.678 19h59.25c1.875 0 3.375 2.4 3.375 4.985v2.03c0 2.77-1.5 4.985-3.375 4.985H3.678C1.803 31 .303 28.785.303 26.015v-2.03c0-2.77 1.5-4.985 3.375-4.985zM42.921 0H23.685C14.067 0 6.303 6.593 6.303 13.89V16h54v-2.813C60.303 5.89 52.54 0 42.921 0z",
    fillRule: "evenodd"
  }));
};

var sauces = function sauces(_a) {
  var _a$title86 = _a.title,
      title = _a$title86 === void 0 ? '' : _a$title86,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 52 39"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M48.858 21.692C48.405 31.312 38.575 39 26.514 39 14.454 39 4.623 31.313 4.17 21.692H2a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v3.692a2 2 0 0 1-2 2h-1.142zM8 11h38c-2.333-1.198-4.667-1.997-7-2.396-3.5-.599-6.5 0-7.5-1.797-1.663-2.988 6.5-4.028 5-5.038-.852-.574-8.89-4.135-18 .845C16.636 3.634 13.136 6.428 8 11z",
    fillRule: "evenodd"
  }));
};

var scanRewards = function scanRewards(_a) {
  var _a$title87 = _a.title,
      title = _a$title87 === void 0 ? '' : _a$title87,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 200 574"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M175.6,299.2H87.8c-13.4,0-24.4,11.2-24.4,25.1v150.3H158c5.2,0,9.5,4.3,9.5,9.5v63.4h8.1\n    c13.4,0,24.4-11.2,24.4-25.1V324.2C200,310.4,189.1,299.2,175.6,299.2z"
  }), React__default.createElement("path", {
    d: "M131.1,227.8c0.9,0,1.6,0.7,1.6,1.6v32.9c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6v-32.9\n    C129.4,228.6,130.2,227.8,131.1,227.8z M149.8,229l8.3,26.3c0.3,0.9-0.2,1.8-1.1,2c-0.9,0.3-1.8-0.2-2.1-1.1l-8.3-26.3\n    c-0.3-0.9,0.2-1.8,1.1-2C148.6,227.6,149.5,228.1,149.8,229z M116,229.5l-8.3,26.4c-0.7,2.1-3.8,1.1-3.1-1l8.3-26.4\n    C113.5,226.5,116.7,227.4,116,229.5z M167.9,0.1c9.8,0.4,17.5,8.5,17.6,18.3v169.8c0,10.1-8.2,18.3-18.4,18.4H96.6\n    c-10.1,0-18.3-8.2-18.4-18.4V18.4c0-9.8,7.8-17.9,17.7-18.3H167.9z M167.8,3.4H96c-8.1,0.4-14.4,7-14.4,15.1v169.7\n    c0,8.3,6.8,15.1,15.1,15.1h70.6c8.3,0,15.1-6.8,15.1-15.1V18.4C182.2,10.4,175.9,3.7,167.8,3.4z M139.3,176.8c1.7,0,3,1.3,3,3v7.1\n    c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H139.3z M165.6,176.8c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3h-14.8\n    c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H165.6z M113,176.8c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3H98.2c-1.7,0-3-1.3-3-3v-7.1\n    c0-1.7,1.3-3,3-3H113z M139.3,158.3c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H139.3z\n    M165.6,158.3c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H165.6z M113,158.3c1.7,0,3,1.3,3,3\n    v7.1c0,1.7-1.3,3-3,3H98.2c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H113z M139.3,139.8c1.7,0,3,1.3,3,3v7c0,1.7-1.3,3-3,3h-14.8\n    c-1.7,0-3-1.3-3-3v-7c0-1.7,1.3-3,3-3H139.3z M165.6,139.8c1.7,0,3,1.3,3,3v7c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7\n    c0-1.7,1.3-3,3-3H165.6z M113,139.8c1.7,0,3,1.3,3,3v7c0,1.7-1.3,3-3,3H98.2c-1.7,0-3-1.3-3-3v-7c0-1.7,1.3-3,3-3H113z M139.3,121.4\n    c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H139.3z M165.6,121.4c1.7,0,3,1.3,3,3v7.1\n    c0,1.7-1.3,3-3,3h-14.8c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H165.6z M113,121.4c1.7,0,3,1.3,3,3v7.1c0,1.7-1.3,3-3,3H98.2\n    c-1.7,0-3-1.3-3-3v-7.1c0-1.7,1.3-3,3-3H113z M167.6,18v91.2H96.1V18H167.6z"
  }), React__default.createElement("g", {
    transform: "translate(17.515789, 121.800000)"
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "99.1,389.2 92.9,389.2 92.9,364.4 117.8,364.4 117.8,370.5 99.1,370.5 "
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "170.5,442 145.7,442 145.7,435.8 164.4,435.8 164.4,417.1 170.5,417.1 "
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "170.5,389.2 164.4,389.2 164.4,370.5 145.7,370.5 145.7,364.4 170.5,364.4 "
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "117.8,442 92.9,442 92.9,417.1 99.1,417.1 99.1,435.8 117.8,435.8 "
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "158.1,429.5 128.6,429.5 128.6,406.3 105.3,406.3 105.3,400.1 134.8,400.1 134.8,423.3 158.1,423.3 "
  }), React__default.createElement("polygon", {
    style: {
      fill: '#FFFFFF'
    },
    points: "158.1,417.1 151.8,417.1 151.8,406.2 145.7,406.2 145.7,417.1 139.5,417.1 139.5,400.1 158.1,400.1 "
  }), React__default.createElement("path", {
    id: "Shape",
    style: {
      fill: '#FFFFFF'
    },
    d: "M124,395.4h-18.6v-18.6H124V395.4z M111.6,389.1h6.1V383h-6.1V389.1z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M158.1,395.4h-18.6v-18.6h18.6V395.4z M145.7,389.1h6.1V383h-6.1L145.7,389.1L145.7,389.1z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M124,429.5h-18.6v-18.6H124V429.5z M111.6,423.3h6.1v-6.1h-6.1V423.3z"
  }), React__default.createElement("rect", {
    x: "128.6",
    y: "376.8",
    style: {
      fill: '#FFFFFF'
    },
    width: "6.2",
    height: "18.6"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M118.8,319.4h25.9c1.4,0,2.6,1.4,2.6,3.1c0,1.7-1.2,3.1-2.6,3.1h-25.9c-1.4,0-2.6-1.4-2.6-3.1\n    C116.2,320.7,117.4,319.4,118.8,319.4L118.8,319.4z"
  }), React__default.createElement("path", {
    d: "M164.5,484.1c0-3.6-2.9-6.5-6.5-6.5H10c-3.6,0-6.5,2.9-6.5,6.5v79.5c0,3.6,2.9,6.5,6.5,6.5h148\n    c3.6,0,6.5-2.9,6.5-6.5V484.1z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M105.2,516.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h22.1c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7\n    H105.2z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M38.9,516.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h21.8c0.4,0,0.7,0.3,0.7,0.7\n    s-0.3,0.7-0.7,0.7H38.9z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M38.7,545c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h88.4c0.4,0,0.7,0.3,0.7,0.7\n    s-0.3,0.7-0.7,0.7H38.7z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M46.1,535.7l-3-4.6h-0.6v4.6h-3v-13.2h5.3c3,0,4.4,2.2,4.4,4.4c0,1.9-1,3.5-3.1,4l3.4,4.8H46.1z\n    M42.5,525.2v3.6h1.9c1.3,0,1.9-0.9,1.9-1.7s-0.6-1.8-1.8-1.8H42.5z M54.6,533.1h5.6v2.6h-8.5v-13.2H60v2.6h-5.4v2.7h4.7v2.7h-4.7\n    V533.1z M75.6,522.6h3.2l-4.4,13.2h-2.3l-1.7-6.7l-1.7,6.7h-2.3l-4.4-13.2h3.2l2.4,7.9l1.6-6h2.4l1.6,6L75.6,522.6z M87.8,535.7\n    l-1-3.1h-4.6l-1,3.1h-3.2l4.8-13.2h3.2l4.8,13.2H87.8z M83.1,530.1H86l-1.5-4.6L83.1,530.1z M98.9,535.7l-3-4.6h-0.6v4.6h-3v-13.2\n    h5.3c3,0,4.4,2.2,4.4,4.4c0,1.9-1,3.5-3.1,4l3.4,4.8H98.9z M95.3,525.2v3.6h1.9c1.3,0,1.9-0.9,1.9-1.7s-0.6-1.8-1.8-1.8H95.3z\n    M104.5,535.7v-13.2h5.2c3.8,0,5.9,2.9,5.9,6.6c0,3.7-2.2,6.5-5.9,6.5H104.5z M107.5,533.1h2.2c2,0,3-1.9,3-3.9c0-2.1-1-4-3-4h-2.2\n    V533.1z M121.9,535.9c-2.8,0-4.7-1.6-4.7-4.1h3c0,0.8,0.8,1.5,1.9,1.5c1,0,1.7-0.4,1.7-1.3c0-0.5-0.3-1-1.4-1.4l-1.6-0.5\n    c-2.9-0.8-3.4-2.6-3.4-3.8c0-2.4,2-4,4.6-4c2.5,0,4.4,1.5,4.4,4.1h-3c0-0.8-0.5-1.5-1.5-1.5c-0.9,0-1.5,0.6-1.5,1.3\n    c0,0.3,0.1,0.9,1.3,1.2l1.4,0.4c1.9,0.6,3.8,1.5,3.8,3.9C126.7,534.7,124.3,535.9,121.9,535.9z"
  }), React__default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M75.7,510.4c0.2-0.5,0.5-0.6,0.8-0.3c0.3,0.2,0.5,0.3,0.7,0.4c0.3,0.3,0.4,0.4,0.2,0.9\n    c-0.7,1.3-1.3,2.7-1.6,3.6c-0.1,0.2-0.3,0.9-0.1,1.1c0.1,0.1,0.2,0.1,0.4,0c0.6-0.2,2.1-2,4-5.1c0.1-0.2,0.2-0.4,0.3-0.5\n    c0.2-0.3,0.3-0.4,0.8-0.2c0.2,0.1,0.5,0.3,0.7,0.5c0.3,0.2,0.3,0.4,0.1,0.9c-0.2,0.4-0.8,1.8-1.5,3.3c1.3-1.5,3.3-3.5,4-4.1\n    c0.2-0.2,0.4-0.2,0.7-0.1c0.3,0.2,0.5,0.3,0.7,0.5c0.3,0.2,0.3,0.3,0.1,0.8c-0.2,0.5-0.6,1.3-1.3,3.1c1.1-1.3,2.6-2.8,3.6-3.8\n    c0.1-0.1,0.1-0.1,0.2-0.1l0,0l0,0c0,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4,0,0.6,0.1c0.2,0.1,0.2,0.2,0.5,0.4c0.3,0.2,0.4,0.4,0.2,0.9\n    c-0.4,0.7-0.9,1.7-1.3,3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.7,0.2,0.7,0.4,0.7c0.4-0.1,0.8-0.6,1.9-2c0.9-1.2,1.7-2.1,2.7-3.1\n    c0.3-0.3,0.7-0.6,0.9-0.8c0.2-0.2,0.4-0.3,0.6-0.3c0.1,0,0.2,0,0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.2,0.2,0.2,0.3\n    c0,0.2-0.1,0.3-0.3,0.4l0,0l-0.1,0.1c-0.5,0.4-1,0.9-0.6,1.7c0.1,0.3,0.5,0.9,0.6,1.4c0.2,0.6,0.2,1,0.1,1.2\n    c-0.2,1.3-1.1,2.1-2.5,2.1c-0.8,0-1.5-0.2-1.9-0.8c-0.2-0.3-0.2-0.6,0.1-1c0.1-0.2,0.3-0.3,0.3-0.3c0.1-0.1,0.2-0.1,0.3-0.1\n    c0.2,0,0.2,0.1,0.3,0.5c0.1,0.5,0.4,0.8,0.8,0.8c0.1,0,0.6,0,0.8-0.5c0.1-0.4,0-0.8-0.3-1.4c-0.4-0.7-0.5-1.3-0.5-1.8\n    c-0.4,0.4-0.7,0.9-1.1,1.3c-1.3,1.8-2,2.7-3,3.1c-0.5,0.2-1,0.2-1.4,0.1c-0.9-0.3-1-1.1-0.9-1.6c0.1-0.6,0.4-1.5,0.8-2.6\n    c0-0.1,0.1-0.2,0.1-0.3c-1.4,1.4-3.1,3.5-3.4,3.9c-0.3,0.4-0.7,0.2-0.8,0.1l0,0l-0.5-0.3c-0.3-0.2-0.4-0.4-0.3-0.8\n    c0.3-1,0.8-2.4,1.2-3.4c-1.6,1.5-3.7,4-4.1,4.5c-0.3,0.3-0.6,0.2-0.8,0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.2-0.4-0.3-0.2-0.9\n    c0.1-0.5,0.4-1.2,0.7-1.9c-1.3,1.8-2.3,2.6-3,3c-0.3,0.1-0.9,0.3-1.4,0.2c-0.6-0.1-1.1-0.7-0.9-1.8\n    C73.9,514.3,75.2,511.5,75.7,510.4z M96.5,516.8c0.4,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6\n    C95.9,517.1,96.2,516.8,96.5,516.8z M96.5,516.9c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5\n    C97,517.2,96.8,517,96.5,516.9z M81.8,503.6c0.5,0,0.6,0,0.8,0.3c0.1,0.3,0.2,0.3,0.3,0.6c0.1,0.3-0.1,0.5-0.4,0.5\n    c-2.3,0.1-4.5,0.2-6.7,0.4c-0.9,2.1-4.9,11.1-5.2,11.9c-0.2,0.3-0.4,0.5-0.8,0.3c-0.4-0.2-0.7-0.4-1-0.6c-0.4-0.3-0.3-0.6-0.2-0.9\n    c1.2-2.6,2-4.5,2.7-5.9c1.1-2.4,1.7-3.6,2.2-4.6c-1.9,0.2-4.4,0.4-4.9,0.5c-0.7,0.1-0.7-0.1-0.9-0.5c-0.1-0.3-0.1-0.2-0.2-0.4\n    c-0.1-0.4-0.2-0.7,0.4-0.8C69.3,504.3,76.3,503.7,81.8,503.6z M78.1,506.7c0.6,0,1.1,0.5,1.1,1.1c0,0.7-0.5,1.3-1.1,1.4\n    c-0.1,0-0.1,0-0.2,0c-0.6,0-1.1-0.5-1.1-1.1c0-0.7,0.5-1.3,1.1-1.4C78,506.7,78,506.7,78.1,506.7z"
  })));
};

var seafood = function seafood(_a) {
  var _a$title88 = _a.title,
      title = _a$title88 === void 0 ? '' : _a$title88,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 65 56"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M44.705 33.796c11.048 1.466 16.301 6.04 17.903 9.82 3.473-7.014 3.212-15.154-1.096-19.044-6.9-6.238-13.891-5.39-16.976.176-3.89 7.011-7.217 9.642-16.278 5.25-5.08-2.463-7.618-6.136-8.896-8.91 3.155-2.835 7.457-8.769 6.869-16.092-.653-2.49-3.05-4.075-5.43-3.527-1.059.245-1.87.894-2.492 1.725C17.03.831 14.202-.483 11.333.164 8.467.834 6.522 3.245 6.417 5.92c-.909-.481-1.932-.71-3-.463-2.38.534-3.84 2.997-3.307 5.526 2.772 6.835 8.402 10.056 12.418 11.292-.54 5.273.338 11.884 3.348 17.885 1.618-2.672 4.655-6.294 10.133-8.419 0 0-5.295 4.89-7.977 12.058 3.501 5.044 8.873 9.182 16.491 11.083-1.89-8.234 2.29-17.699 2.29-17.699-.25 8.753 1.926 15.02 3.73 18.686.233.02.437.077.67.083 7.611.458 13.445-2.438 17.447-6.688 3.585-9.097-13.955-15.468-13.955-15.468",
    fillRule: "evenodd"
  }));
};

var search = function search(_a) {
  var _a$title89 = _a.title,
      title = _a$title89 === void 0 ? '' : _a$title89,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m15.5 14h-0.79l-0.28-0.27c0.98-1.14 1.57-2.62 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5c1.61 0 3.09-0.59 4.23-1.57l0.27 0.28v0.79l5 4.99 1.49-1.49-4.99-5zm-6 0c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
  }));
};

var select = function select(_a) {
  var _a$title90 = _a.title,
      title = _a$title90 === void 0 ? '' : _a$title90,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6 1.41-1.41z"
  }));
};

var settings = function settings(_a) {
  var _a$title91 = _a.title,
      title = _a$title91 === void 0 ? '' : _a$title91,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m19.14 12.94c0.04-0.3 0.06-0.61 0.06-0.94 0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14 0.23-0.41 0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39 0.96c-0.5-0.38-1.03-0.7-1.62-0.94l-0.36-2.54c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24001 0-0.43001 0.17-0.47001 0.41l-0.36 2.54c-0.59 0.24-1.13 0.57-1.62 0.94l-2.39-0.96c-0.22-0.08-0.47 0-0.59 0.22l-1.91 3.32c-0.12 0.21-0.08 0.47 0.12 0.61l2.03 1.58c-0.05 0.3-0.09 0.63-0.09 0.94s0.02 0.64 0.07 0.94l-2.03 1.58c-0.18 0.14-0.23 0.41-0.12 0.61l1.92 3.32c0.12 0.22 0.37 0.29 0.59 0.22l2.39-0.96c0.5 0.38 1.03 0.7 1.62 0.94l0.36 2.54c0.05 0.24 0.24 0.41 0.48001 0.41h3.84c0.24 0 0.44-0.17 0.47-0.41l0.36-2.54c0.59-0.24 1.13-0.56 1.62-0.94l2.39 0.96c0.22 0.08 0.47 0 0.59-0.22l1.92-3.32c0.12-0.22 0.07-0.47-0.12-0.61l-2.01-1.58zm-7.14 2.66c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
  }));
};

var sides = function sides(_a) {
  var _a$title92 = _a.title,
      title = _a$title92 === void 0 ? '' : _a$title92,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 56 44"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M2 19.503H54a2 2 0 0 1 1.93 2.527l-5.598 20.497A2 2 0 0 1 48.403 44H8.397a2 2 0 0 1-1.909-1.404L.09 22.099A2 2 0 0 1 2 19.503zM24.3 1.851A4.648 4.648 0 0 1 28.007 0c1.736 0 3.252.961 4.06 2.39A4.634 4.634 0 0 1 35.5.865c1.898 0 3.532 1.149 4.268 2.8a4.61 4.61 0 0 1 1.352-.201c2.295 0 4.205 1.68 4.605 3.897a4.6 4.6 0 0 1 1.951-.432c2.587 0 4.683 2.133 4.683 4.764 0 2.632-2.096 4.765-4.683 4.765-.093 0-.185-.003-.276-.008H8.614a4.676 4.676 0 0 1-.277.008c-2.586 0-4.683-2.133-4.683-4.765 0-2.63 2.097-4.764 4.683-4.764a4.6 4.6 0 0 1 1.951.432c.401-2.217 2.31-3.897 4.606-3.897a4.6 4.6 0 0 1 2.155.533C17.704 2.171 19.427.866 21.45.866c1.073 0 2.062.367 2.851.985z",
    fillRule: "evenodd"
  }));
};

var signatureChicken = function signatureChicken(_a) {
  var _a$title93 = _a.title,
      title = _a$title93 === void 0 ? '' : _a$title93,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 72 62"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M18.157.013c.45-.039 2.777.017 3.27.077 2.445.313 4.49.943 6.538 2.02 1.404.738 3.18 1.968 4.574 3.17.67.578 2.371 2.345 3.013 3.126 2.405 2.933 4.317 6.124 7.54 12.574 2.314 4.632 2.757 5.499 3.614 7.098 1.411 2.638 2.72 4.825 4.044 6.747.285.42.596.904.683 1.072.687 1.32.753 2.877.182 4.297-.178.437-.41.806-1.71 2.693-.807 1.171-1.034 1.471-1.349 1.78a4.599 4.599 0 0 1-3.067 1.325c-.712.03-1.014-.017-2.18-.36-3.71-1.08-6.888-1.694-14.33-2.758-4.221-.604-6.075-.9-8.09-1.29-4.76-.922-8.345-2.18-11.093-3.89-1.717-1.068-2.769-1.896-4.006-3.157-2.223-2.26-3.783-4.859-4.772-7.921a20.953 20.953 0 0 1 .356-13.913c.26-.69.94-2.131 1.308-2.779 1.34-2.35 3.058-4.353 5.107-5.948A19.166 19.166 0 0 1 14.41.652c1.225-.335 2.202-.502 3.746-.64zm37.591 42.006a2.924 2.924 0 0 1 1.032.072c.453.133.784.352 1.317.875 1.178 1.158 4.68 4.503 4.71 4.503a.892.892 0 0 0 .159-.206c.18-.291.746-.883 1.11-1.162a4.834 4.834 0 0 1 2.978-.99c1.338 0 2.538.493 3.444 1.415 1.308 1.329 1.828 3.43 1.295 5.201-.39 1.291-1.425 2.513-2.587 3.058-.805.382-.877.42-1.128.682a2.27 2.27 0 0 0-.646 1.595c0 .875-.31 1.84-.851 2.672-.294.45-1.061 1.209-1.506 1.492-1.489.94-3.292 1.03-4.827.24-.872-.446-1.497-1.016-2.034-1.857-.985-1.535-1.04-3.64-.138-5.236.084-.154.184-.326.218-.386.033-.06.084-.137.113-.18.067-.081.05-.094-3.703-2.028-1.405-.725-2.659-1.394-2.78-1.488-.894-.682-1.187-2.029-.667-3.08.214-.428 2.822-4.185 3.111-4.48a2.595 2.595 0 0 1 1.38-.712z",
    fillRule: "evenodd"
  }));
};

var sodiumFlag = function sodiumFlag(_a) {
  var _a$title94 = _a.title,
      title = _a$title94 === void 0 ? '' : _a$title94,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 200 200"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M100.2,7.8c4.3,0,8.2,2.2,10.3,6l80.1,139.4c2.1,3.7,2.1,8.2,0,11.9c-2.2,3.7-6,6-10.3,6H19.7c-4.3,0-8.2-2.2-10.3-6\n\t\tc-2.2-3.7-2.2-8.2,0-11.9L89.9,13.7C92,10,95.9,7.8,100.2,7.8L100.2,7.8L100.2,7.8 M100.2,0.1c-6.6,0-13.2,3.3-17,9.8L2.7,149.3\n\t\tc-7.5,13.1,1.9,29.4,17,29.4h160.6c15.1,0,24.5-16.3,17-29.3L117.2,9.9C113.4,3.4,106.8,0.1,100.2,0.1L100.2,0.1z"
  }), React__default.createElement("path", {
    d: "M100,60.4c-1.5,0-2.8,0.5-2.8,1.2s1.2,1.2,2.8,1.2c1.5,0,2.8-0.5,2.8-1.2S101.5,60.4,100,60.4z"
  }), React__default.createElement("path", {
    d: "M98,58.9c0-0.6-1.2-1.2-2.8-1.2c-1.5,0-2.8,0.5-2.8,1.2c0,0.6,1.2,1.2,2.8,1.2C96.7,60.1,98,59.5,98,58.9z"
  }), React__default.createElement("path", {
    d: "M90.7,60.4c-1.5,0-2.8,0.5-2.8,1.2s1.2,1.2,2.8,1.2c1.5,0,2.8-0.5,2.8-1.2S92.2,60.4,90.7,60.4z"
  }), React__default.createElement("ellipse", {
    cx: "108.1",
    cy: "61.6",
    rx: "2.8",
    ry: "1.2"
  }), React__default.createElement("path", {
    d: "M107.3,58.9c0-0.6-1.2-1.2-2.8-1.2c-1.5,0-2.8,0.5-2.8,1.2c0,0.6,1.2,1.2,2.8,1.2C106.1,60.1,107.3,59.5,107.3,58.9z"
  }), React__default.createElement("path", {
    d: "M109.3,85.8L109.3,85.8c-0.5,0.1-0.8,0.5-0.7,1c0.9,5.2,5.5,34,1.9,59.1c-0.1,0.5,0.3,0.9,0.7,1c0.5,0.1,0.9-0.3,1-0.7\n\t\t\tc3.6-25.3-1-54.3-1.9-59.6C110.2,86.1,109.8,85.8,109.3,85.8z"
  }), React__default.createElement("path", {
    d: "M90.1,85.8L90.1,85.8c-0.5-0.1-0.9,0.2-1,0.7c-0.9,5.3-5.5,34.3-1.9,59.6c0.1,0.5,0.5,0.8,1,0.7c0.5-0.1,0.8-0.5,0.7-1\n\t\t\tc-3.6-25.1,1-53.9,1.9-59.1C90.9,86.4,90.6,85.9,90.1,85.8z"
  }), React__default.createElement("path", {
    d: "M187.5,155.1L107.4,15.7c-3.2-5.5-11.2-5.5-14.4,0L12.5,155.1c-3.2,5.5,0.8,12.4,7.2,12.4h160.7\n\t\t\t\tC186.7,167.5,190.6,160.6,187.5,155.1z M99.3,55.2c8.9,0,16.4,4,18.2,9.4c-5.1,1.5-11.4,2.4-18.2,2.4c-6.8,0-13.1-0.9-18.2-2.4\n\t\t\t\tC82.9,59.2,90.4,55.2,99.3,55.2z M81,67c0,0,17.7,5.7,36.4,0V72C98.8,79.6,81,72,81,72V67z M122.8,146.7l-12.7,7.6h-22l-12.4-7.6\n\t\t\t\tc-1.8-14.8-2.6-24.6-2.3-36.9c0.5-19.7,7-35.7,7-35.7s18.4,7.7,37.7,0h0c0,0,6.6,15.9,7.1,35.7\n\t\t\t\tC125.5,122.1,124.7,132,122.8,146.7z"
  }));
};

var store = function store(_a) {
  var _a$title95 = _a.title,
      title = _a$title95 === void 0 ? '' : _a$title95,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 31 22"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M22.806 5.069H.263c-.114 0-.229-.083-.229-.166V3.166C.034 3.083.15 3 .264 3h22.542c.114 0 .228.083.228.166v1.737c0 .083-.114.166-.228.166zM24.034.077c0-.039.022-.077.043-.077h5.915c.021 0 .042.038.042.077v21.846c0 .039-.02.077-.042.077h-5.915c-.021 0-.043-.038-.043-.077V.077zM0 6.113C0 6.038.063 6 .19 6h22.62c.127 0 .19.038.19.113v15.774c0 .075-.063.113-.19.113H.19c-.127 0-.19-.038-.19-.113V6.113zM2 12v7h9v-7H2zm10 0v7h9v-7h-9z",
    fillRule: "evenodd"
  }));
};

var storeMarker = function storeMarker(_a) {
  var _a$title96 = _a.title,
      title = _a$title96 === void 0 ? '' : _a$title96,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 62 77"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M21.2 60.4C8.9 56.3 0 44.7 0 31 0 13.9 13.9 0 31 0s31 13.9 31 31c0 15-10.6 27.4-24.7 30.4L29.5 77l-8.3-16.6z M39.3 21h-.2L38 18.7c-.1-.2-.3-.4-.6-.4H24.6c-.2 0-.5.1-.6.4L22.9 21h-.2c-.7 0-1.3.6-1.3 1.3v1.3c0 .7.6 1.3 1.3 1.3v.2l2.5 19.5c.1.6.6 1.1 1.3 1.1h9.2c.7 0 1.2-.5 1.3-1.1L39.4 25v-.2c.7 0 1.3-.6 1.3-1.3v-1.3c0-.7-.6-1.2-1.4-1.2zM25 19.6h12l.6 1.3H24.3l.7-1.3zm10.6 24.8h-9.2l-2.5-19.5H38l-2.4 19.5zm3.7-20.8H22.6v-1.9.6H39.3v1.3z"
  }), React__default.createElement("path", {
    d: "M37 19.6H25l-.7 1.4h13.4zM23.9 24.9l2.5 19.5h9.2l2.5-19.5H23.9zM38.7 22.3v-.1h-16v-.5l-.1.5.1 1.3 16.6.1v-1.4h-.6z"
  }));
};

var storeThree = function storeThree(_a) {
  var _a$title97 = _a.title,
      title = _a$title97 === void 0 ? '' : _a$title97,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 29 28"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M23.614 14.07H5.853c-.522 0-.784-.392-.653-.784l1.175-3.003h16.586l1.176 3.003c.26.392 0 .784-.523.784zM22.961 15.768h-1.567v4.179h-3.395v-4.18H16.43v4.18h-3.395v-4.18h-1.567v4.18H8.073v-4.18H6.506v6.4H22.96v-6.4zM19.304 4.667h-9.141c-.523 0-.915.391-.915.914V7.8c0 .522.392.914.915.914h9.141c.523 0 .915-.392.915-.914v-2.22c0-.523-.392-.914-.915-.914z"
  }));
};

var storeTwo = function storeTwo(_a) {
  var _a$title98 = _a.title,
      title = _a$title98 === void 0 ? '' : _a$title98,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 26 21"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    fillRule: "evenodd"
  }, React__default.createElement("rect", {
    width: 26,
    height: 4,
    rx: 0.5
  }), React__default.createElement("path", {
    d: "M2.5 5h21a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zm2 3a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-7zm10 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-7z"
  })));
};

var swap = function swap(_a) {
  var _a$title99 = _a.title,
      title = _a$title99 === void 0 ? '' : _a$title99,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 66 50"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M49.41 47.508s8.602-2.51 10.856-10.923c2.31-8.62-3.2-12.762-3.2-12.762 4.846 3.175 7.082 7.854 5.749 12.832-1.841 6.87-7.94 10.056-13.405 10.853m-18.5-45.91c3.885 1.042 5.86 2.087 5.86 2.087s-8.472-1.473-10.067 4.48c-1.815 6.773 9.92 10.547 17.345 10.695-12.596-1.99-16.407-6.743-15.346-10.7.634 8.001 14.362 8.71 22.016 10.76 11.002 2.948 16.4 10.588 14.324 18.332-2.88 10.751-15.34 13.899-22.593 11.955 0 0 4.391-.419 5.213-3.485.468-1.75-.175-4.495-5.519-5.927-2.687-.72-12.388-1.912-21.718-4.412C2.533 30.59-.763 20.108 1.217 12.72 3.322 4.862 12.56-3.318 30.91 1.599zm-8.57 17.35c-1.948-.522-3.119.063-3.662 2.091-.185.69-.279 1.201.09 2.04.158.331.367.634.43.723.178.309.294.528.462.82.255.401.657.9.5 1.322-.11.304-.43.363-.903.236-.176-.047-.466-.154-.613-.309-.06-.045-.083-.124-.14-.182-.033-.038-.026-.065-.06-.103-.126-.121-.162-.203-.415-.286-.578-.169-.693.366-.729.5-.061.23-.074.387-.136.617-.08.297-.161.493-.24.79-.048.176-.049.234.003.364.187.44 1.39.821 1.7.904.406.11 1.215.282 1.666.273.31-.019.722-.097 1.068-.25.807-.364 1.122-.888 1.44-2.078.2-.744.191-1.253-.262-2.158-.131-.267-.258-.445-.41-.69-.393-.64-.823-1.307-.878-1.481a.727.727 0 01-.013-.438c.138-.514.644-.35.725-.328.27.073.409.153.533.23.05.028.306.212.522.27.5.134.63-.295.666-.43.05-.19.07-.315.12-.504l.015-.054c.08-.298.161-.493.24-.79.171-.636-.827-.86-1.72-1.1zm2.204 1.213c-.051.19-.252 2.615-.262 2.815-.014.43.018.744.014 1.192-.009.52-.076.878-.088 1.411-.035.89.042 1.519-.037 2.41-.049.669-.157 1.452-.038 1.657.089.155.186.224.43.29l.585.142c.27.072.456.136.74.213.121.032.223.03.292-.01.103-.059.076-.066.148-.119.017-.01.178-.286.283-.46.23-.373.387-.636.618-1.009.16-.276.382-.724.55-.65.115.06.095.46.098.505-.003.173-.02.31-.033.47l-.009.171c-.003.014-.073 1.3-.063 1.317 0 0 .002.101.012.119.042.112.088.212.277.262.203.055.36.068.562.122.352.094.588.186.953.284.135.036.257.07.421-.003.134-.066.3-.31.472-.57.202-.322.325-.564.5-.894.2-.367.367-.612.567-.979.154-.306.23-.533.398-.835.207-.394.367-.67.601-1.057.371-.625.633-1.062.94-1.72.256-.525.398-.892.665-1.4.239-.459.476-.859.523-1.034.116-.433-.354-.516-.598-.581-.216-.058-.386-.074-.616-.136-.266-.086-.445-.177-.715-.25-.23-.061-.325-.087-.48.002-.12.07-.169.201-.176.228-.021.024-.275.81-.283.838-.127.313-.253.512-.39.808-.176.388-.266.668-.425 1.046-.177.387-.347.646-.524 1.034-.144.323-.327.897-.462.861-.136-.036-.014-.598.053-.957.187-1.022.165-1.753.295-2.776.028-.268.048-.45.1-.698.112-.636.242-.906-.298-1.05-.23-.062-.386-.075-.63-.14-.297-.08-.503-.179-.8-.258-.068-.019-.546-.234-.684.28-.069.257-.058.593-.069.851-.017.387-.045.655-.071 1.025-.027.37-.023.733-.019 1.096-.217.377-.378.653-.58 1.033a8.118 8.118 0 01-.246.427c-.077.125-.055.26-.204.221-.027-.007-.037-.024-.053-.072.007-.027.05-.784.065-1.215.021-.893-.026-1.529.04-2.424.025-.254.028-.427.066-.678.04-.308.2-.961-.341-1.106-.19-.05-.319-.056-.508-.107-.324-.087-.557-.193-.882-.28-.189-.05-.536-.216-.684.338zm12.05 2.708c-.297-.08-.47-.083-.634-.011-.155.09-.353.398-.532.742-.284.518-.393.923-.653 1.462-.166.347-.32.596-.485.943-.14.31-.216.537-.34.837-.174.431-.334.707-.522 1.135-.2.425-.297.732-.498 1.157-.137.296-.25.498-.387.795-.162.333-.237.56-.385.897-.13.27-.253.512-.282.62-.098.365.165.464.409.53l.815.203c.257.07.429.13.686.199.216.058.312.025.439-.071.114-.1.347-.863.39-.968.134-.283.13-.43.643-.291.311.083.821.234.845.255.066.076.037.024.086.11.09.154-.087.919-.106 1.044-.009.143-.174.49.313.62.27.073.467.096.737.169.325.087.544.189.868.276.406.108.588-.408.591-.422.051-.189.083-1.282.169-2.143.067-.576.172-.968.24-1.545.058-.433.06-.766.091-1.207.034-.556.064-.94.11-1.492.049-.451.105-.77.153-1.22.004-.014.094-1.323.098-1.337-.007-.03-.005-.146-.025-.18-.073-.266-.167-.35-.518-.443l-.055-.015-1.03-.262c-.46-.123-.77-.264-1.23-.387zm7.99 2.126c-.23-.062-.454-.093-.68-.168l-.484-.144-.737-.168c-.162-.044-.33-.118-.507-.165-.419-.112-.776-.078-.917.45-.134.5-.202.859-.322 1.363-.175.707-.333 1.186-.517 1.876-.109.406-.204.815-.317 1.234-.134.5-.258.858-.396 1.372-.102.379-.166.782-.268 1.16-.061.23-.145.382-.22.608-.054.145-.056.26-.1.423-.049.132-.099.263-.135.398-.112.42-.002.55.268.623.298.08.515.08.812.16.311.083.52.168.845.255.433.116.509-.168.556-.344.04-.149.038-.25.078-.4.04-.206.09-.337.128-.53.047-.176.053-.305.1-.48.127-.475.448-.428.645-.378l.074.02c.149.039.28.089.415.125.934.25 1.59-.038 2.06-.332 1.106-.718 1.3-1.493 1.441-1.86.21-.568.299-.79.378-1.088.207-.77.125-1.17.092-1.584-.018-.15.006-.404-.156-.825-.277-.697-.926-1.306-2.137-1.601zm-7.637.94c.04.01.094.083.095.184.017.048-.032.34-.063.563-.024.197-.066 1.055-.258 1.772-.13.487-.468.396-.644.349-.216-.058-.408-.153-.296-.572.025-.095.477-1.133.52-1.238.07-.155.144-.266.228-.417.031-.064.228-.475.274-.535.031-.064.103-.117.144-.107zm6.852 1.285c.351.094.576.502.42 1.083-.044.162-.086.267-.13.43-.043.162-.055.26-.099.422-.09.338-.245.485-.457.573-.13.052-.253.077-.361.048-.301-.066-.52-.443-.381-.957l.228-.852c.101-.378.266-.668.474-.742a.38.38 0 01.252-.02l.054.015z",
    fillRule: "evenodd"
  }));
};

var telephone = function telephone(_a) {
  var _a$title100 = _a.title,
      title = _a$title100 === void 0 ? '' : _a$title100,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c0.27-0.27 0.67-0.36 1.02-0.24 1.12 0.37 2.33 0.57 3.57 0.57 0.55 0 1 0.45 1 1v3.49c0 0.55-0.45 1-1 1-9.39 0-17-7.61-17-17 0-0.55 0.45-1 1-1h3.5c0.55 0 1 0.45 1 1 0 1.25 0.2 2.45 0.57 3.57 0.11 0.35 0.03 0.74-0.25 1.02l-2.2 2.2z"
  }));
};

var tendersAndWings = function tendersAndWings(_a) {
  var _a$title101 = _a.title,
      title = _a$title101 === void 0 ? '' : _a$title101,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 76 51"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M56.315 27c1.134-6.255-2.428-10.916-7.908-11.299-4.843-.338-13.011 1.94-19.395 1.172-.828-.1-1.968-.447-3.313-.936-2.53-2.705-2.856-7.13.042-11.464C29.473-1.106 33.617-.375 37.55.854c7.474 2.336 13.72 9.395 16.485 12.483 2.28 2.547 9.817 8.638 12.503 13.663H56.315zm-38.622 0C11.556 23.796 3.49 19.167 5.786 14.955c3.15-5.778 18.758 3.819 23.366 4.43 5.613.743 12.767-1.233 17.023-.888 4.315.35 7.307 3.767 7.204 8.503H17.693zM2.791 30h70.462a2 2 0 0 1 1.903 2.614l-5.486 17A2 2 0 0 1 67.767 51H8.558a2 2 0 0 1-1.894-1.357l-5.767-17A2 2 0 0 1 2.79 30z"
  }));
};

var thRewards = function thRewards(_a) {
  var _a$title102 = _a.title,
      title = _a$title102 === void 0 ? '' : _a$title102,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m22.924 13.331c-0.6769-0.2257-2.5628-1.1444-0.9026-4.3036 0.0322-0.04835 0.0161-0.11283-0.0161-0.14506-0.0322-0.03224-0.0967-0.04836-0.1451-0.01612-3.1592 1.644-4.0779-0.24178-4.3036-0.90263-0.0322-0.09671-0.145-0.11283-0.2095-0.03224l-1.8214 2.4016 0.4674-6.7374c0.0162-0.09671-0.0967-0.16119-0.1773-0.11283-0.6286 0.32237-2.6273 0.99934-3.6911-2.4016-0.0161-0.06447-0.0644-0.08059-0.1128-0.08059s-0.0967 0.03224-0.1128 0.08059c-1.0638 3.401-3.0625 2.724-3.6911 2.4016-0.08059-0.04836-0.1773 0.01612-0.1773 0.11283l0.46743 6.7374-1.8375-2.4177c-0.06448-0.08059-0.1773-0.04835-0.20954 0.03224-0.22566 0.67697-1.1444 2.5628-4.3036 0.90263-0.04835-0.03224-0.11283-0.01612-0.14506 0.01612-0.03224 0.03224-0.04836 0.09671-0.01612 0.14506 1.6441 3.1592-0.24178 4.078-0.90263 4.3036-0.096713 0.0323-0.11283 0.1451-0.03224 0.2096l6.1895 4.7065-1.6763 1.6602c-0.06448 0.0645-0.01612 0.1935 0.08059 0.1935h2.9658v1.2733c0 0.0322 0.04836 0.1128 0.12895 0.0967 0.62861-0.0967 2.0792-0.3385 3.1592 0.7737 0.0161 0.0161 0.0483 0.0322 0.0967 0.0322 0.0483 0 0.0806-0.0161 0.0967-0.0322 1.0799-1.1122 2.5306-0.8704 3.1592-0.7737 0.0806 0.0161 0.1289-0.0645 0.1289-0.0967v-1.2733h2.9658c0.0967 0 0.1451-0.129 0.0806-0.1935l-1.6763-1.6602 6.1895-4.7065c0.0967-0.0323 0.0644-0.1612-0.0162-0.1934z"
  }));
};

var tiktok = function tiktok(_a) {
  var _a$title103 = _a.title,
      title = _a$title103 === void 0 ? '' : _a$title103,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m15.483 2c0.33 2.8381 1.914 4.5302 4.6681 4.7102v3.1921c-1.596 0.15604-2.9941-0.36602-4.6201-1.35v5.9702c0 7.5843-8.2683 9.9543-11.592 4.5182-2.1361-3.4982-0.82802-9.6364 6.0242-9.8824v3.3661c-0.52202 0.084-1.08 0.216-1.59 0.3901-1.524 0.516-2.3881 1.482-2.1481 3.1861 0.46201 3.2641 6.4502 4.2301 5.9521-2.1481v-11.946h3.3062v-6e-3z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

var time = function time(_a) {
  var _a$title104 = _a.title,
      title = _a$title104 === void 0 ? '' : _a$title104,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm0.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0.5-13h-1.5v6l5.25 3.15 0.75-1.23-4.5-2.67v-5.25z"
  }));
};

var timHortonsLogo = function timHortonsLogo(_a) {
  var _a$title105 = _a.title,
      title = _a$title105 === void 0 ? '' : _a$title105,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 166 32"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M163.406536,28.1435391 C163.406536,27.910321 163.233776,27.7573004 162.854457,27.7573004 C162.697659,27.7573004 162.585929,27.7711276 162.522083,27.788642 L162.522083,28.5131852 L162.804695,28.5131852 C163.138946,28.5131852 163.406536,28.407177 163.406536,28.1435391 M163.98866,29.3216132 C164.069406,29.7096955 164.116352,29.8673251 164.180198,29.9585844 L163.534228,29.9585844 C163.452542,29.8673251 163.406536,29.634107 163.327667,29.3382058 C163.280722,29.0588971 163.123924,28.9335309 162.79155,28.9335309 L162.506121,28.9335309 L162.506121,29.9585844 L161.907097,29.9585844 L161.907097,27.4153086 C162.143702,27.3692181 162.475137,27.3369547 162.90328,27.3369547 C163.391513,27.3369547 163.612157,27.4153086 163.800878,27.5231605 C163.942653,27.6319342 164.053445,27.8338107 164.053445,28.0826996 C164.053445,28.3592428 163.832801,28.5795556 163.516388,28.669893 L163.516388,28.7003128 C163.769894,28.7943374 163.911669,28.981465 163.98866,29.3216132 M164.904097,28.6486914 C164.904097,27.5167078 164.069406,26.5995062 162.915486,26.5995062 C161.764382,26.5995062 160.915608,27.5167078 160.915608,28.6330206 C160.915608,29.7640823 161.764382,30.6628477 162.931447,30.6628477 C164.069406,30.6628477 164.904097,29.7640823 164.904097,28.6486914 M165.567906,28.6182716 C165.567906,30.0590617 164.413986,31.1901235 162.915486,31.1901235 C161.434825,31.1901235 160.251799,30.0590617 160.251799,28.6182716 C160.251799,27.2060576 161.434825,26.0740741 162.915486,26.0740741 C164.413986,26.0740741 165.567906,27.2060576 165.567906,28.6182716"
  }), React__default.createElement("path", {
    d: "M125.797949,22.5428691 C124.110728,22.4497662 122.700485,21.5934041 123.108911,19.3202189 C123.199985,18.8123012 123.482597,18.3043835 123.794315,17.9080049 C123.777415,17.9098485 121.443285,18.1255522 119.135444,22.4009103 C117.405972,25.6042025 117.678256,29.0425564 119.830238,29.1356592 C121.543748,29.2103259 123.791499,27.3842189 125.122873,24.4288938 C125.441163,23.7227868 125.637395,23.1512642 125.797949,22.5428691 M88.9917425,22.4894041 C86.8012657,22.5686798 85.9224461,20.6706716 86.2942544,19.1653547 C86.422885,18.6445317 86.6754518,18.038902 87.2087526,17.6167127 C87.1768297,17.6185564 87.1439678,17.6194782 87.1092282,17.6213218 C84.8962176,17.8453218 83.3235435,20.1498485 82.2888648,22.2598732 C80.6786343,25.5461284 80.9189953,28.9291736 82.9320181,29.0314946 C84.6305061,29.1181448 86.7871821,27.3574864 88.2011804,24.4288938 C88.43403,23.945865 88.8358834,22.928186 88.9917425,22.4894041 M72.1542714,18.1615029 C71.0641971,18.1937662 67.02219,18.2868691 64.6589538,18.360614 C66.2757566,18.9708527 68.9619778,20.7766798 69.6361151,24.6879226 C69.7656847,24.3348691 71.3411755,20.1987045 72.1542714,18.1615029 M157.456113,21.5141284 C157.708679,22.0533876 158.450418,23.3964658 158.79312,24.4040049 C159.222202,25.6678074 159.148967,26.4716263 159.088877,26.9140955 C158.713313,29.7154782 156.859905,31.3203506 153.667611,31.3728938 C151.872416,31.4023918 150.367343,30.9488609 149.643443,29.7062601 C149.288536,29.0960214 149.192767,28.3604164 149.755174,27.6395605 C150.014313,27.3077086 150.346687,27.0247127 150.495035,26.9122518 C150.713801,26.7481695 150.894071,26.6735029 151.048053,26.6817992 C151.46399,26.7048444 151.572903,26.9242354 151.709984,27.7695358 C151.875232,28.8019638 152.507119,29.4315605 153.383122,29.4140461 C153.682634,29.4085152 154.752052,29.3264741 155.075037,28.2636263 C155.309765,27.4929926 155.089121,26.5564329 154.454418,25.4226057 C153.637566,23.960614 153.265758,22.7336839 153.319276,21.5528444 C152.563453,22.4211901 151.786036,23.3817169 151.072464,24.3090584 C148.220056,28.0156592 146.875537,29.9800378 144.689755,30.8364 C143.578086,31.2724164 142.460783,31.3166634 141.677732,31.1018815 C139.710716,30.5653876 139.598047,28.7890584 139.732311,27.6616839 C139.891925,26.3149185 140.563246,24.3016839 141.765051,21.7270667 C138.074196,25.1986057 134.540139,29.6343588 133.906375,30.4169761 C133.295145,31.1700955 132.589084,30.8843341 132.176903,30.6262271 C131.676464,30.3137333 131.488682,30.1892889 131.022044,29.8648115 C130.478415,29.4877909 130.349784,29.2978979 130.593901,28.3696346 C131.166636,26.1960049 132.436981,22.6995769 133.610618,20.118507 C132.295205,21.0440049 131.095279,21.5620625 129.618373,21.8902271 C129.447492,22.908828 129.059722,23.9735193 128.433469,25.0584905 C126.011082,29.2619473 121.721202,31.9158403 117.517703,31.006935 C115.432384,30.5543259 114.249357,29.0314946 114.058759,27.0173383 C112.563075,28.9476099 111.30118,29.7541942 110.068392,30.3229514 C108.528579,31.0336675 107.192511,30.8308691 106.86577,30.7589679 C104.770123,30.2952971 104.642431,28.5383259 104.848992,27.130721 C104.896876,26.809009 104.995462,26.3988033 105.13442,25.9194617 C103.035957,28.4562848 101.018239,29.9459308 99.3882917,30.5755276 C98.5160444,30.9110667 97.3358347,31.1599555 96.1903646,30.9479391 C94.7078259,30.6741613 93.8618681,29.5716757 93.9970711,27.6183588 C94.1491745,25.4032477 95.7819388,22.5502436 99.2671723,18.7155111 C98.7949006,18.4988856 98.5019608,18.0739308 98.3733301,17.6406798 C97.3677576,18.8860461 95.0383222,20.5047457 92.873196,21.4302436 C92.6948031,22.6829843 92.2600878,23.9016181 91.5775003,25.1211736 C89.2687209,29.2416675 84.7065578,31.9803671 80.5838044,30.8686634 C76.9962297,29.9007621 76.1221046,25.7341778 78.59801,21.5749679 C79.49373,20.069651 80.6683063,18.7975522 81.9686965,17.8185893 C79.4636849,17.9144576 76.8394318,18.0057169 76.8394318,18.0057169 C76.8394318,18.0057169 74.0884258,24.1919885 71.5655749,30.5165317 C71.377793,30.9866551 70.9177271,31.576614 70.0210682,31.0106222 C69.5816583,30.7322354 69.3234581,30.5423424 68.7018998,30.0583918 C68.2070943,29.6739967 68.1761102,29.4324823 68.1742324,28.907972 C68.1873772,24.6252395 66.4503939,20.7305893 62.8421632,19.5580461 C61.4460042,22.8682683 59.9033752,26.8357415 58.3682575,30.7202518 C58.0452725,31.5369761 57.3514181,31.4033136 56.6115571,30.9064576 C56.1421022,30.5902765 55.8144226,30.3561366 55.3825241,30.0169103 C54.7224704,29.5016181 54.5994733,29.3034288 54.9675259,28.2571736 C55.3327619,27.2192148 56.8866577,23.0203671 58.5119108,18.6850913 C58.1119351,18.6970749 56.810606,18.7459308 56.810606,18.7459308 C56.3768297,18.759758 56.1317742,18.6841695 55.9993879,18.3495522 C55.8200561,17.8904905 55.7102036,17.5991983 55.5862675,17.2479885 C55.424775,16.7944576 55.4595147,16.378721 56.2472601,16.3188033 C56.5467724,16.295758 57.9898769,16.2496675 59.4592708,16.1897498 C62.10418,9.53243291 65.584719,1.89615307 66.1912547,0.668301219 C66.605314,-0.169624707 67.302924,-0.110628822 67.949833,0.253486404 C68.4221046,0.518967886 69.0521132,0.881239491 69.8276527,1.37440821 C70.5524912,1.83623538 70.8379198,2.1745399 70.3036801,3.29269628 C70.2069723,3.49457282 67.1104475,9.83755225 64.3275186,16.0874288 C65.8729643,16.0302765 71.5571248,15.8440708 73.0744031,15.8237909 C75.7465407,9.34622714 78.5444922,3.22448229 78.9613681,2.32018599 C79.2270796,1.74313249 79.4843409,1.26839998 80.4927302,1.78461398 C81.6128497,2.36074566 81.8541495,2.46306665 82.5620876,2.87972509 C83.2230801,3.27057282 83.4446629,3.57753579 83.037176,4.41914896 C82.8371882,4.83212015 80.3612828,9.95001315 77.8234094,15.7187045 C79.1932789,15.6845975 84.5873162,15.5601531 86.2013023,15.5140625 C86.7036191,15.4993136 88.715703,15.4181942 89.684658,15.677223 C91.2066309,16.0846634 92.1352128,17.0405811 92.643163,18.414079 C92.737054,18.6537498 92.8778905,19.1902436 92.9323473,19.4898321 C95.5171662,18.1836263 98.0137276,15.9998568 99.4051921,13.5920872 C99.6849872,13.106293 99.9920107,13.0602025 100.574135,13.2851243 C101.032323,13.4611901 100.937493,13.8713959 100.843602,14.1765152 C100.623897,14.8798568 100.606997,15.6163835 100.903692,16.1104741 C101.180671,16.5723012 101.527128,17.021223 103.480061,17.2461448 C103.926982,17.2977662 104.134481,17.4793629 104.234945,17.7835605 C104.336347,18.0923671 104.386109,18.331116 103.898815,18.8712971 C101.337469,21.7086304 99.7525887,23.6213876 98.8737691,25.8623094 C97.811862,28.5705893 99.0061554,28.4664247 99.5807682,28.3309185 C101.166587,27.9594288 104.720361,24.5514946 107.246029,20.225437 C108.151138,18.034293 109.195205,15.6541778 110.17355,13.4814699 C108.801802,13.5625893 107.971806,13.6188197 107.799046,13.6308033 C107.213167,13.6741284 107.101436,13.3782271 106.993462,13.1274946 C106.884548,12.8776839 106.791596,12.6232642 106.672355,12.2812724 C106.553113,11.9392806 106.553113,11.5788527 107.295791,11.5069514 C107.51174,11.4866716 109.034652,11.3640708 111.207289,11.2036757 C112.298303,8.82448229 113.180878,6.95781562 113.494474,6.30609546 C113.924495,5.41101727 114.470001,5.2072971 115.318776,5.6977004 C116.103704,6.15030945 116.23703,6.23603784 116.888633,6.64900904 C117.499863,7.03801315 117.774964,7.28874566 117.307387,8.29628476 C116.888633,9.19781562 116.490535,10.0486469 116.111216,10.8579967 C120.480902,10.5648609 125.419568,10.277256 128.276671,10.247758 C129.139529,10.2385399 129.298205,10.3537662 129.477537,10.7427704 C129.66438,11.1465234 129.795827,11.4332066 129.970465,11.845256 C130.165758,12.3033959 130.006143,12.6758074 129.459698,12.6896346 C123.776476,12.8279062 118.768331,13.0362354 114.999546,13.2215193 C112.897327,17.6904576 111.320897,21.0799555 109.519129,25.8613876 C108.559563,28.4083506 110.018629,28.0442354 110.16416,27.9981448 C112.095498,27.3832971 114.03153,24.121009 116.334676,20.761009 C118.973952,16.9096839 122.837566,15.1536346 126.150979,15.9592971 C127.387523,16.2607292 128.240993,16.7612724 128.884146,17.7651243 C129.086011,18.0370584 129.270038,18.4076263 129.384585,18.745009 C129.520727,19.173651 129.633396,19.6594453 129.669075,20.1728938 C131.608862,19.6539144 133.29045,18.7044494 135.182353,16.8534535 C135.587024,16.4579967 136.018922,16.227544 136.820751,16.7769432 C137.326824,17.123544 137.651686,17.3346387 138.116447,17.6978321 C138.757722,18.1992971 139.060051,18.4380461 138.438493,19.5617333 C138.087341,20.1950173 137.070501,22.1013218 135.552284,25.9120872 C138.944565,21.8174041 143.140554,17.8517745 144.036274,17.2415358 C144.272879,17.0792971 144.71135,16.8414699 145.468111,17.3069843 C145.971367,17.6167127 146.216422,17.7669679 146.714984,18.1320049 C147.360954,18.6030502 147.591925,18.9588691 147.126226,19.8917415 C146.681183,20.7831325 145.163904,23.5734535 144.345175,26.2577662 C143.687938,28.4157251 144.440005,28.5650584 145.006168,28.3972889 C145.774196,28.167758 146.785402,27.1076757 149.015313,24.2417662 C150.963551,21.7372066 152.693023,19.7212066 154.772708,17.7522189 C155.335115,17.2203341 156.159478,16.4884164 156.710618,16.0625399 C157.130311,15.7371407 157.602583,15.4440049 157.969696,15.4181942 C158.229774,15.4006798 158.385633,15.4642848 158.693596,15.7509679 C158.942407,15.9814206 158.987475,16.0265893 159.149906,16.1832971 C159.487914,16.505009 159.664429,16.6460461 159.685085,16.8958568 C159.718886,17.313437 159.510448,17.4323506 159.033481,17.8121366 L158.805326,17.9992642 C157.815715,18.8187539 156.695596,19.8963506 157.456113,21.5141284 M23.1910596,13.4261613 C24.6482478,13.1929432 25.7448945,11.8240543 25.6350421,10.3731243 C25.5364565,9.0669185 24.5139837,8.11837529 23.2042044,8.11837529 C23.0643068,8.11837529 22.9215925,8.12943702 22.7788782,8.15248229 C21.322629,8.38477859 20.2259822,9.75458928 20.3348958,11.2055193 C20.4325424,12.5117251 21.4550153,13.4602683 22.7657335,13.4602683 C22.905631,13.4602683 23.0483453,13.4492066 23.1910596,13.4261613 M49.0185929,20.3803012 C49.6392123,19.2464741 49.3735008,18.9376675 48.6711962,18.4555605 C48.0740495,18.0444329 47.9519912,17.9421119 47.5473211,17.6812395 C46.7464309,17.1641037 46.1840239,17.3641366 45.5624656,17.9273629 C43.3926448,19.8935852 40.2059847,23.1383588 37.8427485,25.9084 C39.2482966,22.1501778 40.014447,20.5167292 40.5289697,19.3598568 C40.9711962,18.3615358 40.8566492,18.083149 40.2970589,17.7070502 C39.9074113,17.4461778 39.4886575,17.1760872 38.816398,16.7538979 C38.2220681,16.3796428 37.7385295,16.5133053 37.3254091,16.8829514 C35.8710377,18.1836263 31.6337374,22.3446798 28.7587953,25.5645646 C30.1671601,22.2875276 31.3961932,19.4815358 31.8309084,18.555116 C32.242151,17.6775522 32.3153859,17.2572066 31.6036922,16.7474453 C31.0666358,16.363972 30.5868528,16.0643835 30.0789026,15.7592642 C29.1550153,15.2043341 28.802924,15.5795111 28.4395659,16.1491901 C28.303424,16.3612066 28.0959249,16.7078074 27.8264578,17.1364494 C23.8051067,23.8324823 20.5311279,27.5400049 19.2288599,27.9704905 C18.6702085,28.1548527 18.4035581,28.0248774 18.2739886,27.9031983 C17.7979612,27.4542765 18.2223485,26.1757251 18.4129472,25.6613547 C19.0992903,23.809437 20.4400537,20.8596428 21.8183734,18.0333712 C22.3441629,16.9548527 22.1817315,16.6460461 21.4362371,16.1196922 C20.9686599,15.7896839 20.5348836,15.5306551 19.9743544,15.190507 C19.1396635,14.6871983 18.6364078,14.9499144 18.1707085,15.9104411 C17.0562224,18.2075934 14.2225924,24.0168444 13.7061919,27.2007786 C13.3165443,29.59933 14.3653067,30.661256 15.7577101,30.9691407 C16.8055335,31.2005152 18.0045214,30.9101448 18.6683307,30.5985728 C20.1471138,29.906293 22.2089599,28.1696016 24.9834386,24.3035276 C24.4463822,25.6779473 23.8792806,27.2468691 23.5750738,28.2415029 C23.2323717,29.3651901 23.4304817,29.6574041 24.1111913,30.0878897 C24.4219705,30.2842354 24.5665626,30.3828691 25.0069114,30.6520378 C25.4613438,30.9295029 26.1561371,31.2143424 26.7683063,30.4934864 C27.5832801,29.5348033 31.9726838,24.2307045 35.430689,20.9896181 C34.6391879,23.0701448 33.4571004,26.2245811 32.9012657,28.2285975 C32.6533935,29.1199885 32.8646482,29.4204987 33.6120205,29.9136675 L34.7340178,30.6142436 C34.9959737,30.7691078 35.7367736,31.1166304 36.3864992,30.3533712 C37.0155688,29.614079 40.6688672,25.0225399 43.6320668,22.1372724 C42.5138252,24.6657992 41.880061,26.614507 41.6659895,28.0921695 C41.5936935,28.5871819 41.2707085,31.1378321 43.9541129,31.5397415 C44.8019486,31.6660296 46.3464553,31.5406634 47.4769028,30.4676757 C47.7717205,30.1883671 47.9012901,29.8546716 47.8665504,29.6574041 C47.8214828,29.4057498 47.6186782,29.3845481 47.3172882,29.3651901 C47.0938276,29.3522848 46.8121546,29.3338485 46.5257871,29.1891243 C45.5389928,28.6885811 46.0178369,27.4754782 46.2450531,26.7444823 C47.1050945,23.9781284 48.1951689,21.8856181 49.0185929,20.3803012 M18.0007658,5.58155225 C16.0018266,10.0117745 7.73096941,29.025042 6.94979638,30.7460625 C6.61554446,31.4825893 6.08975492,31.8070667 5.15084503,31.3009926 C4.22414097,30.802293 3.72088527,30.4999391 2.98571883,30.0390337 C2.07685406,29.4684329 2.3754274,28.752186 2.64395563,28.1815852 C5.22971347,22.6922025 6.8662334,18.691544 8.26896478,15.7030337 C10.6922912,10.5381284 11.8762566,8.15432591 12.9306524,5.94843291 C8.88301184,6.36601315 3.58943789,6.85826007 2.45054019,7.01773332 C1.00649678,7.22053167 0.8750494,6.71998846 0.543614209,5.89128064 C0.275085981,5.22112426 0.351137682,5.48568393 0.205606649,5.07086912 C-0.0601048497,4.31037529 -0.317366159,3.53974155 1.14357763,3.3894864 C4.32648215,3.06224361 19.4034972,1.75419422 31.022507,1.5366469 C31.9952177,1.51728887 32.3679649,1.54309957 32.6937666,2.23169217 C32.9960956,2.87142879 33.0345909,2.85852344 33.3453701,3.58951933 C33.6570882,4.32143702 33.137871,4.68370863 32.4477722,4.71136295 C27.4969004,4.91139587 22.6962541,5.24693496 18.0007658,5.58155225"
  }));
};

var timsCard = function timsCard(_a) {
  var _a$title106 = _a.title,
      title = _a$title106 === void 0 ? '' : _a$title106,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    transform: "translate(1.000000, 5.000000)"
  }, React__default.createElement("mask", {
    id: "mask-tim-card",
    fill: "#FFFFFF"
  }, React__default.createElement("path", {
    d: "M14.6791953,10.2966664 L14.6803831,10.2980371 C14.8504609,10.1442206 14.9229678,9.96649626 15.1467544,9.64417294 C15.482136,9.16169612 15.8846536,8.55622371 16.8048642,7.56419376 C16.5933113,8.0103768 16.5148368,8.34681437 16.5070788,8.61296875 C16.490071,9.22132161 16.8433555,9.46356819 16.8335089,9.81383196 C16.8236623,10.1638077 16.6323993,10.3190644 16.4324833,10.3135915 C16.1979549,10.3075426 15.9508944,10.0727852 15.9631281,9.63898812 C15.9655152,9.55833527 15.9416446,9.51743276 15.9040484,9.51656862 C15.8652587,9.51570449 15.8127435,9.55747114 15.7590347,9.64302076 C15.6933906,9.7481575 15.5588202,9.95411029 15.4988454,10.0477252 C15.4716926,10.0897799 15.4579671,10.1185845 15.4570719,10.1508456 C15.4528946,10.3035099 15.8601862,10.6382192 16.5127481,10.655502 C17.6000527,10.6840185 17.8211539,9.89016411 17.8327909,9.47825852 C17.8444278,9.06116811 17.5433601,8.59338163 17.5544003,8.2056719 C17.5600695,8.0002952 17.6301893,7.78022816 17.8220491,7.52559561 C17.8533792,7.4846931 17.8733708,7.43630139 17.8748627,7.38186073 C17.876653,7.320795 17.8608388,7.25569664 17.8327909,7.1989516 C17.7677435,7.06616246 17.6003511,6.72050742 17.4911433,6.56582679 C17.4735387,6.5407668 17.4544422,6.53183738 17.4356442,6.53126129 C17.4052092,6.5306852 17.3762661,6.55228864 17.3571697,6.56640288 C16.7338493,7.01517834 15.9705877,8.03630093 15.3433883,8.87566658 C15.0184501,9.31090388 14.6511416,9.78531542 14.4375,10.0177684 L14.5607782,10.1600221 C14.3242016,10.1548005 14.2162772,10.0081164 14.2162772,9.76538771 C14.2162772,9.35170252 14.5301828,8.65865286 15.0568535,7.90831937 C15.1006399,7.84793149 15.125,7.81406913 15.125,7.78048895 C15.125,7.75339906 15.1151326,7.72405168 15.0750465,7.6865209 C14.9199438,7.54091274 14.7645327,7.4136467 14.6094301,7.30528715 C14.533883,7.25223611 14.4611112,7.22091343 14.3871059,7.22091343 C14.3192678,7.22091343 14.251738,7.24659239 14.1826664,7.30246528 C14.0321891,7.41900824 12.7266131,8.67586623 12.1515306,9.41773413 C12.2724058,9.01618296 12.4568022,8.4388297 12.7941429,7.78331082 C12.8465632,7.68087717 12.8743152,7.62726177 12.8743152,7.58690912 C12.8743152,7.5253925 12.8366959,7.48306454 12.8058604,7.45682121 C12.618072,7.295975 12.4302837,7.15375308 12.242187,7.03015546 C12.1950086,6.99911496 12.1604729,6.9714607 12.1086692,6.9714607 C12.0722833,6.9714607 12.0284968,6.98726313 11.9708344,7.03071983 C11.8326913,7.13710408 10.4851789,8.28503814 9.68746396,9.36863371 C9.79847184,9.08277894 10.4037731,7.85921894 10.5860111,7.53018966 C10.6205469,7.46810867 10.6828346,7.35043696 10.6828346,7.30726245 C10.6828346,7.26211264 10.6600163,7.23022558 10.6325727,7.20736848 C10.5693599,7.15572838 10.1281036,6.88116107 10.0288132,6.83121409 C9.98070978,6.80525294 9.9350732,6.79001488 9.89437031,6.79001488 C9.8462669,6.79001488 9.80463894,6.81061448 9.77133658,6.85830397 L8.80680144,8.24383893 C8.21260092,9.09660607 7.32453787,9.75325369 7.01803277,9.75325369 C6.93755206,9.75325369 6.89129878,9.71092574 6.89129878,9.62119048 C6.89129878,9.54669329 6.92336772,9.44030904 6.99213093,9.29752275 C7.2644086,8.73371443 7.53637791,8.15128181 7.86970991,7.49463418 C7.93292273,7.36990782 7.94217338,7.30923775 7.94217338,7.24066647 C7.94217338,7.17830329 7.90948773,7.11565792 7.83486577,7.03692793 C7.67575447,6.86846268 7.51725988,6.71918611 7.35814859,6.58825164 C7.32052925,6.55749333 7.27458432,6.53125 7.22216393,6.53125 C7.16604328,6.53350749 7.10498895,6.5518496 7.04424297,6.64468891 C6.84165358,6.97851536 6.19379926,8.09061175 5.52497677,9.77723953 C5.51140914,9.8150525 5.5,9.85258329 5.5,9.89039626 C5.5,9.96432908 5.55087861,10.0281032 5.69950583,10.1164275 C5.98627619,10.2871503 6.20613347,10.4257038 6.4262991,10.4257038 C6.87310582,10.4257038 7.59280691,10.0266923 8.11176876,9.5692682 C8.66341626,9.08221456 9.01617463,8.57371477 9.01617463,8.57371477 C8.90948373,8.73286787 8.49659608,9.56390666 8.29986544,9.98323557 C8.27858893,10.0283854 8.26902992,10.0664805 8.26902992,10.0980854 C8.26902992,10.168632 8.31404979,10.2013656 8.39823076,10.2513126 C8.54500785,10.3385082 8.78860848,10.4643633 8.92089287,10.5055625 C8.97423832,10.5216471 9.02203338,10.5414002 9.07075351,10.5414002 C9.1472256,10.5414002 9.21352198,10.5097953 9.25761677,10.4558977 C9.89899564,9.66097876 10.9921149,8.54493176 11.5875489,8.08355709 C11.3128044,8.50937628 10.7654738,9.94598697 10.7654738,10.0241526 C10.7654738,10.0876445 10.8228279,10.1370271 10.8894326,10.1737113 C11.1105233,10.2961802 11.3309973,10.4000248 11.5514713,10.4852451 C11.5897073,10.500201 11.627635,10.5126172 11.6643293,10.5126172 C11.7145912,10.5126172 11.7608445,10.494275 11.7910633,10.4527936 C12.0713582,10.0645052 13.0883137,8.74161565 13.7876634,8.25089359 C13.434905,8.77463145 13.1172991,9.64602288 13.1172991,10.0058105 C13.1172991,10.3890195 13.5203194,10.65625 13.941841,10.65625 C14.2141768,10.65625 14.494206,10.5448442 14.6791953,10.2966664 Z M0,2.00747252 C0,0.898776059 0.889673948,0 1.991155,0 L20.008845,0 C21.1085295,0 22,0.903130285 22,2.00747252 L22,12.4300275 C22,13.5387239 21.1103261,14.4375 20.008845,14.4375 L1.991155,14.4375 C0.891470458,14.4375 0,13.5343697 0,12.4300275 L0,2.00747252 Z M7.5625,5.89240218 C7.5625,6.27104894 7.87304809,6.53125 8.20065926,6.53125 C8.69378232,6.53125 8.9375,6.11275995 8.9375,5.79157427 C8.9375,5.35600853 8.55784643,5.15625 8.30645036,5.15625 C7.84233454,5.15625 7.5625,5.53787823 7.5625,5.89240218 Z M11.4803162,4.04192062 C11.6409521,4.04223636 11.6875,3.96740571 11.6875,3.89320654 C11.6875,3.8467926 11.6169176,3.50642366 11.5831475,3.35265773 C11.5578961,3.23646499 11.5134778,3.09375 11.3348921,3.09375 C8.63115916,3.09375 5.40110035,3.39559852 2.87321502,3.72902115 C2.77190489,3.74228228 2.75,3.80479903 2.75,3.87741949 C2.75,4.04223636 2.89755378,4.33240246 2.98060983,4.4555415 C3.06062353,4.57520738 3.09652322,4.63740839 3.19692064,4.62509448 C3.60642041,4.58973148 5.38193357,4.39744513 5.86262425,4.38134233 C5.06400841,5.83785617 3.90487456,8.51755114 3.18201314,10.3431664 C3.15250238,10.4224174 3.14063723,10.4808295 3.14063723,10.5341897 C3.14063723,10.6178611 3.18475125,10.6743788 3.25776756,10.7432104 C3.38797997,10.8609818 3.53614222,11.0153792 3.80812796,11.2316619 C3.90457033,11.3099657 3.98853908,11.34375 4.06033845,11.34375 C4.19085509,11.34375 4.27482384,11.2458702 4.32441408,11.1164164 C4.91067417,9.49319123 6.27060285,6.13496857 7.245979,4.22568195 C8.87941459,4.11580404 11.316638,4.04128913 11.4803162,4.04192062 Z M18.1617193,7.21875 L18.2744388,7.21875 L18.2744388,6.60760118 L18.5625,6.60760118 L18.5625,6.53125 L17.875,6.53125 L17.875,6.60760118 L18.1617193,6.60760118 L18.1617193,7.21875 Z M19.1626324,7.21875 L19.25,7.21875 L19.25,6.53125 L19.1248424,6.53125 L18.90677,7.06095755 L18.6876576,6.53125 L18.5625,6.53125 L18.5625,7.21875 L18.6498676,7.21875 L18.6498676,6.64051703 L18.8887418,7.21875 L18.9244516,7.21875 L19.1626324,6.64051703 L19.1626324,7.21875 Z"
  })), React__default.createElement("g", {
    mask: "url(#mask-tim-card)"
  }, React__default.createElement("g", {
    transform: "translate(-1.000000, -5.000000)"
  }, React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }))), React__default.createElement("g", {
    mask: "url(#mask-tim-card)"
  }, React__default.createElement("g", {
    transform: "translate(2.750000, 3.093750)"
  }))));
};

var timsLogo = function timsLogo(_a) {
  var _a$title107 = _a.title,
      title = _a$title107 === void 0 ? '' : _a$title107,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 25 15",
    "aria-hidden": "true"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "timCard",
    transform: "translate(3.125000, 4.375000)"
  }, React__default.createElement("path", {
    d: "M10.0401133,5.26676463 C9.33512252,5.26676463 8.76822275,4.66237756 8.76822275,3.91263158 C8.76822275,3.17053606 9.33512252,2.56614899 10.0401133,2.56614899 C10.479824,2.56614899 10.8650251,2.7994883 11.0939654,3.15140989 L10.6506207,3.47655483 C10.5197977,3.26616693 10.3271971,3.13610895 10.0655511,3.13610895 C9.64401021,3.13610895 9.34239047,3.47655483 9.34239047,3.91263158 C9.34239047,4.34870832 9.6331083,4.70062991 10.0619171,4.70062991 C10.3271971,4.70062991 10.5197977,4.57057193 10.6506207,4.35635879 L11.0939654,4.68532897 C10.8650251,5.03725056 10.479824,5.26676463 10.0401133,5.26676463 Z M13.0163371,5.23616276 L12.8273705,4.62412522 L11.947949,4.62412522 L11.7626164,5.23616276 L11.152109,5.23616276 L12.078772,2.6005761 L12.7001814,2.6005761 L13.6232105,5.23616276 L13.0163371,5.23616276 Z M12.1042099,4.10389331 L12.6674757,4.10389331 L12.3840258,3.18201177 L12.1042099,4.10389331 Z M15.1385772,5.23616276 L14.5607755,4.31045598 L14.4481224,4.31045598 L14.4481224,5.23616276 L13.8775886,5.23616276 L13.8775886,2.6005761 L14.902369,2.6005761 C15.4838046,2.6005761 15.7454507,3.03665285 15.7454507,3.4727296 C15.7454507,3.84377735 15.5601181,4.1689223 15.1567471,4.27602887 L15.8035943,5.23616276 L15.1385772,5.23616276 Z M14.4481224,3.12463325 L14.4481224,3.83612689 L14.8115197,3.83612689 C15.0622638,3.83612689 15.171283,3.66399133 15.171283,3.48803054 C15.171283,3.31206974 15.0586298,3.12463325 14.8260556,3.12463325 L14.4481224,3.12463325 Z M16.2105992,5.23616276 L16.2105992,2.6005761 L17.1990398,2.6005761 C17.9222005,2.6005761 18.3401073,3.1743613 18.3401073,3.92410728 C18.3401073,4.67002803 17.9222005,5.23616276 17.1990398,5.23616276 L16.2105992,5.23616276 Z M16.781133,4.71210561 L17.1990398,4.71210561 C17.5733391,4.71210561 17.7659396,4.33340739 17.7659396,3.92410728 C17.7659396,3.51098194 17.5733391,3.12463325 17.1990398,3.12463325 L16.781133,3.12463325 L16.781133,4.71210561 Z",
    fill: "#432726",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    d: "M3.942642,2.17110154 C3.91795865,2.17527618 3.89327529,2.17728 3.86907911,2.17728 C3.64238201,2.17728 3.46553878,2.00545209 3.44865018,1.76883388 C3.42981288,1.50599896 3.61948495,1.25785876 3.87135258,1.21577846 C3.89603593,1.21160382 3.92071928,1.2096 3.94491547,1.2096 C4.17145018,1.2096 4.3482934,1.38142791 4.3653444,1.61804612 C4.38434409,1.88088104 4.19467202,2.12885425 3.942642,2.17110154 Z M8.44300726,3.36833557 C8.30005437,3.63095951 8.11080887,3.99602769 7.9614989,4.47865747 C7.92205238,4.6061901 7.83892129,4.81783315 8.01023655,4.90516003 C8.0599522,4.93040924 8.10885285,4.9336257 8.14764736,4.93587722 C8.19997105,4.9392545 8.23517951,4.94295343 8.24300362,4.9868581 C8.2490347,5.02127422 8.2265404,5.07949214 8.17535773,5.12822151 C7.97910314,5.31541946 7.7109646,5.33729139 7.56377366,5.31525864 C7.09791351,5.24513982 7.15398625,4.80014262 7.16653742,4.71378067 C7.20370191,4.45598143 7.31372836,4.11600164 7.50786392,3.67486419 C6.99342913,4.17824013 6.35918776,4.97929942 6.24997632,5.10827946 C6.13717884,5.24144089 6.00857014,5.18081062 5.96309254,5.15379236 L5.76830497,5.03156689 C5.63855526,4.9455266 5.60187977,4.8930983 5.64491234,4.73758248 C5.74140961,4.3879533 5.94662932,3.83761705 6.08404013,3.47463957 C5.48370321,4.04009319 4.72166816,4.96546865 4.58018229,5.13272455 C4.47390489,5.25848813 4.3532833,5.20879382 4.27439026,5.16038611 C4.19794225,5.11342579 4.17283992,5.09621773 4.11888621,5.06196244 C4.00070965,4.9868581 3.9663162,4.93587722 4.02581198,4.739834 C4.07862468,4.566306 4.17707798,4.29258527 4.27031521,4.0527982 C3.78864385,4.7272898 3.43069113,5.03028031 3.17396274,5.15105837 C3.05872022,5.20541654 2.85056648,5.25607578 2.66865608,5.21570921 C2.42692389,5.16199434 2.24485048,4.97672626 2.31249638,4.55826485 C2.40214756,4.00278225 2.89408805,2.9892758 3.0875716,2.58850492 C3.16842067,2.42092737 3.25578982,2.37509281 3.40069873,2.46290216 C3.49801102,2.52224585 3.57331801,2.56743711 3.65449308,2.62501173 C3.78391679,2.71684166 3.81211616,2.77071736 3.72083496,2.95888025 C3.4815478,3.45196353 3.24878073,3.96659708 3.12962616,4.28969046 C3.09653672,4.37942969 3.02285975,4.60249117 3.10550184,4.68081196 C3.12799614,4.7020406 3.17428875,4.72471664 3.27127503,4.69255204 C3.49735901,4.61744771 4.06574751,3.97061766 4.76388572,2.80239949 C4.81066734,2.7276168 4.84669081,2.66714736 4.87032612,2.63015807 C4.93340795,2.53076946 4.99453376,2.46531451 5.15492788,2.56212995 C5.24311204,2.61536236 5.32640614,2.66762983 5.41964337,2.73453219 C5.543199,2.8234673 5.53048483,2.89680258 5.45908989,3.04990606 C5.38361989,3.21153316 5.17025008,3.70107833 4.92574685,4.27280405 C5.42485944,3.71104936 6.16048814,2.9850944 6.41297847,2.75817317 C6.48469942,2.69368315 6.56864553,2.67036382 6.67182589,2.73565795 C6.78853543,2.80931488 6.86123439,2.85643601 6.92888028,2.90194892 C7.02602956,2.96756469 7.04591582,3.01613324 6.96914181,3.19030453 C6.87981663,3.39213738 6.74680688,3.67711571 6.50279266,4.33279102 C6.91306907,3.84951795 7.46629837,3.28342104 7.84299634,2.94038561 C7.95090376,2.84212277 8.04854205,2.80722418 8.18758289,2.89744587 C8.25783681,2.94295878 8.27902709,2.96081013 8.38269646,3.03253718 C8.50462207,3.1166476 8.55075168,3.1705233 8.44300726,3.36833557 Z M3.09304341,0.717987899 C2.74956882,1.50360375 1.32840037,4.875246 1.19417264,5.18043634 C1.13673865,5.31104539 1.04639306,5.36858529 0.885061641,5.27884266 C0.725827532,5.19040775 0.639353893,5.13679102 0.513031394,5.0550582 C0.356862582,4.95387297 0.408165973,4.82686017 0.454306758,4.72567494 C0.89861348,3.75223707 1.17981414,3.0427962 1.42084328,2.5128406 C1.83723966,1.59694263 2.04067858,1.17422049 2.22185376,0.783047222 C1.52635402,0.857097156 0.616767495,0.944387807 0.421072486,0.972667362 C0.172944767,1.0086298 0.150358369,0.919867961 0.0934083787,0.772912353 C0.0472675935,0.654072834 0.0603354383,0.700987472 0.0353290687,0.627427935 C-0.0103277223,0.492568784 -0.0545325304,0.355911511 0.196499154,0.329266612 C0.743412657,0.271236311 3.33407255,0.0392785708 5.33054883,0.000700680329 C5.49768818,-0.00273209806 5.56173675,0.00184493979 5.61771875,0.123953771 C5.66966747,0.237398924 5.67628206,0.235110405 5.72968275,0.364738655 C5.78324478,0.494530372 5.69402851,0.558772367 5.57544992,0.563676337 C4.72474936,0.59914838 3.89986183,0.658649872 3.09304341,0.717987899 Z",
    fill: "#C8102E",
    fillRule: "evenodd"
  })));
};

var timsText = function timsText(_a) {
  var _a$title108 = _a.title,
      title = _a$title108 === void 0 ? '' : _a$title108,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 120 80",
    enableBackground: "new 0 0 120 80",
    xmlSpace: "preserve"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: "\n              M42.4,25.5c-0.2,0.1-0.5,0.1-0.7,0.2c-2.3,0.9-3.5,3.5-2.8,5.9c0.6,2.1,2.6,3.3,4.7,2.8\n              c0.2,0,0.5-0.1,0.7-0.2c2.3-0.9,3.5-3.5,2.8-5.9C46.5,26.2,44.5,25,42.4,25.5\n            "
  }), React__default.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: "\n              M115,49.3c-1,0.2-1.8-0.4-2-1.3c-0.2-0.9,0.3-1.8,1.3-2.1c0.9-0.2,1.8,0.4,2,1.3\n              C116.4,48.2,115.9,49.1,115,49.3 M114.1,45.5c-1.2,0.3-2,1.4-1.7,2.6c0.3,1.2,1.4,1.9,2.7,\n              1.6c1.2-0.3,2-1.4,1.7-2.6 C116.5,45.9,115.3,45.2,114.1,45.5\n            "
  }), React__default.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: "\n              M114.4,47.5l-0.2,0.1l-0.1-0.5c0.1,0,0.1-0.1,0.3-0.1c0.3-0.1,0.5,0,0.5,0.2\n              C114.9,47.3,114.7,47.4,114.4,47.5 M115,47.5L115,47.5c0.2-0.1,0.4-0.3,\n              0.3-0.5c0-0.2-0.2-0.3-0.3-0.4c-0.2,0-0.4-0.1-0.8,0\n              s-0.6,0.2-0.8,0.2l0.4,1.8l0.5-0.1l-0.2-0.7l0.2-0.1c0.3-0.1,0.4,0,0.5,0.2s0.2,0.4,0.3,0.4l0.5-0.1c-0.1-0.1-0.1-0.2-0.3-0.4\n              C115.4,47.6,115.3,47.5,115,47.5\n            "
  }), React__default.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: "\n              M106.6,28.7l0.3-0.4c0.6-0.8,0.9-1.1,0.7-1.7c-0.1-0.4-0.5-0.6-1.1-1c-0.3-0.2-0.4-0.3-0.9-0.5\n              c-0.6-0.4-0.9-0.4-1.3-0.3c-0.6,0.2-1.2,0.8-1.8,1.5c-0.7,0.9-1.8,\n              2.4-2.5,3.5c-2.6,4-4.7,7.9-6.9,12.7c-2.5,5.5-3.8,7.6-4.9,8.3\n              c-0.7,0.4-1.8,0.5-1.9-2c0-0.4,0.1-0.8,0.1-1.1c0.4-4.8,1.4-8.7,2.1-11.4c0.6-2.1,0-2.5-1.3-3c-1.1-0.5-1.3-0.6-2.1-0.9\n              c-0.9-0.3-1.5-0.3-2.1,0.1c-0.3,0.1-0.4,0.3-0.6,0.4l0,0c-0.2,0.2-0.3,0.4-0.5,0.6c-2.8,\n              4-6.7,10.5-9.5,15.9 c0.9-6.7,1.5-9.6,1.9-11.7c0.3-1.8,\n              0.1-2.2-1-2.6c-0.7-0.3-1.5-0.6-2.7-1c-1.1-0.4-1.8,0-2.4,0.8c-1.9,2.7-7.2,11-10.6,17.3\n              c1.1-5.9,2-10.9,2.4-12.6c0.3-1.6,0.3-2.3-1-2.9c-1-0.4-1.9-0.8-2.8-1.1c-1.7-0.6-2.1,\n              0.2-2.5,1.2c-0.1,0.4-0.3,1-0.6,1.8 c-4,12.4-8,19.7-9.9,20.8c-0.8,0.5-1.3,0.4-1.6,0.2c-0.9-0.6-0.7-2.8-0.6-3.7c0.4-3.3,1.5-8.6,2.7-13.7c0.5-2,0.1-2.4-1.3-3\n              c-0.9-0.4-1.7-0.6-2.7-1c-1.5-0.5-2.2,0.1-2.6,1.8c-1,4.2-3.4,14.7-3.1,20.1c0.3,4.1,2.3,5.4,4.7,\n              5.4c1.8,0,3.6-0.9,4.6-1.7 c2.1-1.7,4.8-5.3,7.9-12.6c-0.4,2.4-0.7,5.2-0.8,7c-0.1,2,\n              0.3,2.4,1.5,2.8c0.6,0.2,0.8,0.3,1.7,0.6c0.8,0.3,2.1,0.5,2.8-0.9\n              c1-1.9,6.1-12.1,10.5-18.7c-0.5,3.7-1.3,9.3-1.4,12.8c-0.1,1.5,0.4,2,1.8,\n              2.5l2.1,0.7c0.5,0.2,1.8,0.5,2.6-1 c0.7-1.4,5-10.3,8.7-16.1c-0.1,0.3-0.1,0.6-0.2,\n              0.9c-0.8,4.2-1.1,7.3-0.9,9.4c0.2,1.9,1,4.8,4.4,4.9c1.3,0.1,3.1-0.4,4.8-1.5\n              c3.2-2.2,4.7-5.9,7.9-13c0.8-1.8,1.7-3.6,2.6-5.3c0.3,2,1.4,3.8,3.3,5.9c1.4,1.6,2.1,\n              3.1,2,4.4c-0.1,1.9-1.8,2.4-2.3,2.5 c-1.4,0.3-2.7-0.5-3.3-2.1c-0.5-1.3-0.8-1.7-1.5-1.5c-0.3,0-0.5,\n              0.2-0.8,0.6c-0.2,0.2-0.6,0.8-0.9,1.5c-0.6,1.4-0.2,2.6,0.6,3.4 c1.6,1.8,4.2,2\n              ,7.1,1.3c5.1-1.2,7.5-4.5,7.1-9.3c-0.1-0.7-0.2-2.1-1.4-4c-0.9-1.5-2.6-3.5-3.2-4.2C103.9,\n              32.6,105.3,30.4,106.6,28.7\n            "
  }), React__default.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: "\n              M56,16.6c1.1-0.3,1.8-1.1,1-2.2s-0.8-1-1.6-2s-1.4-0.9-3-0.5C33.9,16.5,10,24.1,5,25.7\n              c-2.3,0.8-1.6,1.9-0.9,3.1C4.5,29.4,4.3,29,4.9,30c0.8,1.2,1.2,2,3.5,1.2c1.8-0.7,10.1-3.4,\n              16.5-5.5C24,29.7,23,34,21,43.3 c-1.2,5.4-2.3,12.5-4.5,22.4c-0.2,1-0.4,2.3,1.2,\n              2.9c1.4,0.5,2.3,0.8,4,1.3s2.4-0.2,2.7-1.6c0.6-3.1,7-37.2,8.6-45.2\n              C40.5,21,48.1,18.7,56,16.6\n            "
  }));
};

var twitter = function twitter(_a) {
  var _a$title109 = _a.title,
      title = _a$title109 === void 0 ? '' : _a$title109,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m23.149 5.1307c-0.8149 0.36147-1.6907 0.60566-2.6098 0.71552 0.938-0.56236 1.6586-1.4528 1.9979-2.514-0.8781 0.52073-1.8505 0.89895-2.8857 1.1026-0.8288-0.8832-2.0097-1.4349-3.3168-1.4349-2.5095 0-4.5441 2.0345-4.5441 4.544 0 0.35615 0.0402 0.70301 0.1177 1.0356-3.7767-0.18949-7.125-1.9986-9.366-4.7479-0.39115 0.67111-0.6153 1.4516-0.6153 2.2844 0 1.5766 0.8022 2.9674 2.0216 3.7824-0.74487-0.0237-1.4456-0.22802-2.0582-0.56845-4.4e-4 0.01904-4.4e-4 0.03798-4.4e-4 0.05725 0 2.2016 1.5664 4.0381 3.6452 4.4557-0.38129 0.1037-0.78277 0.1593-1.1972 0.1593-0.29281 0-0.57753-0.0284-0.85507-0.0815 0.57831 1.8053 2.2564 3.1191 4.2449 3.1557-1.5552 1.2189-3.5145 1.9454-5.6435 1.9454-0.36679 0-0.72848-0.0216-1.084-0.0637 2.011 1.2894 4.3996 2.0418 6.9657 2.0418 8.358 0 12.929-6.9243 12.929-12.929 0-0.19702-0.0046-0.39303-0.0133-0.58794 0.8879-0.64066 1.6583-1.4409 2.2674-2.3522",
    fillRule: "evenodd"
  }));
};

var visa = function visa(_a) {
  var _a$title110 = _a.title,
      title = _a$title110 === void 0 ? '' : _a$title110,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 32 20"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "icon-/-card-/-visa",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    id: "Rectangle",
    fill: "#FFFFFF",
    d: "M2,0h28c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  })), React__default.createElement("path", {
    fill: "#1A1F71",
    d: "M13.09,6.23l-3.17,7.56H7.85L6.29,7.76C6.19,7.38,6.11,7.25,5.82,7.09C5.35,6.84,4.58,6.6,3.89,6.45l0.05-0.22\n      h3.33c0.42,0,0.81,0.28,0.9,0.77L9,11.38l2.04-5.15H13.09z M21.19,11.32c0.01-2-2.76-2.11-2.74-3c0.01-0.27,0.26-0.56,0.83-0.63\n      c0.28-0.04,1.05-0.06,1.93,0.34l0.34-1.6c-0.47-0.17-1.08-0.34-1.83-0.34c-1.93,0-3.29,1.03-3.31,2.5c-0.01,1.09,0.97,1.7,1.71,2.06\n      c0.76,0.37,1.02,0.61,1.01,0.94c-0.01,0.51-0.61,0.73-1.17,0.74c-0.98,0.02-1.55-0.27-2.01-0.48l-0.35,1.66\n      c0.46,0.21,1.3,0.39,2.18,0.4C19.84,13.91,21.18,12.89,21.19,11.32 M26.3,13.79h1.81l-1.58-7.56h-1.67c-0.38,0-0.69,0.22-0.83,0.55\n      l-2.94,7.01h2.05l0.41-1.13h2.51L26.3,13.79z M24.11,11.11l1.03-2.84l0.59,2.84H24.11z M15.88,6.23l-1.62,7.56h-1.96l1.62-7.56\n      H15.88z"
  }));
};

var visibility = function visibility(_a) {
  var _a$title111 = _a.title,
      title = _a$title111 === void 0 ? '' : _a$title111,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 5c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
  }));
};

var visibilityOff = function visibilityOff(_a) {
  var _a$title112 = _a.title,
      title = _a$title112 === void 0 ? '' : _a$title112,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 7.5c2.76 0 5 2.24 5 5 0 0.65-0.13 1.26-0.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74 0.25-3.98 0.7l2.16 2.16c0.57-0.23 1.18-0.36 1.83-0.36zm-10-2.73 2.74 2.74c-1.66 1.29-2.96 3.01-3.74 4.99 1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-0.3 4.38-0.84l0.42 0.42 2.93 2.92 1.27-1.27-17.73-17.73-1.27 1.27zm5.53 5.53 1.55 1.55c-0.05 0.21-0.08 0.43-0.08 0.65 0 1.66 1.34 3 3 3 0.22 0 0.44-0.03 0.65-0.08l1.55 1.55c-0.67 0.33-1.41 0.53-2.2 0.53-2.76 0-5-2.24-5-5 0-0.79 0.2-1.53 0.53-2.2zm4.31-0.78 3.15 3.15 0.02-0.16c0-1.66-1.34-3-3-3l-0.17 0.01z"
  }));
};

var voice = function voice(_a) {
  var _a$title113 = _a.title,
      title = _a$title113 === void 0 ? '' : _a$title113,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m12 15c1.66 0 2.99-1.34 2.99-3l0.01-6c0-1.66-1.34-3-3-3s-3 1.34-3 3v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1s-5.3-2.1-5.3-5.1h-1.7c0 3.42 2.72 6.23 6 6.72v3.28h2v-3.28c3.28-0.48 6-3.3 6-6.72h-1.7z"
  }));
};

var warning$1 = function warning$1(_a) {
  var _a$title114 = _a.title,
      title = _a$title114 === void 0 ? '' : _a$title114,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M1 22H23L12 3L1 22ZM13 19H11V17H13V19ZM13 15H11V11H13V15Z"
  }));
};

var youtube = function youtube(_a) {
  var _a$title115 = _a.title,
      title = _a$title115 === void 0 ? '' : _a$title115,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "m24 16.677v-8.554s0-4.123-4.1359-4.123h-15.73s-4.1345 1e-5 -4.1345 4.123v8.554s-3.991e-6 4.123 4.1345 4.123h15.73s4.1359 0 4.1359-4.123zm-7.3405-4.265-7.8571 4.5998v-9.2011l7.8571 4.6013z",
    fillRule: "evenodd"
  }));
};

var poppyBag = function poppyBag(_a) {
  var _a$title116 = _a.title,
      title = _a$title116 === void 0 ? '' : _a$title116,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    "data-legacy-icon": true,
    viewBox: "0 0 73 100"
  }, props), React__default.createElement("title", null, title), React__default.createElement("g", {
    id: "Bag Icon"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    d: "M37.9722222,10.4583333 C39.1666667,10.8472222 40.8194444,11.6111111 44.2916667,10.1527778 C44.2916667,13.6388889 44.2777778,21.7083333 44.2638889,25.7638889 C44.25,30.1111111 44.5694444,36.6944444 43.4166667,41.4583333 C46.5138889,41.8472222 48.6111111,45.0833333 51.9027778,43.8055556 C53.0555556,43.3472222 55.4027778,41.3333333 56.6111111,41.0833333 C59.3888889,40.5 62.3055556,43.2638889 64.9027778,42.1111111 C67.8888889,40.7777778 69.25,39.5416667 68.3055556,36.4166667 C64.3611111,27.7916667 59.5555556,18.9444444 59.5555556,18.9444444 L59.6527778,18.9166667 C62.8472222,18.0972222 63.4722222,13.9444444 59.7361111,11.7222222 L62.4166667,9.25 L58.5,7.65277778 L59.9583333,2.30555556 L51.5555556,5.63888889 C51.5694444,5.63888889 51.5833333,5.625 51.5833333,5.625 C51.5833333,5.625 49.4583333,1.18055556 46.2222222,1.15277778 C43.5,1.125 42.2083333,3.09722222 42.2083333,3.09722222 C42.2083333,3.09722222 41.4861111,1.06944444 39.6111111,0.513888889 C37.75,-0.0416666667 34.7083333,1.04166667 34.3194444,4.43055556 C33.8888889,8.18055556 36.9583333,10.1388889 37.9722222,10.4583333 Z M52.3055556,8.83333333 C53.1666667,8.38888889 54.2638889,8.81944444 54.75,9.77777778 C55.2361111,10.7361111 54.9444444,11.875 54.0833333,12.3194444 C53.2222222,12.7638889 52.125,12.3333333 51.6388889,11.375 C51.1527778,10.4027778 51.4444444,9.26388889 52.3055556,8.83333333 Z",
    id: "Shape"
  }), React__default.createElement("path", {
    d: "M16.8194444,37.2222222 C18.5833333,38.625 19.2777778,40.5694444 19.4305556,42.6944444 C19.4722222,43.2222222 19.7777778,43.6805556 20.25,43.9166667 C21.7083333,44.6388889 23.1527778,45.1666667 24.0833333,45.2083333 C26.2916667,45.3055556 28,42.875 30,43.1388889 C30.0694444,42.1111111 30.2222222,40.9722222 30.4722222,39.7361111 C31.7916667,33.125 32.9166667,26.5416667 27.3611111,21.625 C21.8194444,16.7222222 11.8333333,16.1805556 0.305555556,30.0833333 L7.83333333,39.1805556 C7.81944444,39.1666667 11.8472222,33.25 16.8194444,37.2222222 Z",
    id: "Path"
  })), React__default.createElement("g", {
    transform: "translate(12.500000, 40.277778)"
  }, React__default.createElement("path", {
    d: "M59.4444444,46.8333333 C59.5972222,44.9583333 59.7916667,43.0972222 59.9722222,41.2222222 C60.5,35.8194444 60.2222222,30.3055556 60.125,24.8888889 C60.0833333,22.9166667 60.3888889,20.9722222 60.3888889,19.0972222 C60.375,14.3472222 60.4305556,10.0833333 60.4722222,7.05555556 C60.4861111,5.5 60.2777778,2.94444444 59.1666667,1.68055556 C57.625,-0.0694444444 55.7638889,1.94444444 55.0277778,3.45833333 C54.4166667,4.68055556 53.6666667,6.13888889 52.2083333,6.33333333 C50.2222222,6.59722222 48.9861111,4.375 47.125,3.69444444 C45.1666667,2.97222222 43.0277778,4.09722222 41.25,5.13888889 C39.4722222,6.18055556 37.2222222,7.19444444 35.3611111,6.29166667 C34.3611111,5.80555556 33.75,4.88888889 33.0277778,4.09722222 C32.3055556,3.30555556 31.2777778,2.58333333 30.1666667,2.73611111 C27.9027778,3.05555556 26.9444444,6.38888889 24.8194444,7.34722222 C23.8611111,7.77777778 22.7916667,7.90277778 21.7638889,7.56944444 C20.8055556,7.25 20.0416667,6.59722222 19.1944444,6.09722222 C18.3472222,5.59722222 17.2638889,5.23611111 16.3194444,5.58333333 C16.0694444,5.68055556 15.8333333,5.81944444 15.6111111,5.97222222 C14.875,6.43055556 14.1111111,7.125 13.3055556,7.45833333 C12.5972222,7.73611111 11.7222222,7.77777778 10.9583333,7.65277778 C9.375,7.40277778 7.95833333,6.48611111 6.91666667,5.38888889 C3.27777778,1.59722222 2.47222222,3.77777778 2.22222222,5.875 C2.11111111,6.81944444 0.847222222,10.625 1.26388889,15.3888889 C1.52777778,18.4444444 2,22.75 2.375,26.1527778 C3.38888889,35.5277778 3.31944444,44.7638889 4.20833333,54.1388889 C4.72222222,59.5416667 7.70833333,58.8472222 12.9444444,58.75 C14.5555556,58.7222222 16.9583333,58.3055556 22.0972222,58.3611111 C24.4166667,58.3888889 29.4583333,57.9444444 32.0833333,57.9722222 C35.9027778,58.0138889 40.75,58.3194444 44.5694444,58.3611111 C50.2916667,58.4166667 51.9722222,58.6111111 55.5138889,58.6111111 C57.6388889,58.6111111 59.1666667,57.0833333 59.1388889,54.8888889 C59.0694444,52.2083333 59.2222222,49.5277778 59.4444444,46.8333333 Z M55.4583333,55.5138889 C53.8333333,55.7777778 49.7083333,56.4722222 46.8194444,56.3194444 C43.0138889,56.1111111 39.4166667,55.3333333 37.3194444,55.5138889 C35.7361111,55.6527778 31.3194444,55.375 26.9583333,55.9166667 C24.6805556,56.1944444 21.875,55.6805556 19.6666667,55.9305556 C15.9861111,56.3611111 12.7916667,56.6944444 11.4027778,56.7087217 C8.45833333,56.75 7.23611111,53.4305556 6.91666667,50.7361111 C6.16666667,44.5 5.51388889,31.4166667 4.68055556,24.7083333 C4.36111111,22.0833333 3.45833333,14.9166667 3.20833333,12.2916667 C2.91666667,9.18055556 4.09722222,8.61111111 5.51388889,8.54166667 C6.76388889,9.70833333 8.44444444,10.75 10.5,10.7777778 L10.5,10.7777778 L10.5,10.7777778 C10.75,10.7777778 11,10.7638889 11.25,10.7361111 C11.3055556,10.7361111 11.375,10.7222222 11.4305556,10.7083333 C11.5416667,10.6944444 11.6388889,10.6805556 11.75,10.6527778 C11.8472222,10.6388889 11.9305556,10.6111111 12.0277778,10.5972222 C12.125,10.5694444 12.2083333,10.5555556 12.3055556,10.5277778 C12.4861111,10.4722222 12.6666667,10.4166667 12.8472222,10.3611111 C12.9166667,10.3333333 12.9861111,10.3055556 13.0555556,10.2777778 C13.1944444,10.2222222 13.3472222,10.1527778 13.5,10.0972222 C13.5694444,10.0694444 13.625,10.0416667 13.6944444,10 C13.9027778,9.90277778 14.1111111,9.79166667 14.3333333,9.66666667 C14.4305556,9.61111111 14.5,9.54166667 14.5833333,9.47222222 C14.8611111,9.25 15.0972222,8.95833333 15.3194444,8.65277778 C15.5138889,8.38888889 15.7222222,8.11111111 15.9444444,7.88888889 L15.9583333,7.875 C16.3333333,7.51388889 16.8194444,7.375 17.2916667,7.41666667 C17.7638889,7.47222222 18.2222222,7.72222222 18.5416667,8.13888889 C18.75,8.41666667 18.9722222,8.69444444 19.1805556,8.95833333 L19.1944444,8.97222222 C19.4166667,9.23611111 19.6388889,9.47222222 19.8611111,9.70833333 L19.875,9.72222222 C20.0972222,9.95833333 20.3333333,10.1805556 20.5694444,10.375 C20.5694444,10.375 20.5694444,10.375 20.5833333,10.3888889 C20.8194444,10.5972222 21.0694444,10.7777778 21.3194444,10.9583333 L21.3194444,10.9583333 C22.4027778,11.6944444 23.6111111,12.1111111 25.0138889,12.0277778 C26.5277778,11.9444444 27.875,10.9444444 28.5416667,9.51388889 C28.9722222,8.58333333 29.4166667,7.63888889 29.875,6.72222222 C30.25,5.97222222 31.4027778,5.94444444 31.8611111,6.65277778 C32.2083333,7.20833333 32.4583333,7.83333333 32.7777778,8.41666667 C33.0138889,8.84722222 33.2777778,9.25 33.5555556,9.61111111 C33.5694444,9.625 33.5833333,9.65277778 33.5972222,9.66666667 C33.7361111,9.84722222 33.875,10.0138889 34.0138889,10.1666667 C34.0416667,10.1944444 34.0555556,10.2222222 34.0833333,10.25 C34.2222222,10.4027778 34.3611111,10.5416667 34.5,10.6666667 C34.5277778,10.6944444 34.5694444,10.7361111 34.5972222,10.7638889 C34.7361111,10.8888889 34.8611111,11 35,11.1111111 C35.0416667,11.1388889 35.0833333,11.1805556 35.125,11.2083333 C35.2638889,11.3055556 35.3888889,11.4027778 35.5277778,11.4861111 C35.5833333,11.5138889 35.6388889,11.5555556 35.6805556,11.5833333 C35.8194444,11.6666667 35.9444444,11.7361111 36.0833333,11.8055556 C36.1388889,11.8333333 36.2083333,11.8611111 36.2638889,11.8888889 C36.4027778,11.9444444 36.5277778,12 36.6666667,12.0555556 C36.7361111,12.0833333 36.8055556,12.1111111 36.875,12.125 C37,12.1666667 37.1388889,12.2083333 37.2638889,12.2361111 C37.3472222,12.25 37.4166667,12.2638889 37.5,12.2916667 C37.625,12.3194444 37.75,12.3333333 37.8888889,12.3611111 C37.9722222,12.375 38.0694444,12.375 38.1527778,12.3888889 C38.2777778,12.4027778 38.4027778,12.4027778 38.5277778,12.4027778 C38.625,12.4027778 38.7222222,12.4027778 38.8194444,12.3888889 C38.9444444,12.3888889 39.0555556,12.375 39.1805556,12.375 C39.2916667,12.3611111 39.3888889,12.3472222 39.5,12.3333333 C39.6111111,12.3194444 39.7361111,12.3055556 39.8472222,12.2777778 C39.9583333,12.25 40.0833333,12.2222222 40.1944444,12.1944444 C40.3055556,12.1666667 40.4166667,12.1388889 40.5277778,12.1111111 C40.6527778,12.0694444 40.7916667,12.0277778 40.9166667,11.9722222 C41.0138889,11.9305556 41.125,11.9027778 41.2222222,11.8611111 C41.375,11.8055556 41.5277778,11.7222222 41.6805556,11.6527778 C41.7638889,11.6111111 41.8472222,11.5833333 41.9305556,11.5416667 C42.1666667,11.4166667 42.4027778,11.2916667 42.6527778,11.1388889 C43.4722222,10.6388889 44.2638889,10.0972222 45.0416667,9.56944444 C45.0833333,9.54166667 45.125,9.52777778 45.1666667,9.5 C45.9861111,9.01388889 47.0416667,9 47.875,9.48611111 C48.2777778,9.72222222 48.625,9.90277778 48.9444444,10.0555556 C49.0277778,10.0972222 49.1111111,10.125 49.1805556,10.1666667 C49.3194444,10.2222222 49.4444444,10.2638889 49.5694444,10.3055556 C49.6944444,10.3472222 49.8194444,10.3888889 49.9444444,10.4027778 C50.1805556,10.4583333 50.4027778,10.4722222 50.625,10.4722222 C50.9305556,10.4583333 51.2361111,10.4027778 51.5833333,10.3055556 C52.1527778,10.125 52.8194444,9.81944444 53.6944444,9.38888889 C53.8194444,9.41666667 53.9444444,9.44444444 54.0555556,9.48611111 C54.0833333,9.5 54.125,9.5 54.1527778,9.51388889 C54.1944444,9.52777778 54.2361111,9.54166667 54.2777778,9.55555556 C54.375,9.58333333 54.4722222,9.61111111 54.5694444,9.65277778 C54.5833333,9.65277778 54.5972222,9.66666667 54.5972222,9.66666667 C54.8472222,9.76388889 55.0555556,9.86111111 55.25,9.98611111 C55.4861111,10.125 55.6805556,10.2916667 55.8472222,10.4722222 L55.8472222,10.4722222 C55.9305556,10.5694444 56,10.6666667 56.0694444,10.7638889 L56.0694444,10.7638889 C56.3333333,11.1666667 56.4861111,11.6388889 56.5555556,12.1805556 C56.5555556,12.2083333 56.5555556,12.2222222 56.5694444,12.25 C56.5833333,12.3611111 56.5972222,12.4722222 56.6111111,12.5833333 C56.6111111,12.6111111 56.6111111,12.6527778 56.625,12.6805556 C56.6388889,12.7916667 56.6388889,12.9027778 56.6388889,13.0138889 C56.6388889,13.0416667 56.6388889,13.0833333 56.6388889,13.1111111 C56.6388889,13.2638889 56.6388889,13.4027778 56.6388889,13.5555556 C56.6388889,14.9583333 56.8888889,18.0138889 56.5833333,21.0555556 C56.3472222,23.4166667 56.1805556,25.7638889 56.3611111,27.3055556 C56.375,27.4722222 56.4027778,27.6388889 56.4305556,27.8333333 C56.4305556,27.8472222 56.4305556,27.8611111 56.4305556,27.875 C56.4583333,28.0416667 56.4722222,28.2222222 56.5,28.4166667 L56.5,28.4305556 L56.5,28.4305556 C57.2777778,34.5 56.6111111,45.9027778 57,50.2083333 L57,50.2361111 C57.2222222,52.1805556 57.5416667,55.1805556 55.4583333,55.5138889 Z",
    id: "Shape"
  }), React__default.createElement("path", {
    d: "M44.3194444,24.1805556 C43.3472222,24.2638889 42.3611111,24.3333333 41.3888889,24.3333333 C40.2916667,24.3333333 39.3055556,24.2083333 38.25,23.9861111 C37.2916667,23.7916667 36.2083333,23.9444444 35.2222222,23.9861111 C33.0555556,24.0694444 30.875,24.1388889 28.7083333,24.2361111 C24.1805556,24.4166667 19.6527778,24.6527778 15.1388889,24.9166667 C5.30555556,25.5 7.40277778,27.1944444 14.4583333,27.1666667 C21.5138889,27.1388889 33.8194444,27 43.9722222,26.8194444 C46.8055556,26.7638889 49.5972222,26.375 52.4166667,26.0416667 C52.4722222,25.3888889 52.4583333,24.625 51.9027778,24.2222222 C51.6944444,24.0694444 51.4305556,24 51.1666667,23.9444444 C50.2083333,23.7361111 49.2083333,23.7638889 48.2222222,23.8333333 C46.9166667,23.9166667 45.625,24.0694444 44.3194444,24.1805556 Z",
    id: "Path"
  }))), React__default.createElement("g", {
    id: "Group",
    transform: "translate(8.333333, 94.444444)"
  }, React__default.createElement("polygon", {
    id: "Path",
    points: "0.722222222 1.59722222 1.47222222 1.59722222 1.47222222 3.80555556 1.80555556 3.80555556 1.80555556 1.59722222 2.54166667 1.59722222 2.54166667 1.29166667 0.722222222 1.29166667"
  }), React__default.createElement("polygon", {
    id: "Path",
    points: "4.125 3.09722222 3.33333333 1.29166667 2.90277778 1.29166667 2.90277778 3.80555556 3.22222222 3.80555556 3.22222222 1.77777778 3.95833333 3.45833333 4.27777778 3.45833333 5.01388889 1.77777778 5.01388889 3.80555556 5.33333333 3.80555556 5.33333333 1.29166667 4.90277778 1.29166667"
  })));
};

var halal = function halal(_a) {
  var _a$title117 = _a.title,
      title = _a$title117 === void 0 ? '' : _a$title117,
      props = __rest(_a, ["title"]);

  return React__default.createElement("svg", Object.assign({
    viewBox: "0 0 74 12"
  }, props), React__default.createElement("title", null, title), React__default.createElement("path", {
    d: "M4.541 0c.08.012.156.021.227.03.17.023.318.042.463.075a.303.303 0 01.192.15c.125.338.242.678.363 1.032l.146.423h-.295c.031.258.065.516.1.774.072.554.146 1.107.188 1.661a19.244 19.244 0 01-.313 5.3c-.264 1.304-1.448 2.141-2.902 2.134-1.348-.007-2.372-.812-2.647-2.1-.2-.936.084-1.751.71-2.458a.811.811 0 01.174-.12l.07.056c-.026.041-.05.086-.076.13-.028.052-.058.105-.09.155C.27 8.18.276 9.196.87 9.991c.493.66 1.36.921 2.244.677.883-.244 1.418-.812 1.428-1.694.012-.949-.017-1.902-.047-2.856-.013-.406-.025-.811-.035-1.217a48.342 48.342 0 00-.014-.462c-.012-.374-.025-.748-.016-1.122.017-.778.047-1.556.077-2.354V.962L4.54 0zm2.125 10.512c.248-.038.492-.075.726-.144 1.623-.47 2.543-1.64 3.006-3.183.201-.711.317-1.443.344-2.181.049-.959.058-1.92.068-2.88.004-.434.008-.866.016-1.299 0-.086.01-.172.022-.258.004-.038.01-.076.013-.114h.114l.018.102c.014.074.027.148.035.222.063.61.124 1.219.185 1.828.16 1.58.32 3.16.497 4.74.055.422.176.833.36 1.218.361.774.958 1.042 1.778.797.37-.111.727-.269 1.084-.426.158-.07.316-.14.475-.205.198-.08.398-.157.593-.232l.235-.091c-.928-1.083-2.056-1.006-3.26-.48V7.82a.781.781 0 01.082-.166 2.705 2.705 0 013.252-.663c.678.343 1.372.608 2.14.656.33.02.91.702.911 1.033v.463l-.738.175c-.581.137-1.163.275-1.742.425-.661.172-1.32.361-1.971.571-.619.2-1.243.328-1.888.215-1.082-.19-1.813-1.004-2.06-2.261a11.23 11.23 0 01-.059-.338 37.807 37.807 0 00-.044-.267c-.625 2.435-2.075 3.886-4.526 4.337v-1.433c.111-.02.223-.037.334-.055zm-.229-7.536C8.02 4.182 9.043 5.746 9.59 7.634c-.041-2.177-.787-4.077-2.207-5.773l-.945 1.115zM56.07 9.842c-1.392.505-1.672-.292-1.958-1.103a4.552 4.552 0 00-.296-.712c-.301 0-.602.003-.903.006-.6.007-1.197.013-1.787-.006-.536-.021-.617.316-.695.638-.022.092-.044.183-.076.264-.433 1.095-.59 1.192-1.887.913.223-.57.443-1.139.664-1.707.74-1.909 1.476-3.811 2.296-5.684.093-.215.527-.28.967-.345.204-.03.409-.06.582-.106l3.094 7.842zm-2.606-2.884l-1.2-3.296-1.17 3.303 2.37-.007zM36.624 8.87c.361 1.19.451 1.2 1.899 1.024l-3.033-7.71c-.78-.07-1.158-.106-1.412.056-.24.153-.367.483-.615 1.125l-.002.006c-.034.085-.07.168-.104.251-.041.098-.082.196-.121.294l-2.354 6.01c.165-.001.336.017.503.035.547.06 1.053.114 1.174-.514.28-1.432 1.161-1.558 2.31-1.418.166.024.335.024.502 0 .688-.11 1.041.149 1.253.84zm-1.039-2.768l.307.847h-2.366c.186-.511.367-1.012.554-1.531.198-.549.403-1.117.628-1.736.319.877.598 1.648.876 2.418v.002h.001zM26.467 9.94h1.391v-7.75h-1.456V5.42h-3.583V2.192H21.36v7.715h1.515v-3.3h3.592v3.332zm19.577-1.225h-3.138V2.176h-1.423v7.747h4.561V8.714zm19.974 1.128c-1.393.505-1.673-.292-1.959-1.103-.087-.248-.175-.498-.295-.712-.302 0-.603.003-.904.006-.599.007-1.196.013-1.786-.006-.537-.021-.618.316-.695.638-.023.092-.044.183-.076.264-.433 1.095-.591 1.192-1.888.913.223-.569.443-1.137.663-1.705l.001-.002c.74-1.909 1.477-3.811 2.297-5.684.092-.215.526-.28.967-.345.203-.03.408-.06.582-.106l3.093 7.842zm-2.606-2.884l-1.195-3.303-1.16 3.31 2.355-.007zM73.58 9.907V8.692h-3.145V2.176h-1.364v7.731h4.51z",
    fill: "#502314"
  }));
};

var Svgs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  account: account,
  add: add,
  amex: amex,
  applepay: applepay,
  arrowUp: arrowUp,
  back: back,
  bkCrown: bkCrown,
  book: book,
  burgerKingLogo: burgerKingLogo,
  calendar: calendar,
  cart: cart,
  catering: catering,
  cateringPLK: cateringPLK,
  cateringTwo: cateringTwo,
  check: check,
  checkCircle: checkCircle,
  circlePlus: circlePlus,
  close: close,
  cluckNorris: cluckNorris,
  cluckNorrisLoveThatChicken: cluckNorrisLoveThatChicken,
  cluckNorrisSaxophone: cluckNorrisSaxophone,
  coffeeCup: coffeeCup,
  coffeeCupFilled: coffeeCupFilled,
  combo: combo,
  curbside: curbside,
  deleteCredit: deleteCredit,
  delivery: delivery,
  deliveryPLK: deliveryPLK,
  desserts: desserts,
  dineIn: dineIn,
  discover: discover,
  drinks: drinks,
  driveThru: driveThru,
  drive: drive,
  edit: edit,
  editWithEraser: editWithEraser,
  error: error,
  facebook: facebook,
  familyMeals: familyMeals,
  fastFood: fastFood,
  favorite: favorite,
  favoriteFill: favoriteFill,
  gear: gear,
  googlePay: googlePay,
  home: home,
  hotDrink: hotDrink,
  info: info,
  instagram: instagram,
  kidsMeal: kidsMeal,
  kioskCard: kioskCard,
  language: language,
  list: list,
  location: location,
  lock: lock,
  lockUnlocked: lockUnlocked,
  loyaltyCard: loyaltyCard,
  map: map,
  mapleLeaf: mapleLeaf,
  mapleLeafFilled: mapleLeafFilled,
  mastercard: mastercard,
  menu: menu,
  mobile: mobile,
  mobileNavHomePLK: mobileNavHomePLK,
  mobileNavHomeBK: mobileNavHomeBK,
  mobileNavHomeTH: mobileNavHomeTH,
  WhatsNewIcon: WhatsNewIcon,
  next: next,
  offer: offer,
  order: order,
  paymentCard: paymentCard,
  paymentCash: paymentCash,
  paypal: paypal,
  plkRewards: plkRewards,
  popeyesLogo: popeyesLogo,
  previous: previous,
  profile: profile,
  profileTH: profileTH,
  qr: qr,
  mobileRaggedEdge: mobileRaggedEdge,
  desktopRaggedEdge: desktopRaggedEdge,
  refresh: refresh,
  remove: remove,
  restaurant: restaurant,
  sadFace: sadFace,
  sandwiches: sandwiches,
  sauces: sauces,
  scanRewards: scanRewards,
  seafood: seafood,
  search: search,
  select: select,
  settings: settings,
  sides: sides,
  signatureChicken: signatureChicken,
  sodiumFlag: sodiumFlag,
  store: store,
  storeMarker: storeMarker,
  storeThree: storeThree,
  storeTwo: storeTwo,
  swap: swap,
  telephone: telephone,
  tendersAndWings: tendersAndWings,
  thRewards: thRewards,
  tiktok: tiktok,
  time: time,
  timHortonsLogo: timHortonsLogo,
  timsCard: timsCard,
  timsLogo: timsLogo,
  timsText: timsText,
  twitter: twitter,
  visa: visa,
  visibility: visibility,
  visibilityOff: visibilityOff,
  voice: voice,
  warning: warning$1,
  youtube: youtube,
  poppyBag: poppyBag,
  halal: halal
});

var useThemeIcon = function useThemeIcon(icon) {
  var _a;

  var theme = useTheme();

  if (theme === undefined) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error('useThemeIcon must be used within a ThemeProvider');
    }

    return undefined;
  }

  var ThemeIcon = Svgs[(_a = theme.icon) === null || _a === void 0 ? void 0 : _a[icon]];
  return ThemeIcon;
};

var ActionIconStyles = styled.button(_templateObject2(), function (p) {
  return p.theme.token('border-radius-input-icon-hover-focus');
}, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return p.$emphasize ? css(_templateObject3(), p.theme.token('icon-form-input-action'), p.theme.token('icon-form-input-action')) : css(_templateObject4(), p.theme.token('icon-form-input-default'), p.theme.token('icon-form-input-default'), p.theme.token('icon-form-input-action'), p.theme.token('icon-form-input-action'), p.theme.token('icon-form-input-default'), p.theme.token('icon-form-input-default'), p.theme.token('icon-form-input-action'), p.theme.token('icon-form-input-action'));
}, function (p) {
  return p.theme.token('icon-disabled');
}, function (p) {
  return p.theme.token('icon-disabled');
});
/**
 * An icon button that responds to user interactions,
 * for use inside other components like the TextInput
 */

var ActionIcon = React__default.forwardRef(function ActionIcon(_ref3, forwardedRef) {
  var title = _ref3.title,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'button' : _ref3$type,
      icon = _ref3.icon,
      _ref3$emphasize = _ref3.emphasize,
      emphasize = _ref3$emphasize === void 0 ? false : _ref3$emphasize,
      onClick = _ref3.onClick,
      disabled = _ref3.disabled,
      testId = _ref3['data-testid'],
      ariaLabel = _ref3['aria-label'];
  var Icon = useThemeIcon(icon);

  if (!Icon) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error("Icon with name \"".concat(icon, "\" not found. This makes the ActionIcon unusable."));
    }

    return null;
  }

  return React__default.createElement(ActionIconStyles, {
    "data-testid": testId,
    type: type,
    title: title,
    "aria-label": ariaLabel,
    "$emphasize": emphasize,
    onClick: onClick,
    disabled: disabled,
    ref: forwardedRef
  }, React__default.createElement(Icon, {
    "aria-hidden": true,
    focusable: "false"
  }));
}); // Empty animation keyframes used to detect change in autofill state.
// Their values need to be different, or styled-components gives them
// the same class name.

var onAutoFillStart = keyframes(_templateObject5());
var onAutoFillCancel = keyframes(_templateObject6());
/**
 * Required for use of useAutofillDetector
 */

var autofillDetectableStyle = css(_templateObject7(), onAutoFillStart, onAutoFillCancel, onAutoFillStart, onAutoFillCancel);
/**
 * Use animation to detect autofill start and stop
 *
 * Requires autofillDetectableStyle on the style of the element in question
 * @link https://stackoverflow.com/a/41530164
 */

var useAutofillDetector = function useAutofillDetector(onAnimationStart) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAutofilled = _useState2[0],
      setIsAutofilled = _useState2[1];

  var handleAnimationStart = useCallback(function (event) {
    if (event.animationName === onAutoFillStart.getName() && !isAutofilled) {
      setIsAutofilled(true);
    }

    if (event.animationName === onAutoFillCancel.getName() && isAutofilled) {
      setIsAutofilled(false);
    }

    if (typeof onAnimationStart === 'function') {
      onAnimationStart(event);
    }
  }, [isAutofilled, onAnimationStart]);
  return {
    handleAnimationStart: handleAnimationStart,
    isAutofilled: isAutofilled
  };
};

function useFocusDetector(_ref4) {
  var onBlur = _ref4.onBlur,
      onFocus = _ref4.onFocus;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var handleBlur = useCallback(function (event) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  }, [onBlur]);
  var handleFocus = useCallback(function (event) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  }, [onFocus]);
  return {
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    isFocused: isFocused
  };
}
/**
 * Lets us get a copy of the value of a forwardedRef
 *
 * Refs passed to a React component can take a couple different forms:
 * 1. An object with a `current` property containing the value
 * 2. A callback that is called with the value
 *
 * This function lets us reliably access the same value that is passed to the
 * forwarded ref by wrapping its assignment in our own callback function, and
 * passing that to the React component
 */


var useForwardedRefLocally = function useForwardedRefLocally(forwardedRef) {
  var localRef = useRef(null);
  return {
    localRef: localRef,
    refForProps: function refForProps(element) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }

      localRef.current = element;
    }
  };
};

var count = 0;

var useIdCounter = function useIdCounter() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _useState5 = useState(function () {
    return count++;
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      counter = _useState6[0];

  return [prefix, "".concat(counter)].filter(Boolean).join('-');
};

var mediaQuery = {
  mobileTiny: 'screen and (max-width: 374px)',
  tablet: 'screen and (min-width: 700px)',
  desktopSmall: 'screen and (min-width: 950px)',
  desktopLarge: 'screen and (min-width: 1200px)',
  desktop: 'screen and (min-width: 813px)',
  mobileSmall: 'screen and (max-width: 670px)',
  mobile: 'screen and (max-width: 812px)',
  mobileLandscape: 'screen and (max-width: 812px) and (orientation: landscape)',
  mobileFullScreen: 'screen and (display-mode: standalone)'
};
/**
 * Returns `true` if the current screen matches the given media query.
 *
 * It will also watch the screen for dimension changes and update if the
 * matching state changes.
 * Based on {@link https://www.netlify.com/blog/2020/12/05/building-a-custom-react-media-query-hook-for-more-responsive-apps/}
 *
 * @param queryName The name of an existing media query found on the
 * {@link mediaQuery} object, or an object of shape `{ custom: string }`
 * containing a custom query
 *
 * @returns `true` if the screen matches the query, `false` if not
 */

var useMediaQuery = function useMediaQuery(queryName) {
  var query = typeof queryName === 'string' ? mediaQuery[queryName] : queryName.custom;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMatching = _useState8[0],
      setIsMatching = _useState8[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(query);

    if (isMatching !== mediaQueryList.matches) {
      setIsMatching(mediaQueryList.matches);
    }

    var mediaListener = function mediaListener() {
      setIsMatching(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', mediaListener);
    return function () {
      mediaQueryList.removeEventListener('change', mediaListener);
    };
  }, [query, isMatching]);
  return isMatching;
};
/**
 * Detect the validity of an input or select as determined by native APIs
 *
 * "Native APIs" include things such as the `required` or `pattern` attributes
 * or formats enforced by input[type=email], etc.
 */


var useNativeInvalidDetector = function useNativeInvalidDetector(localRef, onInvalid) {
  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isNativeInvalid = _useState10[0],
      setIsNativeInvalid = _useState10[1]; // Resets validity back to correct value after renders (most importantly,
  // those triggered by input events that reset the validation state)
  // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(function () {
    if (isNativeInvalid && localRef.current && localRef.current.validity.valid) {
      setIsNativeInvalid(false);
    } // ** Why no dependency array on the useEffect? **
    // The linter would prefer I have a dependency array of `[isNativeInvalid,
    // localRef]`, which would limit the frequency with which the effect would be
    // called, causing it to not work properly. I want it to run on every render
    // so it can detect the validity of the input returning to "valid" (HTML only
    // specifies an `onInvalid` event, with no corresponding `onValid` event, so
    // this approach was the most reliable to detect it becoming valid again).
    // I could add extra values to the dependency array, like the value of the field
    // or its validation-related props, but ultimately, the only purpose of a
    // dependency array here would be [to
    // optimize](https://reactjs.org/docs/hooks-effect.html#tip-optimizing-performance-by-skipping-effects),
    // and we do not need the optimization. The value of
    // `localRef.current.validity.valid` is not going to change often enough to
    // present the risk of a performance problem.

  });
  var handleInvalid = useCallback(function (event) {
    setIsNativeInvalid(true);

    if (typeof onInvalid === 'function') {
      onInvalid(event);
    }
  }, [onInvalid]);
  return {
    handleInvalid: handleInvalid,
    isNativeInvalid: isNativeInvalid
  };
};

var callbackMap = new Map();

var getCallbacks = function getCallbacks(element) {
  return callbackMap.get(element) || [];
};

var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
  entries.forEach(function (_ref5) {
    var target = _ref5.target,
        _ref5$contentRect = _ref5.contentRect,
        width = _ref5$contentRect.width,
        height = _ref5$contentRect.height;
    getCallbacks(target).forEach(function (callback) {
      return callback(width, height, target);
    });
  });
}) : undefined;
/**
 * Uses ResizeObserver to watch for changes in element dimensions
 *
 * @param elementRef A ref for the element to be observed
 * @param callback A callback to be called when a change is detected
 */

var useResizeObserver = function useResizeObserver(elementRef, callback) {
  var targetElement = elementRef.current;
  useLayoutEffect(function () {
    // We need to access the element here rather than outside the
    // useLayoutEffect because targetElement, defined outside, may be null at
    // the time this hook is first invoked, and elementRef.current's value
    // changing (because the corresponding element mounted, most likely) will
    // not trigger another render before this useLayoutEffect is called. So it
    // will be called with a stale value of elementRef.current
    var el = elementRef.current;

    if (!el) {
      return;
    } // Add a callback to be called when this element changes size


    callbackMap.set(el, [].concat(_toConsumableArray2(getCallbacks(el)), [callback]));
    return function () {
      // Remove the registered callback for the element
      var next = getCallbacks(el).filter(function (cb) {
        return cb !== callback;
      });

      if (next.length > 0) {
        callbackMap.set(el, next);
      } else {
        callbackMap.delete(el);
      }
    };
  }, [targetElement, elementRef, callback]);
  useLayoutEffect(function () {
    var el = elementRef.current;

    if (!el || !resizeObserver) {
      return;
    } // Have the resize observer watch this element


    resizeObserver.observe(el);
    return function () {
      resizeObserver.unobserve(el);
    };
  }, [targetElement, elementRef]);
};
/**
 * Returns a throttled version of a callback limited to one call per timeFrameMs
 * milliseconds
 *
 * When the throttled function is called twice or more within the same time
 * frame, it will run `cb` immediately with the parameters given (leading edge
 * call) and will call `cb` with the parameters from the last invocation of the
 * throttled function after timeFrameMs milliseconds have passed (trailing edge
 * call).
 *
 * @param cb Callback to create throttled version of. It should be memoized
 * prior to being used in this function. If the function changes on every
 * render, every render will reset the internal state used to throttle, and it
 * will not work correctly.
 * @param timeFrameMs the duration of a single time frame in milliseconds
 * @returns a throttled version of `cb`
 */


var useThrottled = function useThrottled(cb, timeFrameMs) {
  var trailingCallRef = useRef(null);
  var throttledCb = useMemo(function () {
    var lastTime = 0;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var now = Date.now(); // Clear any remaining trailing edge calls of the function, as they may
      // contain stale parameters

      if (trailingCallRef.current !== null) {
        clearTimeout(trailingCallRef.current);
        trailingCallRef.current = null;
      }

      if (now - lastTime >= timeFrameMs) {
        // leading edge call
        cb.apply(void 0, args);
        lastTime = now;
      } else {
        // trailing edge call
        var timeToEndOfFrame = timeFrameMs - (now - lastTime);
        trailingCallRef.current = setTimeout(function () {
          cb.apply(void 0, args);
          lastTime = Date.now();
          trailingCallRef.current = null;
        }, timeToEndOfFrame);
      }
    };
  }, [cb, trailingCallRef, timeFrameMs]);
  useEffect(function () {
    // In the cleanup stage cancel any leftover trailing calls to avoid late
    // setState calls on unmounted components, etc.
    return function () {
      if (trailingCallRef.current !== null) {
        clearTimeout(trailingCallRef.current);
        trailingCallRef.current = null;
      }
    };
  }, [throttledCb]);
  return throttledCb;
};
/**
 * Assembles strings from potentially falsey parts for use in aria-describedby, className, etc.
 */


var combineAttributeStrings = function combineAttributeStrings() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var filtered = args.filter(function (a) {
    return !!a;
  });
  return filtered.length !== 0 ? filtered.join(' ') : undefined;
};
/**
 * Assembles a string with an asterisks postfix when required is true.
 */


var getRequiredLabel = function getRequiredLabel(label, required) {
  if (label.endsWith('*')) {
    return label;
  }

  return combineAttributeStrings(label, required ? '*' : undefined);
};
/** Provides default values from theme config for certain component props */


var useDefaultPropsFromTheme = function useDefaultPropsFromTheme(componentName, props) {
  var theme = useTheme();
  return Object.entries(theme.components[componentName].defaultProps).reduce(function (acc, _ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        defaultValue = _ref7[1];

    if (acc[key] === undefined) {
      acc[key] = defaultValue;
    }

    return acc;
  }, Object.assign({}, props));
};

var Wrapper$9 = styled.div(_templateObject8(), function (p) {
  return p.theme.token('text-style-form-hint');
}, function (_ref8) {
  var $hasError = _ref8.$hasError,
      $disabled = _ref8.$disabled,
      token = _ref8.theme.token;

  if ($hasError) {
    return token('text-error');
  }

  if ($disabled) {
    return token('text-disabled');
  }

  return token('text-default');
});
/**
 * Show error or hint messages for form field components.
 */

var InputMessage = function InputMessage(_ref9) {
  var id = _ref9.id,
      hasError = _ref9.hasError,
      disabled = _ref9.disabled,
      children = _ref9.children,
      disableScreenReaderAlert = _ref9.disableScreenReaderAlert,
      testId = _ref9['data-testid'];

  if (!children) {
    return null;
  }

  var props = Object.assign({
    id: id,
    $hasError: hasError,
    $disabled: disabled,
    'data-testid': testId !== null && testId !== void 0 ? testId : 'input-message'
  }, hasError && !disableScreenReaderAlert && {
    role: 'alert'
  });
  return React__default.createElement(Wrapper$9, Object.assign({}, props), children);
};

var PlainIconStyles = styled.svg(_templateObject9(), function (p) {
  return p.theme.token('icon-form-input-default');
}, function (p) {
  return p.theme.token('icon-form-input-default');
}, function (p) {
  return p.$disabled && css(_templateObject10(), p.theme.token('icon-disabled'), p.theme.token('icon-disabled'));
});
/**
 * A non-interactive icon for use inside other components, like the TextInput
 *
 * Use ActionIcon when you want to use an icon as a button
 */

var PlainIcon = React__default.forwardRef(function PlainIcon(_ref10, forwardedRef) {
  var icon = _ref10.icon,
      _ref10$title = _ref10.title,
      title = _ref10$title === void 0 ? '' : _ref10$title,
      testId = _ref10['data-testid'],
      ariaHidden = _ref10['aria-hidden'];
  var Icon = useThemeIcon(icon);

  if (!Icon) {
    return null;
  }

  return React__default.createElement(PlainIconStyles, {
    as: Icon,
    role: "img",
    title: title,
    "aria-hidden": ariaHidden,
    focusable: "false",
    ref: forwardedRef,
    "data-testid": testId
  });
});
/**
 * Class used to return side values, unable to be used itself as a value in
 * styled-components (if a plain object was used instead of this class, it
 * would be interpreted as a styled-components CSSObject)
 */

var MustSelectASideResult = function MustSelectASideResult(_ref11) {
  var top = _ref11.top,
      right = _ref11.right,
      bottom = _ref11.bottom,
      left = _ref11.left,
      topAndBottom = _ref11.topAndBottom,
      leftAndRight = _ref11.leftAndRight;

  _classCallCheck(this, MustSelectASideResult);

  this.top = top;
  this.right = right;
  this.bottom = bottom;
  this.left = left;
  this.topAndBottom = topAndBottom;
  this.leftAndRight = leftAndRight;
};
/**
 * Parses CSS units to get per-side sizes
 *
 * CSS's unit shorthand allows many different patterns for specifying sizes.
 * For example, the padding values of `4px 12px`, `4px 12px 4px`, and
 * `4px 12px 4px 12px` are all equivalent. This makes sizes derived from sizes
 * defined elsewhere (design tokens, etc) very difficult to calculate.
 * This utility simplifies the extraction of per-side sizes for those
 * calculations.
 */


var calcCSSUnitSides = function calcCSSUnitSides(valueString) {
  if (!valueString.trim()) {
    // Make sure this utility is being used on an appropriate unit value
    if (process.env.NODE_ENV === 'development') {
      throw new Error('Empty unit string');
    }

    return new MustSelectASideResult({
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
      topAndBottom: '0px',
      leftAndRight: '0px'
    });
  }

  var values = valueString.split(' ') // Filter out any extra values from whitespace in the unit value
  .filter(function (value) {
    return value.trim() !== '';
  }).map(function (value) {
    var trimmed = value.trim(); // Make sure this utility is being used on an appropriate unit value

    if (process.env.NODE_ENV === 'development' && trimmed !== '0' && // Check against a short list of known units
    !trimmed.match(/.+(px|em|rem|ch|pt|vh|vw|%)$/)) {
      throw new Error("unexpected value \"".concat(valueString, "\" found in design token value.") + 'The token needs to correspond to a value that can be broken ' + 'down into four sides (e.g., padding, margin, border-width)');
    } // Make sure no zero values go without a unit, which breaks css's `calc()`


    return value.trim() === '0' ? '0px' : value.trim();
  });

  if (values.length === 3) {
    values = [values[0], values[1], values[2], values[1]];
  } else if (values.length === 2) {
    values = [values[0], values[1], values[0], values[1]];
  } else if (values.length === 1) {
    values = [values[0], values[0], values[0], values[0]];
  }

  return new MustSelectASideResult({
    top: values[0],
    right: values[1],
    bottom: values[2],
    left: values[3],
    // Provide summed values for convenience, which can be nested in another calc
    // e.g.,
    // `height: calc(
    //   ${p => p.theme.token('height-input')} -
    //     ${p => calcCSSUnitSides(p.theme.token('border-width-input')).topAndBottom}
    // )`
    topAndBottom: "calc(".concat(values[0], " + ").concat(values[2], ")"),
    leftAndRight: "calc(".concat(values[3], " + ").concat(values[1], ")")
  });
};
/**
 * Fetch a color from the current brand theme
 *
 * Fetches the color using the tokenOrColorName to look up colors in this order:
 * 1. Checks design tokens named with tokenOrColorName
 * 2. Checks theme colors with keys named with tokenOrColorName
 * 3. Uses the fallback color string, if one was provided
 */


var getThemeColor = function getThemeColor(theme, tokenOrColorName) {
  var fallbackColorString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var _a, _b;

  return ((_a = theme === null || theme === void 0 ? void 0 : theme.token) === null || _a === void 0 ? void 0 : _a.call(theme, tokenOrColorName)) || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b[tokenOrColorName]) || fallbackColorString;
}; // NOTE: The following components are used by both TextArea and TextInput. If


var TextFieldWrapper = styled.div(_templateObject11(), function (p) {
  return p.theme.token('height-input');
}, function (p) {
  return calcCSSUnitSides(p.theme.token('border-width-input')).topAndBottom;
}, function (p) {
  return calcCSSUnitSides(p.theme.token('padding-input')).right;
}, function (p) {
  return p.theme.token('width-icon');
});
var TextFieldInner = styled.div(_templateObject12(), function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.theme.token('border-color-input');
}, function (p) {
  return p.theme.token('border-width-input');
}, function (p) {
  return !p.$disabled && !p.$hasError && css(_templateObject13(), p.theme.token('border-color-hover'));
}, function (p) {
  return p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.$disabled && css(_templateObject14(), p.theme.token('border-color-disabled'));
}, function (p) {
  return p.$hasError && css(_templateObject15(), p.theme.token('border-color-error'));
});
var iconMargin = '12px';

var getInputRightPadding = function getInputRightPadding() {
  var iconCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return iconCount === 0 ? 'var(--padding-right-input)' : "calc(".concat(iconMargin, " + (").concat(iconMargin, " + var(--width-icon)) * ").concat(iconCount, ")");
};

var labelLeftOffset = '12px';
var TextFieldLabel = styled.label(_templateObject16(), labelLeftOffset, function (p) {
  return p.theme.token('text-style-form-label-default');
}, function (p) {
  return p.theme.token('text-default');
}, labelLeftOffset, function (p) {
  return getInputRightPadding(p.$iconCount);
}, function (p) {
  return p.$disabled && css(_templateObject17(), p.theme.token('text-disabled'));
}, function (p) {
  return (p.$focused || p.$autofilled || p.$isDate || p.$hasValue) && css(_templateObject18(), p.theme.token('text-style-form-label-value'), p.$hasError && css(_templateObject19(), p.theme.token('text-error')));
}, function (p) {
  return p.$autofilled && css(_templateObject20());
});
var StyledTextField = styled.input(_templateObject21(), function (p) {
  return p.theme.token('padding-input');
}, function (p) {
  return p.theme.token('text-style-form-input');
}, function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('text-default');
}, function (p) {
  return p.$iconCount > 0 && css(_templateObject22(), getInputRightPadding(p.$iconCount));
}, function (p) {
  return p.$disabled && css(_templateObject23(), p.theme.token('text-disabled'));
}, autofillDetectableStyle);
var IconStyles = styled.div(_templateObject24(), iconMargin, function (p) {
  return calcCSSUnitSides(p.theme.token('border-width-input')).top;
}, iconMargin, iconMargin, function (p) {
  return p.theme.token('height-icon');
}, function (p) {
  return p.theme.token('width-icon');
});
var StyledTextInput = styled(StyledTextField)(_templateObject25());
var StyledComboBox = styled.div(_templateObject26());
var OptionsList = styled.ul(_templateObject27(), function (props) {
  return props.theme.token('drop-shadow-component');
});
var StyledOptionListItem = styled.li(_templateObject28(), function (props) {
  return props.theme.token('text-default');
}, function (props) {
  return props.theme.token('text-style-form-options');
});
var StyledOptionButton = styled.button(_templateObject29(), function (props) {
  return props.isFocused ? props.theme.token('background-focus') : props.theme.token('background-input');
}, function (props) {
  return props.theme.token('text-default');
}, function (props) {
  return props.theme.token('text-style-form-options');
}, function (props) {
  return props.theme.token('border-color-default');
}, function (p) {
  return p.theme.token('background-focus');
}, function (props) {
  return props.theme.token('background-input');
});
var MainPredictionText = styled.span(_templateObject30());
/* eslint-disable jsx-a11y/label-has-associated-control */

var AutocompleteOptionsDropdown = React__default.forwardRef(function (_ref12, forwardedRef) {
  var testId = _ref12['data-testid'],
      label = _ref12.label,
      _ref12$predictions = _ref12.predictions,
      predictions = _ref12$predictions === void 0 ? [] : _ref12$predictions,
      onSelection = _ref12.onSelection,
      onInputChange = _ref12.onInputChange,
      errorMessage = _ref12.errorMessage,
      noPredictionsFoundText = _ref12.noPredictionsFoundText,
      clearTextIconTitle = _ref12.clearTextIconTitle,
      ariaLabel = _ref12['aria-label'],
      autoFocus = _ref12.autoFocus,
      className = _ref12.className,
      disabled = _ref12.disabled,
      onAnimationStart = _ref12.onAnimationStart,
      pattern = _ref12.pattern,
      readOnly = _ref12.readOnly,
      required = _ref12.required,
      value = _ref12.value,
      onBlur = _ref12.onBlur,
      onFocus = _ref12.onFocus;

  var genId = function genId(suffix) {
    return testId ? "".concat(testId, "-").concat(suffix) : undefined;
  };

  var wrapperTestId = genId('wrapper');
  var labelTestId = genId('label');

  var _useForwardedRefLocal = useForwardedRefLocally(forwardedRef),
      localRef = _useForwardedRefLocal.localRef;

  var _useAutofillDetector = useAutofillDetector(onAnimationStart),
      isAutofilled = _useAutofillDetector.isAutofilled,
      handleAnimationStart = _useAutofillDetector.handleAnimationStart;

  var _useFocusDetector = useFocusDetector({
    onBlur: onBlur,
    onFocus: onFocus
  }),
      isFocused = _useFocusDetector.isFocused,
      handleBlur = _useFocusDetector.handleBlur,
      handleFocus = _useFocusDetector.handleFocus;
  /** useCombobox documentation: https://github.com/downshift-js/downshift/tree/master/src/hooks/useCombobox */


  var _useCombobox = useCombobox({
    inputValue: value,
    itemToString: function itemToString(item) {
      return item ? String(item.description) : '';
    },
    items: (predictions === null || predictions === void 0 ? void 0 : predictions.slice(0, 5)) || [],

    /** This function controls what happens when an input value is changed manually (via keyDown or clearing via the icon) */
    onInputValueChange: function onInputValueChange(_ref13) {
      var inputValue = _ref13.inputValue;

      var _a;

      if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length)) {
        (_a = localRef === null || localRef === void 0 ? void 0 : localRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }

      onInputChange(inputValue || '');
    },

    /** This function controls what happens when one of the options in the dropdown is selected */
    onSelectedItemChange: function onSelectedItemChange(_ref14) {
      var selectedItem = _ref14.selectedItem;
      onSelection({
        address: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description) || '',
        placeId: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) || ''
      });
    }
  }),
      isOpen = _useCombobox.isOpen,
      getLabelProps = _useCombobox.getLabelProps,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      getItemProps = _useCombobox.getItemProps,
      currentValue = _useCombobox.inputValue,
      reset = _useCombobox.reset;
  /** Reuse styled logic from TextInput */


  var stateAttrs = {
    $disabled: disabled || !!readOnly,
    $focused: isFocused,
    $autofilled: isAutofilled,
    $hasValue: !!value,
    $hasError: !!errorMessage,
    $isDate: false,
    $iconCount: 1
  };
  return React__default.createElement(TextFieldWrapper, {
    style: {
      position: 'relative'
    },
    className: className,
    "data-testid": wrapperTestId
  }, React__default.createElement(StyledComboBox, Object.assign({
    onAnimationStart: handleAnimationStart
  }, getComboboxProps()), React__default.createElement(TextFieldInner, Object.assign({}, stateAttrs), React__default.createElement(TextFieldLabel, Object.assign({}, stateAttrs, {
    "data-testid": labelTestId
  }, getLabelProps()), getRequiredLabel(label, required)), React__default.createElement(StyledTextInput, Object.assign({}, stateAttrs, {
    "aria-label": ariaLabel,
    autoComplete: false,
    "data-private": true,
    "data-testid": testId,
    pattern: pattern,
    required: required
  }, getInputProps({
    ref: localRef,
    disabled: disabled,
    type: 'text',
    onBlur: handleBlur,
    onFocus: handleFocus,
    autoFocus: autoFocus
  }))), React__default.createElement(IconStyles // Prevent clicks to icons within from stealing focus from the
  // input, but still allow keyboard focus
  , {
    // Prevent clicks to icons within from stealing focus from the
    // input, but still allow keyboard focus
    onMouseDownCapture: function onMouseDownCapture(event) {
      return event.preventDefault();
    },
    onMouseUpCapture: function onMouseUpCapture(event) {
      var _a;

      event.preventDefault(); // Gives focus to the text input after clicking a button. The
      // preventDefault from the mouseDown will prevent icons from
      // stealing focus from the input, but this ensures that the text
      // input ends up with focus even if it didn't start with it

      (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, currentValue && React__default.createElement(ActionIcon, {
    title: clearTextIconTitle,
    onClick: function onClick() {
      reset();
    },
    icon: 'close'
  }), !currentValue && React__default.createElement(PlainIcon, {
    title: "search",
    icon: 'search'
  })))), React__default.createElement(OptionsList, Object.assign({}, getMenuProps()), isOpen && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) >= 3 && (predictions === null || predictions === void 0 ? void 0 : predictions.map(function (prediction, index) {
    return React__default.createElement(StyledOptionListItem, Object.assign({
      key: "".concat(prediction.id, "-").concat(index)
    }, getItemProps({
      item: prediction,
      index: index
    })), React__default.createElement(StyledOptionButton, {
      isFocused: highlightedIndex === index ? true : false
    }, React__default.createElement(MainPredictionText, null, prediction.mainText), prediction.secondaryText));
  })), currentValue && !(predictions === null || predictions === void 0 ? void 0 : predictions.length) && React__default.createElement(StyledOptionListItem, null, React__default.createElement(StyledOptionButton, {
    disabled: true
  }, noPredictionsFoundText))), errorMessage && React__default.createElement(InputMessage, {
    "data-testid": 'address-autocomplete-dropdown-error-message',
    id: "address-autocomplete-error-message",
    hasError: true,
    disableScreenReaderAlert: false
  }, errorMessage));
});
var ButtonSizes;

(function (ButtonSizes) {
  ButtonSizes["SMALL"] = "small";
  ButtonSizes["LARGE"] = "large";
})(ButtonSizes || (ButtonSizes = {}));

var getFontSize = function getFontSize(_ref15) {
  var _fontSizes;

  var size = _ref15.size,
      theme = _ref15.theme;

  var _a, _b;

  var fontSizes = (_fontSizes = {}, _defineProperty2(_fontSizes, ButtonSizes.SMALL, (_a = theme.fontSize) === null || _a === void 0 ? void 0 : _a.button.SMALL), _defineProperty2(_fontSizes, ButtonSizes.LARGE, (_b = theme.fontSize) === null || _b === void 0 ? void 0 : _b.button.LARGE), _fontSizes);
  return fontSizes[size || ButtonSizes.LARGE];
};

var getIconSize = function getIconSize(_ref16) {
  var _iconSizes;

  var size = _ref16.size;
  var iconSizes = (_iconSizes = {}, _defineProperty2(_iconSizes, ButtonSizes.SMALL, '16px'), _defineProperty2(_iconSizes, ButtonSizes.LARGE, '24px'), _iconSizes);
  return iconSizes[size || ButtonSizes.LARGE];
};

var BaseButton$1 = styled.button(_templateObject31(), function (_ref17) {
  var theme = _ref17.theme;

  var _a;

  return (_a = theme.fontFamily) === null || _a === void 0 ? void 0 : _a.primary;
}, function (_ref18) {
  var theme = _ref18.theme;

  var _a;

  return (_a = theme.fontWeight) === null || _a === void 0 ? void 0 : _a.button;
}, getFontSize, function (_ref19) {
  var theme = _ref19.theme;

  var _a;

  return (_a = theme.textTransform) === null || _a === void 0 ? void 0 : _a.button;
}, function (_ref20) {
  var theme = _ref20.theme;

  var _a;

  return (_a = theme.letterSpacing) === null || _a === void 0 ? void 0 : _a.button;
}, function (p) {
  return p.wrapText ? "\n      white-space: normal;\n      overflow-wrap: break-word;" : "\n      white-space: \n      nowrap; overflow: hidden;\n      text-overflow: ellipsis;";
}, function (_ref21) {
  var disabled = _ref21.disabled,
      theme = _ref21.theme;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('text-button-primary');
}, function (_ref22) {
  var disabled = _ref22.disabled,
      theme = _ref22.theme,
      transparent = _ref22.transparent;

  var _a;

  if (transparent) {
    return 'transparent';
  }

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : theme.token('background-button-primary-default');
}, function (p) {
  return p.isSquare ? 'none' : '9999rem';
}, function (p) {
  return p.fullWidth ? '100%' : 'auto';
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (_ref23) {
  var size = _ref23.size,
      onlyIcon = _ref23.onlyIcon;

  if (size === ButtonSizes.SMALL) {
    return onlyIcon ? '0.375rem' : '0.375rem 1.5rem';
  }

  return onlyIcon ? '0.75rem' : '0.75rem 3rem';
}, function (_ref24) {
  var hasStartIcon = _ref24.hasStartIcon,
      hasEndIcon = _ref24.hasEndIcon;
  return hasStartIcon || hasEndIcon ? 'flex' : 'block';
}, getIconSize, getIconSize, function (_ref25) {
  var theme = _ref25.theme,
      disabled = _ref25.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('text-button-primary');
}, function (_ref26) {
  var theme = _ref26.theme,
      disabled = _ref26.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('text-button-primary');
}, function (_ref27) {
  var size = _ref27.size;
  return size === ButtonSizes.SMALL ? '12px' : '16px';
}, function (_ref28) {
  var size = _ref28.size;
  return size === ButtonSizes.SMALL ? '12px' : '16px';
}, function (p) {
  return p.hasStartIcon ? '0.5rem' : 0;
}, function (p) {
  return p.hasEndIcon ? '0.5rem' : 0;
}, function (_ref29) {
  var disabled = _ref29.disabled,
      theme = _ref29.theme;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.buttonsPrimaryHover;
}, function (p) {
  return p.disabled ? 'none' : 'scale(0.95)';
}, function (_ref30) {
  var disabled = _ref30.disabled,
      theme = _ref30.theme;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.buttonsPrimaryActive;
}, function (_ref31) {
  var theme = _ref31.theme;

  var _a;

  return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsFocused;
});
var Button = forwardRef$1(function (_a, forwardedRef) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      onClick = _a.onClick,
      size = _a.size,
      startIcon = _a.startIcon,
      endIcon = _a.endIcon,
      _a$onlyIcon = _a.onlyIcon,
      onlyIcon = _a$onlyIcon === void 0 ? !children : _a$onlyIcon,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$isSquare = _a.isSquare,
      isSquare = _a$isSquare === void 0 ? false : _a$isSquare,
      _a$transparent = _a.transparent,
      transparent = _a$transparent === void 0 ? false : _a$transparent,
      _a$wrapText = _a.wrapText,
      wrapText = _a$wrapText === void 0 ? false : _a$wrapText,
      rest = __rest(_a, ["children", "className", "disabled", "onClick", "size", "startIcon", "endIcon", "onlyIcon", "fullWidth", "isSquare", "transparent", "wrapText"]);

  return React__default.createElement(BaseButton$1, Object.assign({
    "aria-disabled": disabled,
    className: className,
    disabled: disabled,
    onClick: onClick,
    size: size,
    hasStartIcon: !!startIcon,
    hasEndIcon: !!endIcon,
    onlyIcon: onlyIcon,
    fullWidth: fullWidth,
    isSquare: isSquare,
    transparent: transparent,
    ref: forwardedRef,
    wrapText: wrapText
  }, rest), startIcon, children && (startIcon || endIcon ? React__default.createElement("span", null, children) : children), endIcon);
});
var OutlineButton = styled(Button)(_templateObject32(), function (_ref32) {
  var theme = _ref32.theme,
      disabled = _ref32.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : theme.token('border-color-button-secondary');
}, function (_ref33) {
  var transparent = _ref33.transparent,
      theme = _ref33.theme;

  var _a;

  return transparent ? 'transparent' : (_a = theme.color) === null || _a === void 0 ? void 0 : _a.white;
}, function (_ref34) {
  var theme = _ref34.theme,
      disabled = _ref34.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('text-button-secondary');
}, function (_ref35) {
  var theme = _ref35.theme,
      disabled = _ref35.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('icon-button-secondary');
}, function (_ref36) {
  var theme = _ref36.theme,
      disabled = _ref36.disabled;

  var _a;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : theme.token('icon-button-secondary');
}, function (_ref37) {
  var theme = _ref37.theme,
      disabled = _ref37.disabled,
      transparent = _ref37.transparent;

  var _a, _b;

  if (disabled) {
    if (transparent) {
      return 'transparent';
    }

    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.white;
  }

  return (_b = theme.color) === null || _b === void 0 ? void 0 : _b.buttonsSecondaryHover;
}, function (_ref38) {
  var theme = _ref38.theme,
      disabled = _ref38.disabled,
      transparent = _ref38.transparent;

  var _a, _b;

  if (disabled) {
    if (transparent) {
      return 'transparent';
    }

    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.white;
  }

  return (_b = theme.color) === null || _b === void 0 ? void 0 : _b.buttonsSecondaryActive;
}, function (_ref39) {
  var theme = _ref39.theme,
      disabled = _ref39.disabled,
      transparent = _ref39.transparent;

  var _a, _b;

  if (disabled) {
    if (transparent) {
      return 'transparent';
    }

    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.white;
  }

  return (_b = theme.color) === null || _b === void 0 ? void 0 : _b.buttonsSecondaryActive;
}, function (_ref40) {
  var theme = _ref40.theme,
      disabled = _ref40.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.white;
}, function (_ref41) {
  var theme = _ref41.theme,
      disabled = _ref41.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.white;
}, function (_ref42) {
  var theme = _ref42.theme,
      disabled = _ref42.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.white;
});
var ButtonGroup = styled.div(_templateObject33());
var TextVariants;

(function (TextVariants) {
  TextVariants["H1"] = "H1 Headline";
  TextVariants["H2"] = "H2 Headline";
  TextVariants["H3"] = "H3 Headline";
  TextVariants["H4"] = "H4 Headline";
  TextVariants["H5"] = "H5 Headline";
  TextVariants["H6"] = "H6 Headline";
  TextVariants["subtitle1"] = "Subtitle 1";
  TextVariants["subtitle2"] = "Subtitle 2";
  TextVariants["body1"] = "Body 1";
  TextVariants["body2"] = "Body 2";
  TextVariants["caption"] = "Caption";
  TextVariants["overline"] = "Overline";
})(TextVariants || (TextVariants = {}));

var getStyleForVariant = function getStyleForVariant(_ref43) {
  var _styles;

  var variant = _ref43.variant,
      theme = _ref43.theme;

  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47;

  var currentTheme = theme;
  var styles = (_styles = {}, _defineProperty2(_styles, TextVariants.H1, {
    fontSize: (_a = currentTheme.fontSize) === null || _a === void 0 ? void 0 : _a.headings.H1,
    fontFamily: (_b = currentTheme.fontFamily) === null || _b === void 0 ? void 0 : _b.primary,
    fontWeight: (_c = currentTheme.fontWeight) === null || _c === void 0 ? void 0 : _c.headings,
    textTransform: (_d = currentTheme.textTransform) === null || _d === void 0 ? void 0 : _d.heading,
    letterSpacing: (_e = currentTheme.letterSpacing) === null || _e === void 0 ? void 0 : _e.headings.H1,
    lineHeight: (_f = currentTheme.lineHeight) === null || _f === void 0 ? void 0 : _f.heading.LARGE
  }), _defineProperty2(_styles, TextVariants.H2, {
    fontSize: (_g = currentTheme.fontSize) === null || _g === void 0 ? void 0 : _g.headings.H2,
    fontFamily: (_h = currentTheme.fontFamily) === null || _h === void 0 ? void 0 : _h.primary,
    fontWeight: (_j = currentTheme.fontWeight) === null || _j === void 0 ? void 0 : _j.headings,
    textTransform: (_k = currentTheme.textTransform) === null || _k === void 0 ? void 0 : _k.heading,
    letterSpacing: (_l = currentTheme.letterSpacing) === null || _l === void 0 ? void 0 : _l.headings.H2,
    lineHeight: (_m = currentTheme.lineHeight) === null || _m === void 0 ? void 0 : _m.heading.LARGE
  }), _defineProperty2(_styles, TextVariants.H3, {
    fontSize: (_o = currentTheme.fontSize) === null || _o === void 0 ? void 0 : _o.headings.H3,
    fontFamily: (_p = currentTheme.fontFamily) === null || _p === void 0 ? void 0 : _p.primary,
    fontWeight: (_q = currentTheme.fontWeight) === null || _q === void 0 ? void 0 : _q.primary,
    textTransform: (_r = currentTheme.textTransform) === null || _r === void 0 ? void 0 : _r.heading,
    letterSpacing: (_s = currentTheme.letterSpacing) === null || _s === void 0 ? void 0 : _s.headings.H3,
    lineHeight: (_t = currentTheme.lineHeight) === null || _t === void 0 ? void 0 : _t.heading.LARGE
  }), _defineProperty2(_styles, TextVariants.H4, {
    fontSize: (_u = currentTheme.fontSize) === null || _u === void 0 ? void 0 : _u.headings.H4,
    fontFamily: (_v = currentTheme.fontFamily) === null || _v === void 0 ? void 0 : _v.primary,
    fontWeight: (_w = currentTheme.fontWeight) === null || _w === void 0 ? void 0 : _w.primary,
    textTransform: (_x = currentTheme.textTransform) === null || _x === void 0 ? void 0 : _x.heading,
    letterSpacing: (_y = currentTheme.letterSpacing) === null || _y === void 0 ? void 0 : _y.headings.H4,
    lineHeight: (_z = currentTheme.lineHeight) === null || _z === void 0 ? void 0 : _z.heading.SMALL
  }), _defineProperty2(_styles, TextVariants.H5, {
    fontSize: (_0 = currentTheme.fontSize) === null || _0 === void 0 ? void 0 : _0.headings.H5,
    fontFamily: (_1 = currentTheme.fontFamily) === null || _1 === void 0 ? void 0 : _1.primary,
    fontWeight: (_2 = currentTheme.fontWeight) === null || _2 === void 0 ? void 0 : _2.primary,
    textTransform: (_3 = currentTheme.textTransform) === null || _3 === void 0 ? void 0 : _3.heading,
    letterSpacing: (_4 = currentTheme.letterSpacing) === null || _4 === void 0 ? void 0 : _4.headings.H5,
    lineHeight: (_5 = currentTheme.lineHeight) === null || _5 === void 0 ? void 0 : _5.heading.SMALL
  }), _defineProperty2(_styles, TextVariants.H6, {
    fontSize: (_6 = currentTheme.fontSize) === null || _6 === void 0 ? void 0 : _6.headings.H6,
    fontFamily: (_7 = currentTheme.fontFamily) === null || _7 === void 0 ? void 0 : _7.primary,
    fontWeight: (_8 = currentTheme.fontWeight) === null || _8 === void 0 ? void 0 : _8.primary,
    textTransform: (_9 = currentTheme.textTransform) === null || _9 === void 0 ? void 0 : _9.heading,
    letterSpacing: (_10 = currentTheme.letterSpacing) === null || _10 === void 0 ? void 0 : _10.headings.H6,
    lineHeight: (_11 = currentTheme.lineHeight) === null || _11 === void 0 ? void 0 : _11.heading.SMALL
  }), _defineProperty2(_styles, TextVariants.subtitle1, {
    fontSize: (_12 = currentTheme.fontSize) === null || _12 === void 0 ? void 0 : _12.subtitle.LARGE,
    fontFamily: (_13 = currentTheme.fontFamily) === null || _13 === void 0 ? void 0 : _13.secondary,
    fontWeight: (_14 = currentTheme.fontWeight) === null || _14 === void 0 ? void 0 : _14.secondary,
    textTransform: (_15 = currentTheme.textTransform) === null || _15 === void 0 ? void 0 : _15.body,
    letterSpacing: (_16 = currentTheme.letterSpacing) === null || _16 === void 0 ? void 0 : _16.body,
    lineHeight: (_17 = currentTheme.lineHeight) === null || _17 === void 0 ? void 0 : _17.subtitle.LARGE
  }), _defineProperty2(_styles, TextVariants.subtitle2, {
    fontSize: (_18 = currentTheme.fontSize) === null || _18 === void 0 ? void 0 : _18.subtitle.SMALL,
    fontFamily: (_19 = currentTheme.fontFamily) === null || _19 === void 0 ? void 0 : _19.secondary,
    fontWeight: (_20 = currentTheme.fontWeight) === null || _20 === void 0 ? void 0 : _20.secondary,
    textTransform: (_21 = currentTheme.textTransform) === null || _21 === void 0 ? void 0 : _21.body,
    letterSpacing: (_22 = currentTheme.letterSpacing) === null || _22 === void 0 ? void 0 : _22.body,
    lineHeight: (_23 = currentTheme.lineHeight) === null || _23 === void 0 ? void 0 : _23.subtitle.SMALL
  }), _defineProperty2(_styles, TextVariants.body1, {
    fontSize: (_24 = currentTheme.fontSize) === null || _24 === void 0 ? void 0 : _24.body.LARGE,
    fontFamily: (_25 = currentTheme.fontFamily) === null || _25 === void 0 ? void 0 : _25.secondary,
    fontWeight: (_26 = currentTheme.fontWeight) === null || _26 === void 0 ? void 0 : _26.tertiary,
    textTransform: (_27 = currentTheme.textTransform) === null || _27 === void 0 ? void 0 : _27.body,
    letterSpacing: (_28 = currentTheme.letterSpacing) === null || _28 === void 0 ? void 0 : _28.body,
    lineHeight: (_29 = currentTheme.lineHeight) === null || _29 === void 0 ? void 0 : _29.body
  }), _defineProperty2(_styles, TextVariants.body2, {
    fontSize: (_30 = currentTheme.fontSize) === null || _30 === void 0 ? void 0 : _30.body.SMALL,
    fontFamily: (_31 = currentTheme.fontFamily) === null || _31 === void 0 ? void 0 : _31.secondary,
    fontWeight: (_32 = currentTheme.fontWeight) === null || _32 === void 0 ? void 0 : _32.tertiary,
    textTransform: (_33 = currentTheme.textTransform) === null || _33 === void 0 ? void 0 : _33.body,
    letterSpacing: (_34 = currentTheme.letterSpacing) === null || _34 === void 0 ? void 0 : _34.body,
    lineHeight: (_35 = currentTheme.lineHeight) === null || _35 === void 0 ? void 0 : _35.body
  }), _defineProperty2(_styles, TextVariants.caption, {
    fontSize: (_36 = currentTheme.fontSize) === null || _36 === void 0 ? void 0 : _36.caption,
    fontFamily: (_37 = currentTheme.fontFamily) === null || _37 === void 0 ? void 0 : _37.secondary,
    fontWeight: (_38 = currentTheme.fontWeight) === null || _38 === void 0 ? void 0 : _38.tertiary,
    textTransform: (_39 = currentTheme.textTransform) === null || _39 === void 0 ? void 0 : _39.body,
    letterSpacing: (_40 = currentTheme.letterSpacing) === null || _40 === void 0 ? void 0 : _40.body,
    lineHeight: (_41 = currentTheme.lineHeight) === null || _41 === void 0 ? void 0 : _41.caption
  }), _defineProperty2(_styles, TextVariants.overline, {
    fontSize: (_42 = currentTheme.fontSize) === null || _42 === void 0 ? void 0 : _42.overline,
    fontFamily: (_43 = currentTheme.fontFamily) === null || _43 === void 0 ? void 0 : _43.secondary,
    fontWeight: (_44 = currentTheme.fontWeight) === null || _44 === void 0 ? void 0 : _44.secondary,
    textTransform: (_45 = currentTheme.textTransform) === null || _45 === void 0 ? void 0 : _45.overline,
    letterSpacing: (_46 = currentTheme.letterSpacing) === null || _46 === void 0 ? void 0 : _46.overline,
    lineHeight: (_47 = currentTheme.lineHeight) === null || _47 === void 0 ? void 0 : _47.overline
  }), _styles);
  return styles[variant];
};

var BaseTextStyled = styled.p(_templateObject34(), function (p) {
  return getStyleForVariant(p).fontFamily;
}, function (p) {
  return getStyleForVariant(p).fontWeight;
}, function (p) {
  return getStyleForVariant(p).textTransform;
}, function (p) {
  return getStyleForVariant(p).fontSize;
}, function (p) {
  return getStyleForVariant(p).letterSpacing;
}, function (p) {
  return getStyleForVariant(p).lineHeight;
}, function (_ref44) {
  var align = _ref44.align;
  return align ? align : 'left';
}, function (_ref45) {
  var color = _ref45.color,
      theme = _ref45.theme;

  var _a, _b;

  return color ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a[color] : ((_b = theme.color) === null || _b === void 0 ? void 0 : _b.black) || 'black';
});

var BaseText = function BaseText(_ref46) {
  var children = _ref46.children,
      color = _ref46.color,
      align = _ref46.align,
      variant = _ref46.variant;
  return React__default.createElement(BaseTextStyled, {
    color: color,
    align: align,
    variant: variant
  }, children);
};

var H1 = function H1(_ref47) {
  var children = _ref47.children,
      color = _ref47.color,
      align = _ref47.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H1
  }, children);
};

var H2 = function H2(_ref48) {
  var children = _ref48.children,
      color = _ref48.color,
      align = _ref48.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H2
  }, children);
};

var H3 = function H3(_ref49) {
  var children = _ref49.children,
      color = _ref49.color,
      align = _ref49.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H3
  }, children);
};

var H4 = function H4(_ref50) {
  var children = _ref50.children,
      color = _ref50.color,
      align = _ref50.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H4
  }, children);
};

var H5 = function H5(_ref51) {
  var children = _ref51.children,
      color = _ref51.color,
      align = _ref51.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H5
  }, children);
};

var H6 = function H6(_ref52) {
  var children = _ref52.children,
      color = _ref52.color,
      align = _ref52.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.H6
  }, children);
};

var Subtitle1 = function Subtitle1(_ref53) {
  var children = _ref53.children,
      color = _ref53.color,
      align = _ref53.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.subtitle1
  }, children);
};

var Subtitle2 = function Subtitle2(_ref54) {
  var children = _ref54.children,
      color = _ref54.color,
      align = _ref54.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.subtitle2
  }, children);
};

var Body1 = function Body1(_ref55) {
  var children = _ref55.children,
      color = _ref55.color,
      align = _ref55.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.body1
  }, children);
};

var Body2 = function Body2(_ref56) {
  var children = _ref56.children,
      color = _ref56.color,
      align = _ref56.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.body2
  }, children);
};

var Caption = function Caption(_ref57) {
  var children = _ref57.children,
      color = _ref57.color,
      align = _ref57.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.caption
  }, children);
};

var Overline = function Overline(_ref58) {
  var children = _ref58.children,
      color = _ref58.color,
      align = _ref58.align;
  return React__default.createElement(BaseText, {
    color: color,
    align: align,
    variant: TextVariants.overline
  }, children);
};

var BaseScanButton = styled(Button)(_templateObject35(), function (_ref59) {
  var disabled = _ref59.disabled,
      theme = _ref59.theme;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.tertiary;
}, function (_ref60) {
  var disabled = _ref60.disabled,
      theme = _ref60.theme;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.white;
}, function (_ref61) {
  var theme = _ref61.theme,
      disabled = _ref61.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.tertiary;
}, function (_ref62) {
  var disabled = _ref62.disabled,
      theme = _ref62.theme;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledBackground : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.white;
});

var ScanButton = function ScanButton(_a) {
  var endIcon = _a.endIcon,
      title = _a.title,
      description = _a.description,
      _a$disabled2 = _a.disabled,
      disabled = _a$disabled2 === void 0 ? false : _a$disabled2,
      rest = __rest(_a, ["endIcon", "title", "description", "disabled"]);

  return React__default.createElement(BaseScanButton, Object.assign({
    disabled: disabled,
    endIcon: endIcon,
    title: title,
    description: description
  }, rest), React__default.createElement(Subtitle1, {
    color: disabled ? 'buttonsDisabledLabel' : 'tertiary'
  }, title), React__default.createElement(Caption, {
    color: disabled ? 'buttonsDisabledLabel' : 'tertiary'
  }, description));
};

var getColorComponentsFromString = function getColorComponentsFromString(hexOrRGB) {
  var _a;

  if (hexOrRGB.startsWith('#')) {
    if (hexOrRGB.length === 4) {
      return {
        r: parseInt(hexOrRGB.substring(1, 2) + hexOrRGB.substring(1, 2), 16),
        g: parseInt(hexOrRGB.substring(2, 3) + hexOrRGB.substring(2, 3), 16),
        b: parseInt(hexOrRGB.substring(3, 4) + hexOrRGB.substring(3, 4), 16)
      };
    }

    if (hexOrRGB.length >= 7) {
      return {
        r: parseInt(hexOrRGB.substring(1, 3), 16),
        g: parseInt(hexOrRGB.substring(3, 5), 16),
        b: parseInt(hexOrRGB.substring(5, 7), 16)
      };
    }
  }

  if (hexOrRGB.startsWith('rgb')) {
    var valuesString = (_a = hexOrRGB.match(/rgba?\((.*)\)/i)) === null || _a === void 0 ? void 0 : _a[1];

    if (valuesString) {
      var _valuesString$split$m = valuesString.split(',').map(function (v) {
        return parseInt(v, 10);
      }),
          _valuesString$split$m2 = _slicedToArray(_valuesString$split$m, 3),
          r = _valuesString$split$m2[0],
          g = _valuesString$split$m2[1],
          b = _valuesString$split$m2[2];

      return {
        r: r,
        g: g,
        b: b
      };
    }
  }

  return {
    r: 0,
    g: 0,
    b: 0
  };
};

var getNonTransparentColor = function getNonTransparentColor(_ref63) {
  var hexOrRGB = _ref63.hexOrRGB,
      hexWhite = _ref63.hexWhite,
      opacity = _ref63.opacity;

  var _getColorComponentsFr = getColorComponentsFromString(hexOrRGB),
      r = _getColorComponentsFr.r,
      g = _getColorComponentsFr.g,
      b = _getColorComponentsFr.b;

  r = (1 - opacity) * parseInt(hexWhite.substring(1, 3), 16) + opacity * r;
  g = (1 - opacity) * parseInt(hexWhite.substring(3, 5), 16) + opacity * g;
  b = (1 - opacity) * parseInt(hexWhite.substring(5, 7), 16) + opacity * b;
  return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
};

var getColorWithOpacity = function getColorWithOpacity(hexOrRGB, opacity) {
  var _getColorComponentsFr2 = getColorComponentsFromString(hexOrRGB),
      r = _getColorComponentsFr2.r,
      g = _getColorComponentsFr2.g,
      b = _getColorComponentsFr2.b;

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity, ")");
};
/**
 * Determine if a color appears dark to humans
 * Adapted from {@link http://alienryderflex.com/hsp.html}
 */


var isColorDark = function isColorDark(hexOrRGB) {
  var _getColorComponentsFr3 = getColorComponentsFromString(hexOrRGB),
      r = _getColorComponentsFr3.r,
      g = _getColorComponentsFr3.g,
      b = _getColorComponentsFr3.b;

  var hsp = 0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b);
  return hsp < 16256;
};

var getColor$1 = function getColor$1(_ref64) {
  var disabled = _ref64.disabled,
      color = _ref64.color,
      theme = _ref64.theme;

  var _a;

  if (disabled) {
    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel;
  }

  return getThemeColor(theme, color, color);
};

var getBackgroundColor = function getBackgroundColor(_ref65) {
  var transparent = _ref65.transparent,
      disabled = _ref65.disabled,
      color = _ref65.color,
      theme = _ref65.theme;

  var _a;

  if (disabled) {
    if (transparent) {
      return 'transparent';
    }

    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.white;
  }

  return getThemeColor(theme, color, color);
};

var BaseInverseButton = styled(OutlineButton)(_templateObject36(), getColor$1, getColor$1, getColor$1, function (p) {
  var _a;

  if (!p.disabled) {
    return getNonTransparentColor({
      hexOrRGB: getBackgroundColor({
        transparent: p.transparent,
        disabled: p.disabled,
        color: p.color,
        theme: p.theme
      }),
      hexWhite: ((_a = p.theme.color) === null || _a === void 0 ? void 0 : _a.white) || '#ffffff',
      opacity: 0.15
    });
  }

  return getBackgroundColor;
}, function (p) {
  var _a;

  if (p.color === 'primary') {
    return (_a = p.theme.color) === null || _a === void 0 ? void 0 : _a.buttonsSecondaryActive;
  }

  return getBackgroundColor;
}, function (p) {
  var _a;

  if (!p.disabled) {
    return getNonTransparentColor({
      hexOrRGB: getBackgroundColor({
        transparent: p.transparent,
        disabled: p.disabled,
        color: p.color,
        theme: p.theme
      }),
      hexWhite: ((_a = p.theme.color) === null || _a === void 0 ? void 0 : _a.white) || '#ffffff',
      opacity: 0.25
    });
  }

  return getBackgroundColor;
});

var InverseButton = function InverseButton(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'text-button-secondary' : _a$color,
      children = _a.children,
      rest = __rest(_a, ["color", "children"]);

  return React__default.createElement(BaseInverseButton, Object.assign({
    color: color
  }, rest), children);
};

var BaseBoxShadowStyle = css(_templateObject37());
var BaseBoxShadowButtonPrimary = styled(Button)(_templateObject38(), BaseBoxShadowStyle);
var BaseBoxShadowButtonInverse = styled(InverseButton)(_templateObject39(), BaseBoxShadowStyle);

var BoxShadowButton = function BoxShadowButton(_a) {
  var children = _a.children,
      _a$inverse = _a.inverse,
      inverse = _a$inverse === void 0 ? false : _a$inverse,
      rest = __rest(_a, ["children", "inverse"]);

  return inverse ? React__default.createElement(BaseBoxShadowButtonInverse, Object.assign({}, rest), children) : React__default.createElement(BaseBoxShadowButtonPrimary, Object.assign({}, rest), children);
};

var getColor = function getColor(_ref66) {
  var disabled = _ref66.disabled,
      color = _ref66.color,
      theme = _ref66.theme;

  var _a;

  if (disabled) {
    return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel;
  }

  return color && getThemeColor(theme, color) || 'black';
};

var BaseTextOnlyButton = styled(OutlineButton)(_templateObject40(), getColor, getColor, getColor, function (_ref67) {
  var theme = _ref67.theme,
      disabled = _ref67.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_ref68) {
  var theme = _ref68.theme,
      disabled = _ref68.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_ref69) {
  var theme = _ref69.theme,
      disabled = _ref69.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (p) {
  return p.disabled ? 'none' : 'scale(0.95)';
}, function (_ref70) {
  var theme = _ref70.theme,
      disabled = _ref70.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_ref71) {
  var theme = _ref71.theme,
      disabled = _ref71.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_ref72) {
  var theme = _ref72.theme,
      disabled = _ref72.disabled;

  var _a, _b;

  return disabled ? (_a = theme.color) === null || _a === void 0 ? void 0 : _a.buttonsDisabledLabel : (_b = theme.color) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_ref73) {
  var theme = _ref73.theme;

  var _a;

  return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.primary;
}, function (_ref74) {
  var theme = _ref74.theme;

  var _a;

  return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.primary;
}, function (_ref75) {
  var theme = _ref75.theme;

  var _a;

  return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.primary;
}, function (_ref76) {
  var theme = _ref76.theme;

  var _a;

  return (_a = theme.color) === null || _a === void 0 ? void 0 : _a.primary;
});

var TextOnlyButton = function TextOnlyButton(_a) {
  var _a$color2 = _a.color,
      color = _a$color2 === void 0 ? 'black' : _a$color2,
      children = _a.children,
      transformText = _a.transformText,
      rest = __rest(_a, ["color", "children", "transformText"]);

  return React__default.createElement(BaseTextOnlyButton, Object.assign({
    color: color,
    transformText: transformText
  }, rest), children);
};

var IconWrapper$2 = styled.div(_templateObject41(), function (p) {
  return p.width || 'auto';
}, function (p) {
  return p.height || 'auto';
}, function (_ref77) {
  var theme = _ref77.theme,
      color = _ref77.color;
  return getThemeColor(theme, color);
}, function (_ref78) {
  var theme = _ref78.theme,
      strokeColor = _ref78.strokeColor,
      color = _ref78.color;
  return strokeColor ? getThemeColor(theme, strokeColor) : getThemeColor(theme, color);
}, function (p) {
  return p.strokeWidth || '0';
}, function (_ref79) {
  var hoverColor = _ref79.hoverColor,
      theme = _ref79.theme;
  return hoverColor && {
    fill: getThemeColor(theme, hoverColor)
  };
});

function Icon(_ref80) {
  var color = _ref80.color,
      strokeColor = _ref80.strokeColor,
      hoverColor = _ref80.hoverColor,
      strokeWidth = _ref80.strokeWidth,
      width = _ref80.width,
      height = _ref80.height,
      testId = _ref80['data-testid'],
      _ref80$title = _ref80.title,
      title = _ref80$title === void 0 ? '' : _ref80$title,
      ariaHidden = _ref80['aria-hidden'],
      icon = _ref80.icon;
  var ThemeIcon = useThemeIcon(icon);
  return ThemeIcon ? React__default.createElement(IconWrapper$2, {
    color: color,
    hoverColor: hoverColor,
    strokeColor: strokeColor,
    strokeWidth: strokeWidth,
    width: width,
    height: height,
    "data-testid": testId,
    "aria-hidden": ariaHidden
  }, React__default.createElement(ThemeIcon, {
    title: title,
    focusable: "false"
  })) : null;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SystemContext = /*#__PURE__*/createContext({});

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function isRenderProp(children) {
  return typeof children === "function";
}
/**
 * Custom hook that will call `children` if it's a function. If
 * `useCreateElement` has been passed to the context, it'll be used instead.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useCreateElement } from "reakit-system";
 *
 * const system = {
 *   useCreateElement(type, props, children = props.children) {
 *     // very similar to what `useCreateElement` does already
 *     if (typeof children === "function") {
 *       const { children: _, ...rest } = props;
 *       return children(rest);
 *     }
 *     return React.createElement(type, props, children);
 *   },
 * };
 *
 * function Component(props) {
 *   return useCreateElement("div", props);
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component url="url">{({ url }) => <a href={url}>link</a>}</Component>
 *     </SystemProvider>
 *   );
 * }
 */


var useCreateElement = function useCreateElement(type, props, children) {
  if (children === void 0) {
    children = props.children;
  }

  var context = useContext(SystemContext);

  if (context.useCreateElement) {
    return context.useCreateElement(type, props, children);
  }

  if (typeof type === "string" && isRenderProp(children)) {
    props.children;

    var rest = _objectWithoutPropertiesLoose$1(props, ["children"]);

    return children(rest);
  }

  return /*#__PURE__*/createElement(type, props, children);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}
/**
 * Checks whether `arg` is an object or not.
 *
 * @returns {boolean}
 */


function isObject(arg) {
  return typeof arg === "object" && arg != null;
}
/**
 * Checks whether `arg` is a plain object or not.
 *
 * @returns {boolean}
 */


function isPlainObject(arg) {
  var _proto$constructor;

  if (!isObject(arg)) return false;
  var proto = Object.getPrototypeOf(arg);
  if (proto == null) return true;
  return ((_proto$constructor = proto.constructor) === null || _proto$constructor === void 0 ? void 0 : _proto$constructor.toString()) === Object.toString();
}
/**
 * Splits an object (`props`) into a tuple where the first item is an object
 * with the passed `keys`, and the second item is an object with these keys
 * omitted.
 *
 * @deprecated will be removed in version 2
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ a: "a", b: "b" }, ["a"]); // [{ a: "a" }, { b: "b" }]
 */


function __deprecatedSplitProps(props, keys) {
  var propsKeys = Object.keys(props);
  var picked = {};
  var omitted = {};

  for (var _i = 0, _propsKeys = propsKeys; _i < _propsKeys.length; _i++) {
    var key = _propsKeys[_i];

    if (keys.indexOf(key) >= 0) {
      picked[key] = props[key];
    } else {
      omitted[key] = props[key];
    }
  }

  return [picked, omitted];
}
/**
 * Splits an object (`props`) into a tuple where the first item
 * is the `state` property, and the second item is the rest of the properties.
 *
 * It is also backward compatible with version 1. If `keys` are passed then
 * splits an object (`props`) into a tuple where the first item is an object
 * with the passed `keys`, and the second item is an object with these keys
 * omitted.
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ a: "a", b: "b" }, ["a"]); // [{ a: "a" }, { b: "b" }]
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ state: { a: "a" }, b: "b" }); // [{ a: "a" }, { b: "b" }]
 */


function splitProps(props, keys) {
  if (keys === void 0) {
    keys = [];
  }

  if (!isPlainObject(props.state)) {
    return __deprecatedSplitProps(props, keys);
  }

  var _deprecatedSplitProp = __deprecatedSplitProps(props, [].concat(keys, ["state"])),
      picked = _deprecatedSplitProp[0],
      omitted = _deprecatedSplitProp[1];

  var state = picked.state,
      restPicked = _objectWithoutPropertiesLoose(picked, ["state"]);

  return [_objectSpread2(_objectSpread2({}, state), restPicked), omitted];
}
/**
 * Compares two objects.
 *
 * @example
 * import { shallowEqual } from "reakit-utils";
 *
 * shallowEqual({ a: "a" }, {}); // false
 * shallowEqual({ a: "a" }, { b: "b" }); // false
 * shallowEqual({ a: "a" }, { a: "a" }); // true
 * shallowEqual({ a: "a" }, { a: "a", b: "b" }); // false
 */


function shallowEqual(objA, objB) {
  if (objA === objB) return true;
  if (!objA) return false;
  if (!objB) return false;
  if (typeof objA !== "object") return false;
  if (typeof objB !== "object") return false;
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var length = aKeys.length;
  if (bKeys.length !== length) return false;

  for (var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++) {
    var key = _aKeys[_i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
}
/**
 * This higher order functions take `propsAreEqual` function and
 * returns a new function which normalizes the props.
 *
 * Normalizing in our case is making sure the `propsAreEqual` works with
 * both version 1 (object spreading) and version 2 (state object) state passing.
 *
 * To achieve this, the returned function in case of a state object
 * will spread the state object in both `prev` and `next props.
 *
 * Other case it just returns the function as is which makes sure
 * that we are still backward compatible
 */


function normalizePropsAreEqual(propsAreEqual) {
  if (propsAreEqual.name === "normalizePropsAreEqualInner") {
    return propsAreEqual;
  }

  return function normalizePropsAreEqualInner(prev, next) {
    if (!isPlainObject(prev.state) || !isPlainObject(next.state)) {
      return propsAreEqual(prev, next);
    }

    return propsAreEqual(_objectSpread2(_objectSpread2({}, prev.state), prev), _objectSpread2(_objectSpread2({}, next.state), next));
  };
}

function forwardRef(component) {
  return /*#__PURE__*/forwardRef$1(component);
}

function memo(component, propsAreEqual) {
  return /*#__PURE__*/memo$1(component, propsAreEqual);
}
/**
 * Creates a React component.
 *
 * @example
 * import { createComponent } from "reakit-system";
 *
 * const A = createComponent({ as: "a" });
 *
 * @param options
 */


function createComponent(_ref) {
  var type = _ref.as,
      useHook = _ref.useHook,
      shouldMemo = _ref.memo,
      _ref$propsAreEqual = _ref.propsAreEqual,
      propsAreEqual = _ref$propsAreEqual === void 0 ? useHook === null || useHook === void 0 ? void 0 : useHook.unstable_propsAreEqual : _ref$propsAreEqual,
      _ref$keys = _ref.keys,
      keys = _ref$keys === void 0 ? (useHook === null || useHook === void 0 ? void 0 : useHook.__keys) || [] : _ref$keys,
      _ref$useCreateElement = _ref.useCreateElement,
      useCreateElement$1 = _ref$useCreateElement === void 0 ? useCreateElement : _ref$useCreateElement;

  var Comp = function Comp(_ref2, ref) {
    var _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? type : _ref2$as,
        props = _objectWithoutPropertiesLoose$1(_ref2, ["as"]);

    if (useHook) {
      var _as$render;

      var _splitProps = splitProps(props, keys),
          _options = _splitProps[0],
          htmlProps = _splitProps[1];

      var _useHook = useHook(_options, _objectSpread2$1({
        ref: ref
      }, htmlProps)),
          wrapElement = _useHook.wrapElement,
          elementProps = _objectWithoutPropertiesLoose$1(_useHook, ["wrapElement"]); // @ts-ignore


      var asKeys = ((_as$render = as.render) === null || _as$render === void 0 ? void 0 : _as$render.__keys) || as.__keys;
      var asOptions = asKeys && splitProps(props, asKeys)[0];
      var allProps = asOptions ? _objectSpread2$1(_objectSpread2$1({}, elementProps), asOptions) : elementProps;

      var _element = useCreateElement$1(as, allProps);

      if (wrapElement) {
        return wrapElement(_element);
      }

      return _element;
    }

    return useCreateElement$1(as, _objectSpread2$1({
      ref: ref
    }, props));
  };

  if (process.env.NODE_ENV !== "production" && useHook) {
    Comp.displayName = useHook.name.replace(/^(unstable_)?use/, "");
  }

  Comp = forwardRef(Comp);

  if (shouldMemo) {
    Comp = memo(Comp, propsAreEqual && normalizePropsAreEqual(propsAreEqual));
  }

  Comp.__keys = keys;
  Comp.unstable_propsAreEqual = normalizePropsAreEqual(propsAreEqual || shallowEqual);
  return Comp;
}
/**
 * React custom hook that returns the value of any token defined in the
 * SystemContext. It's mainly used internally in [`useOptions`](#useoptions)
 * and [`useProps`](#useprops).
 *
 * @example
 * import { SystemProvider, useToken } from "reakit-system";
 *
 * const system = {
 *   token: "value",
 * };
 *
 * function Component(props) {
 *   const token = useToken("token", "default value");
 *   return <div {...props}>{token}</div>;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component />
 *     </SystemProvider>
 *   );
 * }
 */


function useToken(token, defaultValue) {
  useDebugValue(token);
  var context = useContext(SystemContext);
  return context[token] != null ? context[token] : defaultValue;
}
/**
 * React custom hook that returns the props returned by a given
 * `use${name}Props` in the SystemContext.
 *
 * @example
 * import { SystemProvider, useProps } from "reakit-system";
 *
 * const system = {
 *   useAProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useProps("A", { url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A url="url">It will convert url into href in useAProps</A>
 *     </SystemProvider>
 *   );
 * }
 */


function useProps(name, options, htmlProps) {
  if (options === void 0) {
    options = {};
  }

  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var hookName = "use" + name + "Props";
  useDebugValue(hookName);
  var useHook = useToken(hookName);

  if (useHook) {
    return useHook(options, htmlProps);
  }

  return htmlProps;
}
/**
 * React custom hook that returns the options returned by a given
 * `use${name}Options` in the SystemContext.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useOptions } from "reakit-system";
 *
 * const system = {
 *   useAOptions(options, htmlProps) {
 *     return {
 *       ...options,
 *       url: htmlProps.href,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const options = useOptions("A", { url }, htmlProps);
 *   return <a href={options.url} {...htmlProps} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A href="url">
 *         It will convert href into url in useAOptions and then url into href in A
 *       </A>
 *     </SystemProvider>
 *   );
 * }
 */


function useOptions(name, options, htmlProps) {
  if (options === void 0) {
    options = {};
  }

  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var hookName = "use" + name + "Options";
  useDebugValue(hookName);
  var useHook = useToken(hookName);

  if (useHook) {
    return _objectSpread2$1(_objectSpread2$1({}, options), useHook(options, htmlProps));
  }

  return options;
}
/**
 * Transforms `arg` into an array if it's not already.
 *
 * @example
 * import { toArray } from "reakit-utils";
 *
 * toArray("a"); // ["a"]
 * toArray(["a"]); // ["a"]
 */


function toArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }

  return typeof arg !== "undefined" ? [arg] : [];
}
/**
 * Creates a React custom hook that will return component props.
 *
 * @example
 * import { createHook } from "reakit-system";
 *
 * const useA = createHook({
 *   name: "A",
 *   keys: ["url"], // custom props/options keys
 *   useProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * });
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useA({ url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * @param options
 */


function createHook(options) {
  var _options$useState, _composedHooks$;

  var composedHooks = toArray(options.compose);

  var __useOptions = function __useOptions(hookOptions, htmlProps) {
    // Call the current hook's useOptions first
    if (options.useOptions) {
      hookOptions = options.useOptions(hookOptions, htmlProps);
    } // If there's name, call useOptions from the system context


    if (options.name) {
      hookOptions = useOptions(options.name, hookOptions, htmlProps);
    } // Run composed hooks useOptions


    if (options.compose) {
      for (var _iterator = _createForOfIteratorHelperLoose$1(composedHooks), _step; !(_step = _iterator()).done;) {
        var hook = _step.value;
        hookOptions = hook.__useOptions(hookOptions, htmlProps);
      }
    }

    return hookOptions;
  };

  var useHook = function useHook(hookOptions, htmlProps, unstable_ignoreUseOptions) {
    if (hookOptions === void 0) {
      hookOptions = {};
    }

    if (htmlProps === void 0) {
      htmlProps = {};
    }

    if (unstable_ignoreUseOptions === void 0) {
      unstable_ignoreUseOptions = false;
    } // This won't execute when useHook was called from within another useHook


    if (!unstable_ignoreUseOptions) {
      hookOptions = __useOptions(hookOptions, htmlProps);
    } // Call the current hook's useProps


    if (options.useProps) {
      htmlProps = options.useProps(hookOptions, htmlProps);
    } // If there's name, call useProps from the system context


    if (options.name) {
      htmlProps = useProps(options.name, hookOptions, htmlProps);
    }

    if (options.compose) {
      if (options.useComposeOptions) {
        hookOptions = options.useComposeOptions(hookOptions, htmlProps);
      }

      if (options.useComposeProps) {
        htmlProps = options.useComposeProps(hookOptions, htmlProps);
      } else {
        for (var _iterator2 = _createForOfIteratorHelperLoose$1(composedHooks), _step2; !(_step2 = _iterator2()).done;) {
          var hook = _step2.value;
          htmlProps = hook(hookOptions, htmlProps, true);
        }
      }
    } // Remove undefined values from htmlProps


    var finalHTMLProps = {};
    var definedHTMLProps = htmlProps || {};

    for (var prop in definedHTMLProps) {
      if (definedHTMLProps[prop] !== undefined) {
        finalHTMLProps[prop] = definedHTMLProps[prop];
      }
    }

    return finalHTMLProps;
  };

  useHook.__useOptions = __useOptions;
  var composedKeys = composedHooks.reduce(function (keys, hook) {
    keys.push.apply(keys, hook.__keys || []);
    return keys;
  }, []); // It's used by createComponent to split option props (keys) and html props

  useHook.__keys = [].concat(composedKeys, ((_options$useState = options.useState) === null || _options$useState === void 0 ? void 0 : _options$useState.__keys) || [], options.keys || []);
  useHook.unstable_propsAreEqual = options.propsAreEqual || ((_composedHooks$ = composedHooks[0]) === null || _composedHooks$ === void 0 ? void 0 : _composedHooks$.unstable_propsAreEqual) || shallowEqual;

  if (process.env.NODE_ENV !== "production" && options.name) {
    Object.defineProperty(useHook, "name", {
      value: "use" + options.name
    });
  }

  return useHook;
} // https://github.com/mui-org/material-ui/blob/2bcc874cf07b81202968f769cb9c2398c7c11311/packages/material-ui/src/utils/useForkRef.js


function setRef(ref, value) {
  if (value === void 0) {
    value = null;
  }

  if (!ref) return;

  if (typeof ref === "function") {
    ref(value);
  } else {
    ref.current = value;
  }
}
/**
 * Merges up to two React Refs into a single memoized function React Ref so you
 * can pass it to an element.
 *
 * @example
 * import React from "react";
 * import { useForkRef } from "reakit-utils";
 *
 * const Component = React.forwardRef((props, ref) => {
 *   const internalRef = React.useRef();
 *   return <div {...props} ref={useForkRef(internalRef, ref)} />;
 * });
 */


function useForkRef(refA, refB) {
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (value) {
      setRef(refA, value);
      setRef(refB, value);
    };
  }, [refA, refB]);
}

var buttonInputTypes = ["button", "color", "file", "image", "reset", "submit"];
/**
 * Checks whether `element` is a native HTML button element.
 *
 * @example
 * import { isButton } from "reakit-utils";
 *
 * isButton(document.querySelector("button")); // true
 * isButton(document.querySelector("input[type='button']")); // true
 * isButton(document.querySelector("div")); // false
 * isButton(document.querySelector("input[type='text']")); // false
 * isButton(document.querySelector("div[role='button']")); // false
 *
 * @returns {boolean}
 */

function isButton(element) {
  if (element.tagName === "BUTTON") return true;

  if (element.tagName === "INPUT") {
    var input = element;
    return buttonInputTypes.indexOf(input.type) !== -1;
  }

  return false;
}
/**
 * Transforms an array with multiple levels into a flattened one.
 *
 * @example
 * import { flatten } from "reakit-utils";
 *
 * flatten([0, 1, [2, [3, 4], 5], 6]);
 * // => [0, 1, 2, 3, 4, 5, 6]
 */


function flatten(array) {
  var flat = [];

  for (var _iterator = _createForOfIteratorHelperLoose(array), _step; !(_step = _iterator()).done;) {
    var maybeArray = _step.value;

    if (Array.isArray(maybeArray)) {
      flat.push.apply(flat, flatten(maybeArray));
    } else {
      flat.push(maybeArray);
    }
  }

  return flat;
}
/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 *
 * @example
 * import { warning } from "reakit-warning";
 *
 * warning(true, "a", "b"); // console.warn("a", "\n", "b")
 * warning(false, "a", "b"); // does nothing
 */


function warning(condition) {
  if (process.env.NODE_ENV !== "production") {
    var _console;

    if (!condition) return;

    for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      messages[_key - 1] = arguments[_key];
    }

    var warns = flatten(messages.map(function (message) {
      return [message, "\n"];
    })); // eslint-disable-next-line no-console

    (_console = console).warn.apply(_console, warns.slice(0, -1)); // Throwing an error and catching it immediately to improve debugging
    // A consumer can use 'pause on caught exceptions'
    // https://github.com/facebook/react/issues/4216


    try {
      throw Error(warns.join(""));
    } catch (x) {// do nothing
    }
  }
}

function isRefObject(ref) {
  return isObject(ref) && "current" in ref;
}
/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 * This should be used inside components.
 */


function useWarning(condition) {
  for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning.apply(void 0, [condition].concat(messages.map(function (message) {
        return isRefObject(message) ? message.current : message;
      }))) : void 0;
    }, [condition]);
  }
}
/**
 * Returns `element.ownerDocument || document`.
 */


function getDocument(element) {
  return element ? element.ownerDocument || element : document;
} // Thanks to Fluent UI for doing the [research on IE11 memery leak](https://github.com/microsoft/fluentui/pull/9010#issuecomment-490768427)


var _window; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.


try {
  _window = window;
} catch (e) {
  /* no-op */
}
/**
 * Returns `element.ownerDocument.defaultView || window`.
 */


function getWindow(element) {
  if (!element) {
    return _window;
  }

  return getDocument(element).defaultView || _window;
}

function checkIsBrowser() {
  var _window = getWindow();

  return Boolean(typeof _window !== "undefined" && _window.document && _window.document.createElement);
}
/**
 * It's `true` if it is running in a browser environment or `false` if it is not (SSR).
 *
 * @example
 * import { canUseDOM } from "reakit-utils";
 *
 * const title = canUseDOM ? document.title : "";
 */


var canUseDOM = checkIsBrowser();
/**
 * `React.useLayoutEffect` that fallbacks to `React.useEffect` on server side
 * rendering.
 */

var useIsomorphicEffect = !canUseDOM ? useEffect : useLayoutEffect;
/**
 * A `React.Ref` that keeps track of the passed `value`.
 */

function useLiveRef(value) {
  var ref = useRef(value);
  useIsomorphicEffect(function () {
    ref.current = value;
  });
  return ref;
}
/**
 * Returns `true` if `event.target` and `event.currentTarget` are the same.
 */


function isSelfTarget(event) {
  return event.target === event.currentTarget;
}
/**
 * Returns `element.ownerDocument.activeElement`.
 */


function getActiveElement(element) {
  var _getDocument = getDocument(element),
      activeElement = _getDocument.activeElement;

  if (!(activeElement !== null && activeElement !== void 0 && activeElement.nodeName)) {
    // In IE11, activeElement might be an empty object if we're interacting
    // with elements inside of an iframe.
    return null;
  }

  return activeElement;
}
/**
 * Similar to `Element.prototype.contains`, but a little bit faster when
 * `element` is the same as `child`.
 *
 * @example
 * import { contains } from "reakit-utils";
 *
 * contains(document.getElementById("parent"), document.getElementById("child"));
 */


function contains(parent, child) {
  return parent === child || parent.contains(child);
}
/**
 * Checks if `element` has focus within. Elements that are referenced by
 * `aria-activedescendant` are also considered.
 *
 * @example
 * import { hasFocusWithin } from "reakit-utils";
 *
 * hasFocusWithin(document.getElementById("id"));
 */


function hasFocusWithin(element) {
  var activeElement = getActiveElement(element);
  if (!activeElement) return false;
  if (contains(element, activeElement)) return true;
  var activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (activeDescendant === element.id) return true;
  return !!element.querySelector("#" + activeDescendant);
}
/**
 * Ponyfill for `Element.prototype.matches`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */


function matches(element, selectors) {
  if ("matches" in element) {
    return element.matches(selectors);
  }

  if ("msMatchesSelector" in element) {
    return element.msMatchesSelector(selectors);
  }

  return element.webkitMatchesSelector(selectors);
}
/**
 * Ponyfill for `Element.prototype.closest`
 *
 * @example
 * import { closest } from "reakit-utils";
 *
 * closest(document.getElementById("id"), "div");
 * // same as
 * document.getElementById("id").closest("div");
 */


function closest(element, selectors) {
  if ("closest" in element) return element.closest(selectors);

  do {
    if (matches(element, selectors)) return element;
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);

  return null;
}
/** @module tabbable */


var selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), " + "textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], " + "iframe, object, embed, area[href], audio[controls], video[controls], " + "[contenteditable]:not([contenteditable='false'])";

function isVisible(element) {
  var htmlElement = element;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}

function hasNegativeTabIndex(element) {
  var tabIndex = parseInt(element.getAttribute("tabindex") || "0", 10);
  return tabIndex < 0;
}
/**
 * Checks whether `element` is focusable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isFocusable } from "reakit-utils";
 *
 * isFocusable(document.querySelector("input")); // true
 * isFocusable(document.querySelector("input[tabindex='-1']")); // true
 * isFocusable(document.querySelector("input[hidden]")); // false
 * isFocusable(document.querySelector("input:disabled")); // false
 */


function isFocusable(element) {
  return matches(element, selector) && isVisible(element);
}
/**
 * Checks whether `element` is tabbable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isTabbable } from "reakit-utils";
 *
 * isTabbable(document.querySelector("input")); // true
 * isTabbable(document.querySelector("input[tabindex='-1']")); // false
 * isTabbable(document.querySelector("input[hidden]")); // false
 * isTabbable(document.querySelector("input:disabled")); // false
 */


function isTabbable(element) {
  return isFocusable(element) && !hasNegativeTabIndex(element);
}
/**
 * Returns all the tabbable elements in `container`, including the container
 * itself.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return focusable elements if there are no tabbable ones.
 *
 * @returns {Element[]}
 */


function getAllTabbableIn(container, fallbackToFocusable) {
  var allFocusable = Array.from(container.querySelectorAll(selector));
  var allTabbable = allFocusable.filter(isTabbable);

  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }

  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }

  return allTabbable;
}
/**
 * Returns the first tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the first focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */


function getFirstTabbableIn(container, fallbackToFocusable) {
  var _getAllTabbableIn = getAllTabbableIn(container, fallbackToFocusable),
      first = _getAllTabbableIn[0];

  return first || null;
}
/**
 * Returns the last tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the last focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */


function getLastTabbableIn(container, fallbackToFocusable) {
  var allTabbable = getAllTabbableIn(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
} // Automatically generated


var ROLE_KEYS = ["unstable_system"];
var useRole = createHook({
  name: "Role",
  keys: ROLE_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    var prevSystem = prev.unstable_system,
        prevProps = _objectWithoutPropertiesLoose$2(prev, ["unstable_system"]);

    var nextSystem = next.unstable_system,
        nextProps = _objectWithoutPropertiesLoose$2(next, ["unstable_system"]);

    if (prevSystem !== nextSystem && !shallowEqual(prevSystem, nextSystem)) {
      return false;
    }

    return shallowEqual(prevProps, nextProps);
  }
});
createComponent({
  as: "div",
  useHook: useRole
});
/**
 * React custom hook that returns the very first value passed to `initialState`,
 * even if it changes between re-renders.
 */

function useSealedState(initialState) {
  var _React$useState = useState(initialState),
      sealed = _React$useState[0];

  return sealed;
}
/**
 * A `React.useEffect` that will not run on the first render.
 */


function useUpdateEffect(effect, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      return effect();
    }

    mounted.current = true;
    return undefined;
  }, deps);
}

var isIE11 = canUseDOM && "msCrypto" in window;
/**
 * Cross-browser method that returns the next active element (the element that
 * is receiving focus) after a blur event is dispatched. It receives the blur
 * event object as the argument.
 *
 * @example
 * import { getNextActiveElementOnBlur } from "reakit-utils";
 *
 * const element = document.getElementById("id");
 * element.addEventListener("blur", (event) => {
 *   const nextActiveElement = getNextActiveElementOnBlur(event);
 * });
 */

function getNextActiveElementOnBlur(event) {
  // IE 11 doesn't support event.relatedTarget on blur.
  // document.activeElement points the the next active element.
  // On modern browsers, document.activeElement points to the current target.
  if (isIE11) {
    var activeElement = getActiveElement(event.currentTarget);
    return activeElement;
  }

  return event.relatedTarget;
}
/**
 * Checks if `element` has focus. Elements that are referenced by
 * `aria-activedescendant` are also considered.
 *
 * @example
 * import { hasFocus } from "reakit-utils";
 *
 * hasFocus(document.getElementById("id"));
 */


function hasFocus(element) {
  var activeElement = getActiveElement(element);
  if (!activeElement) return false;
  if (activeElement === element) return true;
  var activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element.id;
}
/**
 * Ensures `element` will receive focus if it's not already.
 *
 * @example
 * import { ensureFocus } from "reakit-utils";
 *
 * ensureFocus(document.activeElement); // does nothing
 *
 * const element = document.querySelector("input");
 *
 * ensureFocus(element); // focuses element
 * ensureFocus(element, { preventScroll: true }); // focuses element preventing scroll jump
 *
 * function isActive(el) {
 *   return el.dataset.active === "true";
 * }
 *
 * ensureFocus(document.querySelector("[data-active='true']"), { isActive }); // does nothing
 *
 * @returns {number} `requestAnimationFrame` call ID so it can be passed to `cancelAnimationFrame` if needed.
 */


function ensureFocus(element, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      preventScroll = _ref.preventScroll,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? hasFocus : _ref$isActive;

  if (isActive(element)) return -1;
  element.focus({
    preventScroll: preventScroll
  });
  if (isActive(element)) return -1;
  return requestAnimationFrame(function () {
    element.focus({
      preventScroll: preventScroll
    });
  });
}

var defaultPrefix = "id";

function generateRandomString(prefix) {
  if (prefix === void 0) {
    prefix = defaultPrefix;
  }

  return "" + (prefix ? prefix + "-" : "") + Math.random().toString(32).substr(2, 6);
}

var unstable_IdContext = /*#__PURE__*/createContext(generateRandomString);

function unstable_useIdState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      initialBaseId = _useSealedState.baseId;

  var generateId = useContext(unstable_IdContext);
  var idCountRef = useRef(0);

  var _React$useState = useState(function () {
    return initialBaseId || generateId();
  }),
      baseId = _React$useState[0],
      setBaseId = _React$useState[1];

  return {
    baseId: baseId,
    setBaseId: setBaseId,
    unstable_idCountRef: idCountRef
  };
}

function useLastValue(value) {
  var lastValue = useRef(null);
  useIsomorphicEffect(function () {
    lastValue.current = value;
  }, [value]);
  return lastValue;
}

function useDisclosureState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$visib = _useSealedState.visible,
      initialVisible = _useSealedState$visib === void 0 ? false : _useSealedState$visib,
      _useSealedState$anima = _useSealedState.animated,
      initialAnimated = _useSealedState$anima === void 0 ? false : _useSealedState$anima,
      sealed = _objectWithoutPropertiesLoose$2(_useSealedState, ["visible", "animated"]);

  var id = unstable_useIdState(sealed);

  var _React$useState = useState(initialVisible),
      visible = _React$useState[0],
      setVisible = _React$useState[1];

  var _React$useState2 = useState(initialAnimated),
      animated = _React$useState2[0],
      setAnimated = _React$useState2[1];

  var _React$useState3 = useState(false),
      animating = _React$useState3[0],
      setAnimating = _React$useState3[1];

  var lastVisible = useLastValue(visible);
  var visibleHasChanged = lastVisible.current != null && lastVisible.current !== visible;

  if (animated && !animating && visibleHasChanged) {
    // Sets animating to true when when visible is updated
    setAnimating(true);
  }

  useEffect(function () {
    if (typeof animated === "number" && animating) {
      var timeout = setTimeout(function () {
        return setAnimating(false);
      }, animated);
      return function () {
        clearTimeout(timeout);
      };
    }

    if (animated && animating && process.env.NODE_ENV === "development") {
      var _timeout = setTimeout(function () {
        process.env.NODE_ENV !== "production" ? warning(animating, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?") : void 0;
      }, 8000);

      return function () {
        clearTimeout(_timeout);
      };
    }

    return function () {};
  }, [animated, animating]);
  var show = useCallback(function () {
    return setVisible(true);
  }, []);
  var hide = useCallback(function () {
    return setVisible(false);
  }, []);
  var toggle = useCallback(function () {
    return setVisible(function (v) {
      return !v;
    });
  }, []);
  var stopAnimation = useCallback(function () {
    return setAnimating(false);
  }, []);
  return _objectSpread2$2(_objectSpread2$2({}, id), {}, {
    visible: visible,
    animated: animated,
    animating: animating,
    show: show,
    hide: hide,
    toggle: toggle,
    setVisible: setVisible,
    setAnimated: setAnimated,
    stopAnimation: stopAnimation
  });
}

function useDialogState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$modal = _useSealedState.modal,
      initialModal = _useSealedState$modal === void 0 ? true : _useSealedState$modal,
      sealed = _objectWithoutPropertiesLoose$2(_useSealedState, ["modal"]);

  var disclosure = useDisclosureState(sealed);

  var _React$useState = useState(initialModal),
      modal = _React$useState[0],
      setModal = _React$useState[1];

  var disclosureRef = useRef(null);
  return _objectSpread2$2(_objectSpread2$2({}, disclosure), {}, {
    modal: modal,
    setModal: setModal,
    unstable_disclosureRef: disclosureRef
  });
} // Automatically generated


var DISCLOSURE_STATE_KEYS = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"];
var DISCLOSURE_KEYS = DISCLOSURE_STATE_KEYS;
var DISCLOSURE_CONTENT_KEYS = DISCLOSURE_KEYS;
var useDisclosureContent = createHook({
  name: "DisclosureContent",
  compose: useRole,
  keys: DISCLOSURE_CONTENT_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlOnTransitionEnd = _ref.onTransitionEnd,
        htmlOnAnimationEnd = _ref.onAnimationEnd,
        htmlStyle = _ref.style,
        htmlProps = _objectWithoutPropertiesLoose$2(_ref, ["onTransitionEnd", "onAnimationEnd", "style"]);

    var animating = options.animated && options.animating;

    var _React$useState = useState(null),
        transition = _React$useState[0],
        setTransition = _React$useState[1];

    var hidden = !options.visible && !animating;
    var style = hidden ? _objectSpread2$2({
      display: "none"
    }, htmlStyle) : htmlStyle;
    var onTransitionEndRef = useLiveRef(htmlOnTransitionEnd);
    var onAnimationEndRef = useLiveRef(htmlOnAnimationEnd);
    var raf = useRef(0);
    useEffect(function () {
      if (!options.animated) return undefined; // Double RAF is needed so the browser has enough time to paint the
      // default styles before processing the `data-enter` attribute. Otherwise
      // it wouldn't be considered a transition.
      // See https://github.com/reakit/reakit/issues/643

      raf.current = window.requestAnimationFrame(function () {
        raf.current = window.requestAnimationFrame(function () {
          if (options.visible) {
            setTransition("enter");
          } else if (animating) {
            setTransition("leave");
          } else {
            setTransition(null);
          }
        });
      });
      return function () {
        return window.cancelAnimationFrame(raf.current);
      };
    }, [options.animated, options.visible, animating]);
    var onEnd = useCallback(function (event) {
      if (!isSelfTarget(event)) return;
      if (!animating) return; // Ignores number animated

      if (options.animated === true) {
        var _options$stopAnimatio;

        (_options$stopAnimatio = options.stopAnimation) === null || _options$stopAnimatio === void 0 ? void 0 : _options$stopAnimatio.call(options);
      }
    }, [options.animated, animating, options.stopAnimation]);
    var onTransitionEnd = useCallback(function (event) {
      var _onTransitionEndRef$c;

      (_onTransitionEndRef$c = onTransitionEndRef.current) === null || _onTransitionEndRef$c === void 0 ? void 0 : _onTransitionEndRef$c.call(onTransitionEndRef, event);
      onEnd(event);
    }, [onEnd]);
    var onAnimationEnd = useCallback(function (event) {
      var _onAnimationEndRef$cu;

      (_onAnimationEndRef$cu = onAnimationEndRef.current) === null || _onAnimationEndRef$cu === void 0 ? void 0 : _onAnimationEndRef$cu.call(onAnimationEndRef, event);
      onEnd(event);
    }, [onEnd]);
    return _objectSpread2$2({
      id: options.baseId,
      "data-enter": transition === "enter" ? "" : undefined,
      "data-leave": transition === "leave" ? "" : undefined,
      onTransitionEnd: onTransitionEnd,
      onAnimationEnd: onAnimationEnd,
      hidden: hidden,
      style: style
    }, htmlProps);
  }
});
createComponent({
  as: "div",
  useHook: useDisclosureContent
});

function getBodyElement() {
  return canUseDOM ? document.body : null;
}

var PortalContext = /*#__PURE__*/createContext(getBodyElement());

function Portal(_ref) {
  var children = _ref.children; // if it's a nested portal, context is the parent portal
  // otherwise it's document.body
  // https://github.com/reakit/reakit/issues/513

  var context = useContext(PortalContext) || getBodyElement();

  var _React$useState = useState(function () {
    if (canUseDOM) {
      var element = document.createElement("div");
      element.className = Portal.__className;
      return element;
    } // ssr


    return null;
  }),
      hostNode = _React$useState[0];

  useIsomorphicEffect(function () {
    if (!hostNode || !context) return undefined;
    context.appendChild(hostNode);
    return function () {
      context.removeChild(hostNode);
    };
  }, [hostNode, context]);

  if (hostNode) {
    return /*#__PURE__*/createPortal( /*#__PURE__*/createElement(PortalContext.Provider, {
      value: hostNode
    }, children), hostNode);
  } // ssr


  return null;
}

Portal.__className = "__reakit-portal";
Portal.__selector = "." + Portal.__className;
/**
 * Immutably removes an index from an array.
 *
 * @example
 * import { removeIndexFromArray } from "reakit-utils";
 *
 * removeIndexFromArray(["a", "b", "c"], 1); // ["a", "c"]
 *
 * @returns {Array} A new array without the item in the passed index.
 */

function removeIndexFromArray(array, index) {
  if (index === -1) return array;
  return [].concat(array.slice(0, index), array.slice(index + 1));
}
/**
 * Immutably removes an item from an array.
 *
 * @example
 * import { removeItemFromArray } from "reakit-utils";
 *
 * removeItemFromArray(["a", "b", "c"], "b"); // ["a", "c"]
 *
 * // This only works by reference
 * const obj = {};
 * removeItemFromArray([obj], {}); // [obj]
 * removeItemFromArray([obj], obj); // []
 *
 * @returns {Array} A new array without the passed item.
 */


function removeItemFromArray(array, item) {
  var index = array.indexOf(item);
  return removeIndexFromArray(array, index);
}

var MenuContext = /*#__PURE__*/createContext(null);

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
} // Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi


var hasPassiveEvents = false;

if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }

  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0; // returns true if `el` should be allowed to receive touchmove events.

var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event; // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.

  if (allowTouchMove(e.target)) {
    return true;
  } // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).


  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;

    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  } // If previousBodyOverflowSetting is already set, don't set it again.


  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight; // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.

    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting; // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.

    previousBodyOverflowSetting = undefined;
  }
}; // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions


var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  } // disableBodyScroll must not have been called on this targetElement before


  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };

    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};

var DialogBackdropContext = /*#__PURE__*/createContext(undefined);
/**
 * Checks whether `arg` is empty or not.
 *
 * @example
 * import { isEmpty } from "reakit-utils";
 *
 * isEmpty([]); // true
 * isEmpty(["a"]); // false
 * isEmpty({}); // true
 * isEmpty({ a: "a" }); // false
 * isEmpty(); // true
 * isEmpty(null); // true
 * isEmpty(undefined); // true
 * isEmpty(""); // true
 */

function isEmpty(arg) {
  if (Array.isArray(arg)) return !arg.length;
  if (isObject(arg)) return !Object.keys(arg).length;
  if (arg == null) return true;
  if (arg === "") return true;
  return false;
} // Automatically generated


var DIALOG_STATE_KEYS = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"];
var DIALOG_KEYS = [].concat(DIALOG_STATE_KEYS, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]);
var DIALOG_BACKDROP_KEYS = DIALOG_STATE_KEYS;

function useDisclosureRef(dialogRef, options) {
  var ref = useRef(null);
  var animating = !!(options.animated && options.animating);
  useEffect(function () {
    if (options.visible || animating) return undefined; // We get the last focused element before the dialog opens, so we can move
    // focus back to it when the dialog closes.

    var onFocus = function onFocus(event) {
      var target = event.target;

      if ("focus" in target) {
        ref.current = target;

        if (options.unstable_disclosureRef) {
          options.unstable_disclosureRef.current = target;
        }
      }
    };

    var document = getDocument(dialogRef.current);
    document.addEventListener("focusin", onFocus);
    return function () {
      return document.removeEventListener("focusin", onFocus);
    };
  }, [options.visible, animating, options.unstable_disclosureRef, dialogRef]);
  useEffect(function () {
    var _options$unstable_dis;

    if (!options.visible || animating) return undefined; // Safari and Firefox on MacOS don't focus on buttons on mouse down.
    // Instead, they focus on the closest focusable parent (ultimately, the
    // body element). This works around that by preventing that behavior and
    // forcing focus on the disclosure button. Otherwise, we wouldn't be able
    // to close the dialog by clicking again on the disclosure.

    var onMouseDown = function onMouseDown(event) {
      var element = event.currentTarget;
      if (!isButton(element)) return;
      event.preventDefault();
      element.focus();
    };

    var disclosure = ((_options$unstable_dis = options.unstable_disclosureRef) === null || _options$unstable_dis === void 0 ? void 0 : _options$unstable_dis.current) || ref.current;
    disclosure === null || disclosure === void 0 ? void 0 : disclosure.addEventListener("mousedown", onMouseDown);
    return function () {
      return disclosure === null || disclosure === void 0 ? void 0 : disclosure.removeEventListener("mousedown", onMouseDown);
    };
  }, [options.visible, animating, options.unstable_disclosureRef]);
  return options.unstable_disclosureRef || ref;
}

function usePreventBodyScroll(targetRef, options) {
  var shouldPrevent = Boolean(options.preventBodyScroll && options.visible);
  useEffect(function () {
    var element = targetRef.current;
    if (!element || !shouldPrevent) return undefined;
    disableBodyScroll(element, {
      reserveScrollBarGap: true
    });
    return function () {
      return enableBodyScroll(element);
    };
  }, [targetRef, shouldPrevent]);
}

function useFocusOnShow(dialogRef, nestedDialogs, options) {
  var initialFocusRef = options.unstable_initialFocusRef;
  var shouldFocus = options.visible && options.unstable_autoFocusOnShow;
  var animating = !!(options.animated && options.animating);
  useUpdateEffect(function () {
    var dialog = dialogRef.current;
    process.env.NODE_ENV !== "production" ? warning(!!shouldFocus && !dialog, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog") : void 0;
    if (!shouldFocus) return;
    if (!dialog) return;
    if (animating) return; // If there're nested open dialogs, let them handle focus

    if (nestedDialogs.some(function (child) {
      return child.current && !child.current.hidden;
    })) {
      return;
    }

    if (initialFocusRef !== null && initialFocusRef !== void 0 && initialFocusRef.current) {
      initialFocusRef.current.focus({
        preventScroll: true
      });
    } else {
      var tabbable = getFirstTabbableIn(dialog, true);

      var isActive = function isActive() {
        return hasFocusWithin(dialog);
      };

      if (tabbable) {
        ensureFocus(tabbable, {
          preventScroll: true,
          isActive: isActive
        });
      } else {
        ensureFocus(dialog, {
          preventScroll: true,
          isActive: isActive
        });
        process.env.NODE_ENV !== "production" ? warning(dialog.tabIndex === undefined || dialog.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", dialog) : void 0;
      }
    }
  }, [dialogRef, shouldFocus, animating, nestedDialogs, initialFocusRef]);
}

function usePortalRef(dialogRef, options) {
  var portalRef = useRef(null);
  useEffect(function () {
    var dialog = dialogRef.current;
    if (!dialog || !options.visible) return;
    portalRef.current = closest(dialog, Portal.__selector);
  }, [dialogRef, options.visible]);
  return portalRef;
}

function removeFromDOM(element) {
  if (element.parentNode == null) return;
  element.parentNode.removeChild(element);
}

var focusTrapClassName = "__reakit-focus-trap";

function isFocusTrap(element) {
  var _element$classList;

  return (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.contains(focusTrapClassName);
}

function useFocusTrap(dialogRef, visibleModals, options) {
  var portalRef = usePortalRef(dialogRef, options);
  var shouldTrap = options.visible && options.modal;
  var beforeElement = useRef(null);
  var afterElement = useRef(null); // Create before and after elements
  // https://github.com/w3c/aria-practices/issues/545

  useEffect(function () {
    if (!shouldTrap) return undefined;
    var portal = portalRef.current;

    if (!portal) {
      process.env.NODE_ENV !== "production" ? warning(true, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog") : void 0;
      return undefined;
    }

    if (!beforeElement.current) {
      var document = getDocument(portal);
      beforeElement.current = document.createElement("div");
      beforeElement.current.className = focusTrapClassName;
      beforeElement.current.tabIndex = 0;
      beforeElement.current.style.position = "fixed";
      beforeElement.current.setAttribute("aria-hidden", "true");
    }

    if (!afterElement.current) {
      afterElement.current = beforeElement.current.cloneNode();
    }

    portal.insertAdjacentElement("beforebegin", beforeElement.current);
    portal.insertAdjacentElement("afterend", afterElement.current);
    return function () {
      if (beforeElement.current) removeFromDOM(beforeElement.current);
      if (afterElement.current) removeFromDOM(afterElement.current);
    };
  }, [portalRef, shouldTrap]); // Focus trap

  useEffect(function () {
    var before = beforeElement.current;
    var after = afterElement.current;
    if (!shouldTrap || !before || !after) return undefined;

    var handleFocus = function handleFocus(event) {
      var dialog = dialogRef.current;
      if (!dialog || visibleModals.length) return;
      event.preventDefault();
      var isAfter = event.target === after;
      var tabbable = isAfter ? getFirstTabbableIn(dialog) : getLastTabbableIn(dialog);

      if (tabbable) {
        tabbable.focus();
      } else {
        // fallback to dialog
        dialog.focus();
      }
    };

    before.addEventListener("focus", handleFocus);
    after.addEventListener("focus", handleFocus);
    return function () {
      before.removeEventListener("focus", handleFocus);
      after.removeEventListener("focus", handleFocus);
    };
  }, [dialogRef, visibleModals, shouldTrap]);
}

function hidByFocusingAnotherElement(dialogRef) {
  var dialog = dialogRef.current;
  if (!dialog) return false;
  var activeElement = getActiveElement(dialog);
  if (!activeElement) return false;
  if (contains(dialog, activeElement)) return false;
  if (isTabbable(activeElement)) return true;
  if (activeElement.getAttribute("data-dialog") === "true") return true;
  return false;
}

function useFocusOnHide(dialogRef, disclosureRef, options) {
  var shouldFocus = options.unstable_autoFocusOnHide && !options.visible;
  var animating = !!(options.animated && options.animating);
  useUpdateEffect(function () {
    var _options$unstable_fin;

    if (!shouldFocus) return;
    if (animating) return; // Hide was triggered by a click/focus on a tabbable element outside
    // the dialog or on another dialog. We won't change focus then.

    if (hidByFocusingAnotherElement(dialogRef)) {
      return;
    }

    var finalFocusEl = ((_options$unstable_fin = options.unstable_finalFocusRef) === null || _options$unstable_fin === void 0 ? void 0 : _options$unstable_fin.current) || disclosureRef.current;

    if (finalFocusEl) {
      if (finalFocusEl.id) {
        var document = getDocument(finalFocusEl);
        var compositeElement = document.querySelector("[aria-activedescendant='" + finalFocusEl.id + "']");

        if (compositeElement) {
          ensureFocus(compositeElement);
          return;
        }
      }

      ensureFocus(finalFocusEl);
      return;
    }

    process.env.NODE_ENV !== "production" ? warning(true, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", dialogRef.current) : void 0;
  }, [shouldFocus, animating, dialogRef, disclosureRef]);
}

var DialogContext = /*#__PURE__*/createContext({});

function useNestedDialogs(dialogRef, options) {
  var context = useContext(DialogContext);

  var _React$useState = useState([]),
      dialogs = _React$useState[0],
      setDialogs = _React$useState[1];

  var _React$useState2 = useState(dialogs),
      visibleModals = _React$useState2[0],
      setVisibleModals = _React$useState2[1];

  var addDialog = useCallback(function (ref) {
    var _context$addDialog;

    (_context$addDialog = context.addDialog) === null || _context$addDialog === void 0 ? void 0 : _context$addDialog.call(context, ref);
    setDialogs(function (prevDialogs) {
      return [].concat(prevDialogs, [ref]);
    });
  }, [context.addDialog]);
  var removeDialog = useCallback(function (ref) {
    var _context$removeDialog;

    (_context$removeDialog = context.removeDialog) === null || _context$removeDialog === void 0 ? void 0 : _context$removeDialog.call(context, ref);
    setDialogs(function (prevDialogs) {
      return removeItemFromArray(prevDialogs, ref);
    });
  }, [context.removeDialog]);
  var showDialog = useCallback(function (ref) {
    var _context$showDialog;

    (_context$showDialog = context.showDialog) === null || _context$showDialog === void 0 ? void 0 : _context$showDialog.call(context, ref);
    setVisibleModals(function (prevDialogs) {
      return [].concat(prevDialogs, [ref]);
    });
  }, [context.showDialog]);
  var hideDialog = useCallback(function (ref) {
    var _context$hideDialog;

    (_context$hideDialog = context.hideDialog) === null || _context$hideDialog === void 0 ? void 0 : _context$hideDialog.call(context, ref);
    setVisibleModals(function (prevDialogs) {
      return removeItemFromArray(prevDialogs, ref);
    });
  }, [context.hideDialog]); // If it's a nested dialog, add it to context

  useEffect(function () {
    var _context$addDialog2;

    if (options.unstable_orphan) return undefined;
    (_context$addDialog2 = context.addDialog) === null || _context$addDialog2 === void 0 ? void 0 : _context$addDialog2.call(context, dialogRef);
    return function () {
      var _context$removeDialog2;

      (_context$removeDialog2 = context.removeDialog) === null || _context$removeDialog2 === void 0 ? void 0 : _context$removeDialog2.call(context, dialogRef);
    };
  }, [options.unstable_orphan, context.addDialog, dialogRef, context.removeDialog]);
  useEffect(function () {
    var _context$showDialog2;

    if (options.unstable_orphan) return undefined;
    if (!options.modal) return undefined;
    if (!options.visible) return undefined;
    (_context$showDialog2 = context.showDialog) === null || _context$showDialog2 === void 0 ? void 0 : _context$showDialog2.call(context, dialogRef);
    return function () {
      var _context$hideDialog2;

      (_context$hideDialog2 = context.hideDialog) === null || _context$hideDialog2 === void 0 ? void 0 : _context$hideDialog2.call(context, dialogRef);
    };
  }, [options.unstable_orphan, options.modal, options.visible, context.showDialog, dialogRef, context.hideDialog]); // Close all nested dialogs when parent dialog closes

  useEffect(function () {
    if (context.visible === false && options.visible && !options.unstable_orphan) {
      var _options$hide;

      (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
    }
  }, [context.visible, options.visible, options.hide, options.unstable_orphan]); // Provider

  var providerValue = useMemo(function () {
    return {
      visible: options.visible,
      addDialog: addDialog,
      removeDialog: removeDialog,
      showDialog: showDialog,
      hideDialog: hideDialog
    };
  }, [options.visible, addDialog, removeDialog, showDialog, hideDialog]);
  var wrap = useCallback(function (element) {
    return /*#__PURE__*/createElement(DialogContext.Provider, {
      value: providerValue
    }, element);
  }, [providerValue]);
  return {
    dialogs: dialogs,
    visibleModals: visibleModals,
    wrap: wrap
  };
}

function dialogContains(target) {
  return function (dialogRef) {
    var dialog = dialogRef.current;
    if (!dialog) return false;
    if (contains(dialog, target)) return true;
    var document = getDocument(dialog);
    var backdrop = document.querySelector("[data-dialog-ref=\"" + dialog.id + "\"]");

    if (backdrop) {
      return contains(backdrop, target);
    }

    return false;
  };
}

function isDisclosure(target, disclosure) {
  return contains(disclosure, target);
}

function isInDocument(target) {
  var document = getDocument(target);

  if (target.tagName === "HTML") {
    return true;
  }

  return contains(document.body, target);
}

function useEventListenerOutside(containerRef, disclosureRef, nestedDialogs, eventType, listener, shouldListen, capture) {
  var listenerRef = useLiveRef(listener);
  useEffect(function () {
    if (!shouldListen) return undefined;

    var onEvent = function onEvent(event) {
      if (!listenerRef.current) return;
      var container = containerRef.current;
      var disclosure = disclosureRef.current;
      var target = event.target;

      if (!container) {
        process.env.NODE_ENV !== "production" ? warning(true, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog") : void 0;
        return;
      } // When an element is unmounted right after it receives focus, the focus
      // event is triggered after that, when the element isn't part of the
      // current document anymore. So we ignore it.


      if (!isInDocument(target)) return; // Event inside dialog

      if (contains(container, target)) return; // Event on disclosure

      if (disclosure && isDisclosure(target, disclosure)) return; // Event inside a nested dialog or focus trap

      if (isFocusTrap(target) || nestedDialogs.some(dialogContains(target))) {
        return;
      }

      listenerRef.current(event);
    };

    var document = getDocument(containerRef.current);
    document.addEventListener(eventType, onEvent, capture);
    return function () {
      return document.removeEventListener(eventType, onEvent, capture);
    };
  }, [containerRef, disclosureRef, nestedDialogs, eventType, shouldListen, listenerRef]);
}

function useMouseDownRef(dialogRef, options) {
  var mouseDownRef = useRef();
  useEffect(function () {
    if (!options.visible) return undefined;
    if (!options.hideOnClickOutside) return undefined;
    var document = getDocument(dialogRef.current);

    var onMouseDown = function onMouseDown(event) {
      mouseDownRef.current = event.target;
    };

    document.addEventListener("mousedown", onMouseDown);
    return function () {
      return document.removeEventListener("mousedown", onMouseDown);
    };
  }, [options.visible, options.hideOnClickOutside, dialogRef]);
  return mouseDownRef;
}

function useHideOnClickOutside(dialogRef, disclosureRef, nestedDialogs, options) {
  var mouseDownRef = useMouseDownRef(dialogRef, options);
  useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "click", function (event) {
    // Make sure the element that has been clicked is the same that last
    // triggered the mousedown event. This prevents the dialog from closing
    // by dragging the cursor (for example, selecting some text inside the
    // dialog and releasing the mouse outside of it).
    if (mouseDownRef.current === event.target) {
      var _options$hide;

      (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
    }
  }, options.visible && options.hideOnClickOutside);
  useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "focusin", function (event) {
    var document = getDocument(dialogRef.current); // Fix for https://github.com/reakit/reakit/issues/619
    // On IE11, calling element.blur() triggers the focus event on
    // document.body, so we make sure to ignore it as well.

    if (event.target !== document && event.target !== document.body) {
      var _options$hide2;

      (_options$hide2 = options.hide) === null || _options$hide2 === void 0 ? void 0 : _options$hide2.call(options);
    }
  }, options.visible && options.hideOnClickOutside);
}

function useDisableHoverOutside(portalRef, nestedDialogs, options) {
  var useEvent = function useEvent(eventType) {
    return useEventListenerOutside(portalRef, {
      current: null
    }, nestedDialogs, eventType, function (event) {
      event.stopPropagation();
      event.preventDefault();
    }, options.visible && options.modal, true);
  };

  useEvent("mouseover");
  useEvent("mousemove");
  useEvent("mouseout");
}
/**
 * When the focused child gets removed from the DOM, we make sure to move focus
 * to the dialog.
 */


function useFocusOnChildUnmount(dialogRef, options) {
  useEffect(function () {
    var dialog = dialogRef.current;
    if (!options.visible || !dialog) return undefined;
    var observer = new MutationObserver(function (mutations) {
      var target = mutations[0].target; // If target is not this dialog, then this observer was triggered by a
      // nested dialog, so we just ignore it here and let the nested dialog
      // handle it there.

      if (target !== dialog) return;
      var document = getDocument(dialog);
      var activeElement = getActiveElement(dialog); // We can check if the current focused element is the document body. On
      // IE 11, it's an empty object when the current document is in a frame or
      // iframe.

      if (activeElement === document.body || isEmpty(activeElement)) {
        dialog.focus();
      }
    });
    observer.observe(dialog, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [options.visible, dialogRef]);
}

function isActualElement(element) {
  return element && element.tagName && element.tagName !== "HTML" && element !== getDocument(element).body;
}

function useFocusOnBlur(dialogRef, options) {
  var _React$useReducer = useReducer(function (n) {
    return n + 1;
  }, 0),
      blurred = _React$useReducer[0],
      scheduleFocus = _React$useReducer[1];

  useIsomorphicEffect(function () {
    var dialog = dialogRef.current;
    if (!options.visible) return;
    if (!blurred) return; // After blur, if the active element isn't an actual element, this probably
    // means that element.blur() was called on an element inside the dialog.
    // In this case, the browser will automatically focus the body element.
    // So we move focus back to the dialog.

    if (!isActualElement(getActiveElement(dialog))) {
      process.env.NODE_ENV !== "production" ? warning(!dialog, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog") : void 0;
      dialog === null || dialog === void 0 ? void 0 : dialog.focus();
    }
  }, [blurred, dialogRef]);
  var onBlur = useCallback(function (event) {
    if (!options.visible) return;
    var nextActiveElement = getNextActiveElementOnBlur(event);

    if (!isActualElement(nextActiveElement)) {
      scheduleFocus();
    }
  }, [options.visible]);
  return onBlur;
}

var useDialog = createHook({
  name: "Dialog",
  compose: useDisclosureContent,
  keys: DIALOG_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? true : _ref$modal,
        _ref$hideOnEsc = _ref.hideOnEsc,
        hideOnEsc = _ref$hideOnEsc === void 0 ? true : _ref$hideOnEsc,
        _ref$hideOnClickOutsi = _ref.hideOnClickOutside,
        hideOnClickOutside = _ref$hideOnClickOutsi === void 0 ? true : _ref$hideOnClickOutsi,
        _ref$preventBodyScrol = _ref.preventBodyScroll,
        preventBodyScroll = _ref$preventBodyScrol === void 0 ? modal : _ref$preventBodyScrol,
        _ref$unstable_autoFoc = _ref.unstable_autoFocusOnShow,
        unstable_autoFocusOnShow = _ref$unstable_autoFoc === void 0 ? true : _ref$unstable_autoFoc,
        _ref$unstable_autoFoc2 = _ref.unstable_autoFocusOnHide,
        unstable_autoFocusOnHide = _ref$unstable_autoFoc2 === void 0 ? true : _ref$unstable_autoFoc2,
        unstable_orphan = _ref.unstable_orphan,
        options = _objectWithoutPropertiesLoose$2(_ref, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);

    return _objectSpread2$2({
      modal: modal,
      hideOnEsc: hideOnEsc,
      hideOnClickOutside: hideOnClickOutside,
      preventBodyScroll: modal && preventBodyScroll,
      unstable_autoFocusOnShow: unstable_autoFocusOnShow,
      unstable_autoFocusOnHide: unstable_autoFocusOnHide,
      unstable_orphan: modal && unstable_orphan
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlRef = _ref2.ref,
        htmlOnKeyDown = _ref2.onKeyDown,
        htmlOnBlur = _ref2.onBlur,
        htmlWrapElement = _ref2.wrapElement,
        tabIndex = _ref2.tabIndex,
        htmlProps = _objectWithoutPropertiesLoose$2(_ref2, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]);

    var dialog = useRef(null);
    var backdrop = useContext(DialogBackdropContext);
    var hasBackdrop = backdrop && backdrop === options.baseId;
    var disclosure = useDisclosureRef(dialog, options);
    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var onBlurRef = useLiveRef(htmlOnBlur);
    var focusOnBlur = useFocusOnBlur(dialog, options);

    var _useNestedDialogs = useNestedDialogs(dialog, options),
        dialogs = _useNestedDialogs.dialogs,
        visibleModals = _useNestedDialogs.visibleModals,
        wrap = _useNestedDialogs.wrap; // VoiceOver/Safari accepts only one `aria-modal` container, so if there
    // are visible child modals, then we don't want to set aria-modal on the
    // parent modal (this component).


    var modal = options.modal && !visibleModals.length ? true : undefined;
    usePreventBodyScroll(dialog, options);
    useFocusTrap(dialog, visibleModals, options);
    useFocusOnChildUnmount(dialog, options);
    useFocusOnShow(dialog, dialogs, options);
    useFocusOnHide(dialog, disclosure, options);
    useHideOnClickOutside(dialog, disclosure, dialogs, options);
    useDisableHoverOutside(dialog, dialogs, options);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;
      if (event.key !== "Escape") return;
      if (!options.hideOnEsc) return;

      if (!options.hide) {
        process.env.NODE_ENV !== "production" ? warning(true, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", dialog.current) : void 0;
        return;
      }

      event.stopPropagation();
      options.hide();
    }, [options.hideOnEsc, options.hide]);
    var onBlur = useCallback(function (event) {
      var _onBlurRef$current;

      (_onBlurRef$current = onBlurRef.current) === null || _onBlurRef$current === void 0 ? void 0 : _onBlurRef$current.call(onBlurRef, event);
      focusOnBlur(event);
    }, [focusOnBlur]);
    var wrapElement = useCallback(function (element) {
      element = wrap(element);

      if (options.modal && !hasBackdrop) {
        element = /*#__PURE__*/createElement(Portal, null, element);
      }

      if (htmlWrapElement) {
        element = htmlWrapElement(element);
      }

      return (
        /*#__PURE__*/
        // Prevents Menu > Dialog > Menu to behave as a sub menu
        createElement(MenuContext.Provider, {
          value: null
        }, element)
      );
    }, [wrap, options.modal, hasBackdrop, htmlWrapElement]);
    return _objectSpread2$2({
      ref: useForkRef(dialog, htmlRef),
      role: "dialog",
      tabIndex: tabIndex != null ? tabIndex : -1,
      "aria-modal": modal,
      "data-dialog": true,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      wrapElement: wrapElement
    }, htmlProps);
  }
});
var Dialog$1 = createComponent({
  as: "div",
  useHook: useDialog,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog") : void 0;
    return useCreateElement(type, props, children);
  }
});
var useDialogBackdrop = createHook({
  name: "DialogBackdrop",
  compose: useDisclosureContent,
  keys: DIALOG_BACKDROP_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? true : _ref$modal,
        options = _objectWithoutPropertiesLoose$2(_ref, ["modal"]);

    return _objectSpread2$2({
      modal: modal
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlWrapElement = _ref2.wrapElement,
        htmlProps = _objectWithoutPropertiesLoose$2(_ref2, ["wrapElement"]);

    var wrapElement = useCallback(function (element) {
      if (options.modal) {
        element = /*#__PURE__*/createElement(Portal, null, /*#__PURE__*/createElement(DialogBackdropContext.Provider, {
          value: options.baseId
        }, element));
      }

      if (htmlWrapElement) {
        return htmlWrapElement(element);
      }

      return element;
    }, [options.modal, htmlWrapElement]);
    return _objectSpread2$2({
      id: undefined,
      "data-dialog-ref": options.baseId,
      wrapElement: wrapElement
    }, htmlProps);
  }
});
var DialogBackdrop = createComponent({
  as: "div",
  memo: true,
  useHook: useDialogBackdrop
});
/**
 * Style Primitives - USE IN CSS ONLY WHEN DESIGN TOKENS ARE NOT APPROPRIATE
 */

var primitive = {
  // Brand-agnostic primitives go here
  // colors
  $black: '#000',
  $white: '#fff',
  $error: 'rgb(209,69,69)',
  $disabledText: 'rgba(0,0,0,0.55)',
  $disabledTextReversed: 'rgba(255,255,255,0.51)',
  $blackOpacity70: 'rgba(0,0,0,0.7)',
  $blackOpacity30: 'rgba(0,0,0,0.3)',
  $blackOpacity10: 'rgba(0,0,0,0.1)',
  $blackOpacity4: 'rgba(0,0,0,0.04)',
  $whiteOpacity30: 'rgba(255,255,255,0.3)',
  $whiteOpacity10: 'rgba(255,255,255,0.1)',
  $whiteOpacity4: 'rgba(255,255,255,0.04)',
  // spacing
  $spacing0: '0',
  $spacing1: '4px',
  $spacing2: '8px',
  $spacing3: '12px',
  $spacing4: '16px',
  $spacing5: '20px',
  $spacing6: '24px',
  $spacing7: '32px',
  $spacing8: '40px',
  $spacing9: '48px',
  $spacing10: '56px',
  $spacing11: '80px',

  /** Burger-King-only primitives */
  bk: {
    // colors
    $bbqBrown: 'rgb(80,35,20)',
    $mayoEggWhite: 'rgb(245,235,220)',
    $fieryRed: 'rgb(214,35,0)',
    $crunchyGreen: 'rgb(25,135,55)',
    $flamingOrange: 'rgb(255,135,50)',
    $meltyYellow: 'rgb(255,170,0)',
    $fieryRedOpacity10: 'rgba(214,35,0,0.1)',
    $fieryRedDarken10: 'rgb(163,27,0)',
    // text styles

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $hero: '32px/36px "Flame", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOne: '24px/24px "Flame", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwo: '18px/20px "Flame", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThree: '16px/20px "Flame", "Cooper Black", "Helvetica Neue", Helvetica, Arial, sans-serif',
    $headerFour: '13px/16px "Flame", "Cooper Black", "Helvetica Neue", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOne: '15px/20px "Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwo: '12px/16px "Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',
    $formUtility: '11px/12px "Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',
    // text styles for Desktop

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $heroDesktop: '56px/56px "Flame Bold", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOneDesktop: '30px/32px "Flame", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwoDesktop: '24px/28px "Flame", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThreeDesktop: '18px/20px "Flame", "Cooper Black", "Helvetica Neue", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOneDesktop: '16px/24px "Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwoDesktop: '13px/20px "Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif'
  },

  /** Love-That-Wing-only primitives */
  ltw: {
    // colors
    $loveDark: 'rgb(31,31,31)',
    $loveLight: 'rgb(249,243,228)',
    $loveRed: 'rgb(219,30,18)',
    $loveTeal: 'rgb(151,206,185)',
    $loveOrange: 'rgb(255,154,44)',
    $loveYellow: 'rgb(253,189,16)',
    $loveDarkLighten10: 'rgb(57,57,57)',

    /** @deprecated Use the color primitive $loveLight instead */
    $offWhite: 'rgb(249,243,227)',

    /** @deprecated Use the color primitive $loveDark instead */
    $nolaDark: 'rgb(31,31,31)',

    /** @deprecated Use the color primitive $loveTeal instead */
    $nolaTeal: 'rgb(0,166,158)',

    /** @deprecated Use a primitive from the new LTW color palette instead */
    $nolaPurple: 'rgb(145,25,135)',
    // text styles

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $hero: '32px/36px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOne: '24px/28px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwo: '18px/24px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThree: '16px/20px "chicken_sans_bold", sans-serif',
    $headerFour: '13px/16px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOne: '15px/20px "chicken_sans", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwo: '12px/16px "chicken_sans", sans-serif',
    $formUtility: '11px/12px "chicken_sans", sans-serif',
    // text styles for Desktop

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $heroDesktop: '56px/56px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOneDesktop: '30px/32px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwoDesktop: '24px/28px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThreeDesktop: '18px/20px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOneDesktop: '16px/24px "chicken_sans", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwoDesktop: '13px/20px "chicken_sans", sans-serif'
  },

  /** Popeyes-only primitives */
  plk: {
    // colors
    $nolaDark: 'rgb(31,31,31)',
    $nolaLight: 'rgb(245,241,239)',
    $popeyesOrange: 'rgb(255,125,0)',
    $burntOrange: 'rgb(242,86,0)',
    $nolaTeal: 'rgb(0,166,158)',
    $nolaPurple: 'rgb(145,25,135)',
    $butterYellow: 'rgb(255,200,0)',
    $spicyRed: 'rgb(217,15,6)',
    $burntOrangeOpacity10: 'rgba(242,86,0,0.1)',
    $burnOrangeDarken10: 'rgb(191,86,0)',
    // text styles

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $hero: '32px/36px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOne: '24px/28px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwo: '18px/24px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThree: '16px/20px "chicken_sans_bold", sans-serif',
    $headerFour: '13px/16px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOne: '15px/20px "chicken_sans", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwo: '12px/16px "chicken_sans", sans-serif',
    $formUtility: '11px/12px "chicken_sans", sans-serif',
    // text styles for Desktop

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $heroDesktop: '56px/56px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOneDesktop: '30px/32px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwoDesktop: '24px/28px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThreeDesktop: '18px/20px "chicken_sans_bold", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOneDesktop: '16px/24px "chicken_sans", sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwoDesktop: '13px/20px "chicken_sans", sans-serif'
  },

  /** Tim-Horton-only primitives */
  th: {
    // colors
    $coffeeBrown: 'rgb(63,32,33)',
    $alwaysRed: 'rgb(200,16,46)',
    $donutCream: 'rgb(221,203,164)',
    $donutCreamLighten20: 'rgb(249,245,238)',
    $alwaysRedOpacity10: 'rgba(200,16,46,0.1)',
    $alwaysRedDarken10: 'rgb(153,12,35)',
    // text styles

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $hero: '32px/36px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOne: '24px/28px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwo: '18px/24px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThree: '16px/20px "sofia_pro_bold", Helvetica, Arial, sans-serif',
    $headerFour: '13px/16px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOne: '15px/20px "sofia_pro", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwo: '12px/16px "sofia_pro", Helvetica, Arial, sans-serif',
    $formUtility: '11px/12px "sofia_pro", Helvetica, Arial, sans-serif',
    // text styles for Desktop

    /** @deprecated Use the CSS variable for this font instead: var(--font-hero) */
    $heroDesktop: '56px/56px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerOne) */
    $headerOneDesktop: '30px/32px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerTwo) */
    $headerTwoDesktop: '24px/28px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-headerThree) */
    $headerThreeDesktop: '18px/20px "sofia_pro_bold", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyOne) */
    $copyOneDesktop: '16px/24px "sofia_pro", Helvetica, Arial, sans-serif',

    /** @deprecated Use the CSS variable for this font instead: var(--font-copyTwo) */
    $copyTwoDesktop: '13px/20px "sofia_pro", Helvetica, Arial, sans-serif'
  }
};
var StyledDialogBackdrop = styled(DialogBackdrop)(_templateObject42(), primitive.$blackOpacity70);
var StyledDialog$1 = styled(Dialog$1)(_templateObject43(), function (p) {
  return p.theme.token('background-pattern');
}, function (p) {
  return p.theme.token('border-radius-pattern');
}, function (p) {
  return p.theme.token('border-radius-pattern');
}, primitive.$spacing3);
var BottomDrawerHeader = styled.div(_templateObject44(), primitive.$spacing10, function (p) {
  return p.theme.token('text-button-tertiary-default');
}, function (p) {
  return p.theme.token('text-style-card-header');
}, primitive.$blackOpacity10);
var BottomDrawerBody = styled.div(_templateObject45(), primitive.$spacing8);
var BottomDrawerCloseButton = styled.button(_templateObject46(), function (p) {
  return p.theme.token('background-pattern');
}, primitive.$spacing3, primitive.$spacing9, primitive.$spacing1);
/**
 * Show options in a Drawer, which appears from bottom to top. It can be closed as well through backdrop click or close button click
 */

var BottomDrawer = function BottomDrawer(_ref81) {
  var header = _ref81.header,
      dialogState = _ref81.dialogState,
      children = _ref81.children,
      _ref81$hideOnClickOut = _ref81.hideOnClickOutside,
      hideOnClickOutside = _ref81$hideOnClickOut === void 0 ? true : _ref81$hideOnClickOut,
      ariaLabel = _ref81['aria-label'],
      dataTestId = _ref81['data-testid'];
  return React__default.createElement(StyledDialogBackdrop, Object.assign({
    "data-testid": dataTestId
  }, dialogState), React__default.createElement(BottomDrawerCloseButton, {
    "data-testid": "bottom-drawer-close-btn",
    "aria-label": "Close",
    onClick: dialogState.hide
  }, React__default.createElement(Icon, {
    icon: "close",
    color: "icon-default",
    height: "30px",
    width: "30px"
  })), React__default.createElement(StyledDialog$1, Object.assign({
    "data-testid": "bottom-drawer-body"
  }, dialogState, {
    hideOnClickOutside: hideOnClickOutside,
    "aria-label": ariaLabel
  }), React__default.createElement(BottomDrawerHeader, null, header), React__default.createElement(BottomDrawerBody, null, children)));
};

var useBottomDrawerUIState = function useBottomDrawerUIState() {
  return useDialogState({
    animated: true
  });
};
/**
 * Returns `false` until the boolean remains true for a set period of time.
 *
 * Useful for concealing brief activations of variables whose values change
 * often, like the loading state of a piece of UI.
 */


var usePersistentlyTrueBool = function usePersistentlyTrueBool(value, waitMs) {
  // A ref is used instead of state because we do not want the change in the
  // waited state from `true` to `false` to trigger an unnecessary re-render.
  // The re-render is unnecessary because the return value already evaluates to
  // `false` in the case `value` is `false`
  var stayedTrueRef = useRef(false);

  var _useReducer = useReducer(function (x) {
    return x + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      forceUpdate = _useReducer2[1];

  useEffect(function () {
    if (!value) {
      stayedTrueRef.current = false;
      return;
    }

    if (stayedTrueRef.current) {
      return;
    }

    var timeout = setTimeout(function () {
      stayedTrueRef.current = true;
      forceUpdate();
    }, waitMs);
    return function () {
      clearTimeout(timeout);
    };
  }, [stayedTrueRef, value, waitMs]);
  return stayedTrueRef.current && value;
};

var VisuallyHidden = styled.span(_templateObject47());
var DURATION = 1.25;
var STAGGER_OFFSET = 0.09375;
var animation = keyframes(_templateObject48());
var ParticleAnimation = styled.div(_templateObject49(), animation, DURATION, -DURATION + 0 * STAGGER_OFFSET, animation, DURATION, -DURATION + 1 * STAGGER_OFFSET, animation, DURATION, -DURATION + 2 * STAGGER_OFFSET);

function LoadingAnimation(_ref82) {
  var loadingMessage = _ref82.loadingMessage,
      testId = _ref82['data-testid'];
  return React__default.createElement(ParticleAnimation, {
    "data-testid": testId
  }, React__default.createElement("span", null), React__default.createElement("span", null), React__default.createElement("span", null), React__default.createElement(VisuallyHidden, {
    "aria-live": "polite"
  }, loadingMessage));
}

var BaseButton = styled('button')(_templateObject50(), function (p) {
  return p.$fullWidth && '100%';
}, function (p) {
  return p.$size === 'small' ? primitive.$spacing2 : primitive.$spacing3;
}, primitive.$spacing2, function (p) {
  return p.theme.token('transition-component');
}, function (p) {
  return p.$size === 'small' ? css(_templateObject51(), p.theme.token('text-style-button-small'), p.theme.token('height-button-small'), primitive.$spacing2, p.theme.token('height-icon-small'), p.theme.token('width-icon-small')) : css(_templateObject52(), p.theme.token('text-style-button-large'), p.theme.token('height-button-large'), primitive.$spacing3, p.theme.token('height-icon'), p.theme.token('width-icon'));
}, function (p) {
  return p.$loading && css(_templateObject53(), LoadingWrapper);
}, function (p) {
  return p.$reversed ? p.theme.token('icon-disabled-reversed') : p.theme.token('icon-disabled');
}, function (p) {
  return p.$reversed ? p.theme.token('box-shadow-pattern-reversed') : p.theme.token('box-shadow-pattern');
});
var PrimaryButtonStyle = styled(BaseButton)(_templateObject54(), function (p) {
  return p.$textColor || (p.$reversed ? p.theme.token('text-button-primary-reversed') : p.theme.token('text-button-primary'));
}, function (p) {
  return p.$bgColor || (p.$reversed ? p.theme.token('background-button-primary-default-reversed') : p.theme.token('background-button-primary-default'));
}, function (p) {
  return p.$reversed ? p.theme.token('icon-button-primary-reversed') : p.theme.token('icon-button-primary');
}, function (p) {
  if (p.$bgColor) {
    return getColorWithOpacity(p.$bgColor, 0.8);
  }

  return p.$reversed ? p.theme.token('background-button-hover-reversed') : p.theme.token('background-button-primary-hover');
}, function (p) {
  return p.$reversed && !p.$textColor && css(_templateObject55(), p.theme.token('text-button-primary'), p.theme.token('icon-button-primary'), p.theme.token('icon-button-primary'));
}, function (p) {
  return p.$reversed ? p.theme.token('text-disabled-reversed') : p.theme.token('text-disabled');
}, function (p) {
  return p.theme.token('border-width-button-secondary');
}, function (p) {
  return p.$reversed ? p.theme.token('border-color-disabled-reversed') : p.theme.token('border-color-disabled');
});
var SecondaryButtonStyle = styled(BaseButton)(_templateObject56(), function (p) {
  return p.theme.token('border-width-button-secondary');
}, function (p) {
  return p.$reversed ? p.theme.token('border-color-button-secondary-reversed') : p.theme.token('border-color-button-secondary');
}, function (p) {
  return p.$reversed ? p.theme.token('text-button-reversed') : p.theme.token('text-button-secondary');
}, function (p) {
  return p.$reversed ? p.theme.token('icon-button-reversed') : p.theme.token('icon-button-secondary');
}, function (p) {
  return p.$reversed ? p.theme.token('background-button-hover-reversed') : p.theme.token('background-button-secondary-hover');
}, function (p) {
  return p.$reversed ? p.theme.token('text-disabled-reversed') : p.theme.token('text-disabled');
}, function (p) {
  return p.$reversed ? p.theme.token('border-color-disabled-reversed') : p.theme.token('border-color-disabled');
});
var TertiaryButtonStyle = styled(BaseButton)(_templateObject57(), function (p) {
  return p.$reversed ? p.theme.token('text-button-reversed') : p.theme.token('text-button-tertiary-default');
}, function (p) {
  return p.$reversed ? p.theme.token('icon-button-reversed') : p.theme.token('icon-button-tertiary-default');
}, function (p) {
  return p.$reversed ? css(_templateObject58(), p.theme.token('background-button-hover-reversed')) : css(_templateObject59(), p.theme.token('text-button-tertiary-hover'), p.theme.token('icon-button-tertiary-hover'), p.theme.token('icon-button-tertiary-hover'));
}, function (p) {
  return p.$reversed ? p.theme.token('text-disabled-reversed') : p.theme.token('text-disabled');
});
var IconOnlyButtonStyle = styled(SecondaryButtonStyle)(_templateObject60(), function (p) {
  return p.theme.token('height-icon-small');
}, function (p) {
  return p.theme.token('width-icon-small');
}, function (p) {
  return p.$size === 'small' ? css(_templateObject61(), p.theme.token('border-width-button-secondary')) : css(_templateObject62(), p.theme.token('border-width-button-secondary'));
});
var TextWrapper$3 = styled.span(_templateObject63(), primitive.$spacing1, primitive.$spacing2);
var LoadingWrapper = styled.div(_templateObject64());
var LOADING_SHOW_DELAY_MS = 300;
var TheEveryButton = forwardRef$1(function (_ref83, forwardedRef) {
  var children = _ref83.children,
      disabled = _ref83.disabled,
      type = _ref83.type,
      onClick = _ref83.onClick,
      size = _ref83.size,
      iconProp = _ref83.icon,
      showNavigationIcon = _ref83.showNavigationIcon,
      fullWidth = _ref83.fullWidth,
      as = _ref83.as,
      to = _ref83.to,
      href = _ref83.href,
      title = _ref83.title,
      variant = _ref83.variant,
      reversed = _ref83.reversed,
      actuallyLoading = _ref83.loading,
      loadingMessage = _ref83.loadingMessage,
      textColor = _ref83.textColor,
      bgColor = _ref83.bgColor,
      testId = _ref83['data-testid'],
      ariaLabel = _ref83['aria-label'],
      ariaDescribedBy = _ref83['aria-describedby'];
  // Only display the loading indicator after the button has been loading for
  // longer than a fixed timeout. Reduces occurences of loading UI flashing on
  // and off on fast connections.
  var loadingShown = usePersistentlyTrueBool(!!actuallyLoading, LOADING_SHOW_DELAY_MS);
  var Variant = {
    primary: PrimaryButtonStyle,
    secondary: SecondaryButtonStyle,
    tertiary: TertiaryButtonStyle,
    iconOnly: IconOnlyButtonStyle
  }[variant];

  var asProps = function () {
    if (!as || as === 'button') {
      return {
        as: 'button',
        disabled: disabled,
        type: type
      };
    }

    if (as === 'a') {
      return {
        as: 'a',
        href: href
      };
    }

    return {
      as: as,
      to: to
    };
  }(); // ^^^ here we cheat the type a bit, omitting the following possibility:
  // | { as: RouterLinkType; to: any };
  // to avoid a type error seeming to originate from styled-components
  // `as`-typing magic.


  var icon = null;

  if (iconProp && (size === 'small' || variant === 'iconOnly')) {
    if (typeof iconProp === 'string') {
      icon = React__default.createElement(Icon, {
        icon: iconProp,
        color: "icon-default",
        "aria-hidden": true,
        "data-testid": testId ? "".concat(testId, "-icon") : undefined
      });
    } else if (iconProp.element) {
      icon = iconProp.element;
    }
  }

  return React__default.createElement(Variant, Object.assign({}, asProps, {
    onClick: actuallyLoading ? undefined : onClick,
    ref: forwardedRef,
    "$fullWidth": fullWidth,
    "data-full-width": fullWidth || undefined,
    "$hasEndIcon": showNavigationIcon,
    "$hasStartIcon": !!icon,
    "$reversed": reversed,
    "$loading": loadingShown,
    "$size": size
  }, variant === 'primary' && {
    $textColor: textColor,
    $bgColor: bgColor
  }, {
    "data-testid": testId,
    title: title,
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedBy
  }), icon, children && React__default.createElement(TextWrapper$3, {
    "aria-hidden": loadingShown || undefined
  }, children), showNavigationIcon && variant === 'tertiary' && size === 'small' && asProps.as !== 'button' && React__default.createElement(Icon, {
    icon: "next",
    color: "icon-default",
    "aria-hidden": true,
    "data-testid": testId ? "".concat(testId, "-icon-nav") : undefined
  }), loadingShown && React__default.createElement(LoadingWrapper, null, React__default.createElement(LoadingAnimation, {
    loadingMessage: loadingMessage || 'Loading'
  })));
});

var makeIconOnlyButton = function makeIconOnlyButton(initialProps) {
  return React__default.forwardRef(function (props, forwardedRef) {
    return React__default.createElement(TheEveryButton, Object.assign({}, initialProps, props, {
      variant: "iconOnly",
      ref: forwardedRef
    }));
  });
};

var PrimaryButton = React__default.forwardRef(function (props, forwardedRef) {
  return React__default.createElement(TheEveryButton, Object.assign({}, props, {
    variant: "primary",
    ref: forwardedRef
  }));
});
var SecondaryButton = React__default.forwardRef(function (props, forwardedRef) {
  return React__default.createElement(TheEveryButton, Object.assign({}, props, {
    variant: "secondary",
    ref: forwardedRef
  }));
});
var TertiaryButton = React__default.forwardRef(function (props, forwardedRef) {
  return React__default.createElement(TheEveryButton, Object.assign({}, props, {
    variant: "tertiary",
    ref: forwardedRef
  }));
});
var PreviousButton = makeIconOnlyButton({
  icon: 'previous'
});
var NextButton = makeIconOnlyButton({
  icon: 'next'
});
var GlobalStyles$3 = createGlobalStyle(_templateObject65(), primitive.bk.$hero, primitive.bk.$headerOne, primitive.bk.$headerTwo, primitive.bk.$headerThree, primitive.bk.$copyOne, primitive.bk.$copyTwo, mediaQuery.desktopSmall, primitive.bk.$headerOneDesktop, primitive.bk.$headerTwoDesktop, primitive.bk.$headerThreeDesktop, primitive.bk.$copyOneDesktop, primitive.bk.$copyTwoDesktop, mediaQuery.desktopLarge, primitive.bk.$heroDesktop);
var GlobalStyles$2 = createGlobalStyle(_templateObject66(), primitive.ltw.$hero, primitive.ltw.$headerOne, primitive.ltw.$headerTwo, primitive.ltw.$headerThree, primitive.ltw.$copyOne, primitive.ltw.$copyTwo, mediaQuery.desktopSmall, primitive.ltw.$headerOneDesktop, primitive.ltw.$headerTwoDesktop, primitive.ltw.$headerThreeDesktop, primitive.ltw.$copyOneDesktop, primitive.ltw.$copyTwoDesktop, mediaQuery.desktopLarge, primitive.ltw.$heroDesktop);
var GlobalStyles$1 = createGlobalStyle(_templateObject67(), primitive.plk.$hero, primitive.plk.$headerOne, primitive.plk.$headerTwo, primitive.plk.$headerThree, primitive.plk.$copyOne, primitive.plk.$copyTwo, mediaQuery.desktopSmall, primitive.plk.$headerOneDesktop, primitive.plk.$headerTwoDesktop, primitive.plk.$headerThreeDesktop, primitive.plk.$copyOneDesktop, primitive.plk.$copyTwoDesktop, mediaQuery.desktopLarge, primitive.plk.$heroDesktop);
var GlobalStyles = createGlobalStyle(_templateObject68(), primitive.th.$hero, primitive.th.$headerOne, primitive.th.$headerTwo, primitive.th.$headerThree, primitive.th.$copyOne, primitive.th.$copyTwo, mediaQuery.desktopSmall, primitive.th.$headerOneDesktop, primitive.th.$headerTwoDesktop, primitive.th.$headerThreeDesktop, primitive.th.$copyOneDesktop, primitive.th.$copyTwoDesktop, mediaQuery.desktopLarge, primitive.th.$heroDesktop);
/** Resets button styles and makes them more link-like */

var buttonAsLinkReset = css(_templateObject69(), function (p) {
  return p.theme.token('text-link-default');
});
var Wrapper$8 = styled.div(_templateObject70(), function (p) {
  return p.$textColor || p.theme.token('text-default');
}, function (p) {
  return p.$bgColor || p.theme.token('background-pattern');
}, function (p) {
  return p.theme.token('border-radius-pattern-interactive');
});
var ImageLink = styled.a(_templateObject71(), function (p) {
  return p.theme.token('border-radius-pattern-interactive');
});
var TextWrapper$2 = styled.div(_templateObject72(), primitive.$spacing4, mediaQuery.desktopSmall, primitive.$spacing4, primitive.$spacing5);
var HeaderDescriptionWrapper = styled.div(_templateObject73());
var ButtonWrapper = styled.div(_templateObject74(), primitive.$spacing3, mediaQuery.desktopSmall, primitive.$spacing4);
var Header$3 = styled.div(_templateObject75(), function (p) {
  return p.theme.token('text-style-card-header');
}, primitive.$spacing2);
var Description = styled.div(_templateObject76(), function (p) {
  return p.theme.token('text-style-card-copy');
});
var Terms$1 = styled.button(_templateObject77(), buttonAsLinkReset, function (p) {
  return p.$textColor || p.theme.token('text-link-default');
}, function (p) {
  return p.$textColor ? getColorWithOpacity(p.$textColor, 0.8) : p.theme.token('text-link-hover');
});
/**
 * Displays a link comprised of an image and text, used for marketing
 */

var Card = function Card(_ref84) {
  var image = _ref84.image,
      imageAlt = _ref84.imageAlt,
      header = _ref84.header,
      description = _ref84.description,
      callToAction = _ref84.callToAction,
      href = _ref84.href,
      linkAs = _ref84.linkAs,
      termsLinkText = _ref84.termsLinkText,
      termsLinkHref = _ref84.termsLinkHref,
      termsLinkAs = _ref84.termsLinkAs,
      marketingId = _ref84.marketingId,
      _ref84$variant = _ref84.variant,
      variant = _ref84$variant === void 0 ? 'default' : _ref84$variant,
      bgColor = _ref84.bgColor,
      textColor = _ref84.textColor,
      buttonBgColor = _ref84.buttonBgColor,
      buttonTextColor = _ref84.buttonTextColor,
      onClick = _ref84.onClick,
      onClickTermsLink = _ref84.onClickTermsLink;
  var isDesktop = useMediaQuery('desktopSmall');
  var id = useIdCounter('card');
  var allCopyId = "".concat(id, "-all-copy");

  var onMainLinkClick = function onMainLinkClick(event) {
    return onClick === null || onClick === void 0 ? void 0 : onClick(event, {
      marketingId: marketingId
    });
  };

  var ButtonComponent = variant === 'default' ? SecondaryButton : PrimaryButton;
  var buttonProps = Object.assign({
    onClick: onMainLinkClick,
    size: isDesktop ? 'large' : 'small',
    'aria-describedby': allCopyId
  }, variant === 'campaign' && {
    bgColor: buttonBgColor,
    textColor: buttonTextColor,
    reversed: !!bgColor && isColorDark(bgColor)
  });
  var colorTweaks = variant === 'campaign' ? {
    $textColor: textColor,
    $bgColor: bgColor
  } : {};
  return React__default.createElement(Wrapper$8, Object.assign({}, colorTweaks), React__default.createElement(ImageLink, Object.assign({
    as: linkAs || 'a'
  }, linkAs ? {
    to: href
  } : {
    href: href
  }, {
    onClick: onMainLinkClick,
    tabIndex: -1,
    "aria-hidden": true
  }), image), React__default.createElement(TextWrapper$2, null, React__default.createElement(HeaderDescriptionWrapper, {
    id: allCopyId
  }, imageAlt && React__default.createElement(VisuallyHidden, null, imageAlt), React__default.createElement(Header$3, null, header), React__default.createElement(Description, null, description, termsLinkText && React__default.createElement(React__default.Fragment, null, ' ', React__default.createElement(Terms$1, Object.assign({}, colorTweaks, {
    onClick: function onClick(event) {
      return onClickTermsLink === null || onClickTermsLink === void 0 ? void 0 : onClickTermsLink(event, {
        marketingId: marketingId
      });
    }
  }, termsLinkHref && Object.assign({
    as: termsLinkAs || 'a'
  }, termsLinkAs ? {
    to: termsLinkHref
  } : {
    href: termsLinkHref
  }), {
    "aria-describedby": allCopyId
  }), termsLinkText)))), React__default.createElement(ButtonWrapper, null, linkAs ? React__default.createElement(ButtonComponent, Object.assign({}, buttonProps, {
    as: linkAs,
    to: href
  }), callToAction) : React__default.createElement(ButtonComponent, Object.assign({
    as: "a"
  }, buttonProps, {
    href: href
  }), callToAction))));
};

var COLUMNS_MOBILE = 2;
var COLUMNS_TABLET = 8;
var COLUMNS_DESKTOP_SMALL = 8;
var COLUMNS_DESKTOP_LARGE = 12;
var StyledCell = styled.div(_templateObject78(), function (props) {
  var $span = props.$span,
      $spanTablet = props.$spanTablet,
      $spanDesktopSmall = props.$spanDesktopSmall,
      $spanDesktopLarge = props.$spanDesktopLarge,
      $start = props.$start,
      $startTablet = props.$startTablet,
      $startDesktopSmall = props.$startDesktopSmall,
      $startDesktopLarge = props.$startDesktopLarge,
      $row = props.$row,
      $rowTablet = props.$rowTablet,
      $rowDesktopSmall = props.$rowDesktopSmall,
      $rowDesktopLarge = props.$rowDesktopLarge; // Mobile

  $span = Math.min($span !== null && $span !== void 0 ? $span : COLUMNS_MOBILE, COLUMNS_MOBILE);
  $start = $start !== undefined ? Math.min($start, COLUMNS_MOBILE - $span + 1) : undefined;

  var scaleUp = function scaleUp(baseColumnCount, targetColumnCount) {
    return function (baseValue) {
      return Math.round(targetColumnCount / baseColumnCount * baseValue);
    };
  }; // Tablet


  var mobile2Tablet = scaleUp(COLUMNS_MOBILE, COLUMNS_TABLET);
  $spanTablet = Math.min($spanTablet !== null && $spanTablet !== void 0 ? $spanTablet : mobile2Tablet($span), COLUMNS_TABLET);

  if ($startTablet !== undefined) {
    $startTablet = Math.min($startTablet, COLUMNS_TABLET - $spanTablet + 1);
  } else if ($start !== undefined) {
    $startTablet = Math.min(mobile2Tablet($start - 1) + 1, COLUMNS_TABLET - $spanTablet + 1);
  } // Desktop small


  $spanDesktopSmall = Math.min($spanDesktopSmall !== null && $spanDesktopSmall !== void 0 ? $spanDesktopSmall : $spanTablet, COLUMNS_DESKTOP_SMALL);

  if ($startDesktopSmall !== undefined) {
    $startDesktopSmall = Math.min($startDesktopSmall, COLUMNS_DESKTOP_SMALL - $spanDesktopSmall + 1);
  } else if ($startTablet !== undefined) {
    $startDesktopSmall = Math.min($startTablet, COLUMNS_DESKTOP_SMALL - $spanDesktopSmall + 1);
  } // Desktop Large


  var desktopSmall2DesktopLarge = scaleUp(COLUMNS_DESKTOP_SMALL, COLUMNS_DESKTOP_LARGE);
  $spanDesktopLarge = Math.min($spanDesktopLarge !== null && $spanDesktopLarge !== void 0 ? $spanDesktopLarge : desktopSmall2DesktopLarge($spanDesktopSmall), COLUMNS_DESKTOP_LARGE);

  if ($startDesktopLarge !== undefined) {
    $startDesktopLarge = Math.min($startDesktopLarge, COLUMNS_DESKTOP_LARGE - $spanDesktopLarge + 1);
  } else if ($startDesktopSmall !== undefined) {
    $startDesktopLarge = Math.min(desktopSmall2DesktopLarge($startDesktopSmall - 1) + 1, COLUMNS_DESKTOP_LARGE - $spanDesktopLarge + 1);
  }

  $rowTablet !== null && $rowTablet !== void 0 ? $rowTablet : $rowTablet = $row;
  $rowDesktopSmall !== null && $rowDesktopSmall !== void 0 ? $rowDesktopSmall : $rowDesktopSmall = $rowTablet;
  $rowDesktopLarge !== null && $rowDesktopLarge !== void 0 ? $rowDesktopLarge : $rowDesktopLarge = $rowDesktopSmall;
  return css(_templateObject79(), $span, $start, $row, mediaQuery.tablet, $spanTablet, $startTablet, $rowTablet, mediaQuery.desktopSmall, $spanDesktopSmall, $startDesktopSmall, $rowDesktopSmall, mediaQuery.desktopLarge, $spanDesktopLarge, $startDesktopLarge, $rowDesktopLarge);
});

var Cell = function Cell(_a) {
  var children = _a.children,
      style = _a.style,
      className = _a.className,
      otherProps = __rest(_a, ["children", "style", "className"]); // Props are prefixed with `$` in order to avoid them being directly
  // applied to the underlying HTML element


  var styledProps = Object.entries(otherProps).reduce(function (acc, _ref85) {
    var _ref86 = _slicedToArray(_ref85, 2),
        propName = _ref86[0],
        value = _ref86[1];

    acc["$".concat(propName)] = value;
    return acc;
  }, {});
  return React__default.createElement(StyledCell, Object.assign({
    style: style,
    className: className
  }, styledProps), children);
};

var linkStyles = css(_templateObject80(), function (p) {
  return p.theme.token('text-link-default');
}, function (p) {
  return p.theme.token('text-link-hover');
});
var Wrapper$7 = styled.div(_templateObject81(), function (p) {
  return p.$disabled ? 'not-allowed' : 'pointer';
});
var LabelHeader = styled.p(_templateObject82(), function (p) {
  return p.theme.token('text-style-form-checkbox-header');
}, function (p) {
  return p.$disabled ? p.theme.token('text-disabled') : p.theme.token('text-default');
}, linkStyles);
var LabelText = styled.p(_templateObject83(), function (p) {
  return p.theme.token('text-style-form-checkbox');
}, function (p) {
  return p.$disabled ? p.theme.token('text-disabled') : p.theme.token('text-default');
}, linkStyles);

var Label$2 = function Label$2(_ref87) {
  var id = _ref87.id,
      label = _ref87.label,
      labelHeader = _ref87.labelHeader,
      disabled = _ref87.disabled,
      testId = _ref87['data-testid'];

  if (!label) {
    return null;
  }

  return React.createElement(Wrapper$7, {
    id: id,
    "$disabled": disabled,
    "data-testid": testId !== null && testId !== void 0 ? testId : 'label'
  }, labelHeader && React.createElement(LabelHeader, {
    "data-testid": 'label-header',
    "$disabled": disabled
  }, labelHeader), React.createElement(LabelText, {
    "data-testid": 'label-text',
    "$disabled": disabled
  }, label));
};

var HiddenInput$2 = VisuallyHidden.withComponent('input');
var IconContainer = styled.div(_templateObject84());
var LabelWrapper$2 = styled.label(_templateObject85(), function (p) {
  return p.$disabled ? 'not-allowed' : 'pointer';
});
var Check = styled.div(_templateObject86(), function (p) {
  return p.theme.token('width-checkbox-radio');
}, function (p) {
  return p.theme.token('height-checkbox-radio');
}, HiddenInput$2, LabelWrapper$2, function (p) {
  return "border-color: ".concat(p.theme.token('border-color-hover'));
}, HiddenInput$2, LabelWrapper$2, function (p) {
  return "border-color: ".concat(p.theme.token('border-color-input'));
}, HiddenInput$2, LabelWrapper$2, function (p) {
  return p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.theme.token('transition-component');
}, function (_ref88) {
  var $hasError = _ref88.$hasError,
      $disabled = _ref88.$disabled,
      checked = _ref88.checked,
      token = _ref88.theme.token;

  if (!$disabled && !$hasError && checked) {
    return css(_templateObject87(), token('background-checked'));
  }

  if ($hasError) {
    if (checked) {
      return css(_templateObject88(), token('background-error'));
    }

    return css(_templateObject89(), token('border-width-input'), token('border-color-error'));
  }

  if ($disabled && checked) {
    return css(_templateObject90(), token('background-checkbox-disabled'));
  }

  return css(_templateObject91(), token('border-width-input'), token('border-color-input'), token('background-input'));
});

var Checkbox = function Checkbox(_ref89) {
  var ariaLabel = _ref89['aria-label'],
      dataTestId = _ref89['data-testid'],
      checked = _ref89.checked,
      className = _ref89.className,
      disabled = _ref89.disabled,
      disableScreenReaderAlert = _ref89.disableScreenReaderAlert,
      _ref89$errorMessage = _ref89.errorMessage,
      errorMessage = _ref89$errorMessage === void 0 ? '' : _ref89$errorMessage,
      _ref89$hintMessage = _ref89.hintMessage,
      hintMessage = _ref89$hintMessage === void 0 ? '' : _ref89$hintMessage,
      label = _ref89.label,
      _ref89$labelHeader = _ref89.labelHeader,
      labelHeader = _ref89$labelHeader === void 0 ? '' : _ref89$labelHeader,
      name = _ref89.name,
      onChange = _ref89.onChange,
      required = _ref89.required;

  var _useTheme = useTheme(),
      token = _useTheme.token;

  var inputID = useIdCounter('checkbox');
  var messageID = useIdCounter('message');
  var labelID = useIdCounter('label');
  var message = errorMessage || hintMessage;
  return React.createElement(React.Fragment, null, React.createElement(HiddenInput$2, {
    "aria-label": ariaLabel,
    "aria-describedby": messageID,
    type: "checkbox",
    id: inputID,
    name: name,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    "data-testid": dataTestId,
    required: required
  }), React.createElement(LabelWrapper$2, Object.assign({
    className: className,
    htmlFor: inputID
  }, dataTestId && {
    'data-testid': "".concat(dataTestId, "_label_wrapper")
  }, {
    "$disabled": disabled
  }), React.createElement(Check, {
    "data-testid": "check-component",
    checked: checked,
    "$hasError": !!errorMessage,
    "$disabled": disabled
  }, checked && React.createElement(IconContainer, null, React.createElement(Icon, {
    icon: "check",
    color: "icon-form-checkbox",
    width: token('width-checkbox-radio'),
    "aria-hidden": true
  }))), React.createElement(Label$2, Object.assign({
    id: labelID,
    label: label,
    labelHeader: labelHeader,
    disabled: disabled
  }, dataTestId && {
    'data-testid': "".concat(dataTestId, "_label")
  }))), message && React.createElement(InputMessage, {
    id: messageID,
    disableScreenReaderAlert: disableScreenReaderAlert,
    "data-testid": "".concat(dataTestId, "_message"),
    hasError: !!errorMessage,
    disabled: disabled
  }, message));
};

var ChipContainer = styled.div(_templateObject92(), function (p) {
  return p.theme.token('background-chip');
}, function (p) {
  return p.theme.token('text-reversed');
}, function (p) {
  return p.theme.token('text-style-chip');
}, function (p) {
  return p.$roundedCorners ? '12px' : p.theme.token('border-radius-chip');
}, function (p) {
  return p.theme.token('height-chip');
}, primitive.$spacing2);
var ChipText = styled.p(_templateObject93(), function (p) {
  return p.$hasIcon ? primitive.$spacing1 : 0;
});

var Chip = function Chip(_ref90) {
  var children = _ref90.children,
      iconProp = _ref90.icon,
      roundedCorners = _ref90.roundedCorners,
      dataTestId = _ref90['data-testid'],
      ariaLabel = _ref90['aria-label'];

  var _useTheme2 = useTheme(),
      token = _useTheme2.token;

  var icon = null;

  if (iconProp && !roundedCorners) {
    icon = React.createElement(Icon, {
      icon: iconProp,
      color: "icon-reversed",
      "aria-hidden": true,
      width: token('width-icon-small'),
      height: token('height-icon-small'),
      "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-icon") : undefined
    });
  }

  return React.createElement(ChipContainer, {
    "$roundedCorners": roundedCorners,
    "data-testid": dataTestId,
    "aria-label": ariaLabel
  }, icon, React.createElement(ChipText, {
    "$hasIcon": !!icon
  }, children));
};

var FieldSetWrapper = styled.fieldset(_templateObject94(), primitive.$spacing2, primitive.$spacing6);
var Legend = styled.legend(_templateObject95(), function (p) {
  return p.theme.token('text-style-form-legend');
}, function (p) {
  return p.theme.token('text-default');
}, primitive.$spacing3, function (p) {
  return p.$disabled && css(_templateObject96(), p.theme.token('text-disabled'));
}, function (p) {
  return p.$hasError && css(_templateObject97(), p.theme.token('text-error'));
});
/** Negates the spacing added by form field bottom margin */

var FieldSetMessage = styled.div(_templateObject98(), primitive.$spacing4);
/**
 * Groups several form fields and their labels together
 */

var FieldSet = function FieldSet(_ref91) {
  var disabled = _ref91.disabled,
      legend = _ref91.legend,
      children = _ref91.children,
      errorMessage = _ref91.errorMessage,
      hintMessage = _ref91.hintMessage,
      messageIdProp = _ref91.messageId,
      testId = _ref91['data-testid'];
  var defaultMessageId = useIdCounter('fieldset-message');
  var messageId = messageIdProp || defaultMessageId;
  return React.createElement(FieldSetWrapper, {
    disabled: disabled
  }, React.createElement(Legend, {
    "$disabled": disabled,
    "$hasError": !!errorMessage
  }, legend), children, React.createElement(FieldSetMessage, null, React.createElement(InputMessage, {
    disabled: disabled,
    id: messageId,
    hasError: !!errorMessage,
    "data-testid": testId
  }, errorMessage || hintMessage)));
};
/**
 * A component for entering simple text information such as names, addresses,
 * search queries, email addresses, passwords or urls
 */


var TextInput = React__default.forwardRef(function (_ref92, forwardedRef) {
  var testId = _ref92['data-testid'],
      disableScreenReaderAlert = _ref92.disableScreenReaderAlert,
      errorMessage = _ref92.errorMessage,
      _ref92$footer = _ref92.footer,
      footer = _ref92$footer === void 0 ? null : _ref92$footer,
      forceErrorState = _ref92.forceErrorState,
      hintMessage = _ref92.hintMessage,
      icon = _ref92.icon,
      label = _ref92.label,
      labelId = _ref92.labelId,
      ariaDescribedBy = _ref92['aria-describedby'],
      ariaLabel = _ref92['aria-label'],
      autoComplete = _ref92.autoComplete,
      autoFocus = _ref92.autoFocus,
      className = _ref92.className,
      disabled = _ref92.disabled,
      id = _ref92.id,
      inputMode = _ref92.inputMode,
      max = _ref92.max,
      maxLength = _ref92.maxLength,
      min = _ref92.min,
      name = _ref92.name,
      onAnimationStart = _ref92.onAnimationStart,
      onBlur = _ref92.onBlur,
      onChange = _ref92.onChange,
      onFocus = _ref92.onFocus,
      onInvalid = _ref92.onInvalid,
      pattern = _ref92.pattern,
      readOnly = _ref92.readOnly,
      required = _ref92.required,
      style = _ref92.style,
      _ref92$type = _ref92.type,
      type = _ref92$type === void 0 ? 'text' : _ref92$type,
      value = _ref92.value,
      mask = _ref92.mask,
      guide = _ref92.guide,
      placeholderChar = _ref92.placeholderChar;
  var defaultInputId = useIdCounter('floating-label-input');
  var messageId = useIdCounter('message');
  var inputId = id !== null && id !== void 0 ? id : defaultInputId;

  var genId = function genId(suffix) {
    return testId ? "".concat(testId, "-").concat(suffix) : undefined;
  };

  var wrapperTestId = genId('wrapper');
  var labelTestId = genId('label');
  var messageTestId = genId('message');

  var _useForwardedRefLocal2 = useForwardedRefLocally(forwardedRef),
      localRef = _useForwardedRefLocal2.localRef,
      refForProps = _useForwardedRefLocal2.refForProps;

  var _useNativeInvalidDete = useNativeInvalidDetector(localRef, onInvalid),
      isNativeInvalid = _useNativeInvalidDete.isNativeInvalid,
      handleInvalid = _useNativeInvalidDete.handleInvalid;

  var _useAutofillDetector2 = useAutofillDetector(onAnimationStart),
      isAutofilled = _useAutofillDetector2.isAutofilled,
      handleAnimationStart = _useAutofillDetector2.handleAnimationStart;

  var _useFocusDetector2 = useFocusDetector({
    onBlur: onBlur,
    onFocus: onFocus
  }),
      handleBlur = _useFocusDetector2.handleBlur,
      handleFocus = _useFocusDetector2.handleFocus,
      isFocused = _useFocusDetector2.isFocused;

  var stateAttrs = {
    $disabled: disabled || !!readOnly,
    $focused: isFocused,
    $autofilled: isAutofilled,
    $hasError: forceErrorState || !!errorMessage || isNativeInvalid,
    $hasValue: !!value,
    $isDate: type === 'date',
    $iconCount: React__default.Children.count(icon)
  };
  var maskProps = useMemo(function () {
    return mask ? {
      render: function render(internalRef, props) {
        // react-text-mask manages its own ref via this render method
        // in order to reference this input and allow react-text-mask
        // to reference it as well, this function assigns our own ref,
        // then passes the component along to react-text-mask's ref callback
        // because the ref being passed from parent (through forwardRef)
        // is lost during this exchange, so we assign innerInput to our ref
        var refCallback = function refCallback(innerInput) {
          refForProps(innerInput);
          internalRef(innerInput);
        };

        return React__default.createElement("input", Object.assign({
          ref: refCallback
        }, props));
      },
      guide: guide,
      placeholderChar: placeholderChar
    } : {
      ref: refForProps
    };
  }, [guide, mask, placeholderChar, refForProps]);
  return React__default.createElement(TextFieldWrapper, {
    className: className,
    "data-testid": wrapperTestId
  }, React__default.createElement(TextFieldInner, Object.assign({}, stateAttrs), React__default.createElement(TextFieldLabel, Object.assign({}, stateAttrs, {
    id: labelId,
    htmlFor: inputId,
    "data-testid": labelTestId
  }), getRequiredLabel(label, required)), React__default.createElement(StyledTextInput, Object.assign({}, stateAttrs, maskProps, {
    "aria-describedby": combineAttributeStrings(hintMessage || errorMessage ? messageId : undefined, ariaDescribedBy),
    "aria-invalid": stateAttrs.$hasError || undefined,
    "aria-label": ariaLabel,
    as: mask ? MaskedInput : undefined,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    "data-private": true,
    "data-testid": testId,
    disabled: disabled,
    id: inputId,
    inputMode: inputMode,
    mask: mask,
    max: max,
    maxLength: maxLength,
    min: min,
    name: name,
    onAnimationStart: handleAnimationStart,
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus,
    onInvalid: handleInvalid,
    pattern: pattern,
    readOnly: readOnly,
    required: required,
    style: style,
    type: type,
    value: value
  })), icon && React__default.createElement(IconStyles // Prevent clicks to icons within from stealing focus from the
  // input, but still allow keyboard focus
  , {
    // Prevent clicks to icons within from stealing focus from the
    // input, but still allow keyboard focus
    onMouseDownCapture: function onMouseDownCapture(event) {
      return event.preventDefault();
    },
    onMouseUpCapture: function onMouseUpCapture(event) {
      var _a;

      event.preventDefault(); // Gives focus to the text input after clicking a button. The
      // preventDefault from the mouseDown will prevent icons from
      // stealing focus from the input, but this ensures that the text
      // input ends up with focus even if it didn't start with it

      (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, React__default.Children.map(icon, function (el) {
    return React__default.isValidElement(el) ? React__default.cloneElement(el, stateAttrs) : el;
  }))), footer, (errorMessage || hintMessage) && React__default.createElement(InputMessage, {
    id: messageId,
    disableScreenReaderAlert: disableScreenReaderAlert,
    "data-testid": messageTestId,
    hasError: !!errorMessage,
    disabled: stateAttrs.$disabled
  }, errorMessage || hintMessage));
});
var InputGroup = styled.div(_templateObject99(), primitive.$spacing2, primitive.$spacing6, primitive.$spacing2);
var AUTOCOMPLETE_MAP = {
  bday: {
    year: 'bday-year',
    month: 'bday-month',
    day: 'bday-day'
  }
};
/**
 * Allows entry of a date via text inputs for year, month, day
 */

var DateInput = function DateInput(_ref93) {
  var day = _ref93.day,
      disabled = _ref93.disabled,
      hintMessage = _ref93.hintMessage,
      errorMessage = _ref93.errorMessage,
      month = _ref93.month,
      onBlur = _ref93.onBlur,
      onChangeProp = _ref93.onChange,
      required = _ref93.required,
      name = _ref93.name,
      autoCompleteProp = _ref93.autoComplete,
      testId = _ref93['data-testid'],
      year = _ref93.year,
      label = _ref93.label,
      labelYear = _ref93.labelYear,
      labelMonth = _ref93.labelMonth,
      labelDay = _ref93.labelDay,
      labelYearFormat = _ref93.labelYearFormat,
      labelMonthFormat = _ref93.labelMonthFormat,
      labelDayFormat = _ref93.labelDayFormat;
  var messageId = useIdCounter('message');
  var inputGroupRef = useRef(null);
  var autoComplete = AUTOCOMPLETE_MAP[autoCompleteProp] || {};
  var onChange = useCallback(function (event) {
    // Prevent non-numeric values from being entered
    if (!event.target.value.match(/^\d*$/)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    onChangeProp(event);
  }, [onChangeProp]);
  /**
   * Only emits blur if clicking away from the input group input fields.
   *
   * This is required to prevent validation while inputs are being filled.
   */

  var handleBlur = useCallback(function (event) {
    var _a;

    if (!((_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }
  }, [onBlur]);
  return React__default.createElement(FieldSet, {
    disabled: disabled,
    legend: getRequiredLabel(label, required),
    messageId: messageId,
    errorMessage: errorMessage,
    hintMessage: hintMessage,
    "data-testid": testId ? "".concat(testId, "-message") : undefined
  }, React__default.createElement(InputGroup, {
    ref: inputGroupRef
  }, React__default.createElement(TextInput, {
    type: "text",
    maxLength: 4,
    inputMode: "numeric",
    pattern: "[0-9]*",
    autoComplete: autoComplete.year,
    label: labelYear,
    "aria-label": "".concat(label, " ").concat(labelYear),
    name: name ? "".concat(name, "[year]") : 'year',
    value: year,
    onChange: onChange,
    forceErrorState: !!errorMessage,
    hintMessage: !errorMessage ? labelYearFormat : undefined,
    "data-testid": testId ? "".concat(testId, "-year") : undefined,
    disabled: disabled,
    onBlur: handleBlur,
    "aria-describedby": messageId
  }), React__default.createElement(TextInput, {
    type: "text",
    maxLength: 2,
    inputMode: "numeric",
    pattern: "[0-9]*",
    autoComplete: autoComplete.month,
    label: labelMonth,
    "aria-label": "".concat(label, " ").concat(labelMonth),
    name: name ? "".concat(name, "[month]") : 'month',
    value: month,
    onChange: onChange,
    forceErrorState: !!errorMessage,
    hintMessage: !errorMessage ? labelMonthFormat : undefined,
    "data-testid": testId ? "".concat(testId, "-month") : undefined,
    disabled: disabled,
    onBlur: handleBlur,
    "aria-describedby": messageId
  }), React__default.createElement(TextInput, {
    type: "text",
    maxLength: 2,
    inputMode: "numeric",
    pattern: "[0-9]*",
    autoComplete: autoComplete.day,
    label: labelDay,
    "aria-label": "".concat(label, " ").concat(labelDay),
    name: name ? "".concat(name, "[day]") : 'day',
    value: day,
    onChange: onChange,
    forceErrorState: !!errorMessage,
    hintMessage: !errorMessage ? labelDayFormat : undefined,
    "data-testid": testId ? "".concat(testId, "-day") : undefined,
    disabled: disabled,
    onBlur: handleBlur,
    "aria-describedby": messageId
  })));
};

var StyledOverlay = styled(DialogBackdrop)(_templateObject100(), primitive.$blackOpacity70);
var StyledDialog = styled(Dialog$1)(_templateObject101(), primitive.$spacing0, primitive.$spacing7, primitive.$spacing6, primitive.$spacing4, function (p) {
  return p.theme.token('background-pattern');
}, function (p) {
  return p.theme.token('border-radius-pattern');
}, mediaQuery.tablet, primitive.$spacing8, primitive.$spacing8, primitive.$spacing6);
var StyledInformationDialog = styled(StyledDialog)(_templateObject102());
var DialogHeader = styled.h2(_templateObject103(), function (p) {
  return p.theme.token('text-style-dialog-header');
}, function (p) {
  return p.theme.token('text-default');
}, primitive.$spacing3);
var StyledInformationDialogBody = styled.p(_templateObject104(), function (p) {
  return p.theme.token('text-style-dialog-copy');
}, function (p) {
  return p.theme.token('text-default');
});
var StyledDialogBody = styled(StyledInformationDialogBody)(_templateObject105(), primitive.$spacing5, mediaQuery.tablet, primitive.$spacing6);
/**
 *
 * @param {object} dialog - Use the useDialogUIState to control the state of the dialog. "const dialog = useDialogUIState()".
 * @param {string} ariaLabel - The label for the dialog that will be read to screen readers.
 * @param {string} headerText - (Only for 1 or more buttons) header text for the dialog.
 * @param {string | {node: React.ReactNode}} bodyText - The body text of the dialog.
 * @param {IButton} buttons - array of objects containing text, and onClick props for each button.
 * @param {string} closeButtonText - Text for the button that closes the dialog (can also use esc key or click outside dialog).
 * @param {boolean} allButtonsEquallyPreferred - When enabled, switches the first button to a secondary button (only applies for three or more buttons.)
 * @param onDismiss - Optional function to run when closing the dialog.
 */

var Dialog = function Dialog(_ref94) {
  var ariaLabel = _ref94['aria-label'],
      dataTestId = _ref94['data-testid'],
      bodyText = _ref94.bodyText,
      buttons = _ref94.buttons,
      closeButtonText = _ref94.closeButtonText,
      _ref94$allButtonsEqua = _ref94.allButtonsEquallyPreferred,
      allButtonsEquallyPreferred = _ref94$allButtonsEqua === void 0 ? false : _ref94$allButtonsEqua,
      headerText = _ref94.headerText,
      onDismiss = _ref94.onDismiss,
      dialog = _ref94.dialog;

  /**
   * Triggers onDismiss() when user closes the modal.
   * Necessary as users can close via esc key, clicks outside the dialog, or clicks the close button.
   */
  var shouldRunDismissFn = React.useRef(false);
  var onRequestedClose = React.useCallback(function () {
    onDismiss && onDismiss();
    dialog.hide();
  }, [onDismiss, dialog]); // Runs onRequestedClose if the dialog is not visible, and if shouldRunDismiss.current is true

  React.useEffect(function () {
    if (!dialog.visible && shouldRunDismissFn.current) {
      onRequestedClose();
      shouldRunDismissFn.current = false;
    }
  }, [dialog.visible, onRequestedClose, shouldRunDismissFn]); // Prevents us from running onRequestedClose() on the initial render

  if (dialog.visible) {
    shouldRunDismissFn.current = true;
  }

  if (!bodyText || !closeButtonText || !ariaLabel) {
    return null;
  }

  if (!(buttons === null || buttons === void 0 ? void 0 : buttons.length)) {
    return React.createElement(StyledOverlay, Object.assign({}, dialog), React.createElement(StyledInformationDialog, Object.assign({}, dialog, {
      "data-testid": dataTestId,
      "aria-label": ariaLabel
    }), React.createElement(StyledInformationDialogBody, null, bodyText), React.createElement(TertiaryButton, {
      onClick: function onClick() {
        return dialog.hide();
      }
    }, closeButtonText)));
  }

  if (!headerText) {
    return null;
  }

  var ButtonComponents = (buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) {
    var onClick = button.onClick,
        text = button.text;

    function onConfirm(event) {
      // Don't run the onDismiss function when we click one of the confirmation buttons
      shouldRunDismissFn.current = false;
      onClick(event);
      dialog.hide();
    }

    if (index === 0 && (!allButtonsEquallyPreferred || buttons.length < 3)) {
      return React.createElement(PrimaryButton, {
        fullWidth: true,
        key: index,
        onClick: onConfirm
      }, text);
    }

    return React.createElement(SecondaryButton, {
      fullWidth: true,
      key: index,
      onClick: onConfirm
    }, text);
  })) || null;
  return React.createElement(StyledOverlay, Object.assign({}, dialog), React.createElement(StyledDialog, Object.assign({}, dialog, {
    "data-testid": dataTestId,
    "aria-label": ariaLabel
  }), React.createElement(DialogHeader, null, headerText), React.createElement(StyledDialogBody, null, bodyText), ButtonComponents, React.createElement(TertiaryButton, {
    fullWidth: true,
    onClick: function onClick() {
      return dialog.hide();
    }
  }, closeButtonText)));
};

var useDialogUIState = function useDialogUIState() {
  var dialog = useDialogState();
  return dialog;
};

var Grid = styled.div(_templateObject106(), COLUMNS_MOBILE, primitive.$spacing4, mediaQuery.tablet, COLUMNS_TABLET, mediaQuery.desktopSmall, COLUMNS_DESKTOP_SMALL, mediaQuery.desktopLarge, COLUMNS_DESKTOP_LARGE);
var Container$1 = styled.footer(_templateObject107(), function (p) {
  return p.theme.token('background-footer');
});
var TopHalfWrapper = styled(Grid)(_templateObject108(), primitive.$spacing8, primitive.$spacing7, mediaQuery.desktopLarge, primitive.$spacing10, primitive.$spacing8);
var BrandIconContainer = styled.div(_templateObject109(), mediaQuery.desktopSmall, mediaQuery.desktopLarge);
var NavLinksContainer = styled.div(_templateObject110(), primitive.$spacing7, primitive.$spacing3, mediaQuery.tablet, mediaQuery.desktopSmall, primitive.$spacing0, mediaQuery.desktopLarge, primitive.$spacing4);
var StyledMainLink = styled.a(_templateObject111(), function (p) {
  return p.theme.token('text-style-footer-large');
}, function (p) {
  return p.theme.token('text-link-reversed');
});
var MiscLinksContainerLeft = styled.div(_templateObject112(), primitive.$spacing3, mediaQuery.tablet, mediaQuery.desktopSmall, mediaQuery.desktopLarge, primitive.$spacing2);
var MiscLinksContainerRight = styled.div(_templateObject113(), primitive.$spacing3, mediaQuery.tablet, mediaQuery.desktopSmall, mediaQuery.desktopLarge, primitive.$spacing2);
var StyledMiscLink = styled.a(_templateObject114(), function (p) {
  return p.theme.token('text-style-footer-small');
}, function (p) {
  return p.theme.token('text-link-reversed');
});
var StyledHR = styled.hr(_templateObject115(), function (p) {
  return p.theme.token('border-color-reversed');
}, mediaQuery.desktopLarge);
var BottomHalfWrapper = styled.div(_templateObject116(), primitive.$spacing7, primitive.$spacing8, primitive.$spacing6, mediaQuery.desktopSmall, mediaQuery.desktopLarge, primitive.$spacing7, primitive.$spacing0, primitive.$spacing8);
var MiniIconsContainer = styled.div(_templateObject117(), primitive.$spacing7);
var CopyrightAndLanguageSelectorContainer = styled.div(_templateObject118(), mediaQuery.tablet, mediaQuery.desktopSmall);
var Copyright = styled.p(_templateObject119(), function (p) {
  return p.theme.token('text-style-footer-small');
}, function (p) {
  return p.theme.token('text-link-reversed');
}, primitive.$spacing6, mediaQuery.tablet);
var LanguageSelectorWrapper = styled.div(_templateObject120(), function (p) {
  return p.theme.token('text-style-footer-small');
}, function (p) {
  return p.theme.token('text-link-reversed');
}, mediaQuery.tablet, mediaQuery.desktopSmall, primitive.$spacing7);
var BaseBox = styled.div(_templateObject121(), function (p) {
  return p.show ? 'flex' : 'none';
}, function (p) {
  return p.center ? 'center' : p.align;
}, function (p) {
  return p.center ? 'center' : p.alignContent;
}, function (p) {
  return p.alignSelf;
}, function (p) {
  return p.center ? 'center' : p.justify;
}, function (p) {
  return p.flexDirection;
}, function (p) {
  return p.flexWrap;
}, function (p) {
  return p.overflow;
}, function (p) {
  return p.position;
}, function (p) {
  return p.zIndex;
}, function (p) {
  return p.left;
}, function (p) {
  return p.top;
}, function (p) {
  return p.bottom;
}, function (p) {
  return p.right;
}, function (p) {
  return p.margin;
}, function (p) {
  return p.padding;
}, function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.maxWidth;
}, function (p) {
  return p.maxHeight;
}, function (p) {
  return p.minWidth;
}, function (p) {
  return p.minHeight;
}, function (_ref95) {
  var theme = _ref95.theme,
      background = _ref95.background;

  var _a;

  return background ? ((_a = theme.color) === null || _a === void 0 ? void 0 : _a[background]) || background : 'transparent';
}, function (p) {
  return p.borderWidth;
}, function (p) {
  return p.borderStyle;
}, function (p) {
  return p.borderColor;
}, function (p) {
  return p.borderRadius;
}, function (p) {
  return p.boxShadow;
});

var Box = function Box(_ref96) {
  var children = _ref96.children,
      _ref96$center = _ref96.center,
      center = _ref96$center === void 0 ? false : _ref96$center,
      _ref96$show = _ref96.show,
      show = _ref96$show === void 0 ? true : _ref96$show,
      _ref96$align = _ref96.align,
      align = _ref96$align === void 0 ? 'stretch' : _ref96$align,
      _ref96$alignContent = _ref96.alignContent,
      alignContent = _ref96$alignContent === void 0 ? 'stretch' : _ref96$alignContent,
      _ref96$alignSelf = _ref96.alignSelf,
      alignSelf = _ref96$alignSelf === void 0 ? 'auto' : _ref96$alignSelf,
      _ref96$justify = _ref96.justify,
      justify = _ref96$justify === void 0 ? 'flex-start' : _ref96$justify,
      _ref96$flexDirection = _ref96.flexDirection,
      flexDirection = _ref96$flexDirection === void 0 ? 'row' : _ref96$flexDirection,
      _ref96$flexWrap = _ref96.flexWrap,
      flexWrap = _ref96$flexWrap === void 0 ? 'nowrap' : _ref96$flexWrap,
      _ref96$overflow = _ref96.overflow,
      overflow = _ref96$overflow === void 0 ? 'visible' : _ref96$overflow,
      _ref96$zIndex = _ref96.zIndex,
      zIndex = _ref96$zIndex === void 0 ? 'auto' : _ref96$zIndex,
      _ref96$position = _ref96.position,
      position = _ref96$position === void 0 ? 'static' : _ref96$position,
      _ref96$left = _ref96.left,
      left = _ref96$left === void 0 ? 'auto' : _ref96$left,
      _ref96$top = _ref96.top,
      top = _ref96$top === void 0 ? 'auto' : _ref96$top,
      _ref96$bottom = _ref96.bottom,
      bottom = _ref96$bottom === void 0 ? 'auto' : _ref96$bottom,
      _ref96$right = _ref96.right,
      right = _ref96$right === void 0 ? 'auto' : _ref96$right,
      _ref96$margin = _ref96.margin,
      margin = _ref96$margin === void 0 ? '0' : _ref96$margin,
      _ref96$padding = _ref96.padding,
      padding = _ref96$padding === void 0 ? '0' : _ref96$padding,
      _ref96$width = _ref96.width,
      width = _ref96$width === void 0 ? 'auto' : _ref96$width,
      _ref96$height = _ref96.height,
      height = _ref96$height === void 0 ? 'auto' : _ref96$height,
      _ref96$maxWidth = _ref96.maxWidth,
      maxWidth = _ref96$maxWidth === void 0 ? 'none' : _ref96$maxWidth,
      _ref96$maxHeight = _ref96.maxHeight,
      maxHeight = _ref96$maxHeight === void 0 ? 'none' : _ref96$maxHeight,
      _ref96$minWidth = _ref96.minWidth,
      minWidth = _ref96$minWidth === void 0 ? '0' : _ref96$minWidth,
      _ref96$minHeight = _ref96.minHeight,
      minHeight = _ref96$minHeight === void 0 ? '0' : _ref96$minHeight,
      _ref96$background = _ref96.background,
      background = _ref96$background === void 0 ? 'initial' : _ref96$background,
      _ref96$borderWidth = _ref96.borderWidth,
      borderWidth = _ref96$borderWidth === void 0 ? '0' : _ref96$borderWidth,
      _ref96$borderStyle = _ref96.borderStyle,
      borderStyle = _ref96$borderStyle === void 0 ? 'none' : _ref96$borderStyle,
      _ref96$borderColor = _ref96.borderColor,
      borderColor = _ref96$borderColor === void 0 ? 'transparent' : _ref96$borderColor,
      _ref96$borderRadius = _ref96.borderRadius,
      borderRadius = _ref96$borderRadius === void 0 ? '0' : _ref96$borderRadius,
      _ref96$boxShadow = _ref96.boxShadow,
      boxShadow = _ref96$boxShadow === void 0 ? 'none' : _ref96$boxShadow;
  return React__default.createElement(BaseBox, {
    center: center,
    show: show,
    align: align,
    alignContent: alignContent,
    alignSelf: alignSelf,
    justify: justify,
    flexDirection: flexDirection,
    flexWrap: flexWrap,
    overflow: overflow,
    zIndex: zIndex,
    position: position,
    left: left,
    top: top,
    bottom: bottom,
    right: right,
    margin: margin,
    padding: padding,
    width: width,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    minWidth: minWidth,
    minHeight: minHeight,
    background: background,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    borderRadius: borderRadius,
    boxShadow: boxShadow
  }, children);
};

var Panel = function Panel(_ref97) {
  var children = _ref97.children,
      _ref97$center = _ref97.center,
      center = _ref97$center === void 0 ? false : _ref97$center,
      _ref97$show = _ref97.show,
      show = _ref97$show === void 0 ? true : _ref97$show,
      _ref97$align = _ref97.align,
      align = _ref97$align === void 0 ? 'stretch' : _ref97$align,
      _ref97$alignContent = _ref97.alignContent,
      alignContent = _ref97$alignContent === void 0 ? 'stretch' : _ref97$alignContent,
      _ref97$justify = _ref97.justify,
      justify = _ref97$justify === void 0 ? 'flex-start' : _ref97$justify,
      _ref97$flexWrap = _ref97.flexWrap,
      flexWrap = _ref97$flexWrap === void 0 ? 'nowrap' : _ref97$flexWrap,
      _ref97$overflow = _ref97.overflow,
      overflow = _ref97$overflow === void 0 ? 'visible' : _ref97$overflow,
      _ref97$margin = _ref97.margin,
      margin = _ref97$margin === void 0 ? '0' : _ref97$margin,
      _ref97$padding = _ref97.padding,
      padding = _ref97$padding === void 0 ? '0' : _ref97$padding,
      _ref97$height = _ref97.height,
      height = _ref97$height === void 0 ? 'auto' : _ref97$height,
      _ref97$maxHeight = _ref97.maxHeight,
      maxHeight = _ref97$maxHeight === void 0 ? 'none' : _ref97$maxHeight,
      _ref97$minHeight = _ref97.minHeight,
      minHeight = _ref97$minHeight === void 0 ? 'none' : _ref97$minHeight,
      _ref97$background = _ref97.background,
      background = _ref97$background === void 0 ? 'initial' : _ref97$background,
      _ref97$borderWidth = _ref97.borderWidth,
      borderWidth = _ref97$borderWidth === void 0 ? '0' : _ref97$borderWidth,
      _ref97$borderStyle = _ref97.borderStyle,
      borderStyle = _ref97$borderStyle === void 0 ? 'none' : _ref97$borderStyle,
      _ref97$borderColor = _ref97.borderColor,
      borderColor = _ref97$borderColor === void 0 ? 'transparent' : _ref97$borderColor,
      _ref97$borderRadius = _ref97.borderRadius,
      borderRadius = _ref97$borderRadius === void 0 ? '0' : _ref97$borderRadius;
  return React__default.createElement(Box, {
    center: center,
    show: show,
    align: align,
    alignContent: alignContent,
    alignSelf: "auto",
    justify: justify,
    flexDirection: "row",
    flexWrap: flexWrap,
    overflow: overflow,
    zIndex: "auto",
    position: "static",
    left: "0",
    top: "0",
    margin: margin,
    padding: padding,
    width: "100%",
    height: height,
    maxWidth: "none",
    maxHeight: maxHeight,
    minWidth: "none",
    minHeight: minHeight,
    background: background,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    borderRadius: borderRadius
  }, children);
};

var BaseContainer = styled(Box)(_templateObject122());

var Container = function Container(_ref98) {
  var children = _ref98.children,
      _ref98$center = _ref98.center,
      center = _ref98$center === void 0 ? false : _ref98$center,
      _ref98$show = _ref98.show,
      show = _ref98$show === void 0 ? true : _ref98$show,
      _ref98$align = _ref98.align,
      align = _ref98$align === void 0 ? 'stretch' : _ref98$align,
      _ref98$alignContent = _ref98.alignContent,
      alignContent = _ref98$alignContent === void 0 ? 'stretch' : _ref98$alignContent,
      _ref98$justify = _ref98.justify,
      justify = _ref98$justify === void 0 ? 'flex-start' : _ref98$justify,
      _ref98$flexWrap = _ref98.flexWrap,
      flexWrap = _ref98$flexWrap === void 0 ? 'nowrap' : _ref98$flexWrap,
      _ref98$overflow = _ref98.overflow,
      overflow = _ref98$overflow === void 0 ? 'visible' : _ref98$overflow,
      _ref98$margin = _ref98.margin,
      margin = _ref98$margin === void 0 ? '0' : _ref98$margin,
      _ref98$padding = _ref98.padding,
      padding = _ref98$padding === void 0 ? '0' : _ref98$padding,
      _ref98$width = _ref98.width,
      width = _ref98$width === void 0 ? 'auto' : _ref98$width,
      _ref98$maxWidth = _ref98.maxWidth,
      maxWidth = _ref98$maxWidth === void 0 ? 'none' : _ref98$maxWidth,
      _ref98$minWidth = _ref98.minWidth,
      minWidth = _ref98$minWidth === void 0 ? 'none' : _ref98$minWidth,
      _ref98$background = _ref98.background,
      background = _ref98$background === void 0 ? 'initial' : _ref98$background,
      _ref98$borderWidth = _ref98.borderWidth,
      borderWidth = _ref98$borderWidth === void 0 ? '0' : _ref98$borderWidth,
      _ref98$borderStyle = _ref98.borderStyle,
      borderStyle = _ref98$borderStyle === void 0 ? 'none' : _ref98$borderStyle,
      _ref98$borderColor = _ref98.borderColor,
      borderColor = _ref98$borderColor === void 0 ? 'transparent' : _ref98$borderColor,
      _ref98$borderRadius = _ref98.borderRadius,
      borderRadius = _ref98$borderRadius === void 0 ? '0' : _ref98$borderRadius;
  return React__default.createElement(BaseContainer, {
    center: center,
    show: show,
    align: align,
    alignContent: alignContent,
    alignSelf: "auto",
    justify: justify,
    flexDirection: "column",
    flexWrap: flexWrap,
    overflow: overflow,
    zIndex: "auto",
    position: "static",
    left: "0",
    top: "0",
    margin: margin,
    padding: padding,
    width: width,
    height: "auto",
    maxWidth: maxWidth,
    maxHeight: "none",
    minHeight: "none",
    minWidth: minWidth,
    background: background,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    borderRadius: borderRadius
  }, children);
};

var SocialMediaLink = React.forwardRef(function (_ref99, forwardedRef) {
  var href = _ref99.href,
      icon = _ref99.icon;

  if (!href || !icon) {
    return null;
  }

  return React.createElement("a", {
    href: href,
    ref: forwardedRef
  }, React.createElement(Box, {
    height: '20px'
  }, React.createElement(Icon, {
    hoverColor: 'icon-active',
    color: 'text-link-reversed',
    icon: icon,
    title: icon
  })));
});
/**
 * To add  a new social media link:
 *  1. Add new Icon in component library
 *  2. Add link for the icon here
 *  3. Add data to CMS
 */

var SocialMediaLinks = function SocialMediaLinks(_ref100) {
  var socialMediaData = _ref100.socialMediaData;
  var facebookUrl = socialMediaData.facebookUrl,
      instagramUrl = socialMediaData.instagramUrl,
      tiktokUrl = socialMediaData.tiktokUrl,
      twitterUrl = socialMediaData.twitterUrl,
      youtubeUrl = socialMediaData.youtubeUrl;
  return React.createElement(React.Fragment, null, (facebookUrl === null || facebookUrl === void 0 ? void 0 : facebookUrl.locale) && React.createElement(SocialMediaLink, {
    icon: 'facebook',
    href: facebookUrl.locale
  }), (instagramUrl === null || instagramUrl === void 0 ? void 0 : instagramUrl.locale) && React.createElement(SocialMediaLink, {
    icon: 'instagram',
    href: instagramUrl.locale
  }), (tiktokUrl === null || tiktokUrl === void 0 ? void 0 : tiktokUrl.locale) && React.createElement(SocialMediaLink, {
    icon: 'tiktok',
    href: tiktokUrl.locale
  }), (twitterUrl === null || twitterUrl === void 0 ? void 0 : twitterUrl.locale) && React.createElement(SocialMediaLink, {
    icon: 'twitter',
    href: twitterUrl.locale
  }), (youtubeUrl === null || youtubeUrl === void 0 ? void 0 : youtubeUrl.locale) && React.createElement(SocialMediaLink, {
    icon: 'youtube',
    href: youtubeUrl.locale
  }));
};

var Links = function Links(_ref101) {
  var links = _ref101.links,
      LinkComponent = _ref101.LinkComponent,
      _onClick = _ref101.onClick;
  return React.createElement(React.Fragment, null, links.map(function (_ref102) {
    var locale = _ref102.locale,
        text = _ref102.text,
        _key = _ref102._key;

    if (!locale || !text || !_key) {
      return null;
    }

    return React.createElement(LinkComponent, {
      href: locale,
      key: _key,
      onClick: function onClick(event) {
        return _onClick(event, locale);
      }
    }, text);
  }));
};
/**
 * Footer Component
 */


var Footer = function Footer(_ref103) {
  var id = _ref103.id,
      copyrightText = _ref103.copyrightText,
      onClick = _ref103.onClick,
      mainLinks = _ref103.mainLinks,
      miscellaneousLinks = _ref103.miscellaneousLinks,
      localeSelector = _ref103.localeSelector,
      socialMediaData = _ref103.socialMediaData;

  if (!mainLinks || !miscellaneousLinks.length || !copyrightText) {
    return null;
  }

  var length = miscellaneousLinks.length;
  var half = Math.ceil(length / 2);
  var leftLinks = miscellaneousLinks.slice(0, half);
  var rightLinks = miscellaneousLinks.slice(half);
  return React.createElement(React.Fragment, null, React.createElement(Container$1, null, React.createElement(TopHalfWrapper, {
    id: id
  }, React.createElement(BrandIconContainer, null, React.createElement(Icon, {
    "aria-hidden": true,
    icon: 'logo',
    color: 'text-link-reversed',
    height: '80px',
    width: '80px'
  })), React.createElement(NavLinksContainer, null, React.createElement(Links, {
    links: mainLinks,
    LinkComponent: StyledMainLink,
    onClick: onClick
  })), React.createElement(MiscLinksContainerLeft, null, React.createElement(Links, {
    links: leftLinks,
    LinkComponent: StyledMiscLink,
    onClick: onClick
  })), React.createElement(MiscLinksContainerRight, null, React.createElement(Links, {
    links: rightLinks,
    LinkComponent: StyledMiscLink,
    onClick: onClick
  }))), React.createElement(StyledHR, null), React.createElement(BottomHalfWrapper, null, React.createElement(MiniIconsContainer, null, React.createElement(SocialMediaLinks, {
    socialMediaData: socialMediaData
  })), React.createElement(CopyrightAndLanguageSelectorContainer, null, React.createElement(Copyright, null, copyrightText), localeSelector && React.createElement(LanguageSelectorWrapper, null, localeSelector)))));
};

var heroHeaderId = 'hero-header-wrapper';
var heroSubheaderId = 'hero-subheader-wrapper';
var heroImageId = 'hero-image-wrapper';

var HeroCta = function HeroCta(_ref104) {
  var ariaDecribedBy = _ref104['aria-describedby'],
      as = _ref104.as,
      Button = _ref104.Button,
      children = _ref104.children,
      fullWidth = _ref104.fullWidth,
      href = _ref104.href,
      onClick = _ref104.onClick,
      reversed = _ref104.reversed;
  var props = {
    'aria-describedby': ariaDecribedBy,
    fullWidth: fullWidth,
    reversed: reversed,
    children: children,
    onClick: onClick
  }; // Unfortunately the function signature approach used for the button
  // components doesn't make it possible for us to just generate the right
  // combination of as/href/to props and spread it into the props of a single
  // component. We need to split up the different possibilities into different
  // component instances (createElement calls) to help TypeScript identify which
  // signature was used.

  if (href) {
    if (as && typeof as !== 'string') {
      return React.createElement(Button, Object.assign({}, props, {
        to: href,
        as: as
      }));
    }

    return React.createElement(Button, Object.assign({}, props, {
      href: href,
      as: "a"
    }));
  }

  return React.createElement(Button, Object.assign({}, props));
};

var HeroPrimaryCta = function HeroPrimaryCta(props) {
  return React.createElement(HeroCta, Object.assign({}, props, {
    Button: PrimaryButton
  }));
};

var HeroComplementaryCta = function HeroComplementaryCta(props) {
  return React.createElement(HeroCta, Object.assign({}, props, {
    Button: TertiaryButton
  }));
};

var HeroGrid = styled(Grid)(_templateObject123(), primitive.$spacing3, primitive.$spacing4, primitive.$spacing4, function (p) {
  return p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light');
}, mediaQuery.desktopLarge, primitive.$spacing8, primitive.$spacing8);
var ImageWrapper = styled.div(_templateObject124(), mediaQuery.tablet, mediaQuery.desktopLarge);
var HeroHeader = styled.div(_templateObject125(), function (p) {
  return p.theme.token('text-style-hero-header');
});
var HeroSubheader = styled.div(_templateObject126(), primitive.$spacing3, function (p) {
  return p.theme.token('text-style-hero-subheader');
}, mediaQuery.desktopLarge, primitive.$spacing6);
var ButtonsWrapper = styled.div(_templateObject127(), primitive.$spacing6, mediaQuery.tablet, mediaQuery.desktopLarge, primitive.$spacing8);
var TermsWrapper = styled.div(_templateObject128(), function (p) {
  return p.theme.token('text-style-hero-terms');
}, function (p) {
  return p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light');
}, function (p) {
  return p.$isAbsolute && css(_templateObject129(), primitive.$spacing4, primitive.$spacing4, primitive.$spacing6, primitive.$spacing6);
});
var Terms = styled.button(_templateObject130(), buttonAsLinkReset, function (p) {
  return p.theme.token('text-link-hover');
});

var HeroTerms = function HeroTerms(_ref105) {
  var onClickTermsLink = _ref105.onClickTermsLink,
      _ref105$reversed = _ref105.reversed,
      reversed = _ref105$reversed === void 0 ? false : _ref105$reversed,
      termsLinkAs = _ref105.termsLinkAs,
      termsLinkHref = _ref105.termsLinkHref,
      termsLinkText = _ref105.termsLinkText,
      id = _ref105.id;
  var isMobile = !useMediaQuery('tablet');
  return React.createElement(TermsWrapper, {
    "$isAbsolute": !isMobile,
    "$reversed": reversed,
    id: id
  }, "*", ' ', React.createElement(Terms, Object.assign({
    onClick: onClickTermsLink
  }, termsLinkHref && Object.assign({
    as: termsLinkAs || 'a'
  }, termsLinkAs ? {
    to: termsLinkHref
  } : {
    href: termsLinkHref
  }), {
    "aria-describedby": combineAttributeStrings(heroImageId, heroHeaderId, heroSubheaderId)
  }), termsLinkText));
};
/**
 * the default area at the top of the home page
 */


var Hero = function Hero(_ref106) {
  var header = _ref106.header,
      subheader = _ref106.subheader,
      image = _ref106.image,
      _ref106$reversed = _ref106.reversed,
      reversed = _ref106$reversed === void 0 ? false : _ref106$reversed,
      disableButtonReverse = _ref106.disableButtonReverse,
      primaryCtaText = _ref106.primaryCtaText,
      primaryCtaHref = _ref106.primaryCtaHref,
      primaryCtaAs = _ref106.primaryCtaAs,
      onClickPrimaryCta = _ref106.onClickPrimaryCta,
      complementaryCtaText = _ref106.complementaryCtaText,
      complementaryCtaHref = _ref106.complementaryCtaHref,
      complementaryCtaAs = _ref106.complementaryCtaAs,
      onClickComplementaryCta = _ref106.onClickComplementaryCta,
      termsLinkText = _ref106.termsLinkText,
      onClickTermsLink = _ref106.onClickTermsLink,
      termsLinkHref = _ref106.termsLinkHref,
      termsLinkAs = _ref106.termsLinkAs;
  var isMobile = !useMediaQuery('tablet');
  var heroTermsId = termsLinkText ? 'hero-terms-wrapper' : undefined;
  var ctaDescribedByIds = combineAttributeStrings(heroImageId, heroHeaderId, heroSubheaderId, heroTermsId);

  var _useDefaultPropsFromT = useDefaultPropsFromTheme('Hero', {
    disableButtonReverse: disableButtonReverse
  }),
      isButtonReverseDisabled = _useDefaultPropsFromT.disableButtonReverse;

  var isButtonReversed = reversed && !isButtonReverseDisabled;
  return React.createElement("section", {
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement(HeroGrid, {
    "$reversed": reversed
  }, React.createElement(Cell, {
    startTablet: 5,
    span: 2,
    spanTablet: 4
  }, React.createElement(ImageWrapper, {
    id: heroImageId
  }, image)), React.createElement(Cell, {
    rowTablet: 1,
    span: 2,
    startTablet: 1,
    spanTablet: 4,
    spanDesktopLarge: 5,
    startDesktopLarge: 2
  }, React.createElement(HeroHeader, {
    id: heroHeaderId
  }, header), React.createElement(HeroSubheader, {
    id: heroSubheaderId
  }, subheader), React.createElement(ButtonsWrapper, null, React.createElement(HeroPrimaryCta, {
    "aria-describedby": ctaDescribedByIds,
    fullWidth: isMobile,
    reversed: isButtonReversed,
    children: primaryCtaText,
    onClick: onClickPrimaryCta,
    href: primaryCtaHref,
    as: primaryCtaAs
  }), React.createElement(HeroComplementaryCta, {
    "aria-describedby": ctaDescribedByIds,
    fullWidth: isMobile,
    reversed: isButtonReversed,
    children: complementaryCtaText,
    onClick: onClickComplementaryCta,
    href: complementaryCtaHref,
    as: complementaryCtaAs
  }))), isMobile && termsLinkText ? React.createElement(Cell, {
    span: 2
  }, React.createElement(HeroTerms, {
    id: heroTermsId,
    onClickTermsLink: onClickTermsLink,
    reversed: reversed,
    termsLinkAs: termsLinkAs,
    termsLinkHref: termsLinkHref,
    termsLinkText: termsLinkText
  })) : null), !isMobile && termsLinkText ? React.createElement(HeroTerms, {
    id: heroTermsId,
    onClickTermsLink: onClickTermsLink,
    reversed: reversed,
    termsLinkText: termsLinkText,
    termsLinkAs: termsLinkAs,
    termsLinkHref: termsLinkHref
  }) : null);
};

var InlineAlertWrapper = styled.div(_templateObject131(), function (p) {
  return p.theme.token('background-inline-alert');
}, primitive.$spacing3, mediaQuery.tablet, primitive.$spacing4);
var IconWrapper$1 = styled.div(_templateObject132(), mediaQuery.tablet);
var InlineAlertMessage = styled.p(_templateObject133(), primitive.$spacing2, function (p) {
  return p.theme.token('text-style-inline-alert');
}, function (p) {
  return p.theme.token('text-default');
});
/**
 * A simple pattern for displaying alerts inline with the content they are referring to.
 */

var InlineAlert = function InlineAlert(_ref107) {
  var message = _ref107.message,
      iconOption = _ref107.icon;

  var _useTheme3 = useTheme(),
      token = _useTheme3.token;

  var isTablet = useMediaQuery('tablet');
  var icon = iconOption ? iconOption : 'info';
  return React.createElement(InlineAlertWrapper, {
    "aria-live": "polite",
    "aria-atomic": true
  }, React.createElement(IconWrapper$1, null, React.createElement(Icon, {
    icon: icon,
    color: "icon-default",
    "aria-hidden": true,
    width: token(isTablet ? 'width-icon' : 'width-icon-small'),
    height: token(isTablet ? 'height-icon' : 'height-icon-small'),
    "data-testid": "inline-alert-icon"
  })), React.createElement(InlineAlertMessage, null, message));
};

var Wrapper$6 = styled.div(_templateObject134(), function (p) {
  return p.verticalOnly ? 'unset' : 'flex';
}, mediaQuery.tablet);
var ImageContainer$1 = styled.div(_templateObject135(), function (p) {
  return p.verticalOnly ? 0 : primitive.$spacing3;
}, function (p) {
  return p.verticalOnly ? '100px' : '80px';
}, mediaQuery.tablet);
var TextWrapper$1 = styled.div(_templateObject136(), function (p) {
  if (!p.$image) {
    return 'flex-start';
  }

  return p.verticalOnly ? 'center' : 'flex-start';
}, function (p) {
  return p.theme.token('text-default');
}, mediaQuery.tablet, function (p) {
  return p.$image ? 'center' : 'flex-start';
});
var textPadding = css(_templateObject137(), primitive.$spacing1, mediaQuery.tablet, primitive.$spacing2);
var SubheaderText = styled.div(_templateObject138(), function (p) {
  return p.theme.token('text-style-item-description-subheader');
}, textPadding);
var Header$2 = styled.div(_templateObject139(), function (p) {
  return p.theme.token('text-style-item-description-header');
}, textPadding);
var DescriptionText = styled.div(_templateObject140(), function (p) {
  return p.theme.token('text-style-item-description-copy');
}, textPadding);
var PriceContainer = styled.div(_templateObject141(), textPadding);
var PriceText = styled.div(_templateObject142(), function (p) {
  return p.theme.token('text-style-item-description-price');
}, primitive.$spacing2);
var CaloriesText$1 = styled.div(_templateObject143(), function (p) {
  return p.theme.token('text-style-item-description-copy');
});
/**
 * A consistent lockup of image, header and copy that make up an item description.
 */

var ItemDescription = function ItemDescription(_ref108) {
  var image = _ref108.image,
      header = _ref108.header,
      price = _ref108.price,
      calories = _ref108.calories,
      description = _ref108.description,
      subheader = _ref108.subheader,
      _ref108$verticalOnly = _ref108.verticalOnly,
      verticalOnly = _ref108$verticalOnly === void 0 ? false : _ref108$verticalOnly;
  return React.createElement(Wrapper$6, {
    verticalOnly: verticalOnly
  }, image && React.createElement(ImageContainer$1, {
    "aria-hidden": true,
    verticalOnly: verticalOnly
  }, image), React.createElement(TextWrapper$1, {
    "data-testid": "text-wrapper",
    verticalOnly: verticalOnly,
    "$image": !!image
  }, subheader && React.createElement(SubheaderText, null, subheader), React.createElement(Header$2, null, header), description && React.createElement(DescriptionText, null, description), React.createElement(PriceContainer, null, price && React.createElement(PriceText, null, price), React.createElement(CaloriesText$1, null, calories))));
};

var BaseItemAlign = styled.div(_templateObject144(), function (p) {
  return p.isStacked ? '1fr' : 'repeat(3, minmax(0, 1fr))';
});
var LeftAlign = styled.div(_templateObject145(), function (p) {
  return p.isStacked ? 'center' : 'left';
});
var CenterAlign = styled.div(_templateObject146(), function (p) {
  return p.isStacked ? '1' : '2';
});
var RightAlign = styled.div(_templateObject147(), function (p) {
  return p.isStacked ? 'center' : 'right';
}, function (p) {
  return p.isStacked ? '1' : '3';
});

var ItemAlign = function ItemAlign(_ref109) {
  var leftAlignItem = _ref109.leftAlignItem,
      centerAlignItem = _ref109.centerAlignItem,
      rightAlignItem = _ref109.rightAlignItem,
      _ref109$isStacked = _ref109.isStacked,
      isStacked = _ref109$isStacked === void 0 ? false : _ref109$isStacked;
  return React__default.createElement(BaseItemAlign, {
    isStacked: isStacked,
    leftAlignItem: leftAlignItem,
    centerAlignItem: centerAlignItem,
    rightAlignItem: rightAlignItem
  }, leftAlignItem && React__default.createElement(LeftAlign, {
    isStacked: isStacked
  }, leftAlignItem), centerAlignItem && React__default.createElement(CenterAlign, {
    isStacked: isStacked
  }, centerAlignItem), rightAlignItem && React__default.createElement(RightAlign, {
    isStacked: isStacked
  }, rightAlignItem));
};

var LEFT_ICON_SIZE = '24px';
var RIGHT_ICON_SIZE = '16px';
var ELEMENT_HEIGHT = '24px';
var Wrapper$5 = styled.label(_templateObject148());
var LeftIconContainer = styled.div(_templateObject149(), ELEMENT_HEIGHT, LEFT_ICON_SIZE, LEFT_ICON_SIZE, function (p) {
  return p.$reversed ? p.theme.token('icon-reversed') : p.theme.token('icon-default');
}, function (p) {
  return p.$reversed ? p.theme.token('icon-reversed') : p.theme.token('icon-default');
});
var RightIconContainer = styled(LeftIconContainer)(_templateObject150(), RIGHT_ICON_SIZE, RIGHT_ICON_SIZE);
var StyledLocaleSelect = styled.select(_templateObject151(), function (p) {
  return p.theme.token('text-style-footer-location');
}, function (p) {
  return p.$reversed ? p.theme.token('text-reversed') : p.theme.token('text-default');
}, ELEMENT_HEIGHT, RIGHT_ICON_SIZE, primitive.$spacing1, LEFT_ICON_SIZE, primitive.$spacing2, function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.$reversed ? p.theme.token('box-shadow-pattern-reversed') : p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.$reversed ? p.theme.token('box-shadow-pattern-reversed') : p.theme.token('box-shadow-pattern');
});
/**
 * Minimal UI to change locale settings
 */

var LocaleSelect = React.forwardRef(function (_ref110, forwardedRef) {
  var propsId = _ref110.id,
      options = _ref110.options,
      value = _ref110.value,
      onChange = _ref110.onChange,
      _ref110$reversed = _ref110.reversed,
      reversed = _ref110$reversed === void 0 ? false : _ref110$reversed,
      ariaLabel = _ref110['aria-label'],
      testId = _ref110['data-testid'];
  var defaultId = useIdCounter('locale-select');
  var id = propsId || defaultId;
  return React.createElement(Wrapper$5, {
    htmlFor: id
  }, React.createElement(VisuallyHidden, null, ariaLabel), React.createElement(StyledLocaleSelect, {
    id: id,
    "data-testid": testId,
    ref: forwardedRef,
    value: value,
    onChange: onChange,
    "$reversed": reversed
  }, options.map(function (_ref111) {
    var label = _ref111.label,
        optionValue = _ref111.value;
    return React.createElement("option", {
      key: optionValue,
      value: optionValue
    }, label);
  })), React.createElement(LeftIconContainer, {
    "$reversed": reversed
  }, React.createElement(PlainIcon, {
    icon: "language",
    "aria-hidden": true
  })), React.createElement(RightIconContainer, {
    "$reversed": reversed
  }, React.createElement(PlainIcon, {
    icon: "select",
    "aria-hidden": true
  })));
});
var HeaderContainer = styled.div(_templateObject152(), function (p) {
  return p.variant === 'header-only' ? '1fr' : '1fr 1fr;';
}, primitive.$spacing6, primitive.$spacing4, mediaQuery.tablet, primitive.$spacing10, primitive.$spacing4, function (p) {
  return p.variant === 'header-only' ? '1fr' : '1fr auto 1fr;';
}, mediaQuery.desktopLarge);
var Header$1 = styled.h3(_templateObject153(), function (p) {
  return p.theme.token('text-style-module');
}, function (p) {
  return p.theme.token('text-default');
}, mediaQuery.tablet, function (p) {
  return p.variant === 'header-only' ? 1 : 2;
});
var CallToActionButtonWrapper = styled.div(_templateObject154());
/**
 * section header component for home page sections
 */

var SectionHeader = function SectionHeader(_ref112) {
  var callToActionAs = _ref112.callToActionAs,
      callToActionLink = _ref112.callToActionLink,
      callToActionText = _ref112.callToActionText,
      headerText = _ref112.headerText,
      headerId = _ref112.id,
      variant = _ref112.variant;

  if (variant === 'header-only') {
    return React.createElement(HeaderContainer, {
      variant: variant
    }, React.createElement(Header$1, {
      variant: variant,
      id: headerId
    }, headerText));
  }

  return React.createElement(HeaderContainer, {
    variant: variant
  }, React.createElement(Header$1, {
    variant: variant,
    id: headerId
  }, headerText), React.createElement(CallToActionButtonWrapper, null, callToActionAs && React.createElement(TertiaryButton, {
    as: callToActionAs,
    to: callToActionLink,
    size: "small",
    showNavigationIcon: true
  }, callToActionText)));
};

var Wrapper$4 = styled.section(_templateObject155(), function (p) {
  return p.theme.token('background-pattern');
}, primitive.$spacing6, mediaQuery.tablet);
var StyledGrid = styled(Grid)(_templateObject156(), mediaQuery.tablet, mediaQuery.desktopLarge);
var ListWrapper = styled(Cell)(_templateObject157(), mediaQuery.tablet);
var ListContainer = styled.ul(_templateObject158(), primitive.$spacing2, primitive.$spacing6, mediaQuery.tablet, function (p) {
  return p.$cardsPerPage;
}, function (p) {
  return p.$totalCards;
}, function (p) {
  return p.$offset / p.$totalCards;
}, primitive.$spacing4);
var SideButtonWrapper = styled(Cell)(_templateObject159(), mediaQuery.tablet);
/**
 * A carousel designed as a quickview at a limited number of menu items to cover various scenarios.
 */

var MenuCarousel = function MenuCarousel(_ref113) {
  var carouselId = _ref113.id,
      header = _ref113.header,
      children = _ref113.children,
      ctaText = _ref113.ctaText,
      ctaHref = _ref113.ctaHref,
      ctaAs = _ref113.ctaAs,
      previousButtonTitle = _ref113.previousButtonTitle,
      nextButtonTitle = _ref113.nextButtonTitle,
      pageChangeReader = _ref113.pageChangeReader,
      handleNextClick = _ref113.handleNextClick,
      handlePreviousClick = _ref113.handlePreviousClick,
      itemOffset = _ref113.itemOffset,
      lastItemSlide = _ref113.lastItemSlide,
      cardsPerPage = _ref113.cardsPerPage;
  var isTablet = useMediaQuery('tablet');
  var totalCards = children.length;
  var defaultCarousel = useIdCounter('carousel');
  var uniqueId = carouselId !== null && carouselId !== void 0 ? carouselId : defaultCarousel;
  var hideRightButton = itemOffset + cardsPerPage >= totalCards;

  var handlePageReader = function handlePageReader() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return new IntlMessageFormat(message).format({
      firstItemSlide: itemOffset + 1,
      lastItemSlide: lastItemSlide,
      totalCards: totalCards
    });
  };

  if (!Array.isArray(children) || children.length === 0) {
    return null;
  }

  return React__default.createElement(Wrapper$4, {
    "aria-labelledby": uniqueId
  }, header && ctaText && ctaAs && ctaHref && React__default.createElement(SectionHeader, {
    id: 'rewards-section-header',
    variant: "call-to-action",
    headerText: header,
    callToActionAs: ctaAs,
    callToActionText: ctaText,
    callToActionLink: ctaHref
  }), isTablet && React__default.createElement(VisuallyHidden, {
    "aria-live": "polite"
  }, handlePageReader(pageChangeReader)), React__default.createElement(StyledGrid, null, React__default.createElement(SideButtonWrapper, {
    spanTablet: 1,
    spanDesktopLarge: 1
  }, React__default.createElement(PreviousButton, {
    title: previousButtonTitle,
    onClick: handlePreviousClick,
    disabled: itemOffset === 0
  })), React__default.createElement(ListWrapper, {
    spanTablet: 6,
    spanDesktopLarge: 10
  }, React__default.createElement(ListContainer, {
    "$offset": itemOffset,
    "$totalCards": totalCards,
    "$cardsPerPage": cardsPerPage
  }, children)), React__default.createElement(SideButtonWrapper, {
    spanTablet: 1,
    spanDesktopLarge: 1,
    style: {
      justifyContent: 'flex-end'
    }
  }, React__default.createElement(NextButton, {
    title: nextButtonTitle,
    onClick: handleNextClick,
    disabled: hideRightButton
  }))));
};

var CARDS_PER_PAGE_TABLET = 3;
var CARDS_PER_PAGE_DESKTOP = 4;
/** MenuCarousel and MenuCarouselItem Hook.
 * Example of use:
 * `const { menuCarouselProps, menuItemProps } = useMenuCarouselHandler(totalCards);`
 * `cardsPerPageDesktop` and `cardsPerPageTablet` are optional, and may be included
 * if you need to alter de default number that it `4` for desktop and `3` for tablet
 */

var useMenuCarouselHandler = function useMenuCarouselHandler(_ref114) {
  var totalCards = _ref114.totalCards,
      cardsPerPageDesktop = _ref114.cardsPerPageDesktop,
      cardsPerPageTablet = _ref114.cardsPerPageTablet;
  var isDesktop = useMediaQuery('desktopLarge');
  var cardsPerPage = useMemo(function () {
    return isDesktop ? cardsPerPageDesktop !== null && cardsPerPageDesktop !== void 0 ? cardsPerPageDesktop : CARDS_PER_PAGE_DESKTOP : cardsPerPageTablet !== null && cardsPerPageTablet !== void 0 ? cardsPerPageTablet : CARDS_PER_PAGE_TABLET;
  }, [isDesktop, cardsPerPageDesktop, cardsPerPageTablet]);

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      itemOffset = _useState12[0],
      setItemOffset = _useState12[1];

  var _useState13 = useState(cardsPerPage),
      _useState14 = _slicedToArray(_useState13, 2),
      lastItemSlide = _useState14[0],
      setLastSlideItem = _useState14[1];

  var handleNextClick = useCallback(function () {
    setItemOffset(function (o) {
      return Math.min(o + cardsPerPage, totalCards - cardsPerPage);
    });
    setLastSlideItem(function (o) {
      return Math.min(o + cardsPerPage, totalCards);
    });
  }, [cardsPerPage, totalCards]);
  var handlePreviousClick = useCallback(function () {
    setItemOffset(function (o) {
      return Math.max(o - cardsPerPage, 0);
    });
    setLastSlideItem(function (o) {
      return Math.max(o - cardsPerPage, cardsPerPage);
    });
  }, [cardsPerPage]);
  useEffect(function () {
    setLastSlideItem(cardsPerPage);
    setItemOffset(0);
  }, [cardsPerPage]);
  return useMemo(function () {
    return {
      menuCarouselProps: {
        handleNextClick: handleNextClick,
        handlePreviousClick: handlePreviousClick,
        itemOffset: itemOffset,
        lastItemSlide: lastItemSlide,
        cardsPerPage: cardsPerPage
      },
      menuItemProps: {
        itemOffset: itemOffset,
        lastItemSlide: lastItemSlide
      }
    };
  }, [handleNextClick, handlePreviousClick, itemOffset, lastItemSlide, cardsPerPage]);
};

var Wrapper$3 = styled.li(_templateObject160());
var LinkWrapper = styled.a(_templateObject161(), function (p) {
  return p.theme.token('border-radius-pattern-interactive');
}, function (p) {
  return p.theme.token('text-default');
}, primitive.$spacing3, primitive.$spacing3, primitive.$spacing5, function (p) {
  return p.theme.token('background-pattern');
}, function (p) {
  return p.theme.token('border-color-default');
}, function (p) {
  return p.theme.token('background-focus');
}, mediaQuery.tablet, mediaQuery.desktopLarge);
var ImageContainer = styled.div(_templateObject162(), mediaQuery.tablet, mediaQuery.desktopLarge);
var Header = styled.div(_templateObject163(), primitive.$spacing2, function (p) {
  return p.theme.token('text-style-item-description-header');
}, function (p) {
  return p.hasCalories ? '0' : "60px";
}, Wrapper$3, function (p) {
  return p.theme.token('text-active');
});
var TextWrapper = styled.div(_templateObject164());
var CaloriesText = styled.div(_templateObject165(), function (p) {
  return p.theme.token('text-style-item-description-copy');
}, primitive.$spacing2);
var RewardsChipWrapper = styled.div(_templateObject166(), primitive.$spacing2);

var MenuCarouselItem = function MenuCarouselItem(_ref115) {
  var ariaLabel = _ref115['aria-label'],
      caloriesProps = _ref115.calories,
      dataTestId = _ref115['data-testid'],
      header = _ref115.header,
      href = _ref115.href,
      image = _ref115.image,
      imageAlt = _ref115.imageAlt,
      linkAs = _ref115.linkAs,
      onClick = _ref115.onClick,
      rewardsChipProps = _ref115.rewardsChip,
      variant = _ref115.variant,
      index = _ref115.index,
      itemOffset = _ref115.itemOffset,
      lastItemSlide = _ref115.lastItemSlide;
  var calories = variant === 'rewards' || variant === 'item' ? caloriesProps : null;
  var rewardsChip = variant === 'rewards' ? rewardsChipProps : null; // Changing tabIndex of the item for keyboard navigation, setting the hidden items to -1

  var tabIndex = index >= itemOffset && index < lastItemSlide ? 0 : -1;
  return React.createElement(Wrapper$3, {
    "aria-label": ariaLabel
  }, React.createElement(LinkWrapper, Object.assign({
    onClick: onClick,
    as: linkAs || 'a'
  }, linkAs ? {
    to: href
  } : {
    href: href
  }, {
    "data-testid": dataTestId,
    tabIndex: tabIndex
  }), React.createElement(ImageContainer, {
    "aria-hidden": true
  }, image), React.createElement(TextWrapper, null, React.createElement(Header, {
    hasCalories: !!calories
  }, header), imageAlt && React.createElement(VisuallyHidden, null, imageAlt), calories && React.createElement(CaloriesText, null, calories), rewardsChip && React.createElement(RewardsChipWrapper, null, rewardsChip))));
};

var noop = function noop() {};
/**
 * This function is rounding a value based on the step value
 * Ex: If the step is 0.5 and the value is 1.6, the output will be 1.5
 */


var roundByStep = function roundByStep(value, step) {
  var inverse = 1.0 / step;
  return Math.round(value * inverse) / inverse;
}; // These buttons are only ever used inside the component library, so we do not
// export them with the rest


var MinusButton = makeIconOnlyButton({
  icon: 'remove',
  size: 'small'
});
var PlusButton = makeIconOnlyButton({
  icon: 'add',
  size: 'small'
});

var checkIfPropsAreValid = function checkIfPropsAreValid(_ref116) {
  var value = _ref116.value,
      min = _ref116.min,
      max = _ref116.max,
      step = _ref116.step,
      hideNumberInput = _ref116.hideNumberInput,
      displayedValue = _ref116.displayedValue;

  // min, max & value
  if (min !== undefined && min % step !== 0) {
    throw new Error('The min must be divisible by step.');
  }

  if (value < min) {
    throw new Error('The value must be greather than the min.');
  }

  if (value > max) {
    throw new Error('The value must be smaller than the max.');
  }

  if (min > max) {
    throw new Error('The min must be smaller than the max.');
  } // hideNumberInput & displayedValue


  var displayedValueIsNullOrUndefined = displayedValue === null || typeof displayedValue === 'undefined';

  if (hideNumberInput && displayedValueIsNullOrUndefined) {
    throw new Error('Add a displayedValue if hideNumberInput is true.');
  }
};

var Wrapper$2 = styled.div(_templateObject167(), function (p) {
  return p.$disabled && 'cursor: not-allowed;';
});
var Input = styled.input(_templateObject168(), function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('border-width-input');
}, function (p) {
  return p.theme.token('text-style-form-input');
}, function (p) {
  return p.theme.token('text-default');
}, function (p) {
  return p.$isHidden && 'display: none;';
}, function (p) {
  return p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.theme.token('border-color-input');
}, function (p) {
  return !p.disabled && "border-color: ".concat(p.theme.token('border-color-hover'));
}, function (p) {
  return p.theme.token('text-disabled');
});
var DisplayedValue = styled.div(_templateObject169(), function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.$disabled && "color: ".concat(p.theme.token('text-disabled'), ";");
}, function (_ref117) {
  var $width = _ref117.$width;
  return $width && css(_templateObject170(), $width);
});
/**
 * Quickly enable a user to enter a value.
 */

var NumberInput = function NumberInput(_ref118) {
  var value = _ref118.value,
      onChange = _ref118.onChange,
      _ref118$min = _ref118.min,
      min = _ref118$min === void 0 ? 0 : _ref118$min,
      _ref118$max = _ref118.max,
      max = _ref118$max === void 0 ? Infinity : _ref118$max,
      _ref118$step = _ref118.step,
      step = _ref118$step === void 0 ? 1 : _ref118$step,
      inputId = _ref118.id,
      disabled = _ref118.disabled,
      disableDecrement = _ref118.disableDecrement,
      disableIncrement = _ref118.disableIncrement,
      _ref118$onStepButtonC = _ref118.onStepButtonClick,
      onStepButtonClick = _ref118$onStepButtonC === void 0 ? noop : _ref118$onStepButtonC,
      hideNumberInput = _ref118.hideNumberInput,
      displayedValue = _ref118.displayedValue,
      valueWidth = _ref118.valueWidth,
      ariaLabel = _ref118['aria-label'],
      decrementAriaLabel = _ref118['decrement-aria-label'],
      incrementAriaLabel = _ref118['increment-aria-label'],
      screenReaderTextOverride = _ref118.screenReaderTextOverride,
      testId = _ref118['data-testid'];

  var _a; // Temporary input value when the user is typing the number input


  var _useState15 = useState(value),
      _useState16 = _slicedToArray(_useState15, 2),
      inputValue = _useState16[0],
      setInputValue = _useState16[1]; // Use the fallback of useIdCounter if no id is passed as props


  var defaultInputId = useIdCounter('number-input-component');
  var uniqueId = inputId !== null && inputId !== void 0 ? inputId : defaultInputId; // Test ids for the increment and decrement buttons

  var dataTestId = testId !== null && testId !== void 0 ? testId : 'number-input';
  var decrementTestId = "decrement-button-for-".concat(dataTestId);
  var incrementTestId = "increment-button-for-".concat(dataTestId); // Send error messages when the input is not being used properly in dev

  useEffect(function () {
    if (process.env.NODE_ENV === 'development') {
      checkIfPropsAreValid({
        value: value,
        min: min,
        max: max,
        step: step,
        hideNumberInput: hideNumberInput,
        displayedValue: displayedValue
      });
    }
  }, [displayedValue, hideNumberInput, max, min, step, value]); // Update the component if, for some reason, the value has been changed outside of the user's interaction

  useEffect(function () {
    setInputValue(value);
  }, [value]); // Handling step up and step down button click

  var handleChange = useCallback(function (_ref119) {
    var e = _ref119.e,
        isIncrementing = _ref119.isIncrementing;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var element;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              onStepButtonClick(); // Using the native stepUp and stepDown functions to handle incrementor / decrementor buttons clicks

              element = document.getElementById(uniqueId);
              isIncrementing ? element.stepUp() : element.stepDown();
              onChange(Number(element.value));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [onChange, onStepButtonClick, uniqueId]); // Handle the number input change
  // This should only call the onChange function on input blur

  var handleInputChange = useCallback(function (e) {
    setInputValue(e.target.value);
  }, []); // Updating the input on blur and calling the onChange function if needed

  var handleInputBlur = useCallback(function (e) {
    // Rounding the inputValue by step
    var roundedValue = roundByStep(inputValue, step); // Making sure the new value is not out of boundaries

    var newValue = inputValue;

    if (disableDecrement && newValue < value) {
      // Dont allow decrementation if we disable the decrement
      setInputValue(value);
      newValue = value;
    } else if (disableIncrement && newValue > value) {
      // Dont allow incrementation if we disable the increment
      setInputValue(value);
      newValue = value;
    } else if (inputValue < min) {
      // Dont allow value lower than the min
      setInputValue(min);
      newValue = min;
    } else if (inputValue > max) {
      // Dont allow value higher than the min
      setInputValue(max);
      newValue = max;
    } else if (roundedValue !== inputValue) {
      // If the value are differents, update them
      setInputValue(roundedValue);
      newValue = roundedValue;
    } // Only call the onChange function if it's a new value
    // This prevents re-rendering input when the value is unchanged


    if (value !== newValue) {
      onChange(newValue);
    } // Updating the input value
    // This prevents showing negative zeros, leading zeros and "e" (ex: 0e1)


    if (roundedValue !== newValue || e.target.value !== newValue.toString()) {
      e.target.value = roundedValue.toString();
    }
  }, [inputValue, min, max, onChange, step, value, disableDecrement, disableIncrement]); // Handle touching the enter keybord to update the input

  var handleKeyDown = useCallback(function (e) {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  }, []); // When the user is clicking on the input, select all the input value
  // This alllow the use to not have to entre the backspace keys to change the value

  var handleInputClick = useCallback(function (e) {
    return e.target.select();
  }, []); // Disabled step up and down based on max/min

  var stepDownBtnDisabled = disabled || disableDecrement || value <= min;
  var stepUpBtnDisabled = disabled || disableIncrement || value >= max;
  return React.createElement(Wrapper$2, {
    "$disabled": disabled
  }, React.createElement(MinusButton, {
    onClick: function onClick(e) {
      return handleChange({
        e: e,
        isIncrementing: false
      });
    },
    disabled: stepDownBtnDisabled,
    "data-testid": decrementTestId,
    "aria-label": decrementAriaLabel
  }), React.createElement(Input, {
    type: "number",
    id: uniqueId,
    value: inputValue,
    "data-testid": dataTestId,
    min: min,
    max: max,
    step: step,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onFocus: handleInputClick,
    onKeyDown: handleKeyDown,
    inputMode: "decimal",
    disabled: disabled,
    "aria-label": ariaLabel,
    "$isHidden": hideNumberInput
  }), hideNumberInput && React.createElement(DisplayedValue, {
    "data-testid": "displayed-value-".concat(dataTestId),
    "$width": valueWidth,
    "$disabled": disabled
  }, displayedValue), React.createElement(PlusButton, {
    onClick: function onClick(e) {
      return handleChange({
        e: e,
        isIncrementing: true
      });
    },
    disabled: stepUpBtnDisabled,
    "data-testid": incrementTestId,
    "aria-label": incrementAriaLabel
  }), React.createElement(VisuallyHidden, {
    "aria-atomic": true,
    "aria-live": "assertive"
  }, (_a = screenReaderTextOverride !== null && screenReaderTextOverride !== void 0 ? screenReaderTextOverride : displayedValue) !== null && _a !== void 0 ? _a : value));
};

var HiddenInput$1 = VisuallyHidden.withComponent('input');
var LabelWrapper$1 = styled.label(_templateObject171(), function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
});
var IndicatorContainer = styled.span(_templateObject172(), function (p) {
  return p.theme.token('width-checkbox-radio');
}, function (p) {
  return p.theme.token('height-checkbox-radio');
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
});
var Indicator = styled.span(_templateObject173(), function (p) {
  return p.theme.token('width-checkbox-radio');
}, function (p) {
  return p.theme.token('height-checkbox-radio');
}, function (p) {
  return p.theme.token('transition-component');
}, HiddenInput$1, IndicatorContainer, function (p) {
  return p.theme.token('box-shadow-pattern');
}, HiddenInput$1, IndicatorContainer, function (p) {
  return p.theme.token('border-color-hover');
}, HiddenInput$1, IndicatorContainer, function (p) {
  return p.theme.token('border-color-input');
}, function (_ref120) {
  var hasError = _ref120.hasError,
      disabled = _ref120.disabled,
      checked = _ref120.checked,
      token = _ref120.theme.token;

  if (!disabled && !hasError && checked) {
    return css(_templateObject174(), token('background-checked'));
  }

  if (hasError) {
    if (checked) {
      return css(_templateObject175(), token('background-error'));
    }

    return css(_templateObject176(), token('border-width-input'), token('border-color-error'));
  }

  if (disabled && checked) {
    return css(_templateObject177(), token('background-checkbox-disabled'));
  }

  return css(_templateObject178(), token('border-width-input'), token('border-color-input'), token('background-input'));
}, function (p) {
  return p.checked && "background-color: ".concat(p.theme.token('background-input'));
});

var RadioButton = function RadioButton(_ref121) {
  var checked = _ref121.checked,
      radioId = _ref121.id,
      name = _ref121.name,
      disabled = _ref121.disabled,
      onChange = _ref121.onChange,
      value = _ref121.value,
      dataTestId = _ref121['data-testid'],
      ariaLabel = _ref121['aria-label'],
      label = _ref121.label,
      _ref121$labelHeader = _ref121.labelHeader,
      labelHeader = _ref121$labelHeader === void 0 ? '' : _ref121$labelHeader,
      _ref121$hasError = _ref121.hasError,
      hasError = _ref121$hasError === void 0 ? false : _ref121$hasError;
  var defaultRadioId = useIdCounter('radio-button');
  var labelID = useIdCounter('label');
  var uniqueId = radioId !== null && radioId !== void 0 ? radioId : defaultRadioId;
  return React.createElement(LabelWrapper$1, {
    disabled: disabled,
    htmlFor: uniqueId
  }, React.createElement(HiddenInput$1, {
    type: "radio",
    checked: checked,
    disabled: disabled,
    name: name,
    id: uniqueId,
    value: value,
    "data-testid": dataTestId,
    "aria-label": ariaLabel,
    onChange: onChange
  }), React.createElement(IndicatorContainer, Object.assign({
    disabled: disabled
  }, dataTestId && {
    'data-testid': "".concat(dataTestId, "_label_wrapper")
  }), React.createElement(Indicator, Object.assign({
    label: label,
    checked: checked,
    disabled: disabled,
    hasError: hasError
  }, dataTestId && {
    'data-testid': "".concat(dataTestId, "_indicator")
  }))), React.createElement(Label$2, Object.assign({
    id: labelID,
    label: label,
    labelHeader: labelHeader,
    disabled: disabled
  }, dataTestId && {
    'data-testid': "".concat(dataTestId, "_label")
  })));
};

var RewardsChipContainer = styled.div(_templateObject179(), function (p) {
  return p.$rewardsLocked ? p.theme.token('background-chip-rewards-locked') : p.theme.token('background-chip-rewards');
}, function (p) {
  return p.$rewardsLocked ? p.theme.token('text-default') : p.theme.token('text-reversed');
}, function (p) {
  return p.theme.token('text-style-chip-rewards');
}, function (p) {
  return p.theme.token('border-radius-chip');
}, function (p) {
  return p.theme.token('height-chip');
}, primitive.$spacing2);
var RewardsChipText = styled.p(_templateObject180(), primitive.$spacing1);

var RewardsChip = function RewardsChip(_ref122) {
  var children = _ref122.children,
      rewardsLocked = _ref122.rewardsLocked,
      dataTestId = _ref122['data-testid'],
      ariaLabel = _ref122['aria-label'];

  var _useTheme4 = useTheme(),
      token = _useTheme4.token;

  return React.createElement(RewardsChipContainer, {
    "$rewardsLocked": rewardsLocked,
    "data-testid": dataTestId,
    "aria-label": ariaLabel
  }, rewardsLocked ? React.createElement(Icon, {
    icon: "lock",
    color: "icon-default",
    "aria-hidden": true,
    width: token('width-icon-small'),
    height: token('height-icon-small'),
    "data-testid": "lock-icon"
  }) : React.createElement(Icon, {
    icon: "rewards",
    color: "icon-reversed",
    "aria-hidden": true,
    width: token('width-icon-small'),
    height: token('height-icon-small'),
    "data-testid": "rewards-icon"
  }), React.createElement(RewardsChipText, null, children));
};

var calculateTransitionDuration = function calculateTransitionDuration(toDeg, fromDeg) {
  return Math.abs(toDeg - fromDeg) / 600;
};

var IconRotation = styled.div(_templateObject181(), function (props) {
  return props.active ? "rotate(".concat(props.toDeg, "deg)") : "rotate(".concat(props.fromDeg, "deg)");
}, function (props) {
  return calculateTransitionDuration(props.toDeg, props.fromDeg);
});

function RotateIcon(_ref123) {
  var active = _ref123.active,
      children = _ref123.children,
      _ref123$fromDeg = _ref123.fromDeg,
      fromDeg = _ref123$fromDeg === void 0 ? 0 : _ref123$fromDeg,
      _ref123$toDeg = _ref123.toDeg,
      toDeg = _ref123$toDeg === void 0 ? 180 : _ref123$toDeg;
  return React__default.createElement(IconRotation, {
    active: active,
    fromDeg: fromDeg,
    toDeg: toDeg
  }, children);
}

var NO_ACTION_STYLE = "\n  user-select: none;\n  pointer-events: none;\n";
var Wrapper$1 = styled.div(_templateObject182());
var SelectWrapper = styled.div(_templateObject183());
var StyledSelect = styled.select(_templateObject184(), function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.theme.token('height-input');
}, function (p) {
  return p.theme.token('text-style-form-input');
}, function (_ref124) {
  var hasError = _ref124.hasError,
      disabled = _ref124.disabled,
      token = _ref124.theme.token;

  if (hasError) {
    return "\n      color: ".concat(token('text-default'), ";\n      border-color: ").concat(token('border-color-error'), ";\n      ");
  }

  if (disabled) {
    return "\n      color: ".concat(token('text-disabled'), ";\n      border-color: ").concat(token('border-color-disabled'), ";\n      ");
  }

  return "\n      color: ".concat(token('text-default'), ";\n      border-color: ").concat(token('border-color-input'), ";\n      ");
}, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('border-radius-input');
}, function (p) {
  return p.theme.token('border-width-input');
}, function (p) {
  return !p.disabled && "border-color: ".concat(p.theme.token('border-color-hover'));
}, function (p) {
  return p.theme.token('box-shadow-pattern');
}); // This is the label styles when a value is selected

var LABEL_WITH_SELECTED_VALUE_STYLES = css(_templateObject185(), function (p) {
  return p.theme.token('text-style-form-label-value');
});
var Label$1 = styled.label(_templateObject186(), function (p) {
  return p.theme.token('text-style-form-label-default');
}, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('border-radius-input');
}, function (_ref125) {
  var hasError = _ref125.hasError,
      disabled = _ref125.disabled,
      token = _ref125.theme.token;

  if (hasError) {
    return token('text-error');
  }

  if (disabled) {
    return token('text-disabled');
  }

  return token('text-default');
}, function (_ref126) {
  var hasValue = _ref126.hasValue,
      hasError = _ref126.hasError,
      token = _ref126.theme.token;
  return !hasValue && hasError && "color: ".concat(token('text-default'), ";");
}, function (p) {
  return p.hasValue && LABEL_WITH_SELECTED_VALUE_STYLES;
}, NO_ACTION_STYLE);
var IconWrapper = styled.div(_templateObject187(), NO_ACTION_STYLE);
/* eslint-disable jsx-a11y/no-onchange */

/**
 * Select is a drop-down list to select value from options.
 */

var Select = function Select(_ref127) {
  var onChange = _ref127.onChange,
      options = _ref127.options,
      value = _ref127.value,
      label = _ref127.label,
      _ref127$errorMessage = _ref127.errorMessage,
      errorMessage = _ref127$errorMessage === void 0 ? '' : _ref127$errorMessage,
      _ref127$hintMessage = _ref127.hintMessage,
      hintMessage = _ref127$hintMessage === void 0 ? '' : _ref127$hintMessage,
      disabled = _ref127.disabled,
      inputId = _ref127.id,
      name = _ref127.name,
      required = _ref127.required,
      autoComplete = _ref127.autoComplete,
      dataTestId = _ref127['data-testid'];

  var _useTheme5 = useTheme(),
      token = _useTheme5.token; // Add an empty select option with the label name


  var selectOptions = [{
    value: '',
    label: label
  }].concat(_toConsumableArray2(options));
  var hasValue = !!value; // The error message should be prioritize when there is an error

  var inputMessage = errorMessage || hintMessage; // Add an '*' if the input is required

  var inputLabel = getRequiredLabel(label, required); // HC the icon size for now

  var ICON_SIZE = token('width-icon'); // Use the fallback of useIdCounter if no id is passed as props

  var defaultInputId = useIdCounter('select-component');
  var uniqueId = inputId !== null && inputId !== void 0 ? inputId : defaultInputId; // Creating select message ID for aria-describedby

  var selectMessageId = useIdCounter('select-message');
  var hasError = !!errorMessage;
  return React.createElement(Wrapper$1, null, React.createElement(SelectWrapper, null, React.createElement(Label$1, {
    id: "label-for-".concat(uniqueId),
    htmlFor: uniqueId,
    "data-testid": "select-label",
    hasValue: hasValue,
    hasError: hasError,
    disabled: disabled
  }, inputLabel), React.createElement(StyledSelect, {
    name: name,
    id: uniqueId,
    required: required,
    onChange: onChange,
    value: value,
    disabled: disabled,
    hasError: hasError,
    "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'select-component',
    "aria-describedby": selectMessageId,
    autoComplete: autoComplete
  }, selectOptions.map(function (_ref128) {
    var optionValue = _ref128.value,
        optionLabel = _ref128.label,
        optionDisabled = _ref128.disabled;
    return React.createElement("option", {
      value: optionValue,
      key: optionValue,
      disabled: !optionValue || optionDisabled
    }, optionLabel);
  })), !disabled && React.createElement(IconWrapper, null, React.createElement(Icon, {
    icon: "select",
    color: "icon-default",
    width: ICON_SIZE,
    height: ICON_SIZE,
    "aria-hidden": true,
    "data-testid": "select-icon"
  }))), React.createElement(InputMessage, {
    id: selectMessageId,
    hasError: hasError,
    disabled: disabled
  }, inputMessage));
};

var StyledSwitchButton = styled.button(_templateObject188(), function (p) {
  return p.theme.token('background-switch-track');
}, function (p) {
  return p.disabled && {
    background: p.theme.token('background-switch-track-disabled')
  };
}, function (p) {
  return p.disabled ? 'none' : p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.theme.token('background-switch-thumb');
}, function (p) {
  return p.disabled ? p.theme.token('background-switch-track-disabled') : p.theme.token('background-active');
});
var StyledButtonAndLabelWrapper = styled.div(_templateObject189(), StyledSwitchButton);
/**
 * Toggle the state of a single item to on or off.
 * This component MUST be paired with a label to work (use the exported SwitchLabel).
 * Only use this if you need custom styling that is different from the exported 'Switch' component.
 */

var SwitchButton = React.forwardRef(function (_ref129, forwardedRef) {
  var _ref129$disabled = _ref129.disabled,
      disabled = _ref129$disabled === void 0 ? false : _ref129$disabled,
      _ref129$checked = _ref129.checked,
      checked = _ref129$checked === void 0 ? false : _ref129$checked,
      onClick = _ref129.onClick,
      id = _ref129.id,
      dataTestId = _ref129['data-testid'];
  var handleClick = React.useCallback(function (e) {
    onClick(e);
  }, [onClick]);
  return React.createElement(StyledSwitchButton, {
    ref: forwardedRef,
    "data-testid": dataTestId,
    type: "button",
    role: "switch",
    "aria-checked": checked,
    disabled: disabled,
    id: id,
    onClick: handleClick
  });
});
var SwitchLabel = styled.label(_templateObject190(), function (p) {
  return p.theme.token('text-style-list-item');
}, function (p) {
  return p.theme.token('text-default');
}, StyledSwitchButton, function (p) {
  if (p.disabled) {
    return 'none';
  }

  return p.theme.token('box-shadow-pattern');
});
/**
 * toggles the state of a single item to on or off
 */

var Switch = function Switch(_ref130) {
  var _ref130$checked = _ref130.checked,
      checked = _ref130$checked === void 0 ? false : _ref130$checked,
      _ref130$disabled = _ref130.disabled,
      disabled = _ref130$disabled === void 0 ? false : _ref130$disabled,
      propsId = _ref130.id,
      label = _ref130.label,
      onClick = _ref130.onClick,
      dataTestId = _ref130['data-testid'];
  var generatedId = useIdCounter('switch');
  var id = propsId !== null && propsId !== void 0 ? propsId : generatedId;
  return React.createElement(StyledButtonAndLabelWrapper, null, React.createElement(SwitchLabel, {
    disabled: disabled,
    htmlFor: id
  }, label), React.createElement(SwitchButton, {
    "data-testid": dataTestId,
    checked: checked,
    disabled: disabled,
    id: id,
    onClick: onClick
  }));
};

var TabsContainer = styled.div(_templateObject191(), function (p) {
  return p.theme.token('height-tabs');
});
var TabsWrapper = styled.div(_templateObject192());
var Underline = styled.span(_templateObject193(), function (p) {
  return p.theme.token('background-active');
}, function (p) {
  return "".concat(p.tabSlideWidth, "%");
}, function (p) {
  return "translateX(".concat(100 * p.idx, "%)");
}, function (p) {
  return p.theme.token('transition-component');
});
var StyledTab = styled.button(_templateObject194(), function (p) {
  return p.theme.token('height-tabs');
}, function (p) {
  return p.theme.token('border-color-default');
}, function (p) {
  return p.theme.token('transition-component');
}, function (p) {
  return p.theme.token('text-style-tabs');
}, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return !p.disabled && !p.$selected && css(_templateObject195(), p.theme.token('border-color-hover'));
}, function (_ref131) {
  var disabled = _ref131.disabled,
      token = _ref131.theme.token;

  if (disabled) {
    return css(_templateObject196(), token('text-disabled'));
  }

  return css(_templateObject197(), token('text-default'));
});
var StyledTabPanel = styled.div(_templateObject198(), function (p) {
  return p.$selected ? 'flex' : 'none';
}, function (p) {
  return p.theme.token('box-shadow-pattern');
}, function (p) {
  return p.theme.token('box-shadow-pattern');
});

var TabList = function TabList(_ref132) {
  var children = _ref132.children,
      selectedIndex = _ref132.selectedIndex,
      onChange = _ref132.onChange;

  if (!children || React__default.Children.count(children) <= 0) {
    return null;
  } // calculating percentage of tab width


  var tabSlideWidth = 100 / children.length;
  var tabs = React__default.Children.map(children, function (child, indx) {
    if (!isValidElement(child)) {
      return child;
    }

    var onClick = function onClick(e) {
      onChange(e, indx);
    };

    return cloneElement(child, {
      onClick: onClick
    });
  });
  return React__default.createElement(TabsContainer, null, React__default.createElement(TabsWrapper, {
    role: "tablist"
  }, tabs), React__default.createElement(Underline, {
    tabSlideWidth: tabSlideWidth,
    idx: selectedIndex
  }));
};

var Tab = function Tab(_ref133) {
  var id = _ref133.id,
      label = _ref133.label,
      disabled = _ref133.disabled,
      onClick = _ref133.onClick,
      selected = _ref133.selected,
      ariaControls = _ref133['aria-controls'],
      dataTestId = _ref133['data-testid'];
  return React__default.createElement(StyledTab, {
    id: id,
    role: "tab",
    "$selected": selected,
    onClick: onClick,
    disabled: disabled,
    "aria-selected": selected,
    "aria-controls": ariaControls,
    "data-testid": dataTestId
  }, label);
};

var TabPanel = function TabPanel(_ref134) {
  var id = _ref134.id,
      selected = _ref134.selected,
      children = _ref134.children,
      ariaLabelledBy = _ref134['aria-labelledby'],
      dataTestId = _ref134['data-testid'];
  return React__default.createElement(StyledTabPanel, {
    id: id,
    key: "tab-panel_".concat(id),
    hidden: !selected,
    "$selected": selected,
    role: "tabpanel",
    tabIndex: 0,
    "aria-labelledby": ariaLabelledBy,
    "data-testid": dataTestId
  }, children);
};

var StyledTextArea = styled(StyledTextField)(_templateObject199(), function (p) {
  return p.theme.token('text-style-form-input');
});
var TextAreaSizeReference = styled(StyledTextArea)(_templateObject200());
/**
 * Keeps the textarea height automatically adjusted to match its contents.
 *
 * Auto-resizing will be skipped if the user manually adjusts the height of the
 * textarea once.
 *
 * Auto-resizing is handy for the UX of the TextArea for desktop users, but
 * indispensable for mobile users, who (at least on iOS) have no way to resize a
 * textarea element manually.
 */

function useAutoResize(originalRef, sizeReferenceRef, value) {
  // This just tracks the auto-sized height we have assigned so we can
  // differentiate between auto resizes and user-triggered resizes
  var autoHeightRef = useRef();
  var autoSize = useCallback(function () {
    if (!originalRef.current || !sizeReferenceRef.current) {
      return;
    }

    var style = originalRef.current.style;
    var refStyle = sizeReferenceRef.current.style;

    if (autoHeightRef.current !== undefined && style.height !== autoHeightRef.current) {
      // assume the height was manually adjusted by the user and bail
      return;
    } // Padding calculation START
    // We take this opportunity to calculate the ideal padding.
    // The reason a padding calculation is needed in the first place is that we
    // want a single-line TextArea to look nearly identical in dimension and
    // spacing to the single-line TextInput. TextInputs vertically center their
    // text by default, so they did not have to calculate a padding which,
    // paired with the line height of the current font, added up to the standard
    // height of the TextInput. TextAreas, however, do not have that vertical
    // centering behavior, and no CSS rules can set it, either. So without
    // padding, all the text of a TextArea appears bunched-up in the top. We
    // want to set a padding to give the illusion of vertical centering, but the
    // changing line height means giving the element a fixed padding can either
    // result in (1) the text being off-vertical-center (with a small padding),
    // or (2) the height of the single-line box being stretched out beyond the
    // standard one-line height (with a large padding). So rather than setting
    // fixed padding values inside a media query that would be brittle to token
    // or media query changes, we calculate the ideal padding here, with the
    // understanding that the padding can become incorrect (not fatally so,
    // though) if the screen size changes, at least until the `value` of the
    // TextArea is updated again. All of this calculation can be avoided with
    // `calc` in the CSS once we are able to use `lh` units:
    // https://caniuse.com/?search=lh%20unit


    refStyle.paddingTop = '0px';
    refStyle.paddingBottom = '0px'; // This uses our min-height set in CSS to get the ideal pixel height of
    // a single-line textarea

    var minHeightTarget = sizeReferenceRef.current.offsetHeight;
    refStyle.minHeight = '0px'; // With min-height and padding stripped away and height set to auto,
    // offsetHeight gives us the line height of the text in pixels.
    // getComputedStyle would potentially be useful for calculating the same
    // thing, but there's no guarantee it will return a pixel value.

    var lineHeight = sizeReferenceRef.current.offsetHeight;
    var paddingHeight = "".concat((minHeightTarget - lineHeight) / 2, "px");
    refStyle.minHeight = ''; // resetting value used for calculation

    refStyle.paddingTop = paddingHeight;
    refStyle.paddingBottom = paddingHeight; // Padding calculation END
    // Use the scrollHeight to calculate the height of the text content plus
    // padding, and set that as the element height

    var nextHeight = "".concat(sizeReferenceRef.current.scrollHeight, "px");
    autoHeightRef.current = nextHeight;
    style.height = nextHeight;
    style.paddingTop = paddingHeight;
    style.paddingBottom = paddingHeight;
  }, [originalRef, sizeReferenceRef, autoHeightRef]); // Readjust the size whenever the dimensions of the textarea change (e.g.,
  // when its container's width changes, the window is resized, etc.)

  var throttledCb = useThrottled(autoSize, 300);
  useResizeObserver(originalRef, throttledCb); // Readjust the size whenever the value of the textarea changes (so we can add
  // or remove height based on how many lines the text occupies)

  useLayoutEffect(autoSize, [value, autoSize]);
}
/**
 * Allows for the input of potentially long passages of text with newlines
 */


var TextArea = React__default.forwardRef(function (_ref135, forwardedRef) {
  var testId = _ref135['data-testid'],
      disableScreenReaderAlert = _ref135.disableScreenReaderAlert,
      errorMessage = _ref135.errorMessage,
      forceErrorState = _ref135.forceErrorState,
      hintMessage = _ref135.hintMessage,
      label = _ref135.label,
      labelId = _ref135.labelId,
      ariaDescribedBy = _ref135['aria-describedby'],
      ariaLabel = _ref135['aria-label'],
      autoComplete = _ref135.autoComplete,
      autoFocus = _ref135.autoFocus,
      disabled = _ref135.disabled,
      id = _ref135.id,
      inputMode = _ref135.inputMode,
      maxLength = _ref135.maxLength,
      name = _ref135.name,
      onAnimationStart = _ref135.onAnimationStart,
      onBlur = _ref135.onBlur,
      onChange = _ref135.onChange,
      onFocus = _ref135.onFocus,
      onInvalid = _ref135.onInvalid,
      required = _ref135.required,
      value = _ref135.value;
  var defaultInputId = useIdCounter('floating-label-input');
  var messageId = useIdCounter('message');
  var inputId = id !== null && id !== void 0 ? id : defaultInputId;
  var wrapperTestId = testId ? "".concat(testId, "-wrapper") : undefined;
  var labelTestId = testId ? "".concat(testId, "-label") : undefined;
  var messageTestId = testId ? "".concat(testId, "-message") : undefined;
  var sizeReferenceRef = useRef(null);

  var _useForwardedRefLocal3 = useForwardedRefLocally(forwardedRef),
      localRef = _useForwardedRefLocal3.localRef,
      refForProps = _useForwardedRefLocal3.refForProps;

  var _useNativeInvalidDete2 = useNativeInvalidDetector(localRef, onInvalid),
      isNativeInvalid = _useNativeInvalidDete2.isNativeInvalid,
      handleInvalid = _useNativeInvalidDete2.handleInvalid;

  var _useAutofillDetector3 = useAutofillDetector(onAnimationStart),
      isAutofilled = _useAutofillDetector3.isAutofilled,
      handleAnimationStart = _useAutofillDetector3.handleAnimationStart;

  var _useFocusDetector3 = useFocusDetector({
    onBlur: onBlur,
    onFocus: onFocus
  }),
      handleBlur = _useFocusDetector3.handleBlur,
      handleFocus = _useFocusDetector3.handleFocus,
      isFocused = _useFocusDetector3.isFocused;

  useAutoResize(localRef, sizeReferenceRef, value);
  var stateAttrs = {
    $disabled: !!disabled,
    $focused: isFocused,
    $autofilled: isAutofilled,
    $hasError: forceErrorState || !!errorMessage || isNativeInvalid,
    $hasValue: !!value,
    $isDate: false,
    $iconCount: 0
  };
  return React__default.createElement(TextFieldWrapper, {
    "data-testid": wrapperTestId
  }, React__default.createElement(TextFieldInner, Object.assign({}, stateAttrs), React__default.createElement(TextFieldLabel, Object.assign({}, stateAttrs, {
    id: labelId,
    htmlFor: inputId,
    "data-testid": labelTestId
  }), getRequiredLabel(label, required)), React__default.createElement(StyledTextArea, Object.assign({}, stateAttrs, {
    "aria-describedby": combineAttributeStrings(hintMessage || errorMessage ? messageId : undefined, ariaDescribedBy),
    "aria-invalid": stateAttrs.$hasError || undefined,
    "aria-label": ariaLabel,
    as: "textarea",
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    "data-private": true,
    "data-testid": testId,
    disabled: disabled,
    id: inputId,
    inputMode: inputMode,
    maxLength: maxLength,
    name: name,
    onAnimationStart: handleAnimationStart,
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus,
    onInvalid: handleInvalid,
    ref: refForProps,
    required: required,
    value: value
  })), React__default.createElement(TextAreaSizeReference, Object.assign({}, stateAttrs, {
    as: "textarea",
    ref: sizeReferenceRef,
    value: value,
    // set rows to 1 to make height calculation work right
    rows: 1,
    "aria-hidden": true,
    name: undefined,
    disabled // this and the absence of a name prevents it from being submitted with forms
    : true,
    tabIndex: -1
  }))), (errorMessage || hintMessage) && React__default.createElement(InputMessage, {
    id: messageId,
    disableScreenReaderAlert: disableScreenReaderAlert,
    "data-testid": messageTestId,
    hasError: Boolean(errorMessage),
    disabled: stateAttrs.$disabled
  }, errorMessage || hintMessage));
});
var HiddenInput = VisuallyHidden.withComponent('input');
var LabelWrapper = styled.div(_templateObject201());
var Label = styled.label(_templateObject202(), function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('border-color-input');
}, function (p) {
  return p.theme.token('border-radius-toggle-default');
}, function (p) {
  return p.theme.token('border-width-input');
}, function (p) {
  return p.theme.token('text-default');
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.theme.token('text-style-form-input');
}, function (p) {
  return p.theme.token('height-input');
}, function (p) {
  return p.theme.token('border-width-input');
}, function (p) {
  return p.theme.token('padding-input');
}, LabelWrapper, function (p) {
  return p.theme.token('border-radius-toggle-start');
}, LabelWrapper, function (p) {
  return p.theme.token('border-radius-toggle-end');
}, HiddenInput, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return p.theme.token('box-shadow-button');
}, function (p) {
  return p.theme.token('text-default');
}, HiddenInput, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('text-default');
}, HiddenInput, function (p) {
  return p.theme.token('background-focus');
}, function (p) {
  return p.theme.token('box-shadow-button');
}, function (p) {
  return p.theme.token('text-default');
}, HiddenInput, function (p) {
  return p.theme.token('border-color-hover');
}, HiddenInput, function (p) {
  return p.theme.token('background-checked');
}, function (p) {
  return p.theme.token('text-reversed');
}, HiddenInput, function (p) {
  return p.theme.token('border-color-error');
}, HiddenInput, function (p) {
  return p.theme.token('background-input');
}, function (p) {
  return p.theme.token('border-color-disabled');
}, function (p) {
  return p.theme.token('text-disabled');
});
var InputsWrapper = styled.div(_templateObject203());
var Wrapper = styled.div(_templateObject204(), mediaQuery.mobile, InputsWrapper, InputsWrapper, LabelWrapper);

var ToggleInput = function ToggleInput(_ref136) {
  var ariaInvalid = _ref136['aria-invalid'],
      checked = _ref136.checked,
      testId = _ref136['data-testid'],
      disabled = _ref136.disabled,
      label = _ref136.label,
      name = _ref136.name,
      _ref136$onChange = _ref136.onChange,
      _onChange = _ref136$onChange === void 0 ? noop : _ref136$onChange,
      required = _ref136.required,
      value = _ref136.value;

  var inputId = useIdCounter(name);
  return React.createElement(LabelWrapper, null, React.createElement(HiddenInput, {
    "aria-invalid": ariaInvalid,
    checked: checked,
    "data-testid": testId ? "".concat(testId, "-input-").concat(value) : undefined,
    disabled: disabled,
    id: inputId,
    name: name,
    onChange: function onChange() {
      return _onChange(value);
    },
    required: required,
    type: "radio",
    value: value
  }), React.createElement(Label, {
    checked: checked,
    "data-testid": testId ? "".concat(testId, "-label-").concat(value) : undefined,
    disabled: disabled,
    htmlFor: inputId
  }, label));
};
/**
 * A toggle allows the user to make a single choice from more than one option.
 */


var Toggle = function Toggle(_ref137) {
  var testId = _ref137['data-testid'],
      disabled = _ref137.disabled,
      errorMessage = _ref137.errorMessage,
      hintMessage = _ref137.hintMessage,
      label = _ref137.label,
      name = _ref137.name,
      onChange = _ref137.onChange,
      options = _ref137.options,
      required = _ref137.required,
      value = _ref137.value;
  return React.createElement(Wrapper, {
    "data-testid": testId
  }, React.createElement(FieldSet, {
    disabled: disabled,
    errorMessage: errorMessage,
    hintMessage: hintMessage,
    legend: label && getRequiredLabel(label, required),
    "data-testid": testId ? "".concat(testId, "-legend") : undefined
  }, React.createElement(InputsWrapper, null, options.map(function (option) {
    return React.createElement(ToggleInput, {
      "aria-invalid": Boolean(errorMessage),
      checked: option.value === value,
      "data-testid": testId,
      disabled: disabled || option.disabled,
      key: option.value,
      label: option.label,
      name: name,
      onChange: onChange,
      required: required,
      value: option.value
    });
  }))));
};
/**
 * This is a styled version of `react-tooltip`: https://github.com/wwayne/react-tooltip#readme
 *
 * To get a full list of props, visit that link.
 */


var Tooltip = styled(ReactTooltip)(_templateObject205());
Tooltip.defaultProps = {
  arrowColor: 'transparent',
  backgroundColor: '#f4f1ef',
  clickable: true,
  effect: 'solid',
  place: 'right',
  textColor: '#323231'
};
var deprecatedTokens = ['background-icon-hover-focus', 'background-icon-hover-focus-reversed', 'background-dialog', 'border-color-input-default', 'border-color-options', 'box-shadow-component', 'box-shadow-component-reversed', 'text-tabs-default'];
var designTokens$3 = {
  'background-active': primitive.bk.$fieryRed,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.bk.$fieryRed,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.bk.$fieryRedDarken10,
  'background-button-secondary-hover': primitive.bk.$fieryRedOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.bk.$bbqBrown,
  'background-chip': primitive.bk.$bbqBrown,
  'background-chip-rewards': primitive.bk.$bbqBrown,
  'background-chip-rewards-locked': primitive.bk.$mayoEggWhite,
  'background-default': primitive.bk.$mayoEggWhite,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-footer': primitive.bk.$bbqBrown,
  'background-hero-light': primitive.bk.$mayoEggWhite,
  'background-hero-reversed': primitive.bk.$bbqBrown,
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.bk.$bbqBrown,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'background-toast': primitive.$black,
  'border-color-active': primitive.bk.$fieryRed,
  'border-color-button-secondary': primitive.bk.$fieryRed,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.bk.$bbqBrown,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.bk.$bbqBrown,
  'border-color-input': primitive.$blackOpacity30,
  'border-color-input-default': primitive.$blackOpacity30,
  'border-color-options': primitive.$blackOpacity10,
  'border-color-reversed': primitive.$whiteOpacity10,
  'border-radius-button': '100%',
  'border-radius-chip': '4px',
  'border-radius-input': '4px',
  'border-radius-input-icon-hover-focus': '100%',
  'border-radius-pattern': '20px',
  'border-radius-pattern-interactive': '12px',
  'border-radius-toast': '4px',
  'border-radius-toggle-default': '0',
  'border-radius-toggle-end': '0 4px 4px 0',
  'border-radius-toggle-start': '4px 0 0 4px',
  'border-width-button-secondary': '1px',
  'border-width-input': '1px',
  'border-width-tabs': '1px',
  'box-shadow-button': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-pattern': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-pattern-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-toggle': "inset 0 0 0 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-bottom-nav': "0 -1px 1px ".concat(primitive.$blackOpacity10),
  'drop-shadow-component': "0 4px 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-top-nav': "0 1px 1px ".concat(primitive.$blackOpacity10),
  'height-button-large': '48px',
  'height-button-small': '32px',
  'height-checkbox-radio': '20px',
  'height-chip': '24px',
  'height-icon': '24px',
  'height-icon-small': '16px',
  'height-input': '48px',
  'height-tabs': '56px',
  'icon-active': primitive.bk.$fieryRed,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.bk.$bbqBrown,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.bk.$fieryRed,
  'icon-button-tertiary-default': primitive.bk.$bbqBrown,
  'icon-button-tertiary-hover': primitive.bk.$fieryRed,
  'icon-default': primitive.bk.$bbqBrown,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.bk.$bbqBrown,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.bk.$mayoEggWhite,
  'padding-button-icon-end': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing2, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-button-icon-start': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing2),
  'padding-button-large': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing5),
  'padding-button-small': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-input': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'text-active': primitive.bk.$fieryRed,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.bk.$bbqBrown,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.bk.$fieryRed,
  'text-button-tertiary-default': primitive.bk.$bbqBrown,
  'text-button-tertiary-hover': primitive.bk.$fieryRed,
  'text-default': primitive.bk.$bbqBrown,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.bk.$bbqBrown,
  'text-hero-reversed': primitive.bk.$mayoEggWhite,
  'text-link-default': primitive.bk.$bbqBrown,
  'text-link-hover': primitive.bk.$fieryRed,
  'text-link-reversed': primitive.bk.$mayoEggWhite,
  'text-reversed': primitive.bk.$mayoEggWhite,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.bk.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.bk.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-footer-large': 'var(--font-headerThree)',
  'text-style-footer-location': primitive.bk.$headerFour,
  'text-style-footer-small': 'var(--font-copyTwo)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.bk.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.bk.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.bk.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-item-description-price': primitive.bk.$headerFour,
  'text-style-item-description-subheader': primitive.bk.$formUtility,
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-list-item-restaurant': 'var(--font-headerThree)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-toast': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.bk.$headerFour,
  'text-tabs-default': primitive.bk.$bbqBrown,
  'text-toast': primitive.$white,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px'
};
var designTokens$2 = {
  'background-active': primitive.ltw.$loveRed,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.ltw.$loveDark,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.ltw.$loveDarkLighten10,
  'background-button-secondary-hover': primitive.$blackOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.ltw.$loveDark,
  'background-chip': primitive.ltw.$loveDark,
  'background-chip-rewards': primitive.ltw.$loveDark,
  'background-chip-rewards-locked': primitive.ltw.$loveLight,
  'background-default': primitive.ltw.$loveLight,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-footer': primitive.ltw.$loveDark,
  'background-hero-light': primitive.$white,
  'background-hero-reversed': primitive.ltw.$loveTeal,
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.ltw.$loveDark,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'background-toast': primitive.$black,
  'border-color-active': primitive.ltw.$loveRed,
  'border-color-button-secondary': primitive.ltw.$loveDark,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.ltw.$loveDark,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.ltw.$loveDark,
  'border-color-input': primitive.$blackOpacity30,
  'border-color-input-default': primitive.$blackOpacity30,
  'border-color-options': primitive.$blackOpacity10,
  'border-color-reversed': primitive.$whiteOpacity10,
  'border-radius-button': '100%',
  'border-radius-chip': '4px',
  'border-radius-input': '4px',
  'border-radius-input-icon-hover-focus': '100%',
  'border-radius-pattern': '20px',
  'border-radius-pattern-interactive': '12px',
  'border-radius-toast': '4px',
  'border-radius-toggle-default': '0',
  'border-radius-toggle-end': '0 4px 4px 0',
  'border-radius-toggle-start': '4px 0 0 4px',
  'border-width-button-secondary': '1px',
  'border-width-input': '1px',
  'border-width-tabs': '1px',
  'box-shadow-button': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-pattern': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-pattern-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-toggle': "inset 0 0 0 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-bottom-nav': "0 -1px 1px ".concat(primitive.$blackOpacity10),
  'drop-shadow-component': "0 4px 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-top-nav': "0 1px 1px ".concat(primitive.$blackOpacity10),
  'height-button-large': '48px',
  'height-button-small': '32px',
  'height-checkbox-radio': '20px',
  'height-chip': '24px',
  'height-icon': '24px',
  'height-icon-small': '16px',
  'height-input': '48px',
  'height-tabs': '56px',
  'icon-active': primitive.ltw.$loveRed,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.ltw.$loveDark,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.ltw.$loveDark,
  'icon-button-tertiary-default': primitive.ltw.$loveDark,
  'icon-button-tertiary-hover': primitive.ltw.$loveRed,
  'icon-default': primitive.ltw.$loveDark,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.ltw.$loveDark,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.$white,
  'padding-button-icon-end': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing2, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-button-icon-start': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing2),
  'padding-button-large': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing5),
  'padding-button-small': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-input': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'text-active': primitive.ltw.$loveRed,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.ltw.$loveDark,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.ltw.$loveDark,
  'text-button-tertiary-default': primitive.ltw.$loveDark,
  'text-button-tertiary-hover': primitive.ltw.$loveRed,
  'text-default': primitive.ltw.$loveDark,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.ltw.$loveDark,
  'text-hero-reversed': primitive.ltw.$loveDark,
  'text-link-default': primitive.ltw.$loveDark,
  'text-link-hover': primitive.ltw.$loveRed,
  'text-link-reversed': primitive.$white,
  'text-reversed': primitive.$white,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.ltw.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.ltw.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-footer-large': 'var(--font-headerThree)',
  'text-style-footer-location': primitive.ltw.$headerFour,
  'text-style-footer-small': 'var(--font-copyTwo)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.ltw.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.ltw.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.ltw.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-item-description-price': primitive.ltw.$headerFour,
  'text-style-item-description-subheader': primitive.ltw.$formUtility,
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-list-item-restaurant': 'var(--font-headerThree)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-toast': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.ltw.$headerFour,
  'text-tabs-default': primitive.ltw.$loveDark,
  'text-toast': primitive.$white,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px'
};
var designTokens$1 = {
  'background-active': primitive.plk.$popeyesOrange,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.plk.$burntOrange,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.plk.$burnOrangeDarken10,
  'background-button-secondary-hover': primitive.plk.$burntOrangeOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.plk.$nolaDark,
  'background-chip': primitive.plk.$nolaDark,
  'background-chip-rewards': primitive.plk.$nolaPurple,
  'background-chip-rewards-locked': primitive.plk.$nolaLight,
  'background-default': primitive.plk.$nolaLight,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-footer': primitive.plk.$nolaDark,
  'background-hero-light': primitive.$white,
  'background-hero-reversed': "radial-gradient(50% 266.27% at 50% 50%, ".concat(primitive.plk.$popeyesOrange, " 0%, ").concat(primitive.plk.$burntOrange, " 100%)"),
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.plk.$nolaDark,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'background-toast': primitive.$black,
  'border-color-active': primitive.plk.$popeyesOrange,
  'border-color-button-secondary': primitive.plk.$burntOrange,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.plk.$nolaDark,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.plk.$nolaDark,
  'border-color-input': primitive.$blackOpacity30,
  'border-color-input-default': primitive.$blackOpacity30,
  'border-color-options': primitive.$blackOpacity10,
  'border-color-reversed': primitive.$whiteOpacity10,
  'border-radius-button': '100%',
  'border-radius-chip': '4px',
  'border-radius-input': '4px',
  'border-radius-input-icon-hover-focus': '100%',
  'border-radius-pattern': '20px',
  'border-radius-pattern-interactive': '12px',
  'border-radius-toast': '4px',
  'border-radius-toggle-default': '0',
  'border-radius-toggle-end': '0 4px 4px 0',
  'border-radius-toggle-start': '4px 0 0 4px',
  'border-width-button-secondary': '1px',
  'border-width-input': '1px',
  'border-width-tabs': '1px',
  'box-shadow-button': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-pattern': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-pattern-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-toggle': "inset 0 0 0 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-bottom-nav': "0 -1px 1px ".concat(primitive.$blackOpacity10),
  'drop-shadow-component': "0 4px 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-top-nav': "0 1px 1px ".concat(primitive.$blackOpacity10),
  'height-button-large': '48px',
  'height-button-small': '32px',
  'height-checkbox-radio': '20px',
  'height-chip': '24px',
  'height-icon': '24px',
  'height-icon-small': '16px',
  'height-input': '48px',
  'height-tabs': '56px',
  'icon-active': primitive.plk.$popeyesOrange,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.plk.$nolaDark,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.plk.$burntOrange,
  'icon-button-tertiary-default': primitive.plk.$nolaDark,
  'icon-button-tertiary-hover': primitive.plk.$burntOrange,
  'icon-default': primitive.plk.$nolaDark,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.plk.$nolaDark,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.$white,
  'padding-button-icon-end': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing2, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-button-icon-start': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing2),
  'padding-button-large': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing5),
  'padding-button-small': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-input': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'text-active': primitive.plk.$burntOrange,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.plk.$nolaDark,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.plk.$burntOrange,
  'text-button-tertiary-default': primitive.plk.$nolaDark,
  'text-button-tertiary-hover': primitive.plk.$burntOrange,
  'text-default': primitive.plk.$nolaDark,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.plk.$nolaDark,
  'text-hero-reversed': primitive.$white,
  'text-link-default': primitive.plk.$nolaDark,
  'text-link-hover': primitive.plk.$burntOrange,
  'text-link-reversed': primitive.$white,
  'text-reversed': primitive.$white,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.plk.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.plk.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-footer-large': 'var(--font-headerThree)',
  'text-style-footer-location': primitive.plk.$headerFour,
  'text-style-footer-small': 'var(--font-copyTwo)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.plk.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.plk.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.plk.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-item-description-price': primitive.plk.$headerFour,
  'text-style-item-description-subheader': primitive.plk.$formUtility,
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-list-item-restaurant': 'var(--font-headerThree)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-toast': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.plk.$headerFour,
  'text-tabs-default': primitive.plk.$nolaDark,
  'text-toast': primitive.$white,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px'
};
var designTokens = {
  'background-active': primitive.th.$alwaysRed,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.th.$alwaysRed,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.th.$alwaysRedDarken10,
  'background-button-secondary-hover': primitive.th.$alwaysRedOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.th.$coffeeBrown,
  'background-chip': primitive.th.$coffeeBrown,
  'background-chip-rewards': primitive.th.$coffeeBrown,
  'background-chip-rewards-locked': primitive.th.$donutCreamLighten20,
  'background-default': primitive.th.$donutCreamLighten20,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-footer': primitive.th.$coffeeBrown,
  'background-hero-light': primitive.$white,
  'background-hero-reversed': primitive.th.$alwaysRed,
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.th.$coffeeBrown,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'background-toast': primitive.$black,
  'border-color-active': primitive.th.$alwaysRed,
  'border-color-button-secondary': primitive.th.$alwaysRed,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.th.$coffeeBrown,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.th.$coffeeBrown,
  'border-color-input': primitive.$blackOpacity30,
  'border-color-input-default': primitive.$blackOpacity30,
  'border-color-options': primitive.$blackOpacity10,
  'border-color-reversed': primitive.$whiteOpacity10,
  'border-radius-button': '100%',
  'border-radius-chip': '4px',
  'border-radius-input': '4px',
  'border-radius-input-icon-hover-focus': '100%',
  'border-radius-pattern': '20px',
  'border-radius-pattern-interactive': '12px',
  'border-radius-toast': '4px',
  'border-radius-toggle-default': '0',
  'border-radius-toggle-end': '0 4px 4px 0',
  'border-radius-toggle-start': '4px 0 0 4px',
  'border-width-button-secondary': '1px',
  'border-width-input': '1px',
  'border-width-tabs': '1px',
  'box-shadow-button': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-component-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-pattern': "0 0 0 4px ".concat(primitive.$blackOpacity10),
  'box-shadow-pattern-reversed': "0 0 0 4px ".concat(primitive.$whiteOpacity30),
  'box-shadow-toggle': "inset 0 0 0 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-bottom-nav': "0 -1px 1px ".concat(primitive.$blackOpacity10),
  'drop-shadow-component': "0 4px 4px ".concat(primitive.$blackOpacity10),
  'drop-shadow-top-nav': "0 1px 1px ".concat(primitive.$blackOpacity10),
  'height-button-large': '48px',
  'height-button-small': '32px',
  'height-checkbox-radio': '20px',
  'height-chip': '24px',
  'height-icon': '24px',
  'height-icon-small': '16px',
  'height-input': '48px',
  'height-tabs': '56px',
  'icon-active': primitive.th.$alwaysRed,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.th.$coffeeBrown,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.th.$alwaysRed,
  'icon-button-tertiary-default': primitive.th.$coffeeBrown,
  'icon-button-tertiary-hover': primitive.th.$alwaysRed,
  'icon-default': primitive.th.$coffeeBrown,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.th.$coffeeBrown,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.$white,
  'padding-button-icon-end': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing2, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-button-icon-start': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4, " ").concat(primitive.$spacing0, " ").concat(primitive.$spacing2),
  'padding-button-large': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing5),
  'padding-button-small': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'padding-input': "".concat(primitive.$spacing0, " ").concat(primitive.$spacing4),
  'text-active': primitive.th.$alwaysRed,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.th.$coffeeBrown,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.th.$alwaysRed,
  'text-button-tertiary-default': primitive.th.$coffeeBrown,
  'text-button-tertiary-hover': primitive.th.$alwaysRed,
  'text-default': primitive.th.$coffeeBrown,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.th.$coffeeBrown,
  'text-hero-reversed': primitive.$white,
  'text-link-default': primitive.th.$coffeeBrown,
  'text-link-hover': primitive.th.$alwaysRed,
  'text-link-reversed': primitive.$white,
  'text-reversed': primitive.$white,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.th.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.th.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-footer-large': 'var(--font-headerThree)',
  'text-style-footer-location': primitive.th.$headerFour,
  'text-style-footer-small': 'var(--font-copyTwo)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.th.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.th.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.th.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-item-description-price': primitive.th.$headerFour,
  'text-style-item-description-subheader': primitive.th.$formUtility,
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-list-item-restaurant': 'var(--font-headerThree)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-toast': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.th.$headerFour,
  'text-tabs-default': primitive.th.$coffeeBrown,
  'text-toast': primitive.$white,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px'
};
var Mq;

(function (Mq) {
  Mq["DESKTOP"] = "desktop";
})(Mq || (Mq = {}));

var FeatureStatus;

(function (FeatureStatus) {
  /**
   * In active development, subject to change.
   */
  FeatureStatus["UNSTABLE"] = "UNSTABLE";
  /**
   * Weening usage out of the codebase.
   * Avoid using for new features, and look
   * to refctor old features using this
   */

  FeatureStatus["DEPRECATED"] = "DEPRECATED";
})(FeatureStatus || (FeatureStatus = {}));

var SupportedFontTypes;

(function (SupportedFontTypes) {
  SupportedFontTypes["woff"] = "woff";
  SupportedFontTypes["woff2"] = "woff2";
  SupportedFontTypes["otf"] = "otf";
})(SupportedFontTypes || (SupportedFontTypes = {}));

var SupportedFonts;

(function (SupportedFonts) {
  SupportedFonts[SupportedFonts["FlameBold"] = 0] = "FlameBold";
  SupportedFonts[SupportedFonts["FlameRegular"] = 1] = "FlameRegular";
  SupportedFonts[SupportedFonts["FlameSans"] = 2] = "FlameSans";
  SupportedFonts[SupportedFonts["ChickenSansBold"] = 3] = "ChickenSansBold";
  SupportedFonts[SupportedFonts["ChickenSansRegular"] = 4] = "ChickenSansRegular";
  SupportedFonts[SupportedFonts["SofiaProBlack"] = 5] = "SofiaProBlack";
  SupportedFonts[SupportedFonts["SofiaProBold"] = 6] = "SofiaProBold";
  SupportedFonts[SupportedFonts["SofiaProRegular"] = 7] = "SofiaProRegular";
})(SupportedFonts || (SupportedFonts = {}));

var spacing = {
  /* 4px */
  100: '0.25rem',

  /* 8px */
  200: '0.5rem',

  /* 12px */
  300: '0.75rem',

  /* 16px */
  400: '1rem',

  /* 24px */
  500: '1.5rem',

  /* 32px */
  600: '2rem'
};
var zIndex = {
  max: 999900,
  overlay: 400,
  top: 300,
  normal: 200,
  below: 100
};
var textTransform = {
  heading: 'none',
  button: 'none',
  overline: 'uppercase',
  body: 'none'
};
var color$3 = {
  /* BK: Fiery Red */
  primary: '#D62300',

  /* 10% Darker than Fiery Red */
  secondary: '#A71B00',

  /* BBQ Brown */
  tertiary: '#502314',
  black: '#000000',
  brightWhite: '#FFFFFF',

  /* Mayo Egg White */
  white: '#F5EBDC',
  buttonsDisabledBackground: '#d7c7b5',
  buttonsDisabledLabel: '#9f816f',

  /* 10% Darker than Fiery Red */
  buttonsPrimaryHover: '#a71b00',

  /* 15% of Fiery Red over Mayo Egg White */
  buttonsSecondaryHover: '#F0CDBB',

  /* 25% of Fiery Red over Mayo Egg White */
  buttonsFocused: '#EDB9A5',

  /* BBQ Brown */
  buttonsPrimaryActive: '#502314',

  /* BBQ Brown */
  buttonsSecondaryActive: '#502314',
  inputsFocused: '#AF0C2A',

  /* Crunchy Green */
  statusValidated: '#1B8737',

  /* Fiery Red */
  statusError: '#D62300',

  /* BBQ Brown */
  statusPrice: '#502314',

  /* Flaming Orange */
  statusSuccess: '#FF8732',

  /* Darkest to Lightest */
  100: '#2B0200',
  200: '#340000',
  300: '#4E201D',
  400: '#693F34',
  500: '#845F50',
  600: '#9F816F',
  700: '#BBA391',
  800: '#D7C7B5',
  900: '#F5EBDC'
};
var fontFace$3 = [{
  name: 'Flame Bold',
  sources: [{
    source: SupportedFonts.FlameBold,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}, {
  name: 'Flame',
  sources: [{
    source: SupportedFonts.FlameRegular,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}, {
  name: 'Flame Sans',
  sources: [{
    source: SupportedFonts.FlameSans,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}];
var fontFamily$3 = {
  primary: '"Flame", sans-serif',
  secondary: '"Flame Sans", "Helvetica Neue", Helvetica, Arial, sans-serif'
};
var fontSize$3 = {
  headings: {
    H1: '7.5rem',
    H2: '5rem',
    H3: '3.5rem',
    H4: '2rem',
    H5: '1.5rem',
    H6: '1.25rem'
  },
  subtitle: {
    LARGE: '1.125rem',
    SMALL: '1rem'
  },
  body: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  button: {
    LARGE: '1.25rem',
    SMALL: '0.875rem'
  },
  caption: '0.8rem',
  overline: '0.625rem',
  link: '1rem'
};
var fontWeight$3 = {
  headings: 'bold',
  primary: 'normal',
  secondary: 'normal',
  tertiary: 'normal',
  link: 'normal',
  button: 'normal'
};
var commonIcons = {
  account: 'account',
  add: 'add',
  amex: 'amex',
  applepay: 'applepay',
  arrowUp: 'arrowUp',
  back: 'back',
  bkCrown: 'noop',
  calendar: 'calendar',
  cart: 'cart',
  catering: 'catering',
  cateringTwo: 'cateringTwo',
  check: 'check',
  checkCircle: 'checkCircle',
  circlePlus: 'circlePlus',
  close: 'close',
  cluckNorris: 'noop',
  cluckNorrisLoveThatChicken: 'noop',
  cluckNorrisSaxophone: 'noop',
  coffeeCupFilled: 'coffeeCupFilled',
  combo: 'noop',
  curbside: 'curbside',
  deleteCredit: 'deleteCredit',
  delivery: 'delivery',
  desserts: 'desserts',
  dineIn: 'dineIn',
  discover: 'discover',
  drinks: 'drinks',
  drive: 'drive',
  driveThru: 'driveThru',
  edit: 'edit',
  editWithEraser: 'editWithEraser',
  error: 'error',
  facebook: 'facebook',
  familyMeals: 'noop',
  fastFood: 'fastFood',
  favorite: 'favorite',
  favoriteFill: 'favoriteFill',
  gear: 'gear',
  googlePay: 'googlePay',
  home: 'home',
  halal: 'halal',
  hotDrink: 'hotDrink',
  info: 'info',
  instagram: 'instagram',
  kidsMeal: 'noop',
  kioskCard: 'kioskCard',
  language: 'language',
  list: 'list',
  location: 'location',
  lock: 'lock',
  lockUnlocked: 'lockUnlocked',
  logo: 'noop',
  loyaltyCard: 'noop',
  map: 'map',
  mapleLeaf: 'noop',
  mapleLeafFilled: 'noop',
  mastercard: 'mastercard',
  menu: 'menu',
  mobile: 'mobile',
  mobileNavHome: 'noop',
  new: 'WhatsNewIcon',
  next: 'next',
  offer: 'offer',
  order: 'noop',
  paypal: 'paypal',
  paymentCard: 'paymentCard',
  paymentCash: 'paymentCash',
  plkRewards: 'noop',
  poppyBag: 'poppyBag',
  previous: 'previous',
  profile: 'profile',
  qr: 'qr',
  mobileRaggedEdge: 'noop',
  desktopRaggedEdge: 'noop',
  refresh: 'refresh',
  remove: 'remove',
  restaurant: 'restaurant',
  rewards: 'noop',
  sadFace: 'sadFace',
  sandwiches: 'sandwiches',
  sauces: 'sauces',
  scanRewards: 'noop',
  seafood: 'noop',
  search: 'search',
  select: 'select',
  settings: 'settings',
  sides: 'noop',
  signatureChicken: 'noop',
  sodiumFlag: 'sodiumFlag',
  store: 'store',
  storeThree: 'storeThree',
  storeTwo: 'storeTwo',
  storeMarker: 'noop',
  swap: 'swap',
  telephone: 'telephone',
  tendersAndWings: 'noop',
  tiktok: 'tiktok',
  time: 'time',
  timsCard: 'noop',
  timsLogo: 'noop',
  timsText: 'noop',
  visa: 'visa',
  visibility: 'visibility',
  visibilityOff: 'visibilityOff',
  voice: 'voice',
  twitter: 'twitter',
  warning: 'warning',
  youtube: 'youtube'
};
var icon$3 = Object.assign(Object.assign({}, commonIcons), {
  bkCrown: 'bkCrown',
  desktopRaggedEdge: 'desktopRaggedEdge',
  logo: 'burgerKingLogo',
  mobileNavHome: 'mobileNavHomeBK',
  mobileRaggedEdge: 'mobileRaggedEdge',
  order: 'order',
  rewards: 'bkCrown'
});
var letterSpacing$3 = {
  headings: {
    H1: '-1px',
    H2: 'normal',
    H3: 'normal',
    H4: 'normal',
    H5: 'normal',
    H6: 'normal'
  },
  button: 'normal',
  body: 'normal',
  overline: 'normal'
};
var lineHeight$3 = {
  heading: {
    LARGE: '0.9',
    SMALL: '1'
  },
  subtitle: {
    LARGE: '1',
    SMALL: '1.4'
  },
  body: '1.4',
  caption: '1.4',
  link: '1.4',
  overline: '1'
};
var theme$3 = {
  fontFace: fontFace$3,
  fontFamily: fontFamily$3,
  fontSize: fontSize$3,
  fontWeight: fontWeight$3,
  letterSpacing: letterSpacing$3,
  lineHeight: lineHeight$3,
  spacing: spacing,
  textTransform: textTransform,
  zIndex: zIndex,
  icon: icon$3,
  color: color$3,
  components: {
    Hero: {
      defaultProps: {
        disableButtonReverse: false
      }
    }
  }
};
var color$2 = {
  /* LTW: Primary Teal */
  primary: '#97CEB9',

  /* Vivid Red */
  secondary: '#7AA897',
  tertiary: '#D90F06',
  black: '#000000',

  /* Salt White */
  brightWhite: '#FFFFFF',

  /* Off white */
  white: 'rgb(249,243,227)',

  /* Gainsboro */
  buttonsDisabledBackground: '#d0d0d0',
  buttonsDisabledLabel: '#838383',

  /* Lighter Black */
  buttonsPrimaryHover: '#393939',

  /* Lighter Black */
  buttonsSecondaryHover: '#e2dac8',

  /* Black at 40% opacity */
  buttonsFocused: '#e6e6e6',

  /* Lighter Black */
  buttonsPrimaryActive: '#393939',

  /* LTW: Black */
  buttonsSecondaryActive: '#1f1f1f',

  /* NOLA Teal */
  inputsFocused: '#00B2A9',
  statusValidated: '#5E8036',

  /* Spicy Red */
  statusError: '#D90F06',

  /* Spicy Red */
  statusPrice: '#D90F06',

  /* Butter Yellow */
  statusSuccess: '#FFC800',

  /* Darkest to Lightest */
  100: '#1F1F1F',
  200: '#323231',
  300: '#4A4A4A',
  400: '#696969',
  500: '#777777',
  600: '#959595',
  700: '#D0D0D0',
  800: '#EAE7E5',

  /* Off white */
  900: 'rgb(249,243,227)'
};
var fontFace$2 = [{
  name: 'chicken_sans_bold',
  sources: [{
    source: SupportedFonts.ChickenSansBold,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}, {
  name: 'chicken_sans',
  sources: [{
    source: SupportedFonts.ChickenSansRegular,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}];
var fontFamily$2 = {
  primary: '"chicken_sans_bold", sans-serif',
  secondary: '"Helvetica Neue", Helvetica, Arial, sans-serif'
};
var fontSize$2 = {
  headings: {
    H1: '6rem',
    H2: '3.75rem',
    H3: '3rem',
    H4: '2.25rem',
    H5: '1.625rem',
    H6: '1.375rem'
  },
  subtitle: {
    LARGE: '1.125rem',
    SMALL: '1rem'
  },
  body: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  button: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  caption: '0.8rem',
  overline: '0.625rem',
  link: '1rem'
};
var fontWeight$2 = {
  headings: 'bold',
  primary: 'bold',
  secondary: '500',
  tertiary: 'normal',
  link: 'bold',
  button: 'bold'
};
var icon$2 = Object.assign(Object.assign({}, commonIcons), {
  cart: 'cart',
  catering: 'cateringPLK',
  cluckNorris: 'cluckNorris',
  cluckNorrisLoveThatChicken: 'cluckNorrisLoveThatChicken',
  cluckNorrisSaxophone: 'cluckNorrisSaxophone',
  coffeeCupFilled: 'noop',
  combo: 'combo',
  delivery: 'deliveryPLK',
  familyMeals: 'familyMeals',
  hotDrink: 'noop',
  kidsMeal: 'kidsMeal',
  logo: 'popeyesLogo',
  mobileNavHome: 'mobileNavHomePLK',
  order: 'book',
  plkRewards: 'plkRewards',
  rewards: 'plkRewards',
  seafood: 'seafood',
  sides: 'sides',
  signatureChicken: 'signatureChicken',
  tendersAndWings: 'tendersAndWings'
});
var letterSpacing$2 = {
  headings: {
    H1: '-2px',
    H2: 'normal',
    H3: 'normal',
    H4: 'normal',
    H5: 'normal',
    H6: 'normal'
  },
  button: 'normal',
  body: 'normal',
  overline: '0.5px'
};
var lineHeight$2 = {
  heading: {
    LARGE: '0.9',
    SMALL: '1.1'
  },
  subtitle: {
    LARGE: '1.1',
    SMALL: '1.1'
  },
  body: '1.4',
  caption: '1.4',
  link: '1.4',
  overline: 'normal'
};
var theme$2 = {
  fontFace: fontFace$2,
  fontFamily: fontFamily$2,
  fontSize: fontSize$2,
  fontWeight: fontWeight$2,
  letterSpacing: letterSpacing$2,
  lineHeight: lineHeight$2,
  spacing: spacing,
  textTransform: textTransform,
  zIndex: zIndex,
  icon: icon$2,
  color: color$2,
  components: {
    Hero: {
      defaultProps: {
        disableButtonReverse: true
      }
    }
  }
};
var color$1 = {
  /* PLK: Primary Orange */
  primary: '#F25600',

  /* Vivid Orange */
  secondary: '#BE5A09',
  tertiary: '#D90F06',
  black: '#000000',

  /* Salt White */
  brightWhite: '#FFFFFF',

  /* Salt White */
  white: '#FFFFFF',

  /* Gainsboro */
  buttonsDisabledBackground: '#d0d0d0',
  buttonsDisabledLabel: '#838383',

  /* Vivid Orange */
  buttonsPrimaryHover: '#BE5A09',

  /* 15% primary */
  buttonsSecondaryHover: '#FCDDCC',

  /* 25% primary */
  buttonsFocused: '#EBCDB2',

  /* PLK: Primary Orange */
  buttonsPrimaryActive: '#f25600',

  /* PLK: Primary Orange */
  buttonsSecondaryActive: '#f25600',

  /* NOLA Teal */
  inputsFocused: '#00B2A9',
  statusValidated: '#5E8036',

  /* Spicy Red */
  statusError: '#D90F06',

  /* Spicy Red */
  statusPrice: '#D90F06',

  /* Butter Yellow */
  statusSuccess: '#FFC800',

  /* Darkest to Lightest */
  100: '#1F1F1F',
  200: '#323231',
  300: '#4A4A4A',
  400: '#696969',
  500: '#777777',
  600: '#959595',
  700: '#D0D0D0',
  800: '#EAE7E5',

  /* Light Grayish Orange */
  900: '#F5F1EF'
};
var fontFace$1 = [{
  name: 'chicken_sans_bold',
  sources: [{
    source: SupportedFonts.ChickenSansBold,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}, {
  name: 'chicken_sans',
  sources: [{
    source: SupportedFonts.ChickenSansRegular,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}];
var fontFamily$1 = {
  primary: '"chicken_sans_bold", sans-serif',
  secondary: '"Helvetica Neue", Helvetica, Arial, sans-serif'
};
var fontSize$1 = {
  headings: {
    H1: '6rem',
    H2: '3.75rem',
    H3: '3rem',
    H4: '2.25rem',
    H5: '1.625rem',
    H6: '1.375rem'
  },
  subtitle: {
    LARGE: '1.125rem',
    SMALL: '1rem'
  },
  body: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  button: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  caption: '0.8rem',
  overline: '0.625rem',
  link: '1rem'
};
var fontWeight$1 = {
  headings: 'bold',
  primary: 'bold',
  secondary: '500',
  tertiary: 'normal',
  link: 'bold',
  button: 'bold'
};
var icon$1 = Object.assign(Object.assign({}, commonIcons), {
  catering: 'cateringPLK',
  cluckNorris: 'cluckNorris',
  cluckNorrisLoveThatChicken: 'cluckNorrisLoveThatChicken',
  cluckNorrisSaxophone: 'cluckNorrisSaxophone',
  coffeeCupFilled: 'noop',
  combo: 'combo',
  delivery: 'deliveryPLK',
  familyMeals: 'familyMeals',
  hotDrink: 'noop',
  kidsMeal: 'kidsMeal',
  logo: 'popeyesLogo',
  mobileNavHome: 'mobileNavHomePLK',
  order: 'book',
  plkRewards: 'plkRewards',
  rewards: 'plkRewards',
  seafood: 'seafood',
  sides: 'sides',
  signatureChicken: 'signatureChicken',
  tendersAndWings: 'tendersAndWings'
});
var letterSpacing$1 = {
  headings: {
    H1: '-2px',
    H2: 'normal',
    H3: 'normal',
    H4: 'normal',
    H5: 'normal',
    H6: 'normal'
  },
  button: 'normal',
  body: 'normal',
  overline: '0.5px'
};
var lineHeight$1 = {
  heading: {
    LARGE: '0.9',
    SMALL: '1.1'
  },
  subtitle: {
    LARGE: '1.1',
    SMALL: '1.1'
  },
  body: '1.4',
  caption: '1.4',
  link: '1.4',
  overline: 'normal'
};
var theme$1 = {
  fontFace: fontFace$1,
  fontFamily: fontFamily$1,
  fontSize: fontSize$1,
  fontWeight: fontWeight$1,
  letterSpacing: letterSpacing$1,
  lineHeight: lineHeight$1,
  spacing: spacing,
  textTransform: textTransform,
  zIndex: zIndex,
  icon: icon$1,
  color: color$1,
  components: {
    Hero: {
      defaultProps: {
        disableButtonReverse: false
      }
    }
  }
};
var color = {
  /* Strong Red */
  primary: '#C8102E',
  secondary: '#572D2D',

  /* Dark Desaturated Red */
  tertiary: '#432726',
  black: '#000000',
  brightWhite: '#FFFFFF',
  white: '#FFFFFF',

  /* Very Light Gray */
  buttonsDisabledBackground: '#ececec',

  /* Very Dark Gray */
  buttonsDisabledLabel: '#6e6e6e',

  /* Dark Red */
  buttonsPrimaryHover: '#880a1e',

  /* 15% primary */
  buttonsSecondaryHover: '#f4cfd5',

  /* 25% primary */
  buttonsFocused: '#eba9b4',

  /* Dark Desaturated Red */
  buttonsPrimaryActive: '#432726',

  /* Strong Red */
  buttonsSecondaryActive: '#c8102e',
  inputsFocused: '#C90325',

  /* Dark Moderate Green */
  statusValidated: '#5E8035',
  statusError: '#C41230',
  statusPrice: '#C90325',

  /* Bright Orange */
  statusSuccess: '#E68835',

  /* Darkest to Lightest */
  100: '#323231',
  200: '#6E6E6E',
  300: '#76756D',
  400: '#767676',

  /* Dark Grayish Red */
  500: '#8A6C6C',
  600: '#DCDCDC',
  700: '#ECECEC',
  800: '#F4EFE9',
  900: '#F5F1EF'
};
var fontFace = [{
  name: 'sofia_pro_bold',
  sources: [{
    source: SupportedFonts.SofiaProBold,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'bold',
  display: 'swap'
}, {
  name: 'sofia_pro',
  sources: [{
    source: SupportedFonts.SofiaProRegular,
    type: SupportedFontTypes.woff2
  }],
  style: 'normal',
  weight: 'normal',
  display: 'swap'
}];
var fontFamily = {
  primary: '"sofia_pro_bold", Helvetica, Arial, sans-serif',
  secondary: '"sofia_pro", Helvetica, Arial, sans-serif'
};
var fontSize = {
  headings: {
    H1: '5rem',
    H2: '3.5rem',
    H3: '2.5rem',
    H4: '2rem',
    H5: '1.75rem',
    H6: '1.5rem'
  },
  subtitle: {
    LARGE: '1.125rem',
    SMALL: '1rem'
  },
  body: {
    LARGE: '1rem',
    SMALL: '0.875rem'
  },
  button: {
    LARGE: '1.25rem',
    SMALL: '0.875rem'
  },
  caption: '0.8rem',
  overline: '0.625rem',
  link: '1rem'
};
var fontWeight = {
  headings: '900',
  primary: '900',
  secondary: 'bold',
  tertiary: 'normal',
  link: 'bold',
  button: 'normal'
};
var icon = Object.assign(Object.assign({}, commonIcons), {
  logo: 'timHortonsLogo',
  loyaltyCard: 'loyaltyCard',
  mapleLeaf: 'mapleLeaf',
  mapleLeafFilled: 'mapleLeafFilled',
  mobileNavHome: 'mobileNavHomeTH',
  order: 'coffeeCup',
  rewards: 'thRewards',
  sandwiches: 'noop',
  sauces: 'noop',
  scanRewards: 'scanRewards',
  storeMarker: 'storeMarker',
  timsCard: 'timsCard',
  timsLogo: 'timsLogo',
  timsText: 'timsText'
});
var letterSpacing = {
  headings: {
    H1: '-2px',
    H2: '-1.5px',
    H3: '-1px',
    H4: '-0.5px',
    H5: 'normal',
    H6: 'normal'
  },
  button: 'normal',
  body: 'normal',
  overline: '1px'
};
var lineHeight = {
  heading: {
    LARGE: '1',
    SMALL: '1.1'
  },
  subtitle: {
    LARGE: '1.1',
    SMALL: '1.25'
  },
  body: '1.4',
  caption: '1.4',
  link: '1.4',
  overline: 'normal'
};
var theme = {
  fontFace: fontFace,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeight: fontWeight,
  letterSpacing: letterSpacing,
  lineHeight: lineHeight,
  spacing: spacing,
  textTransform: textTransform,
  zIndex: zIndex,
  icon: icon,
  color: color,
  components: {
    Hero: {
      defaultProps: {
        disableButtonReverse: false
      }
    }
  }
};
export { ActionIcon, AutocompleteOptionsDropdown, BaseBox, BaseContainer, BaseItemAlign, BaseText, BaseTextOnlyButton, Body1, Body2, BottomDrawer, Box, BoxShadowButton, Button, ButtonGroup, ButtonSizes, Caption, Card, Cell, Checkbox, Chip, Container, DateInput, Dialog, FeatureStatus, FieldSet, Footer, GlobalStyles$3 as GlobalStylesBk, GlobalStyles$2 as GlobalStylesLtw, GlobalStyles$1 as GlobalStylesPlk, GlobalStyles as GlobalStylesTh, Grid, H1, H2, H3, H4, H5, H6, Hero, Icon, InlineAlert, InputMessage, InverseButton, ItemAlign, ItemDescription, LocaleSelect, MenuCarousel, MenuCarouselItem, Mq, NextButton, NumberInput, OutlineButton, Overline, Panel, PlainIcon, PreviousButton, PrimaryButton, RadioButton, RewardsChip, RotateIcon, ScanButton, SecondaryButton, SectionHeader, Select, Subtitle1, Subtitle2, SupportedFontTypes, SupportedFonts, Switch, SwitchButton, SwitchLabel, Tab, TabList, TabPanel, TertiaryButton, TextArea, TextInput, TextOnlyButton, TextVariants, Toggle, Tooltip, VisuallyHidden, autofillDetectableStyle, calcCSSUnitSides, primitive as componentsLibraryPrimitives, deprecatedTokens, designTokens$3 as designTokensBk, designTokens$2 as designTokensLtw, designTokens$1 as designTokensPlk, designTokens as designTokensTh, getThemeColor, mediaQuery, theme$3 as themeBk, theme$2 as themeLtw, theme$1 as themePlk, theme as themeTh, useAutofillDetector, useBottomDrawerUIState, useDialogUIState, useFocusDetector, useForwardedRefLocally, useIdCounter, useMediaQuery, useMenuCarouselHandler, useNativeInvalidDetector, useResizeObserver, useThrottled };